(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[238],{

/***/ 8308:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'rocket';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f135';
var svgPathData = 'M408 143.1C408 166.1 390.1 183.1 368 183.1C345.9 183.1 328 166.1 328 143.1C328 121.9 345.9 103.1 368 103.1C390.1 103.1 408 121.9 408 143.1zM23.1 288C15.38 288 7.414 283.4 3.145 275.9C-1.123 268.4-1.043 259.2 3.356 251.8L55.83 163.3C68.79 141.4 92.33 127.1 117.8 127.1H199.9C202.4 124 204.8 120.3 207.2 116.7C289.1-4.07 411.1-8.142 483.9 5.275C495.6 7.414 504.6 16.43 506.7 28.06C520.1 100.9 516.1 222.9 395.3 304.8C391.7 307.2 387.1 309.6 384 312.1V394.2C384 419.7 370.6 443.2 348.7 456.2L260.2 508.6C252.8 513 243.6 513.1 236.1 508.9C228.6 504.6 223.1 496.6 223.1 488V391.8C215.2 395.6 207.4 398.9 200.1 401.7C189.1 406.6 175.5 403.9 166.5 394.8L115.8 344.1C106.6 334.9 103.9 321.1 109.1 309.2C111.7 303.2 114.9 296 118.5 288L23.1 288zM461.7 50.32C398.4 41.85 309.1 51.1 246.1 143.7C216.8 188.1 178.1 271.9 157.6 318.1L192.6 353.1C239.1 333.2 323.9 295.2 368.3 265C460 202.9 470.2 113.6 461.7 50.32V50.32z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.tM = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 187:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'user-astronaut';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f4fb';
var svgPathData = 'M358.6 328.8C379.1 308.6 395.1 283.8 404.8 256H416c8.75 0 16-7.25 16-16v-96C432 135.2 424.8 128 416 128h-11.25C378.5 53.5 307.6 0 224 0S69.5 53.5 43.25 128H32C23.25 128 16 135.2 16 144v96C16 248.8 23.25 256 32 256h11.25c9.75 27.75 25.63 52.63 46.13 72.75C37.38 347.2 0 396.1 0 454.4V488C0 501.2 10.75 512 24 512s24-10.75 24-24v-33.63C48 406.8 86.75 368 134.4 368h13C170.9 378.2 196.8 384 224 384s53.13-5.75 76.63-16h13C361.2 368 400 406.8 400 454.4V488c0 13.25 10.75 24 24 24c13.25 0 24-10.75 24-24v-33.63C448 396.1 410.6 347.2 358.6 328.8zM224 336c-79.38 0-144-64.63-144-144S144.6 48 224 48s144 64.62 144 144S303.4 336 224 336zM304 416h-160c-17.75 0-32 14.25-32 32l0 64H160v-48C160 455.2 167.3 448 176 448S192 455.2 192 464V512h144v-64C336 430.2 321.8 416 304 416zM272 480c-8.75 0-16-7.25-16-16s7.25-16 16-16s16 7.25 16 16S280.8 480 272 480zM288 128H160C133.5 128 112 149.5 112 176V192c0 53 43 96 96 96h32c53 0 96-43 96-96V176C336 149.5 314.5 128 288 128zM204 220L192 256L180 220L144 208l36-12L192 160l12 36L240 208L204 220z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.KC = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ FontAwesomeIcon; }
});

;// CONCATENATED MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
/*!
 * Font Awesome Free 6.1.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, Object.create(null));
  }

  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var MUTATION_APPROACH_ASYNC = 'async';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
var PRODUCTION = function () {
  try {
    return "production" === 'production';
  } catch (e) {
    return false;
  }
}();
var PREFIX_TO_STYLE = {
  'fas': 'solid',
  'fa-solid': 'solid',
  'far': 'regular',
  'fa-regular': 'regular',
  'fal': 'light',
  'fa-light': 'light',
  'fat': 'thin',
  'fa-thin': 'thin',
  'fad': 'duotone',
  'fa-duotone': 'duotone',
  'fab': 'brands',
  'fa-brands': 'brands',
  'fak': 'kit',
  'fa-kit': 'kit',
  'fa': 'solid'
};
var STYLE_TO_PREFIX = {
  'solid': 'fas',
  'regular': 'far',
  'light': 'fal',
  'thin': 'fat',
  'duotone': 'fad',
  'brands': 'fab',
  'kit': 'fak'
};
var PREFIX_TO_LONG_STYLE = {
  'fab': 'fa-brands',
  'fad': 'fa-duotone',
  'fak': 'fa-kit',
  'fal': 'fa-light',
  'far': 'fa-regular',
  'fas': 'fa-solid',
  'fat': 'fa-thin'
};
var LONG_STYLE_TO_PREFIX = {
  'fa-brands': 'fab',
  'fa-duotone': 'fad',
  'fa-kit': 'fak',
  'fa-light': 'fal',
  'fa-regular': 'far',
  'fa-solid': 'fas',
  'fa-thin': 'fat'
};
var ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk]?[\-\ ]/; // eslint-disable-line no-useless-escape

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?

var FONT_WEIGHT_TO_PREFIX = {
  '900': 'fas',
  '400': 'far',
  'normal': 'far',
  '300': 'fal',
  '100': 'fat'
};
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
var DUOTONE_CLASSES = {
  GROUP: 'duotone-group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var RESERVED_CLASSES = [].concat(_toConsumableArray(Object.keys(STYLE_TO_PREFIX)), ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', 'beat', 'border', 'fade', 'beat-fade', 'bounce', 'flip-both', 'flip-horizontal', 'flip-vertical', 'flip', 'fw', 'inverse', 'layers-counter', 'layers-text', 'layers', 'li', 'pull-left', 'pull-right', 'pulse', 'rotate-180', 'rotate-270', 'rotate-90', 'rotate-by', 'shake', 'spin-pulse', 'spin-reverse', 'spin', 'stack-1x', 'stack-2x', 'stack', 'ul', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n) {
  return "".concat(n, "x");
})).concat(oneToTwenty.map(function (n) {
  return "w-".concat(n);
}));

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  styleDefault: 'solid',
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread2(_objectSpread2({}, _default), initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_config).forEach(function (key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set(val) {
      _config[key] = val;

      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config[key];
    }
  });
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);

  return function () {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}

var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = '';

  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }

  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";

function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var _cssInserted = false;

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css: css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = string.charCodeAt(counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      var extra = string.charCodeAt(counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // eslint-disable-line eqeqeq
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }

  return output;
}

function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
  var size = string.length;
  var first = string.charCodeAt(index);
  var second;

  if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
    second = string.charCodeAt(index + 1);

    if (second >= 0xDC00 && second <= 0xDFFF) {
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }

  return first;
}

function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});
}

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var duotonePathRe = [/*#__PURE__*/_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
  d1: 1,
  d2: 2
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2,
  cls2: 3,
  d2: 4
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2
})];

var styles = namespace.styles,
    shims = namespace.shims;
var LONG_STYLE = Object.values(PREFIX_TO_LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = Object.keys(PREFIX_TO_STYLE);

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}

function getIconName(familyPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'number';
      });
      aliases.forEach(function (alias) {
        acc[alias.toString(16)] = iconName;
      });
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    acc[iconName] = iconName;

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'string';
      });
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
    }

    return acc;
  });
  _byAlias = lookup(function (acc, icon, iconName) {
    var aliases = icon[2];
    acc[iconName] = iconName;
    aliases.forEach(function (alias) {
      acc[alias] = iconName;
    });
    return acc;
  }); // If we have a Kit, we can't determine if regular is available since we
  // could be auto-fetching it. We'll have to assume that it is available.

  var hasRegular = 'far' in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function (acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    if (typeof maybeNameMaybeUnicode === 'string') {
      acc.names[maybeNameMaybeUnicode] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    if (typeof maybeNameMaybeUnicode === 'number') {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault);
};
onChange(function (c) {
  _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault);
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode('fas', unicode);
  return oldUnicode || (newUnicode ? {
    prefix: 'fas',
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var style = PREFIX_TO_STYLE[styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[styleOrPrefix] || STYLE_TO_PREFIX[style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
function getCanonicalIcon(values) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups,
      skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var givenPrefix = null;
  var canonical = values.reduce(function (acc, cls) {
    var iconName = getIconName(config.familyPrefix, cls);

    if (styles[cls]) {
      cls = LONG_STYLE.includes(cls) ? LONG_STYLE_TO_PREFIX[cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES.indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls);
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass) {
      acc.rest.push(cls);
    }

    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === 'fa' ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);

      if (shim.prefix) {
        givenPrefix = null;
      }

      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;

      if (acc.prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
        // Allow a fallback from the regular style to solid if regular is not available
        // but only if we aren't auto-fetching SVGs
        acc.prefix = 'fas';
      }
    }

    return acc;
  }, emptyCanonicalIcon());

  if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
    // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
  }

  return canonical;
}

var Library = /*#__PURE__*/function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]);
        var longPrefix = PREFIX_TO_LONG_STYLE[key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        var aliases = icon[2];
        if (!additions[prefix]) additions[prefix] = {};

        if (aliases.length > 0) {
          aliases.forEach(function (alias) {
            if (typeof alias === 'string') {
              additions[prefix][alias] = icon;
            }
          });
        }

        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
  var obj = _ref.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function (k) {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });

  _plugins.forEach(function (plugin) {
    var mixout = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout).forEach(function (tk) {
      if (typeof mixout[tk] === 'function') {
        obj[tk] = mixout[tk];
      }

      if (_typeof(mixout[tk]) === 'object') {
        Object.keys(mixout[tk]).forEach(function (sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }

          obj[tk][sk] = mixout[tk][sk];
        });
      }
    });

    if (plugin.hooks) {
      var hooks = plugin.hooks();
      Object.keys(hooks).forEach(function (hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }

        _hooks[hook].push(hooks[hook]);
      });
    }

    if (plugin.provides) {
      plugin.provides(providers);
    }
  });

  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args)); // eslint-disable-line no-useless-call
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    hookFn.apply(null, args);
  });
  return undefined;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : undefined;
}

function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === 'fa') {
    iconLookup.prefix = 'fas';
  }

  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks('noAuto');
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      callHooks('beforeI2svg', params);
      callProvided('pseudoElements2svg', params);
      return callProvided('i2svg', params);
    } else {
      return Promise.reject('Operation requires a DOM of some kind.');
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;

    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }

    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot: autoReplaceSvgRoot
      });
      callHooks('watch', params);
    });
  }
};
var parse = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }

    if (_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }

    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix: prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }

    if (typeof _icon === 'string' && (_icon.indexOf("".concat(config.familyPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(' '), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }

    if (typeof _icon === 'string') {
      var _prefix = getDefaultUsablePrefix();

      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto: noAuto,
  config: config,
  dom: dom,
  parse: parse,
  library: library,
  findIconDefinition: findIconDefinition,
  toHtml: toHtml
};

var autoReplace = function autoReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
      autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};

function domVariants(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread2(_objectSpread2({}, styles), {}, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : ''].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) {
    content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }

  var args = _objectSpread2(_objectSpread2({}, content), {}, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
  });

  var _ref2 = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
    children: [],
    attributes: {}
  } : callProvided('generateAbstractIcon', args) || {
    children: [],
    attributes: {}
  },
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _objectSpread2({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform: transform,
      startCentered: true,
      width: width,
      height: height
    });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
      title = params.title,
      extra = params.extra;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  var styleString = joinStyles(extra.styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}

var styles$1 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};

function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION && !config.showMissingIcons && iconName) {
    console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
  }
}

function findIcon(iconName, prefix) {
  var givenPrefix = prefix;

  if (prefix === 'fa' && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }

  return new Promise(function (resolve, reject) {
    var val = {
      found: false,
      width: 512,
      height: 512,
      icon: callProvided('missingIconAbstract') || {}
    };

    if (givenPrefix === 'fa') {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }

    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      var icon = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon));
    }

    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
    }));
  });
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = "FA \"6.1.2\"";

var begin = function begin(name) {
  p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark("".concat(preamble, " ").concat(name, " ends"));
  p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};

var perf = {
  begin: begin,
  end: end
};

var noop$2 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}

function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon;
}

function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}

function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}

function createElementNS(tag) {
  return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}

function createElement(tag) {
  return DOCUMENT.createElement(tag);
}

function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$ceFn = params.ceFn,
      ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? createElementNS : createElement : _params$ceFn;

  if (typeof abstractObj === 'string') {
    return DOCUMENT.createTextNode(abstractObj);
  }

  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn: ceFn
    }));
  });
  return tag;
}

function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  /* BEGIN.ATTRIBUTION */

  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  /* END.ATTRIBUTION */

  return comment;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];

    if (node.parentNode) {
      mutation[1].forEach(function (abstract) {
        node.parentNode.insertBefore(convertSVG(abstract), node);
      });

      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement

    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
    delete abstract[0].attributes.id;

    if (abstract[0].attributes.class) {
      var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }

        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(' ');

      if (splitClasses.toNode.length === 0) {
        node.removeAttribute('class');
      } else {
        node.setAttribute('class', splitClasses.toNode.join(' '));
      }
    }

    var newInnerHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function performOperationSync(op) {
  op();
}

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$2;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;

    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }

  if (!config.observeMutations) {
    return;
  }

  var _options$treeCallback = options.treeCallback,
      treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
      _options$nodeCallback = options.nodeCallback,
      nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
      _options$pseudoElemen = options.pseudoElementsCallback,
      pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
      _options$observeMutat = options.observeMutationsRoot,
      observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  var style = node.getAttribute('style');
  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
}

function classParser (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  var val = getCanonicalIcon(classArray(node));

  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.iconName && val.prefix) {
    return val;
  }

  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }

  if (!val.iconName && config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) {
    val.iconName = node.firstChild.data;
  }

  return val;
}

function attributesParser (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }

    return acc;
  }, {});
  var title = node.getAttribute('title');
  var titleId = node.getAttribute('data-fa-title-id');

  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }

  return extraAttributes;
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styleParser: true
  };

  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks('parseNodeAttributes', {}, node);
  var extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2({
    iconName: iconName,
    title: node.getAttribute('title'),
    titleId: node.getAttribute('data-fa-title-id'),
    prefix: prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}

var styles$2 = namespace.styles;

function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided('generateLayersText', node, nodeMeta);
  } else {
    return callProvided('generateSvgReplacementMutation', node, nodeMeta);
  }
}

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;

  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$2);

  if (!prefixes.includes('fa')) {
    prefixes.push('fa');
  }

  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
    return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }

  var candidates = [];

  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e) {// noop
  }

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return Promise.resolve();
  }

  var mark = perf.begin('onTree');
  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION) {
        if (e.name === 'MissingIcon') {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);
  return new Promise(function (resolve, reject) {
    Promise.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(function (e) {
      mark();
      reject(e);
    });
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
      mask: mask
    }));
  };
}

var render = function render(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return domVariants(_objectSpread2({
    type: 'icon'
  }, iconDefinition), function () {
    callHooks('beforeDOMElementCreation', {
      iconDefinition: iconDefinition,
      params: params
    });

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === void 0 ? function () {} : _params$callback;
      return onTree(node, callback);
    };

    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      var iconName = nodeMeta.iconName,
          title = nodeMeta.title,
          titleId = nodeMeta.titleId,
          prefix = nodeMeta.prefix,
          transform = nodeMeta.transform,
          symbol = nodeMeta.symbol,
          mask = nodeMeta.mask,
          maskId = nodeMeta.maskId,
          extra = nodeMeta.extra;
      return new Promise(function (resolve, reject) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              main = _ref2[0],
              mask = _ref2[1];

          resolve([node, makeInlineSvgAbstract({
            icons: {
              main: main,
              mask: mask
            },
            prefix: prefix,
            iconName: iconName,
            transform: transform,
            symbol: symbol,
            maskId: maskId,
            title: title,
            titleId: titleId,
            extra: extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };

    providers$$1.generateAbstractIcon = function (_ref3) {
      var children = _ref3.children,
          attributes = _ref3.attributes,
          main = _ref3.main,
          transform = _ref3.transform,
          styles = _ref3.styles;
      var styleString = joinStyles(styles);

      if (styleString.length > 0) {
        attributes['style'] = styleString;
      }

      var nextChild;

      if (transformIsMeaningful(transform)) {
        nextChild = callProvided('generateAbstractTransformGrouping', {
          main: main,
          transform: transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }

      children.push(nextChild || main.icon);
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var Layers = {
  mixout: function mixout() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: 'layer'
        }, function () {
          callHooks('beforeDOMElementCreation', {
            assembler: assembler,
            params: params
          });
          var children = [];
          assembler(function (args) {
            Array.isArray(args) ? args.map(function (a) {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: 'span',
            attributes: {
              class: ["".concat(config.familyPrefix, "-layers")].concat(_toConsumableArray(classes)).join(' ')
            },
            children: children
          }];
        });
      }
    };
  }
};

var LayersCounter = {
  mixout: function mixout() {
    return {
      counter: function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'counter',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.familyPrefix, "-layers-counter")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  }
};

var LayersText = {
  mixout: function mixout() {
    return {
      text: function text(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform = params.transform,
            transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
            _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'text',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersTextAbstract({
            content: content,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.familyPrefix, "-layers-text")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      var title = nodeMeta.title,
          transform = nodeMeta.transform,
          extra = nodeMeta.extra;
      var width = null;
      var height = null;

      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }

      if (config.autoA11y && !title) {
        extra.attributes['aria-hidden'] = 'true';
      }

      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width: width,
        height: height,
        transform: transform,
        title: title,
        extra: extra,
        watchable: true
      })]);
    };
  }
};

var CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}

function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new Promise(function (resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }

    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function (c) {
      return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
    var fontWeight = styles.getPropertyValue('font-weight');
    var content = styles.getPropertyValue('content');

    if (alreadyProcessedPseudoElement && !fontFamily) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== 'none' && content !== '') {
      var _content = styles.getPropertyValue('content');

      var prefix = ~['Solid', 'Regular', 'Light', 'Thin', 'Duotone', 'Brands', 'Kit'].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];

      var _hexValueFromContent = hexValueFromContent(_content),
          hexValue = _hexValueFromContent.value,
          isSecondary = _hexValueFromContent.isSecondary;

      var isV4 = fontFamily[0].startsWith('FontAwesome');
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;

      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);

        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
      // already done so with the same prefix and iconName


      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);

        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }

        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function (main) {
          var abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
            icons: {
              main: main,
              mask: emptyCanonicalIcon()
            },
            prefix: prefix,
            iconName: iconIdentifier,
            extra: extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement('svg');

          if (position === '::before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }

          element.outerHTML = abstract.map(function (a) {
            return toHtml(a);
          }).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}

function replace(node) {
  return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
}

function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function (resolve, reject) {
    var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
    var end = perf.begin('searchPseudoElements');
    disableObservation();
    Promise.all(operations).then(function () {
      end();
      enableObservation();
      resolve();
    }).catch(function () {
      end();
      enableObservation();
      reject();
    });
  });
}

var PseudoElements = {
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.pseudoElements2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node;

      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};

var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks('mutationObserverCallbacks', {}));
      },
      noAuto: function noAuto() {
        disconnect();
      },
      watch: function watch(params) {
        var observeMutationsRoot = params.observeMutationsRoot;

        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks('mutationObserverCallbacks', {
            observeMutationsRoot: observeMutationsRoot
          }));
        }
      }
    };
  }
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
    var parts = n.toLowerCase().split('-');
    var first = parts[0];
    var rest = parts.slice(1).join('-');

    if (first && rest === 'h') {
      acc.flipX = true;
      return acc;
    }

    if (first && rest === 'v') {
      acc.flipY = true;
      return acc;
    }

    rest = parseFloat(rest);

    if (isNaN(rest)) {
      return acc;
    }

    switch (first) {
      case 'grow':
        acc.size = acc.size + rest;
        break;

      case 'shrink':
        acc.size = acc.size - rest;
        break;

      case 'left':
        acc.x = acc.x - rest;
        break;

      case 'right':
        acc.x = acc.x + rest;
        break;

      case 'up':
        acc.y = acc.y - rest;
        break;

      case 'down':
        acc.y = acc.y + rest;
        break;

      case 'rotate':
        acc.rotate = acc.rotate + rest;
        break;
    }

    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute('data-fa-transform');

        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }

        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractTransformGrouping = function (_ref) {
      var main = _ref.main,
          transform = _ref.transform,
          containerWidth = _ref.containerWidth,
          iconWidth = _ref.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer: outer,
        inner: inner,
        path: path
      };
      return {
        tag: 'g',
        attributes: _objectSpread2({}, operations.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread2({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

var Masks = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute('data-fa-mask');
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(function (i) {
          return i.trim();
        }));

        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }

        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute('data-fa-mask-id');
        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractMask = function (_ref) {
      var children = _ref.children,
          attributes = _ref.attributes,
          main = _ref.main,
          mask = _ref.mask,
          explicitMaskId = _ref.maskId,
          transform = _ref.transform;
      var mainWidth = main.width,
          mainPath = main.icon;
      var maskWidth = mask.width,
          maskPath = mask.icon;
      var trans = transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: 'rect',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          fill: 'white'
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.inner),
        children: [fillBlack(_objectSpread2({
          tag: mainPath.tag,
          attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: 'mask',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: 'userSpaceOnUse',
          maskContentUnits: 'userSpaceOnUse'
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: 'defs',
        children: [{
          tag: 'clipPath',
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: 'rect',
        attributes: _objectSpread2({
          fill: 'currentColor',
          'clip-path': "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var MissingIconIndicator = {
  provides: function provides(providers) {
    var reduceMotion = false;

    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    providers.missingIconAbstract = function () {
      var gChildren = [];
      var FILL = {
        fill: 'currentColor'
      };
      var ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
      }; // Ring

      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
      });

      var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
        attributeName: 'opacity'
      });

      var dot = {
        tag: 'circle',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          cx: '256',
          cy: '364',
          r: '28'
        }),
        children: []
      };

      if (!reduceMotion) {
        dot.children.push({
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
            attributeName: 'r',
            values: '28;14;28;28;14;28;'
          })
        }, {
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;1;1;0;1;'
          })
        });
      }

      gChildren.push(dot);
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          opacity: '1',
          d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: reduceMotion ? [] : [{
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;0;0;0;1;'
          })
        }]
      });

      if (!reduceMotion) {
        // Exclamation
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
          }),
          children: [{
            tag: 'animate',
            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
              values: '0;0;1;1;0;0;'
            })
          }]
        });
      }

      return {
        tag: 'g',
        attributes: {
          'class': 'missing'
        },
        children: gChildren
      };
    };
  }
};

var SvgSymbols = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute('data-fa-symbol');
        var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
        accumulator['symbol'] = symbol;
        return accumulator;
      }
    };
  }
};

var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

registerPlugins(plugins, {
  mixoutsTo: api
});
var noAuto$1 = api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
var dom$1 = api.dom;
var parse$1 = api.parse;
var findIconDefinition$1 = api.findIconDefinition;
var toHtml$1 = api.toHtml;
var icon = api.icon;
var index_es_layer = api.layer;
var index_es_text = api.text;
var counter = api.counter;



// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js




function index_es_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function index_es_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? index_es_ownKeys(Object(source), !0).forEach(function (key) {
      index_es_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : index_es_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function index_es_typeof(obj) {
  "@babel/helpers - typeof";

  return index_es_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, index_es_typeof(obj);
}

function index_es_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function index_es_toConsumableArray(arr) {
  return index_es_arrayWithoutHoles(arr) || index_es_iterableToArray(arr) || index_es_unsupportedIterableToArray(arr) || index_es_nonIterableSpread();
}

function index_es_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return index_es_arrayLikeToArray(arr);
}

function index_es_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function index_es_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return index_es_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return index_es_arrayLikeToArray(o, minLen);
}

function index_es_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function index_es_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var beat = props.beat,
      fade = props.fade,
      beatFade = props.beatFade,
      bounce = props.bounce,
      shake = props.shake,
      flash = props.flash,
      spin = props.spin,
      spinPulse = props.spinPulse,
      spinReverse = props.spinReverse,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-beat': beat,
    'fa-fade': fade,
    'fa-beat-fade': beatFade,
    'fa-bounce': bounce,
    'fa-shake': shake,
    'fa-flash': flash,
    'fa-spin': spin,
    'fa-spin-reverse': spinReverse,
    'fa-spin-pulse': spinPulse,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip': flip === true,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, index_es_defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), index_es_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), index_es_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), index_es_defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

var _excluded = ["style"];

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, _excluded);

  mixins.attrs['style'] = index_es_objectSpread2(index_es_objectSpread2({}, mixins.attrs['style']), existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, index_es_objectSpread2(index_es_objectSpread2({}, mixins.attrs), remaining)].concat(index_es_toConsumableArray(children)));
}

var index_es_PRODUCTION = false;

try {
  index_es_PRODUCTION = "production" === 'production';
} catch (e) {}

function log () {
  if (!index_es_PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  // this has everything that it needs to be rendered which means it was probably imported
  // directly from an icon svg package
  if (icon && index_es_typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }

  if (parse$1.icon) {
    return parse$1.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (icon && index_es_typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? index_es_defineProperty({}, key, value) : {};
}

var FontAwesomeIcon = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title,
      titleId = props.titleId,
      maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(index_es_toConsumableArray(classList(props)), index_es_toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse$1.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, index_es_objectSpread2(index_es_objectSpread2(index_es_objectSpread2(index_es_objectSpread2({}, classes), transform), mask), {}, {
    symbol: symbol,
    title: title,
    titleId: titleId,
    maskId: maskId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: ref
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
});
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  beat: (prop_types_default()).bool,
  border: (prop_types_default()).bool,
  beatFade: (prop_types_default()).bool,
  bounce: (prop_types_default()).bool,
  className: (prop_types_default()).string,
  fade: (prop_types_default()).bool,
  flash: (prop_types_default()).bool,
  mask: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).array, (prop_types_default()).string]),
  maskId: (prop_types_default()).string,
  fixedWidth: (prop_types_default()).bool,
  inverse: (prop_types_default()).bool,
  flip: prop_types_default().oneOf([true, false, 'horizontal', 'vertical', 'both']),
  icon: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).array, (prop_types_default()).string]),
  listItem: (prop_types_default()).bool,
  pull: prop_types_default().oneOf(['right', 'left']),
  pulse: (prop_types_default()).bool,
  rotation: prop_types_default().oneOf([0, 90, 180, 270]),
  shake: (prop_types_default()).bool,
  size: prop_types_default().oneOf(['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: (prop_types_default()).bool,
  spinPulse: (prop_types_default()).bool,
  spinReverse: (prop_types_default()).bool,
  symbol: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).string]),
  title: (prop_types_default()).string,
  titleId: (prop_types_default()).string,
  transform: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).object]),
  swapOpacity: (prop_types_default()).bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: '',
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, react.createElement);




/***/ }),

/***/ 160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HN": function() { return /* binding */ f; },
/* harmony export */   "Zb": function() { return /* binding */ h; },
/* harmony export */   "lE": function() { return /* binding */ t; },
/* harmony export */   "qY": function() { return /* binding */ r; }
/* harmony export */ });
/* unused harmony exports ACADEMY, B2B, B2B_TYPE, EXPERT, EXPERT_PLUS, LG_BREAKPOINT, PAYMENT_METHOD_IMG, PAYMENT_METHOD_IMG_LIGHT, PLAN_ACADEMY, PLAN_BASIC, PLAN_ENTERPRISE, PLAN_EXPERT, PLAN_EXPERT_DUO, PLAN_FAMILY, PLAN_FREE, USER_TYPE, XS_BREAKPOINT, b2bEmailRegex, nameRegex */
const a={amex:"https://static.platzi.com/commons/assets/images/amex8c702aae174e8d5b.png",baloto:"https://static.platzi.com/commons/assets/images/baloto7621e7f822d4583d.png",banorte:"https://static.platzi.com/commons/assets/images/banorte87e6a5073635d557.png",bitcoin:"https://static.platzi.com/commons/assets/images/bitcoinadad1b8d54a97811.png",davivienda:"https://static.platzi.com/commons/assets/images/davivienda5f0ce9d108e6b1ee.png",efecty:"https://static.platzi.com/commons/assets/images/efecty91f6cb277fa29fea.png",mastercard:"https://static.platzi.com/commons/assets/images/mastercardbf4ad752b3fb3d0e.png",oxxo:"https://static.platzi.com/commons/assets/images/oxxoe3985c89b2ec0bf5.png",pago_efectivo:"https://static.platzi.com/commons/assets/images/pago_efectivod8f46b2bdaf56e7f.png",pago_facil:"https://static.platzi.com/commons/assets/images/pago_facil5df441661803d43a.png",paypal:"https://static.platzi.com/commons/assets/images/paypalbc538ab7210a384a.png",pse:"https://static.platzi.com/commons/assets/images/psebb0ce4c4463aa51b.png",rapipago:"https://static.platzi.com/commons/assets/images/rapipago1001d95e1020bdf8.png",visa:"https://static.platzi.com/commons/assets/images/visa52d765334f273be7.png",sencillito:"https://static.platzi.com/commons/assets/images/sencillitof1aa0eb82ecec56d.png",servipag:"https://static.platzi.com/commons/assets/images/servipage7972ff9af0f8a91.png"};const s={amex:"https://static.platzi.com/commons/assets/images/amexda647adf95f30924.png",baloto:"https://static.platzi.com/commons/assets/images/baloto7621e7f822d4583d.png",banorte:"https://static.platzi.com/commons/assets/images/banorte87e6a5073635d557.png",bitcoin:"https://static.platzi.com/commons/assets/images/bitcoinadad1b8d54a97811.png",davivienda:"https://static.platzi.com/commons/assets/images/davivienda5f0ce9d108e6b1ee.png",efecty:"https://static.platzi.com/commons/assets/images/efecty22311be7d0475e8f.png",mastercard:"https://static.platzi.com/commons/assets/images/mastercardbf4ad752b3fb3d0e.png",oxxo:"https://static.platzi.com/commons/assets/images/oxxoe3985c89b2ec0bf5.png",pago_efectivo:"https://static.platzi.com/commons/assets/images/pago_efectivo39a4341bf1f15d31.png",pago_facil:"https://static.platzi.com/commons/assets/images/pago_facil632781fca2af5541.png",paypal:"https://static.platzi.com/commons/assets/images/paypal03ae8e5a43fc2f23.png",pse:"https://static.platzi.com/commons/assets/images/pse3962764fe3faa4ea.png",rapipago:"https://static.platzi.com/commons/assets/images/rapipago3cefa48fe3375a12.png",visa:"https://static.platzi.com/commons/assets/images/visa91625977f7206bc0.png"},t={SPANISH_CO:"es-CO",SPANISH_ES:"es-ES",PORTUGUESE:"pt",ENGLISH:"en"},e="monthly_plan",o="expert_plan",i="annual_plan",m="platzi_academy",p="family_plan",c="free_plan",n="enterprise",g="user",l="b2b",f=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,b=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(?!(?:hotmail|gmail|googlemail|yahoo|gmx|ymail|outlook|bluewin|protonmail|live))((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,d=/^[a-zA-Z\s]*$/,z=480,h=768,r=1024,v=1200,x="Platzi Expert",_="Platzi Expert+",y="Plan Empresarial",A="Platzi English Academy";


/***/ }),

/***/ 3099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ index_e9a6ce7d_m; },
  "c": function() { return /* binding */ R; }
});

// UNUSED EXPORTS: S, b, d, i, v

// EXTERNAL MODULE: ./node_modules/@platzi/commons/dist/es/axiosInstance-6d2f1e6e.js
var axiosInstance_6d2f1e6e = __webpack_require__(6905);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js + 1 modules
var context = __webpack_require__(7715);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 7 modules
var i18next = __webpack_require__(5751);
;// CONCATENATED MODULE: ./node_modules/@platzi/commons/dist/es/apiCalls-c0fe2c19.js
const e={middlewares:{verifyUser:"/api/v3/users/is-authenticated/",studentHomeAccess:"/api/v3/users/has-new-home-stundents/",isBetaTester:"/api/v3/users/is-organizer-beta-tester/",enterpriseActivationsAccess:e=>`/api/v3/enterprise/${e}/permissions/can-access-enterprise-activations/`,orgCanAccess:"/api/v3/users/is-es-organization/"},header:"/api/bff/org/header/",home:"/api/bff/web/home/",conf:e=>`/api/v4/conferences/${e}/`,contact:"/api/bff/web/contact-info/",metatags:e=>`/api/bff/org/meta-tags/${e}/`,userLp:"/api/v3/users-learning-paths/",categories:"/api/v3/categories/",b2bDashboard:e=>`/api/v3/companies/${e}/dashboard/overview/`,studentLearningPaths:"/api/v4/user-learning-paths/",studentCategories:"/api/v3/home-user-custom-catalog/",enterpriseActivationsMenu:e=>`/api/v3/enterprise/${e}/menu/`,deals:"/entrenamiento-google/code/",recentLaunches:"/api/v4/recent-launches/",getSchools:"/api/v4/schools-list/",promos:e=>`/api/v4/promo/${e}/`},apiCalls_c0fe2c19_s={auth:{credentials:"/api/v3/users/credentials/",liveCredentials:e=>`/api/v4/live-credentials/${e}/`},preRegister:"/api/v4/preregister-countdown/",registerB2B:"/empresas/",courses:{manualCourses:"/api/v3/courses/user-manual-courses/",privateCourses:"/api/v3/courses/user-private-courses/",bougthCourses:"/api/v3/courses/user-purchased-courses/",getNewCourses:"/api/v3/courses/new-courses/"},users:{statsUrl:"/api/v3/users/stats/",getAlerts:"/api/v3/users/notifications/",mailVerified:"/api/v3/users/mail-verified/"},materials:{getMaterialProgress:"/api/v3/materials/progress/",removeLatestMaterial:e=>`/api/v3/materials/${e}/remove-latest/`},categories:{getCategories:"/api/v3/categories/"},learningPaths:{getUserLp:"/api/v3/learning-paths/",deleteLp:e=>`/api/v3/users-learning-paths/${e}/`,addLp:e=>`/api/v3/users-learning-paths/${e}/assign/`,availableForAdition:e=>`/api/v4/user-learning-paths/get-lps-available/${e}/`},live:{checkLive:"api/v1/lives/"},notifications:{getHomeFeed:e=>`/api/v3/home-feed/?page=${e}`},recommendations:{courses:"/api/v3/users/recommendations/"},discussions:{like:"/api/v3/home-feed/toggle-star/"},homeCatalog:{categoryDetail:e=>`/api/v3/home-catalog/?category=${e}`,categoryLearningPathDetail:e=>`/api/v3/home-catalog/${e}/`},homeUserCatalog:{studentLearningPathDetail:e=>`/api/v3/home-user-catalog/${e}/`,deleteCourse:()=>"/api/v3/home-user-custom-catalog/course/",addCourse:()=>"/api/v3/home-user-custom-catalog/course/"},globalSearch:e=>`/global-search/?search=${e}`,billing:{getInfo:()=>"/api/v3/payment-data/",saveInfo:()=>"/api/v3/billing-data/"},geo:{getStates:()=>"/api/bff/geo/states/",getCities:e=>`/api/bff/geo/municipalities/${e}/`},conf:{registration:(e,s)=>`/api/v4/conferences/${e}/register/?ticket_type=${s}`},deals:{submitCode:()=>"/entrenamiento-google/code/",registerData:()=>"/entrenamiento-google/data/"},platziDay:()=>"/api/v4/progress/courses/get_progress_platzi_day/",getBenefitiaryProgress:e=>`/api/v4/progress/courses/beneficiary-progress/${e}/`,sif:{tracking:"/api/v1/tracking/"},user:{getUserInfo:"/api/v1/components/headerv2/user/",isAccountless:"/api/v3/users/accountless/"}};

;// CONCATENATED MODULE: ./node_modules/@platzi/commons/dist/es/index-8d56a83f.js
var index_8d56a83f_e,n,r,t,o,a,i,u,c,f,s,l,index_8d56a83f_p={exports:{}},y={exports:{}},d={};function m(){return n?y.exports:(n=1,y.exports=(index_8d56a83f_e||(index_8d56a83f_e=1,function(){var e="function"==typeof Symbol&&Symbol.for,n=e?Symbol.for("react.element"):60103,r=e?Symbol.for("react.portal"):60106,t=e?Symbol.for("react.fragment"):60107,o=e?Symbol.for("react.strict_mode"):60108,a=e?Symbol.for("react.profiler"):60114,i=e?Symbol.for("react.provider"):60109,u=e?Symbol.for("react.context"):60110,c=e?Symbol.for("react.async_mode"):60111,f=e?Symbol.for("react.concurrent_mode"):60111,s=e?Symbol.for("react.forward_ref"):60112,l=e?Symbol.for("react.suspense"):60113,p=e?Symbol.for("react.suspense_list"):60120,y=e?Symbol.for("react.memo"):60115,m=e?Symbol.for("react.lazy"):60116,b=e?Symbol.for("react.block"):60121,v=e?Symbol.for("react.fundamental"):60117,h=e?Symbol.for("react.responder"):60118,g=e?Symbol.for("react.scope"):60119;function w(e){if("object"==typeof e&&null!==e){var p=e.$$typeof;switch(p){case n:var d=e.type;switch(d){case c:case f:case t:case a:case o:case l:return d;default:var b=d&&d.$$typeof;switch(b){case u:case s:case m:case y:case i:return b;default:return p}}case r:return p}}}var O=c,S=f,x=u,j=i,T=n,E=s,I=t,P=m,$=y,k=r,R=a,A=o,C=l,_=!1;function M(e){return w(e)===f}d.AsyncMode=O,d.ConcurrentMode=S,d.ContextConsumer=x,d.ContextProvider=j,d.Element=T,d.ForwardRef=E,d.Fragment=I,d.Lazy=P,d.Memo=$,d.Portal=k,d.Profiler=R,d.StrictMode=A,d.Suspense=C,d.isAsyncMode=function(e){return _||(_=!0,console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")),M(e)||w(e)===c},d.isConcurrentMode=M,d.isContextConsumer=function(e){return w(e)===u},d.isContextProvider=function(e){return w(e)===i},d.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===n},d.isForwardRef=function(e){return w(e)===s},d.isFragment=function(e){return w(e)===t},d.isLazy=function(e){return w(e)===m},d.isMemo=function(e){return w(e)===y},d.isPortal=function(e){return w(e)===r},d.isProfiler=function(e){return w(e)===a},d.isStrictMode=function(e){return w(e)===o},d.isSuspense=function(e){return w(e)===l},d.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===t||e===f||e===a||e===o||e===l||e===p||"object"==typeof e&&null!==e&&(e.$$typeof===m||e.$$typeof===y||e.$$typeof===i||e.$$typeof===u||e.$$typeof===s||e.$$typeof===v||e.$$typeof===h||e.$$typeof===g||e.$$typeof===b)},d.typeOf=w}()),d))}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/function b(){if(a)return o;a=1;return o="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}function v(){return u?i:(u=1,i=Function.call.bind(Object.prototype.hasOwnProperty))}var h=m();index_8d56a83f_p.exports=function(){if(l)return s;l=1;var e,n=m(),o=function(){if(t)return r;t=1;var e=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,o=Object.prototype.propertyIsEnumerable;function a(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}return r=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var n={},r=0;r<10;r++)n["_"+String.fromCharCode(r)]=r;if("0123456789"!==Object.getOwnPropertyNames(n).map((function(e){return n[e]})).join(""))return!1;var t={};return"abcdefghijklmnopqrst".split("").forEach((function(e){t[e]=e})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},t)).join("")}catch(e){return!1}}()?Object.assign:function(r,t){for(var i,u,c=a(r),f=1;f<arguments.length;f++){for(var s in i=Object(arguments[f]))n.call(i,s)&&(c[s]=i[s]);if(e){u=e(i);for(var l=0;l<u.length;l++)o.call(i,u[l])&&(c[u[l]]=i[u[l]])}}return c},r}(),a=b(),i=v(),u=function(){if(f)return c;f=1;var e,n=b(),r={},t=v();function o(o,a,i,u,c){for(var f in o)if(t(o,f)){var s;try{if("function"!=typeof o[f]){var l=Error((u||"React class")+": "+i+" type `"+f+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof o[f]+"`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");throw l.name="Invariant Violation",l}s=o[f](a,f,u,i,null,n)}catch(e){s=e}if(!s||s instanceof Error||e((u||"React class")+": type specification of "+i+" `"+f+"` is invalid; the type checker function must return `null` or an `Error` but returned a "+typeof s+". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."),s instanceof Error&&!(s.message in r)){r[s.message]=!0;var p=c?c():"";e("Failed "+i+" type: "+s.message+(null!=p?p:""))}}}return e=function(e){var n="Warning: "+e;"undefined"!=typeof console&&console.error(n);try{throw new Error(n)}catch(e){}},o.resetWarningCache=function(){r={}},c=o}();function p(){return null}return e=function(e){var n="Warning: "+e;"undefined"!=typeof console&&console.error(n);try{throw new Error(n)}catch(e){}},s=function(r,t){var c="function"==typeof Symbol&&Symbol.iterator,f="<<anonymous>>",s={array:m("array"),bigint:m("bigint"),bool:m("boolean"),func:m("function"),number:m("number"),object:m("object"),string:m("string"),symbol:m("symbol"),any:d(p),arrayOf:function(e){return d((function(n,r,t,o,i){if("function"!=typeof e)return new y("Property `"+i+"` of component `"+t+"` has invalid PropType notation inside arrayOf.");var u=n[r];if(!Array.isArray(u))return new y("Invalid "+o+" `"+i+"` of type `"+h(u)+"` supplied to `"+t+"`, expected an array.");for(var c=0;c<u.length;c++){var f=e(u,c,t,o,i+"["+c+"]",a);if(f instanceof Error)return f}return null}))},element:d((function(e,n,t,o,a){var i=e[n];return r(i)?null:new y("Invalid "+o+" `"+a+"` of type `"+h(i)+"` supplied to `"+t+"`, expected a single ReactElement.")})),elementType:d((function(e,r,t,o,a){var i=e[r];return n.isValidElementType(i)?null:new y("Invalid "+o+" `"+a+"` of type `"+h(i)+"` supplied to `"+t+"`, expected a single ReactElement type.")})),instanceOf:function(e){return d((function(n,r,t,o,a){if(!(n[r]instanceof e)){var i=e.name||f;return new y("Invalid "+o+" `"+a+"` of type `"+((u=n[r]).constructor&&u.constructor.name?u.constructor.name:f)+"` supplied to `"+t+"`, expected instance of `"+i+"`.")}var u;return null}))},node:d((function(e,n,r,t,o){return v(e[n])?null:new y("Invalid "+t+" `"+o+"` supplied to `"+r+"`, expected a ReactNode.")})),objectOf:function(e){return d((function(n,r,t,o,u){if("function"!=typeof e)return new y("Property `"+u+"` of component `"+t+"` has invalid PropType notation inside objectOf.");var c=n[r],f=h(c);if("object"!==f)return new y("Invalid "+o+" `"+u+"` of type `"+f+"` supplied to `"+t+"`, expected an object.");for(var s in c)if(i(c,s)){var l=e(c,s,t,o,u+"."+s,a);if(l instanceof Error)return l}return null}))},oneOf:function(n){if(!Array.isArray(n))return e(arguments.length>1?"Invalid arguments supplied to oneOf, expected an array, got "+arguments.length+" arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).":"Invalid argument supplied to oneOf, expected an array."),p;function r(e,r,t,o,a){for(var i=e[r],u=0;u<n.length;u++)if(l(i,n[u]))return null;var c=JSON.stringify(n,(function(e,n){return"symbol"===g(n)?String(n):n}));return new y("Invalid "+o+" `"+a+"` of value `"+String(i)+"` supplied to `"+t+"`, expected one of "+c+".")}return d(r)},oneOfType:function(n){if(!Array.isArray(n))return e("Invalid argument supplied to oneOfType, expected an instance of array."),p;for(var r=0;r<n.length;r++){var t=n[r];if("function"!=typeof t)return e("Invalid argument supplied to oneOfType. Expected an array of check functions, but received "+w(t)+" at index "+r+"."),p}return d((function(e,r,t,o,u){for(var c=[],f=0;f<n.length;f++){var s=(0,n[f])(e,r,t,o,u,a);if(null==s)return null;s.data&&i(s.data,"expectedType")&&c.push(s.data.expectedType)}return new y("Invalid "+o+" `"+u+"` supplied to `"+t+"`"+(c.length>0?", expected one of type ["+c.join(", ")+"]":"")+".")}))},shape:function(e){return d((function(n,r,t,o,i){var u=n[r],c=h(u);if("object"!==c)return new y("Invalid "+o+" `"+i+"` of type `"+c+"` supplied to `"+t+"`, expected `object`.");for(var f in e){var s=e[f];if("function"!=typeof s)return b(t,o,i,f,g(s));var l=s(u,f,t,o,i+"."+f,a);if(l)return l}return null}))},exact:function(e){return d((function(n,r,t,u,c){var f=n[r],s=h(f);if("object"!==s)return new y("Invalid "+u+" `"+c+"` of type `"+s+"` supplied to `"+t+"`, expected `object`.");var l=o({},n[r],e);for(var p in l){var d=e[p];if(i(e,p)&&"function"!=typeof d)return b(t,u,c,p,g(d));if(!d)return new y("Invalid "+u+" `"+c+"` key `"+p+"` supplied to `"+t+"`.\nBad object: "+JSON.stringify(n[r],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(e),null,"  "));var m=d(f,p,t,u,c+"."+p,a);if(m)return m}return null}))}};function l(e,n){return e===n?0!==e||1/e==1/n:e!=e&&n!=n}function y(e,n){this.message=e,this.data=n&&"object"==typeof n?n:{},this.stack=""}function d(n){var r={},o=0;function i(i,u,c,s,l,p,d){if(s=s||f,p=p||c,d!==a){if(t){var m=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");throw m.name="Invariant Violation",m}if("undefined"!=typeof console){var b=s+":"+c;!r[b]&&o<3&&(e("You are manually calling a React.PropTypes validation function for the `"+p+"` prop on `"+s+"`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."),r[b]=!0,o++)}}return null==u[c]?i?null===u[c]?new y("The "+l+" `"+p+"` is marked as required in `"+s+"`, but its value is `null`."):new y("The "+l+" `"+p+"` is marked as required in `"+s+"`, but its value is `undefined`."):null:n(u,c,s,l,p)}var u=i.bind(null,!1);return u.isRequired=i.bind(null,!0),u}function m(e){return d((function(n,r,t,o,a,i){var u=n[r];return h(u)!==e?new y("Invalid "+o+" `"+a+"` of type `"+g(u)+"` supplied to `"+t+"`, expected `"+e+"`.",{expectedType:e}):null}))}function b(e,n,r,t,o){return new y((e||"React class")+": "+n+" type `"+r+"."+t+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+o+"`.")}function v(e){switch(typeof e){case"number":case"string":case"undefined":return!0;case"boolean":return!e;case"object":if(Array.isArray(e))return e.every(v);if(null===e||r(e))return!0;var n=function(e){var n=e&&(c&&e[c]||e["@@iterator"]);if("function"==typeof n)return n}(e);if(!n)return!1;var t,o=n.call(e);if(n!==e.entries){for(;!(t=o.next()).done;)if(!v(t.value))return!1}else for(;!(t=o.next()).done;){var a=t.value;if(a&&!v(a[1]))return!1}return!0;default:return!1}}function h(e){var n=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":function(e,n){return"symbol"===e||!!n&&("Symbol"===n["@@toStringTag"]||"function"==typeof Symbol&&n instanceof Symbol)}(n,e)?"symbol":n}function g(e){if(null==e)return""+e;var n=h(e);if("object"===n){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return n}function w(e){var n=g(e);switch(n){case"array":case"object":return"an "+n;case"boolean":case"date":case"regexp":return"a "+n;default:return n}}return y.prototype=Error.prototype,s.checkPropTypes=u,s.resetWarningCache=u.resetWarningCache,s.PropTypes=s,s},s}()(h.isElement,!0);

// EXTERNAL MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(6245);
;// CONCATENATED MODULE: ./node_modules/@platzi/commons/dist/es/index-e9a6ce7d.js
var index_e9a6ce7d_h=Object.freeze({__proto__:null,ReactTranslationsHOC:t=>r=>{const{t:s,i18n:o}=(0,useTranslation/* useTranslation */.$)();return react.createElement(t,(0,axiosInstance_6d2f1e6e._)({},r,{t:s,i18n:o}))},translationsConfig:({messages:e,locale:t})=>{const r={[t]:{translations:e}};i18next/* default.use */.ZP.use(context/* initReactI18next */.Db).init({resources:r,lng:t,fallbackLng:t,debug:!1,ns:["translations"],defaultNS:"translations",keySeparator:!1,interpolation:{escapeValue:!1}})}}),index_e9a6ce7d_m=Object.freeze({__proto__:null,serverApi:e,clientApi:apiCalls_c0fe2c19_s,axiosInstance:axiosInstance_6d2f1e6e.a,axiosServerInstance:axiosInstance_6d2f1e6e.b});const _=(0,react.createContext)(),E=(e,t)=>{switch(t.type){case"init":return{...e,token:t.payload.token,url:t.payload.url,headers:t.payload.headers||{}};case"track":case"visit":return{...e,lastEvent:t.payload.event}}return e},w={token:null,url:null,lastEvent:null},index_e9a6ce7d_v=({children:e})=>{const[r,s]=(0,react.useReducer)(E,w),n={init:async()=>{const e=await (0,axiosInstance_6d2f1e6e.a)(!0).get(apiCalls_c0fe2c19_s.auth.credentials),{token:r}=null==e?void 0:e.data,a={token:r.access,url:r.microservices.sif_url,headers:r.headers?r.headers:{}};s({type:"init",payload:a})},trackVisit:async(e,a)=>{const o={baseURL:r.url,headers:{Authorization:`Bearer ${r.token}`,...r.headers}},n={source:"web","user-agent":navigator.userAgent,properties:a},i={event:{...n,event:e}};await (0,axiosInstance_6d2f1e6e.a)(!1,o).post(apiCalls_c0fe2c19_s.sif.tracking,{...n,event:e}),s({type:"visit",payload:i})},track:async(e,a)=>{const o={baseURL:r.url,headers:{Authorization:`Bearer ${r.token}`,...r.headers}},n={source:"web",properties:a},i={event:{...n,event:e}};await (0,axiosInstance_6d2f1e6e.a)(!1,o).post(apiCalls_c0fe2c19_s.sif.tracking,{...n,event:e}),s({type:"track",payload:i})}};return react.createElement(_.Provider,{value:{sif:r,sifActions:n}},e)};index_e9a6ce7d_v.propTypes={children:index_8d56a83f_p.exports.node};const index_e9a6ce7d_f=async(e="credentials")=>{const t=localStorage.getItem(`${e}_token`),r=localStorage.getItem(`${e}_headers`),a=localStorage.getItem(`${e}_microservicesUrl`);return t&&a?{token:t,headers:JSON.parse(r),microservicesUrl:JSON.parse(a)}:await index_e9a6ce7d_y(e)},index_e9a6ce7d_y=async(e="credentials")=>{try{const r=await (0,axiosInstance_6d2f1e6e.a)(!0).get("credentials"===e?apiCalls_c0fe2c19_s.auth.credentials:apiCalls_c0fe2c19_s.auth.liveCredentials(e)),{token:{access:a,headers:s,microservices:o}}=r.data;return await localStorage.setItem(`${e}_token`,a),await localStorage.setItem(`${e}_headers`,JSON.stringify(r.data.token.headers?s:{})),await localStorage.setItem(`${e}_microservicesUrl`,JSON.stringify(r.data.token.microservices?r.data.token.microservices:{})),await{token:a,headers:s,microservicesUrl:o}}catch(e){throw new Error({type:"::ERROR::CLIENT_REQUEST_CREDENTIALS_REFRESH_TOKEN",error:e})}},g=async(e="credentials")=>{const t=localStorage.getItem(`${e}_token`);if(!t)return await index_e9a6ce7d_f(e);const{exp:r}=p(t);return Date.now()>=1e3*r?await index_e9a6ce7d_y(e):void 0},R=async(e,t,r="credentials")=>{let a=await index_e9a6ce7d_f(r);void 0===a.microservicesUrl[`${e}_url`]&&(a=await index_e9a6ce7d_y(r));const s={baseURL:`${a.microservicesUrl[`${e}_url`]}`,headers:k(a.token,a.headers)};return await S(0,s,t,r,e)},S=async(e,r,a,s="credentials",o)=>{if(e>=3)return new Promise(((e,t)=>{e({})}));{const{requestURL:i,payload:c,method:l}=a;try{const e=await (0,axiosInstance_6d2f1e6e.a)(!1,r)[l](i,c);return await e.data}catch(t){var n;if(401===(null==t||null===(n=t.response)||void 0===n?void 0:n.status))return index_e9a6ce7d_y(s).then((t=>S(e+1,{...r,headers:k(t.token,t.headers),baseURL:`${t.microservicesUrl[`${o}_url`]}`},a,s,o).catch((e=>{throw new Error({type:"::ERROR::CLIENT_REQUEST_SEND_REQUEST",error:e})})))).catch((e=>{throw new Error({type:"::ERROR::CLIENT_REQUEST_REFRESH_TOKEN",error:e})}));throw new Error({type:"::ERROR::CLIENT_REQUEST_REQUEST",err:t})}}},k=(e,t)=>t==={}?{"API-Authorization":`Bearer ${e}`}:{"API-Authorization":`Bearer ${e}`,...t};var I=Object.freeze({__proto__:null,SIF:(e,t={},r=!1)=>{let a={source:"web",event:e,properties:t};if(r){const e=(()=>{let e={landing:window.location.href,meta_request_method:"GET",meta_path_info:location.pathname};document.referrer.length&&(e={...e,meta_http_referer:document.referrer}),location.search.length&&(e={...e,meta_query_string:location.search});const t=new URLSearchParams(window.location.search);for(const r of t)r[0].includes("utm_")&&(e={...e,[r[0]]:r[1]});return e})();a={...a,properties:{...t,...e},"user-agent":navigator.userAgent}}return a},GOSSIP:()=>{throw new Error("Not implemente yet!")},ENIGMA:()=>{throw new Error("Not implemente yet!")}});


/***/ }),

/***/ 9998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ d; },
/* harmony export */   "b": function() { return /* binding */ r; }
/* harmony export */ });
/* unused harmony exports c, d, g, u */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
const n=o=>{const[n,t]=e(o);return{value:n,onChange:e=>t(e.target.value)}},t="undefined"!=typeof window,i=()=>({width:t?window.innerWidth:void 0,height:t?window.innerHeight:void 0}),d=()=>{const[n,d]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(i());return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{const e=()=>{d(i())};return t?(window.addEventListener("resize",e),()=>{window.removeEventListener("resize",e)}):null}),[]),n},r=(n,t)=>{if("undefined"==typeof window)return[t,null];const[i,d]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((()=>window.localStorage.getItem(n)||t));return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{window.localStorage.setItem(n,i)}),[n,i]),[i,d]},a=e=>"undefined"!=typeof document&&document.cookie.split(";").some((o=>o.trim().startsWith(`${e}=`))),c=(e,o,n)=>document.cookie=`${e}=${o}; max-age=${n}`,s=e=>{const o="undefined"!=typeof document&&document.cookie.match(new RegExp("(?:^|; )"+e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g,"\\$1")+"=([^;]*)"));return o?decodeURIComponent(o[1]):void 0},w=()=>({checkCookie:a,setCookie:c,getCookie:s}),u=n=>{const[t,i]=e("");return o((()=>{if("undefined"!=typeof window){const e=new URLSearchParams(window.location.search);i(e.get(n))}}),[]),{variable:t}};


/***/ }),

/***/ 7400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ l; }
/* harmony export */ });
/* unused harmony export T */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3731);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
const r=n=>{const{defaultVisible:r,updateOn:l,isClickable:c,horizontalOffset:p,config:a,children:d}=n,{content:h}=n,[f,m]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({isVisible:r,toolTipheight:0,mounted:!1}),u="top"===a.position,b="bottom"===a.position,x=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),v=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{m({...f,toolTipContentheight:x.current.offsetHeight,toolTipContentWidth:x.current.offsetWidth,toolTipContainerWidth:v.current.offsetWidth,toolTipContainerHeight:v.current.offsetHeight,mounted:!0})}),[f.isVisible,l]);const T=t=>({hoverPosition:{[t.position]:`-${t.hover.verticalOffset}px`,left:p,width:`${t.hover.width}px`,height:`${t.hover.height}px`},contentPosition:{[t.position]:`-${t.content.height+t.content.verticalOffset}px`,left:`-${t.content.width/2-t.content.containerWidht/2-(null==a?void 0:a.horizontalOffset)}px`}}),g=()=>{m({...f,isVisible:!0})},C=()=>{m({...f,isVisible:!1})},O=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Tooltip-content",{"Tooltip-content--is-visible":f.mounted&&f.isVisible}),y=t=>{t.preventDefault(),c&&m({...f,isVisible:!f.isVisible})},w=(()=>{const{position:t,verticalOffset:e}=a,{toolTipContainerWidth:o,toolTipContentWidth:i,toolTipContentheight:n}=f,s={hover:{verticalOffset:e,width:o,height:e},content:{width:i,height:n,containerWidht:o,verticalOffset:e},position:t};return T(s)})();return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Tooltip-container",ref:v,onMouseEnter:c?()=>{}:g,onMouseLeave:c?()=>{}:C},react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{className:"Tooltip-hover",style:{...w.hoverPosition,zIndex:a.zIndex}}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{ref:x,className:O,style:{...w.contentPosition,zIndex:a.zIndex}},b&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{className:"Tooltip-content-arrow",style:{borderBottom:`8px solid ${a.arrowColor}`}}),react__WEBPACK_IMPORTED_MODULE_0__.createElement(h,{setHidden:C,setVisible:g,isVisible:f.isVisible}),u&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{className:"Tooltip-content-arrow",style:{borderTop:`8px solid ${a.arrowColor}`}})),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{onClick:y,className:"Tooltip-children",onKeyPress:t=>{"Enter"===t.key&&y(t)},tabIndex:"0",role:"button"},d))};r.propTypes={content:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.any,children:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.any,config:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.shape({position:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,zIndex:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.number,verticalOffset:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.number,horizontalOffset:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.number,arrowColor:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,isClickable:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.bool})},r.defaultProps={content:react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",null),children:react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",null),config:{position:"top",zIndex:4,arrowColor:"#000",verticalOffset:10,horizontalOffset:0},defaultVisible:!1,updateOn:!1,isClickable:!1};const l=e=>{const{children:o,isActive:i,position:n,styles:r}=e,l=classnames__WEBPACK_IMPORTED_MODULE_1___default()("BasicTooltip",{"BasicTooltip--active":i,"BasicTooltip--top":"top"===n,"BasicTooltip--bottom":"bottom"===n,"BasicTooltip--left":"left"===n,"BasicTooltip--right":"right"===n});return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:l,style:{...r}},o)};l.propTypes={children:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.node.isRequired,isActive:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.bool.isRequired,position:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOf(["top","bottom","left","right"]),styles:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.object},l.defaultProps={children:"content",isActive:!1,position:"top",width:null};


/***/ }),

/***/ 6993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var _rollupPluginBabelHelpers_1fef267c_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4597);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3731);
const o={as:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,children:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.node.isRequired,type:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,onClick:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.func,size:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOf(["sm","md","lg"]),color:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOf(["platzi","sky","admin","danger"]),hierarchy:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOf(["primary","secondary","tertiary"]),customClass:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,disabled:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.bool,name:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string},n=s=>{const{as:o,children:n,size:a,color:i,hierarchy:l,customClass:p}=s,m=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Button",{"Button--small":"sm"===a,"Button--medium":"md"===a,"Button--big":"lg"===a},{"Button--platzi":"platzi"===i,"Button--sky":"sky"===i,"Button--admin":"admin"===i,"Button--danger":"danger"===i},{"Button--primary":"primary"===l,"Button--secondary":"secondary"===l,"Button--tertiary":"tertiary"===l},p),d={...s};return"string"==typeof o&&(delete d.customClass,delete d.as),react__WEBPACK_IMPORTED_MODULE_0__.createElement(o,(0,_rollupPluginBabelHelpers_1fef267c_js__WEBPACK_IMPORTED_MODULE_3__._)({},d,{className:m}),n)};n.propTypes=o,n.defaultProps={as:"button",children:"Button",onClick:()=>{},size:"md",color:"sky",hierarchy:"primary",disabled:!1};


/***/ }),

/***/ 1339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ p; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3731);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2814);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faAngleLeft__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2901);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faAngleRight__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4962);
/* harmony import */ var _platzi_commons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6518);
/* harmony import */ var _platzi_commons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8719);
const p=l=>{const[p,f]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),[d,b]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),[E,g]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),[w,C]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),[h,x]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(l.numberOfElements.xs),{width:v}=(0,_platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a)();let y=Math.ceil(l.elements.length/h-1);y=y<0?0:y,(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>x(v<_platzi_commons__WEBPACK_IMPORTED_MODULE_3__/* .XS_BREAKPOINT */ .Pt?l.numberOfElements.xs:v<_platzi_commons__WEBPACK_IMPORTED_MODULE_3__/* .SM_BREAKPOINT */ .Zb?l.numberOfElements.sm:v<_platzi_commons__WEBPACK_IMPORTED_MODULE_3__/* .MD_BREAKPOINT */ .qY?l.numberOfElements.md:l.numberOfElements.lg)),[v]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{f((w-A())/h)}),[w,h]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{E>y&&g(y),b(E*-w-E*l.margin)}),[E,w]);const N=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e=>{null!==e&&C(e.offsetWidth)}),[v]),A=()=>l.margin*(h-1);if(0===l.elements.length)return null;const O=l.customSizeItems||0===p;return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:`Carousel ${l.customClass}`},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Carousel-external"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{ref:N,className:"Carousel-internal",style:{gap:l.margin+"px",transform:`translateX(${d}px)`}},l.elements.map(((t,s)=>react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{key:`index-${s}`,className:"Carousel-item",style:{width:O?"auto":p}},t))))),l.showArrows&&y>0&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Carousel-arrows","data-testid":"Carousel-arrows"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Carousel-arrows-left"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{type:"button",onClick:()=>g(E-1),disabled:0===E},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G,{icon:_fortawesome_pro_regular_svg_icons_faAngleLeft__WEBPACK_IMPORTED_MODULE_4__/* .faAngleLeft */ .Ey}))),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Carousel-arrows-right"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{type:"button",onClick:()=>g(E+1),disabled:E===y},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G,{icon:_fortawesome_pro_regular_svg_icons_faAngleRight__WEBPACK_IMPORTED_MODULE_5__/* .faAngleRight */ .yO})))),l.showBullets&&y>0&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Carousel-bullets","data-testid":"Carousel-bullets"},Array.from(new Array(Math.ceil(l.elements.length/h))).map(((t,s)=>react__WEBPACK_IMPORTED_MODULE_0__.createElement("button",{key:`bullet-${s}`,className:E===s?"--active":"",type:"button",onClick:()=>g(s)},react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",null))))))};p.propTypes={elements:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_6__.p.exports.array,customClass:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_6__.p.exports.string,numberOfElements:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_6__.p.exports.object,margin:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_6__.p.exports.number,showArrows:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_6__.p.exports.bool,showBullets:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_6__.p.exports.bool,customSizeItems:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_6__.p.exports.bool},p.defaultProps={elements:[],customClass:"",numberOfElements:{xs:1,sm:1,md:3,lg:4},margin:24,showArrows:!0,showBullets:!0,customSizeItems:!1};


/***/ }),

/***/ 6363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ m; }
/* harmony export */ });
/* unused harmony export c */
/* harmony import */ var _rollupPluginBabelHelpers_1fef267c_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4597);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9960);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
function c(t){return void 0===t&&(t=""),null===t?"":t}function i(t){try{return new URL(t),!0}catch(t){return!1}}var r="static.platzi.com";function o(t){var a=t.src,n=t.width,i=void 0===n?1024:n,o=t.quality,e=void 0===o?85:o,s=t.format,u=void 0===s?"auto":s,d=["width=".concat(i),"quality=".concat(e),"format=".concat(u)].join(","),l=new URL(a);if(l.hostname===r){var m=c(l.pathname);return"https://".concat(r,"/cdn-cgi/image/").concat(d).concat(m)}return"https://".concat(r,"/cdn-cgi/image/").concat(d,"/").concat(a)}function e(t,a){return null===t?"":i(t)?o({src:t,quality:a}):c({src:t}.src)}function s(t,a,n){return void 0===n&&(n=[]),t&&i(t)?function(t,a,n){return void 0===n&&(n=[]),0===n.length?"":n.map((function(n){return"".concat(o({src:t,width:n,quality:a})," ").concat(n,"w")})).join(", ")}(t,a,n):""}var u=[480,768,1024,1200];var d=function(t){var a=t.src,n=t.customClass,c=t.quality,i=t.sizes,r=t.loading,o=t.dataTrans,d={};return d.src=a?e(a,c):void 0,d.srcSet=a?s(a,c,u):void 0,d.loading=r,n&&(d.className=n),i&&(d.sizes=i),o&&(d["data-trans"]=o),d},l=function(t){var a=t.src,n=t.customClass,c=t.quality,i=t.loading,r=t.width,o=t.height,s=t.dataTrans,u={};return u.src=a?e(a,c):void 0,u.loading=i,u.width=r,u.height=o,n&&(u.className=n),s&&(u["data-trans"]=s),u},m=function(c){var i,r=c.alt,o=c.decoding,e=(0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(c,["alt","decoding"]),s=(i=e).width?l(i):d(i);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("img",(0,_rollupPluginBabelHelpers_1fef267c_js__WEBPACK_IMPORTED_MODULE_2__._)({},s,{alt:r,decoding:o}))};m.defaultProps={quality:85,sizes:"50vw",loading:"lazy",decoding:"async"};


/***/ }),

/***/ 2423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ o; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3731);
const a={label:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,id:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,name:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,size:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOf(["md","lg"]),behavior:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOf(["default","error","success","warning"]),message:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,customClass:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,handleChange:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.func.isRequired,currentValue:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.oneOfType([_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.number]),placeholder:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,type:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,maxlength:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.number,required:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.bool,disabled:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.bool},t={label:"",id:"",name:"",size:"lg",behavior:"default",message:"",customClass:"",handleChange:()=>{},currentValue:void 0,placeholder:"",type:"text",maxlength:void 0},o=s=>{const{label:a,id:t,size:o,behavior:l,message:n,customClass:i,handleChange:m,currentValue:p}=s,{placeholder:d,type:u,disabled:c,maxlength:g,required:x,name:h}=s,b=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Form-input","Input-wrapper",i,{"Form-input--error":"error"===l,"Form-input--success":"success"===l,"Form-input--warning":"warning"===l}),f=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Form-field",{"Form-field--medium":"md"===o});return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:b},a&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("label",{htmlFor:t,className:"Form-label"},a),react__WEBPACK_IMPORTED_MODULE_0__.createElement("input",{id:t,name:h,type:u,className:f,onChange:m,value:p,placeholder:d,disabled:c,"aria-label":a,maxLength:g,required:x}),n&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("p",{className:"Form-message"},n))};o.propTypes=a,o.defaultProps=t;


/***/ }),

/***/ 1010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ qa; },
  "M": function() { return /* binding */ rt; },
  "g": function() { return /* binding */ Ds; }
});

// UNUSED EXPORTS: C, F, I, P, R, S, T, a, b, c, d, e, f, h, i, j, k, l, m, n, o, p, q, r, s

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/index-c9810a9c.js
var index_c9810a9c = __webpack_require__(7740);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/index-5808dc9d.js
var index_5808dc9d = __webpack_require__(3731);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(2814);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faTimes.js
var faTimes = __webpack_require__(224);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/Button-4cf71a18.js
var Button_4cf71a18 = __webpack_require__(6993);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/index-2fbf0eeb.js
var index_2fbf0eeb = __webpack_require__(2413);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/BasicTooltip-61801623.js
var BasicTooltip_61801623 = __webpack_require__(7400);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faExclamationTriangle.js
var faExclamationTriangle = __webpack_require__(9907);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/Carousel-7034b698.js
var Carousel_7034b698 = __webpack_require__(1339);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
;// CONCATENATED MODULE: ./node_modules/react-countdown/dist/index.es.js



function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function zeroPad(value) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var strValue = String(value);
  if (length === 0) return strValue;
  var match = strValue.match(/(.*?)([0-9]+)(.*)/);
  var prefix = match ? match[1] : '';
  var suffix = match ? match[3] : '';
  var strNo = match ? match[2] : strValue;
  var paddedNo = strNo.length >= length ? strNo : (_toConsumableArray(Array(length)).map(function () {
    return '0';
  }).join('') + strNo).slice(length * -1);
  return "".concat(prefix).concat(paddedNo).concat(suffix);
}
var timeDeltaFormatOptionsDefaults = {
  daysInHours: false,
  zeroPadTime: 2
};
function calcTimeDelta(date) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$now = options.now,
      now = _options$now === void 0 ? Date.now : _options$now,
      _options$precision = options.precision,
      precision = _options$precision === void 0 ? 0 : _options$precision,
      controlled = options.controlled,
      _options$offsetTime = options.offsetTime,
      offsetTime = _options$offsetTime === void 0 ? 0 : _options$offsetTime,
      overtime = options.overtime;
  var startTimestamp;

  if (typeof date === 'string') {
    startTimestamp = new Date(date).getTime();
  } else if (date instanceof Date) {
    startTimestamp = date.getTime();
  } else {
    startTimestamp = date;
  }

  if (!controlled) {
    startTimestamp += offsetTime;
  }

  var timeLeft = controlled ? startTimestamp : startTimestamp - now();
  var clampedPrecision = Math.min(20, Math.max(0, precision));
  var total = Math.round(parseFloat(((overtime ? timeLeft : Math.max(0, timeLeft)) / 1000).toFixed(clampedPrecision)) * 1000);
  var seconds = Math.abs(total) / 1000;
  return {
    total: total,
    days: Math.floor(seconds / (3600 * 24)),
    hours: Math.floor(seconds / 3600 % 24),
    minutes: Math.floor(seconds / 60 % 60),
    seconds: Math.floor(seconds % 60),
    milliseconds: Number((seconds % 1 * 1000).toFixed()),
    completed: total <= 0
  };
}
function formatTimeDelta(timeDelta, options) {
  var days = timeDelta.days,
      hours = timeDelta.hours,
      minutes = timeDelta.minutes,
      seconds = timeDelta.seconds;

  var _Object$assign = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), options),
      daysInHours = _Object$assign.daysInHours,
      zeroPadTime = _Object$assign.zeroPadTime,
      _Object$assign$zeroPa = _Object$assign.zeroPadDays,
      zeroPadDays = _Object$assign$zeroPa === void 0 ? zeroPadTime : _Object$assign$zeroPa;

  var zeroPadTimeLength = Math.min(2, zeroPadTime);
  var formattedHours = daysInHours ? zeroPad(hours + days * 24, zeroPadTime) : zeroPad(hours, zeroPadTimeLength);
  return {
    days: daysInHours ? '' : zeroPad(days, zeroPadDays),
    hours: formattedHours,
    minutes: zeroPad(minutes, zeroPadTimeLength),
    seconds: zeroPad(seconds, zeroPadTimeLength)
  };
}

var Countdown = function (_React$Component) {
  _inherits(Countdown, _React$Component);

  var _super = _createSuper(Countdown);

  function Countdown() {
    var _this;

    _classCallCheck(this, Countdown);

    _this = _super.apply(this, arguments);
    _this.state = {
      count: _this.props.count || 3
    };

    _this.startCountdown = function () {
      _this.interval = window.setInterval(function () {
        var count = _this.state.count - 1;

        if (count === 0) {
          _this.stopCountdown();

          _this.props.onComplete && _this.props.onComplete();
        } else {
          _this.setState(function (prevState) {
            return {
              count: prevState.count - 1
            };
          });
        }
      }, 1000);
    };

    _this.stopCountdown = function () {
      clearInterval(_this.interval);
    };

    _this.addTime = function (seconds) {
      _this.stopCountdown();

      _this.setState(function (prevState) {
        return {
          count: prevState.count + seconds
        };
      }, _this.startCountdown);
    };

    return _this;
  }

  _createClass(Countdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startCountdown();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children ? (0,react.cloneElement)(this.props.children, {
        count: this.state.count
      }) : null;
    }
  }]);

  return Countdown;
}(react.Component);
Countdown.propTypes = {
  count: prop_types.number,
  children: prop_types.element,
  onComplete: prop_types.func
};

var Countdown$1 = function (_React$Component) {
  _inherits(Countdown$1, _React$Component);

  var _super = _createSuper(Countdown$1);

  function Countdown$1(props) {
    var _this;

    _classCallCheck(this, Countdown$1);

    _this = _super.call(this, props);
    _this.mounted = false;
    _this.initialTimestamp = _this.calcOffsetStartTimestamp();
    _this.offsetStartTimestamp = _this.props.autoStart ? 0 : _this.initialTimestamp;
    _this.offsetTime = 0;
    _this.legacyMode = false;
    _this.legacyCountdownRef = (0,react.createRef)();

    _this.tick = function () {
      var timeDelta = _this.calcTimeDelta();

      var callback = timeDelta.completed && !_this.props.overtime ? undefined : _this.props.onTick;

      _this.setTimeDeltaState(timeDelta, undefined, callback);
    };

    _this.start = function () {
      if (_this.isStarted()) return;
      var prevOffsetStartTimestamp = _this.offsetStartTimestamp;
      _this.offsetStartTimestamp = 0;
      _this.offsetTime += prevOffsetStartTimestamp ? _this.calcOffsetStartTimestamp() - prevOffsetStartTimestamp : 0;

      var timeDelta = _this.calcTimeDelta();

      _this.setTimeDeltaState(timeDelta, "STARTED", _this.props.onStart);

      if (!_this.props.controlled && (!timeDelta.completed || _this.props.overtime)) {
        _this.clearTimer();

        _this.interval = window.setInterval(_this.tick, _this.props.intervalDelay);
      }
    };

    _this.pause = function () {
      if (_this.isPaused()) return;

      _this.clearTimer();

      _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();

      _this.setTimeDeltaState(_this.state.timeDelta, "PAUSED", _this.props.onPause);
    };

    _this.stop = function () {
      if (_this.isStopped()) return;

      _this.clearTimer();

      _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
      _this.offsetTime = _this.offsetStartTimestamp - _this.initialTimestamp;

      _this.setTimeDeltaState(_this.calcTimeDelta(), "STOPPED", _this.props.onStop);
    };

    _this.isStarted = function () {
      return _this.isStatus("STARTED");
    };

    _this.isPaused = function () {
      return _this.isStatus("PAUSED");
    };

    _this.isStopped = function () {
      return _this.isStatus("STOPPED");
    };

    _this.isCompleted = function () {
      return _this.isStatus("COMPLETED");
    };

    if (props.date) {
      var timeDelta = _this.calcTimeDelta();

      _this.state = {
        timeDelta: timeDelta,
        status: timeDelta.completed ? "COMPLETED" : "STOPPED"
      };
    } else {
      _this.legacyMode = true;
    }

    return _this;
  }

  _createClass(Countdown$1, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.legacyMode) {
        return;
      }

      this.mounted = true;
      if (this.props.onMount) this.props.onMount(this.calcTimeDelta());
      if (this.props.autoStart) this.start();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.legacyMode) {
        return;
      }

      if (this.props.date !== prevProps.date) {
        this.initialTimestamp = this.calcOffsetStartTimestamp();
        this.offsetStartTimestamp = this.initialTimestamp;
        this.offsetTime = 0;
        this.setTimeDeltaState(this.calcTimeDelta());
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.legacyMode) {
        return;
      }

      this.mounted = false;
      this.clearTimer();
    }
  }, {
    key: "calcTimeDelta",
    value: function calcTimeDelta$1() {
      var _this$props = this.props,
          date = _this$props.date,
          now = _this$props.now,
          precision = _this$props.precision,
          controlled = _this$props.controlled,
          overtime = _this$props.overtime;
      return calcTimeDelta(date, {
        now: now,
        precision: precision,
        controlled: controlled,
        offsetTime: this.offsetTime,
        overtime: overtime
      });
    }
  }, {
    key: "calcOffsetStartTimestamp",
    value: function calcOffsetStartTimestamp() {
      return Date.now();
    }
  }, {
    key: "addTime",
    value: function addTime(seconds) {
      this.legacyCountdownRef.current.addTime(seconds);
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      window.clearInterval(this.interval);
    }
  }, {
    key: "isStatus",
    value: function isStatus(status) {
      return this.state.status === status;
    }
  }, {
    key: "setTimeDeltaState",
    value: function setTimeDeltaState(timeDelta, status, callback) {
      var _this2 = this;

      if (!this.mounted) return;
      var completing = timeDelta.completed && !this.state.timeDelta.completed;
      var completedOnStart = timeDelta.completed && status === "STARTED";

      if (completing && !this.props.overtime) {
        this.clearTimer();
      }

      var onDone = function onDone() {
        if (callback) callback(_this2.state.timeDelta);

        if (_this2.props.onComplete && (completing || completedOnStart)) {
          _this2.props.onComplete(timeDelta, completedOnStart);
        }
      };

      return this.setState(function (prevState) {
        var newStatus = status || prevState.status;

        if (timeDelta.completed && !_this2.props.overtime) {
          newStatus = "COMPLETED";
        } else if (!status && newStatus === "COMPLETED") {
          newStatus = "STOPPED";
        }

        return {
          timeDelta: timeDelta,
          status: newStatus
        };
      }, onDone);
    }
  }, {
    key: "getApi",
    value: function getApi() {
      return this.api = this.api || {
        start: this.start,
        pause: this.pause,
        stop: this.stop,
        isStarted: this.isStarted,
        isPaused: this.isPaused,
        isStopped: this.isStopped,
        isCompleted: this.isCompleted
      };
    }
  }, {
    key: "getRenderProps",
    value: function getRenderProps() {
      var _this$props2 = this.props,
          daysInHours = _this$props2.daysInHours,
          zeroPadTime = _this$props2.zeroPadTime,
          zeroPadDays = _this$props2.zeroPadDays;
      var timeDelta = this.state.timeDelta;
      return Object.assign(Object.assign({}, timeDelta), {
        api: this.getApi(),
        props: this.props,
        formatted: formatTimeDelta(timeDelta, {
          daysInHours: daysInHours,
          zeroPadTime: zeroPadTime,
          zeroPadDays: zeroPadDays
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.legacyMode) {
        var _this$props3 = this.props,
            count = _this$props3.count,
            _children = _this$props3.children,
            onComplete = _this$props3.onComplete;
        return (0,react.createElement)(Countdown, {
          ref: this.legacyCountdownRef,
          count: count,
          onComplete: onComplete
        }, _children);
      }

      var _this$props4 = this.props,
          className = _this$props4.className,
          overtime = _this$props4.overtime,
          children = _this$props4.children,
          renderer = _this$props4.renderer;
      var renderProps = this.getRenderProps();

      if (renderer) {
        return renderer(renderProps);
      }

      if (children && this.state.timeDelta.completed && !overtime) {
        return (0,react.cloneElement)(children, {
          countdown: renderProps
        });
      }

      var _renderProps$formatte = renderProps.formatted,
          days = _renderProps$formatte.days,
          hours = _renderProps$formatte.hours,
          minutes = _renderProps$formatte.minutes,
          seconds = _renderProps$formatte.seconds;
      return (0,react.createElement)("span", {
        className: className
      }, renderProps.total < 0 ? '-' : '', days, days ? ':' : '', hours, ":", minutes, ":", seconds);
    }
  }]);

  return Countdown$1;
}(react.Component);
Countdown$1.defaultProps = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), {
  controlled: false,
  intervalDelay: 1000,
  precision: 0,
  autoStart: true
});
Countdown$1.propTypes = {
  date: (0,prop_types.oneOfType)([(0,prop_types.instanceOf)(Date), prop_types.string, prop_types.number]),
  daysInHours: prop_types.bool,
  zeroPadTime: prop_types.number,
  zeroPadDays: prop_types.number,
  controlled: prop_types.bool,
  intervalDelay: prop_types.number,
  precision: prop_types.number,
  autoStart: prop_types.bool,
  overtime: prop_types.bool,
  className: prop_types.string,
  children: prop_types.element,
  renderer: prop_types.func,
  now: prop_types.func,
  onMount: prop_types.func,
  onStart: prop_types.func,
  onPause: prop_types.func,
  onStop: prop_types.func,
  onTick: prop_types.func,
  onComplete: prop_types.func
};

/* harmony default export */ var dist_index_es = (Countdown$1);


;// CONCATENATED MODULE: ./node_modules/@platzi/ui/dist/es/Layout-981b30d6.js
const Layout_981b30d6_r=({className:s,children:r})=>react.createElement("div",{className:s},r);Layout_981b30d6_r.propTypes={className:index_5808dc9d.p.exports.string,children:index_5808dc9d.p.exports.node.isRequired},Layout_981b30d6_r.defaultProps={className:""};

// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/_rollupPluginBabelHelpers-1fef267c.js
var _rollupPluginBabelHelpers_1fef267c = __webpack_require__(4597);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__(6064);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/fontawesome-svg-core/index.mjs
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), fontawesome_svg_core_setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, Object.create(null));
  }

  return fontawesome_svg_core_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}

function fontawesome_svg_core_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function fontawesome_svg_core_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function fontawesome_svg_core_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) fontawesome_svg_core_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) fontawesome_svg_core_defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function fontawesome_svg_core_inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) fontawesome_svg_core_setPrototypeOf(subClass, superClass);
}

function fontawesome_svg_core_setPrototypeOf(o, p) {
  fontawesome_svg_core_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return fontawesome_svg_core_setPrototypeOf(o, p);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || fontawesome_svg_core_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function fontawesome_svg_core_toConsumableArray(arr) {
  return fontawesome_svg_core_arrayWithoutHoles(arr) || fontawesome_svg_core_iterableToArray(arr) || fontawesome_svg_core_unsupportedIterableToArray(arr) || fontawesome_svg_core_nonIterableSpread();
}

function fontawesome_svg_core_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return fontawesome_svg_core_arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function fontawesome_svg_core_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function fontawesome_svg_core_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return fontawesome_svg_core_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return fontawesome_svg_core_arrayLikeToArray(o, minLen);
}

function fontawesome_svg_core_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function fontawesome_svg_core_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var _familyProxy, _familyProxy2, _familyProxy3, _familyProxy4, _familyProxy5;

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_CSS_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var MUTATION_APPROACH_ASYNC = 'async';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
var PRODUCTION = function () {
  try {
    return "production" === 'production';
  } catch (e) {
    return false;
  }
}();
var FAMILY_CLASSIC = 'classic';
var FAMILY_SHARP = 'sharp';
var FAMILIES = [FAMILY_CLASSIC, FAMILY_SHARP];

function familyProxy(obj) {
  // Defaults to the classic family if family is not available
  return new Proxy(obj, {
    get: function get(target, prop) {
      return prop in target ? target[prop] : target[FAMILY_CLASSIC];
    }
  });
}
var PREFIX_TO_STYLE = familyProxy((_familyProxy = {}, _defineProperty(_familyProxy, FAMILY_CLASSIC, {
  'fa': 'solid',
  'fas': 'solid',
  'fa-solid': 'solid',
  'far': 'regular',
  'fa-regular': 'regular',
  'fal': 'light',
  'fa-light': 'light',
  'fat': 'thin',
  'fa-thin': 'thin',
  'fad': 'duotone',
  'fa-duotone': 'duotone',
  'fab': 'brands',
  'fa-brands': 'brands',
  'fak': 'kit',
  'fa-kit': 'kit'
}), _defineProperty(_familyProxy, FAMILY_SHARP, {
  'fa': 'solid',
  'fass': 'solid',
  'fa-solid': 'solid'
}), _familyProxy));
var STYLE_TO_PREFIX = familyProxy((_familyProxy2 = {}, _defineProperty(_familyProxy2, FAMILY_CLASSIC, {
  'solid': 'fas',
  'regular': 'far',
  'light': 'fal',
  'thin': 'fat',
  'duotone': 'fad',
  'brands': 'fab',
  'kit': 'fak'
}), _defineProperty(_familyProxy2, FAMILY_SHARP, {
  'solid': 'fass'
}), _familyProxy2));
var PREFIX_TO_LONG_STYLE = familyProxy((_familyProxy3 = {}, _defineProperty(_familyProxy3, FAMILY_CLASSIC, {
  'fab': 'fa-brands',
  'fad': 'fa-duotone',
  'fak': 'fa-kit',
  'fal': 'fa-light',
  'far': 'fa-regular',
  'fas': 'fa-solid',
  'fat': 'fa-thin'
}), _defineProperty(_familyProxy3, FAMILY_SHARP, {
  'fass': 'fa-solid'
}), _familyProxy3));
var LONG_STYLE_TO_PREFIX = familyProxy((_familyProxy4 = {}, _defineProperty(_familyProxy4, FAMILY_CLASSIC, {
  'fa-brands': 'fab',
  'fa-duotone': 'fad',
  'fa-kit': 'fak',
  'fa-light': 'fal',
  'fa-regular': 'far',
  'fa-solid': 'fas',
  'fa-thin': 'fat'
}), _defineProperty(_familyProxy4, FAMILY_SHARP, {
  'fa-solid': 'fass'
}), _familyProxy4));
var ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss)?[\-\ ]/; // eslint-disable-line no-useless-escape

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i; // TODO: this needs to support fass
// TODO: do we need to handle font-weight for kit SVG pseudo-elements?

var FONT_WEIGHT_TO_PREFIX = familyProxy((_familyProxy5 = {}, _defineProperty(_familyProxy5, FAMILY_CLASSIC, {
  '900': 'fas',
  '400': 'far',
  'normal': 'far',
  '300': 'fal',
  '100': 'fat'
}), _defineProperty(_familyProxy5, FAMILY_SHARP, {
  '900': 'fass'
}), _familyProxy5));
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
var DUOTONE_CLASSES = {
  GROUP: 'duotone-group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var prefixes = new Set();
Object.keys(STYLE_TO_PREFIX[FAMILY_CLASSIC]).map(prefixes.add.bind(prefixes));
Object.keys(STYLE_TO_PREFIX[FAMILY_SHARP]).map(prefixes.add.bind(prefixes));
var RESERVED_CLASSES = [].concat(FAMILIES, fontawesome_svg_core_toConsumableArray(prefixes), ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', 'beat', 'border', 'fade', 'beat-fade', 'bounce', 'flip-both', 'flip-horizontal', 'flip-vertical', 'flip', 'fw', 'inverse', 'layers-counter', 'layers-text', 'layers', 'li', 'pull-left', 'pull-right', 'pulse', 'rotate-180', 'rotate-270', 'rotate-90', 'rotate-by', 'shake', 'spin-pulse', 'spin-reverse', 'spin', 'stack-1x', 'stack-2x', 'stack', 'ul', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n) {
  return "".concat(n, "x");
})).concat(oneToTwenty.map(function (n) {
  return "w-".concat(n);
}));

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-css-prefix', 'cssPrefix'], ['data-family-default', 'familyDefault'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  styleDefault: 'solid',
  familyDefault: 'classic',
  cssPrefix: DEFAULT_CSS_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present

if (initial.familyPrefix) {
  initial.cssPrefix = initial.familyPrefix;
}

var _config = _objectSpread2(_objectSpread2({}, _default), initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_default).forEach(function (key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set(val) {
      _config[key] = val;

      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config[key];
    }
  });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0

Object.defineProperty(config, 'familyPrefix', {
  enumerable: true,
  set: function set(val) {
    _config.cssPrefix = val;

    _onChangeCb.forEach(function (cb) {
      return cb(config);
    });
  },
  get: function get() {
    return _config.cssPrefix;
  }
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);

  return function () {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}

var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = '';

  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }

  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";

function css() {
  var dcp = DEFAULT_CSS_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.cssPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dcp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var _cssInserted = false;

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css: css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = string.charCodeAt(counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      var extra = string.charCodeAt(counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // eslint-disable-line eqeqeq
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }

  return output;
}

function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
  var size = string.length;
  var first = string.charCodeAt(index);
  var second;

  if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
    second = string.charCodeAt(index + 1);

    if (second >= 0xDC00 && second <= 0xDFFF) {
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }

  return first;
}

function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});
}

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var duotonePathRe = [/*#__PURE__*/_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
  d1: 1,
  d2: 2
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2,
  cls2: 3,
  d2: 4
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2
})];

var _LONG_STYLE, _PREFIXES, _PREFIXES_FOR_FAMILY;
var styles = namespace.styles,
    shims = namespace.shims;
var LONG_STYLE = (_LONG_STYLE = {}, _defineProperty(_LONG_STYLE, FAMILY_CLASSIC, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_LONG_STYLE, FAMILY_SHARP, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = (_PREFIXES = {}, _defineProperty(_PREFIXES, FAMILY_CLASSIC, Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES, FAMILY_SHARP, Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP])), _PREFIXES);

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}

function getIconName(cssPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === cssPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'number';
      });
      aliases.forEach(function (alias) {
        acc[alias.toString(16)] = iconName;
      });
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    acc[iconName] = iconName;

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'string';
      });
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
    }

    return acc;
  });
  _byAlias = lookup(function (acc, icon, iconName) {
    var aliases = icon[2];
    acc[iconName] = iconName;
    aliases.forEach(function (alias) {
      acc[alias] = iconName;
    });
    return acc;
  }); // If we have a Kit, we can't determine if regular is available since we
  // could be auto-fetching it. We'll have to assume that it is available.

  var hasRegular = 'far' in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function (acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    if (typeof maybeNameMaybeUnicode === 'string') {
      acc.names[maybeNameMaybeUnicode] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    if (typeof maybeNameMaybeUnicode === 'number') {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
    family: config.familyDefault
  });
};
onChange(function (c) {
  _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault, {
    family: config.familyDefault
  });
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode('fas', unicode);
  return oldUnicode || (newUnicode ? {
    prefix: 'fas',
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$family = params.family,
      family = _params$family === void 0 ? FAMILY_CLASSIC : _params$family;
  var style = PREFIX_TO_STYLE[family][styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[family][styleOrPrefix] || STYLE_TO_PREFIX[family][style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
var PREFIXES_FOR_FAMILY = (_PREFIXES_FOR_FAMILY = {}, _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_CLASSIC, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_SHARP, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _PREFIXES_FOR_FAMILY);
function getCanonicalIcon(values) {
  var _famProps;

  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups,
      skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var famProps = (_famProps = {}, _defineProperty(_famProps, FAMILY_CLASSIC, "".concat(config.cssPrefix, "-").concat(FAMILY_CLASSIC)), _defineProperty(_famProps, FAMILY_SHARP, "".concat(config.cssPrefix, "-").concat(FAMILY_SHARP)), _famProps);
  var givenPrefix = null;
  var family = FAMILY_CLASSIC;

  if (values.includes(famProps[FAMILY_CLASSIC]) || values.some(function (v) {
    return PREFIXES_FOR_FAMILY[FAMILY_CLASSIC].includes(v);
  })) {
    family = FAMILY_CLASSIC;
  }

  if (values.includes(famProps[FAMILY_SHARP]) || values.some(function (v) {
    return PREFIXES_FOR_FAMILY[FAMILY_SHARP].includes(v);
  })) {
    family = FAMILY_SHARP;
  }

  var canonical = values.reduce(function (acc, cls) {
    var iconName = getIconName(config.cssPrefix, cls);

    if (styles[cls]) {
      cls = LONG_STYLE[family].includes(cls) ? LONG_STYLE_TO_PREFIX[family][cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES[family].indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls, {
        family: family
      });
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass && cls !== famProps[FAMILY_CLASSIC] && cls !== famProps[FAMILY_SHARP]) {
      acc.rest.push(cls);
    }

    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === 'fa' ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);

      if (shim.prefix) {
        givenPrefix = null;
      }

      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;

      if (acc.prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
        // Allow a fallback from the regular style to solid if regular is not available
        // but only if we aren't auto-fetching SVGs
        acc.prefix = 'fas';
      }
    }

    return acc;
  }, emptyCanonicalIcon());

  if (values.includes('fa-brands') || values.includes('fab')) {
    canonical.prefix = 'fab';
  }

  if (values.includes('fa-duotone') || values.includes('fad')) {
    canonical.prefix = 'fad';
  }

  if (!canonical.prefix && family === FAMILY_SHARP && (styles['fass'] || config.autoFetchSvg)) {
    canonical.prefix = 'fass';
    canonical.iconName = byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
  }

  if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
    // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
  }

  return canonical;
}

var Library = /*#__PURE__*/function () {
  function Library() {
    fontawesome_svg_core_classCallCheck(this, Library);

    this.definitions = {};
  }

  fontawesome_svg_core_createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change

        var longPrefix = PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC][key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        var aliases = icon[2];
        if (!additions[prefix]) additions[prefix] = {};

        if (aliases.length > 0) {
          aliases.forEach(function (alias) {
            if (typeof alias === 'string') {
              additions[prefix][alias] = icon;
            }
          });
        }

        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
  var obj = _ref.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function (k) {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });

  _plugins.forEach(function (plugin) {
    var mixout = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout).forEach(function (tk) {
      if (typeof mixout[tk] === 'function') {
        obj[tk] = mixout[tk];
      }

      if (_typeof(mixout[tk]) === 'object') {
        Object.keys(mixout[tk]).forEach(function (sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }

          obj[tk][sk] = mixout[tk][sk];
        });
      }
    });

    if (plugin.hooks) {
      var hooks = plugin.hooks();
      Object.keys(hooks).forEach(function (hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }

        _hooks[hook].push(hooks[hook]);
      });
    }

    if (plugin.provides) {
      plugin.provides(providers);
    }
  });

  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args)); // eslint-disable-line no-useless-call
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    hookFn.apply(null, args);
  });
  return undefined;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : undefined;
}

function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === 'fa') {
    iconLookup.prefix = 'fas';
  }

  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks('noAuto');
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      callHooks('beforeI2svg', params);
      callProvided('pseudoElements2svg', params);
      return callProvided('i2svg', params);
    } else {
      return Promise.reject('Operation requires a DOM of some kind.');
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;

    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }

    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot: autoReplaceSvgRoot
      });
      callHooks('watch', params);
    });
  }
};
var parse = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }

    if (_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }

    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix: prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }

    if (typeof _icon === 'string' && (_icon.indexOf("".concat(config.cssPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(' '), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }

    if (typeof _icon === 'string') {
      var _prefix = getDefaultUsablePrefix();

      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto: noAuto,
  config: config,
  dom: dom,
  parse: parse,
  library: library,
  findIconDefinition: findIconDefinition,
  toHtml: toHtml
};

var autoReplace = function autoReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
      autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};

function domVariants(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread2(_objectSpread2({}, styles), {}, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.cssPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var attrClass = [config.replacementClass, iconName ? "".concat(config.cssPrefix, "-").concat(iconName) : ''].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) {
    content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }

  var args = _objectSpread2(_objectSpread2({}, content), {}, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
  });

  var _ref2 = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
    children: [],
    attributes: {}
  } : callProvided('generateAbstractIcon', args) || {
    children: [],
    attributes: {}
  },
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _objectSpread2({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform: transform,
      startCentered: true,
      width: width,
      height: height
    });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
      title = params.title,
      extra = params.extra;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  var styleString = joinStyles(extra.styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}

var styles$1 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};

function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION && !config.showMissingIcons && iconName) {
    console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
  }
}

function findIcon(iconName, prefix) {
  var givenPrefix = prefix;

  if (prefix === 'fa' && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }

  return new Promise(function (resolve, reject) {
    var val = {
      found: false,
      width: 512,
      height: 512,
      icon: callProvided('missingIconAbstract') || {}
    };

    if (givenPrefix === 'fa') {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }

    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      var icon = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon));
    }

    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
    }));
  });
}

var noop$1 = function noop() {};

var fontawesome_svg_core_p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = "FA \"6.2.1\"";

var begin = function begin(name) {
  fontawesome_svg_core_p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  fontawesome_svg_core_p.mark("".concat(preamble, " ").concat(name, " ends"));
  fontawesome_svg_core_p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};

var perf = {
  begin: begin,
  end: end
};

var noop$2 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}

function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon;
}

function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}

function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}

function createElementNS(tag) {
  return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}

function createElement(tag) {
  return DOCUMENT.createElement(tag);
}

function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$ceFn = params.ceFn,
      ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? createElementNS : createElement : _params$ceFn;

  if (typeof abstractObj === 'string') {
    return DOCUMENT.createTextNode(abstractObj);
  }

  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn: ceFn
    }));
  });
  return tag;
}

function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  /* BEGIN.ATTRIBUTION */

  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  /* END.ATTRIBUTION */

  return comment;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];

    if (node.parentNode) {
      mutation[1].forEach(function (abstract) {
        node.parentNode.insertBefore(convertSVG(abstract), node);
      });

      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement

    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp("".concat(config.cssPrefix, "-.*"));
    delete abstract[0].attributes.id;

    if (abstract[0].attributes.class) {
      var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }

        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(' ');

      if (splitClasses.toNode.length === 0) {
        node.removeAttribute('class');
      } else {
        node.setAttribute('class', splitClasses.toNode.join(' '));
      }
    }

    var newInnerHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function performOperationSync(op) {
  op();
}

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$2;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;

    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }

  if (!config.observeMutations) {
    return;
  }

  var _options$treeCallback = options.treeCallback,
      treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
      _options$nodeCallback = options.nodeCallback,
      nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
      _options$pseudoElemen = options.pseudoElementsCallback,
      pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
      _options$observeMutat = options.observeMutationsRoot,
      observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  var style = node.getAttribute('style');
  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
}

function classParser (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  var val = getCanonicalIcon(classArray(node));

  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.iconName && val.prefix) {
    return val;
  }

  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }

  if (!val.iconName && config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) {
    val.iconName = node.firstChild.data;
  }

  return val;
}

function attributesParser (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }

    return acc;
  }, {});
  var title = node.getAttribute('title');
  var titleId = node.getAttribute('data-fa-title-id');

  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }

  return extraAttributes;
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styleParser: true
  };

  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks('parseNodeAttributes', {}, node);
  var extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2({
    iconName: iconName,
    title: node.getAttribute('title'),
    titleId: node.getAttribute('data-fa-title-id'),
    prefix: prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}

var styles$2 = namespace.styles;

function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided('generateLayersText', node, nodeMeta);
  } else {
    return callProvided('generateSvgReplacementMutation', node, nodeMeta);
  }
}

var knownPrefixes = new Set();
FAMILIES.map(function (family) {
  knownPrefixes.add("fa-".concat(family));
});
Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC]).map(knownPrefixes.add.bind(knownPrefixes));
Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP]).map(knownPrefixes.add.bind(knownPrefixes));
knownPrefixes = fontawesome_svg_core_toConsumableArray(knownPrefixes);

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;

  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var prefixes = config.autoFetchSvg ? knownPrefixes : FAMILIES.map(function (f) {
    return "fa-".concat(f);
  }).concat(Object.keys(styles$2));

  if (!prefixes.includes('fa')) {
    prefixes.push('fa');
  }

  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
    return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }

  var candidates = [];

  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e) {// noop
  }

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return Promise.resolve();
  }

  var mark = perf.begin('onTree');
  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION) {
        if (e.name === 'MissingIcon') {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);
  return new Promise(function (resolve, reject) {
    Promise.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(function (e) {
      mark();
      reject(e);
    });
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
      mask: mask
    }));
  };
}

var render = function render(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return domVariants(_objectSpread2({
    type: 'icon'
  }, iconDefinition), function () {
    callHooks('beforeDOMElementCreation', {
      iconDefinition: iconDefinition,
      params: params
    });

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === void 0 ? function () {} : _params$callback;
      return onTree(node, callback);
    };

    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      var iconName = nodeMeta.iconName,
          title = nodeMeta.title,
          titleId = nodeMeta.titleId,
          prefix = nodeMeta.prefix,
          transform = nodeMeta.transform,
          symbol = nodeMeta.symbol,
          mask = nodeMeta.mask,
          maskId = nodeMeta.maskId,
          extra = nodeMeta.extra;
      return new Promise(function (resolve, reject) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              main = _ref2[0],
              mask = _ref2[1];

          resolve([node, makeInlineSvgAbstract({
            icons: {
              main: main,
              mask: mask
            },
            prefix: prefix,
            iconName: iconName,
            transform: transform,
            symbol: symbol,
            maskId: maskId,
            title: title,
            titleId: titleId,
            extra: extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };

    providers$$1.generateAbstractIcon = function (_ref3) {
      var children = _ref3.children,
          attributes = _ref3.attributes,
          main = _ref3.main,
          transform = _ref3.transform,
          styles = _ref3.styles;
      var styleString = joinStyles(styles);

      if (styleString.length > 0) {
        attributes['style'] = styleString;
      }

      var nextChild;

      if (transformIsMeaningful(transform)) {
        nextChild = callProvided('generateAbstractTransformGrouping', {
          main: main,
          transform: transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }

      children.push(nextChild || main.icon);
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var Layers = {
  mixout: function mixout() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: 'layer'
        }, function () {
          callHooks('beforeDOMElementCreation', {
            assembler: assembler,
            params: params
          });
          var children = [];
          assembler(function (args) {
            Array.isArray(args) ? args.map(function (a) {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: 'span',
            attributes: {
              class: ["".concat(config.cssPrefix, "-layers")].concat(fontawesome_svg_core_toConsumableArray(classes)).join(' ')
            },
            children: children
          }];
        });
      }
    };
  }
};

var LayersCounter = {
  mixout: function mixout() {
    return {
      counter: function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'counter',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.cssPrefix, "-layers-counter")].concat(fontawesome_svg_core_toConsumableArray(classes))
            }
          });
        });
      }
    };
  }
};

var LayersText = {
  mixout: function mixout() {
    return {
      text: function text(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform = params.transform,
            transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
            _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'text',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersTextAbstract({
            content: content,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.cssPrefix, "-layers-text")].concat(fontawesome_svg_core_toConsumableArray(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      var title = nodeMeta.title,
          transform = nodeMeta.transform,
          extra = nodeMeta.extra;
      var width = null;
      var height = null;

      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }

      if (config.autoA11y && !title) {
        extra.attributes['aria-hidden'] = 'true';
      }

      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width: width,
        height: height,
        transform: transform,
        title: title,
        extra: extra,
        watchable: true
      })]);
    };
  }
};

var CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}

function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new Promise(function (resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }

    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function (c) {
      return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
    var fontWeight = styles.getPropertyValue('font-weight');
    var content = styles.getPropertyValue('content');

    if (alreadyProcessedPseudoElement && !fontFamily) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== 'none' && content !== '') {
      var _content = styles.getPropertyValue('content');

      var family = ~['Sharp'].indexOf(fontFamily[2]) ? FAMILY_SHARP : FAMILY_CLASSIC;
      var prefix = ~['Solid', 'Regular', 'Light', 'Thin', 'Duotone', 'Brands', 'Kit'].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[family][fontWeight];

      var _hexValueFromContent = hexValueFromContent(_content),
          hexValue = _hexValueFromContent.value,
          isSecondary = _hexValueFromContent.isSecondary;

      var isV4 = fontFamily[0].startsWith('FontAwesome');
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;

      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);

        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
      // already done so with the same prefix and iconName


      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);

        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }

        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function (main) {
          var abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
            icons: {
              main: main,
              mask: emptyCanonicalIcon()
            },
            prefix: prefix,
            iconName: iconIdentifier,
            extra: extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement('svg');

          if (position === '::before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }

          element.outerHTML = abstract.map(function (a) {
            return toHtml(a);
          }).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}

function replace(node) {
  return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
}

function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function (resolve, reject) {
    var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
    var end = perf.begin('searchPseudoElements');
    disableObservation();
    Promise.all(operations).then(function () {
      end();
      enableObservation();
      resolve();
    }).catch(function () {
      end();
      enableObservation();
      reject();
    });
  });
}

var PseudoElements = {
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.pseudoElements2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node;

      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};

var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks('mutationObserverCallbacks', {}));
      },
      noAuto: function noAuto() {
        disconnect();
      },
      watch: function watch(params) {
        var observeMutationsRoot = params.observeMutationsRoot;

        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks('mutationObserverCallbacks', {
            observeMutationsRoot: observeMutationsRoot
          }));
        }
      }
    };
  }
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
    var parts = n.toLowerCase().split('-');
    var first = parts[0];
    var rest = parts.slice(1).join('-');

    if (first && rest === 'h') {
      acc.flipX = true;
      return acc;
    }

    if (first && rest === 'v') {
      acc.flipY = true;
      return acc;
    }

    rest = parseFloat(rest);

    if (isNaN(rest)) {
      return acc;
    }

    switch (first) {
      case 'grow':
        acc.size = acc.size + rest;
        break;

      case 'shrink':
        acc.size = acc.size - rest;
        break;

      case 'left':
        acc.x = acc.x - rest;
        break;

      case 'right':
        acc.x = acc.x + rest;
        break;

      case 'up':
        acc.y = acc.y - rest;
        break;

      case 'down':
        acc.y = acc.y + rest;
        break;

      case 'rotate':
        acc.rotate = acc.rotate + rest;
        break;
    }

    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute('data-fa-transform');

        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }

        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractTransformGrouping = function (_ref) {
      var main = _ref.main,
          transform = _ref.transform,
          containerWidth = _ref.containerWidth,
          iconWidth = _ref.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer: outer,
        inner: inner,
        path: path
      };
      return {
        tag: 'g',
        attributes: _objectSpread2({}, operations.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread2({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

var Masks = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute('data-fa-mask');
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(function (i) {
          return i.trim();
        }));

        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }

        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute('data-fa-mask-id');
        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractMask = function (_ref) {
      var children = _ref.children,
          attributes = _ref.attributes,
          main = _ref.main,
          mask = _ref.mask,
          explicitMaskId = _ref.maskId,
          transform = _ref.transform;
      var mainWidth = main.width,
          mainPath = main.icon;
      var maskWidth = mask.width,
          maskPath = mask.icon;
      var trans = transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: 'rect',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          fill: 'white'
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.inner),
        children: [fillBlack(_objectSpread2({
          tag: mainPath.tag,
          attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: 'mask',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: 'userSpaceOnUse',
          maskContentUnits: 'userSpaceOnUse'
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: 'defs',
        children: [{
          tag: 'clipPath',
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: 'rect',
        attributes: _objectSpread2({
          fill: 'currentColor',
          'clip-path': "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var MissingIconIndicator = {
  provides: function provides(providers) {
    var reduceMotion = false;

    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    providers.missingIconAbstract = function () {
      var gChildren = [];
      var FILL = {
        fill: 'currentColor'
      };
      var ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
      }; // Ring

      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
      });

      var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
        attributeName: 'opacity'
      });

      var dot = {
        tag: 'circle',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          cx: '256',
          cy: '364',
          r: '28'
        }),
        children: []
      };

      if (!reduceMotion) {
        dot.children.push({
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
            attributeName: 'r',
            values: '28;14;28;28;14;28;'
          })
        }, {
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;1;1;0;1;'
          })
        });
      }

      gChildren.push(dot);
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          opacity: '1',
          d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: reduceMotion ? [] : [{
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;0;0;0;1;'
          })
        }]
      });

      if (!reduceMotion) {
        // Exclamation
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
          }),
          children: [{
            tag: 'animate',
            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
              values: '0;0;1;1;0;0;'
            })
          }]
        });
      }

      return {
        tag: 'g',
        attributes: {
          'class': 'missing'
        },
        children: gChildren
      };
    };
  }
};

var SvgSymbols = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute('data-fa-symbol');
        var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
        accumulator['symbol'] = symbol;
        return accumulator;
      }
    };
  }
};

var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

registerPlugins(plugins, {
  mixoutsTo: api
});
var noAuto$1 = api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
var dom$1 = api.dom;
var parse$1 = api.parse;
var findIconDefinition$1 = api.findIconDefinition;
var toHtml$1 = api.toHtml;
var icon = api.icon;
var fontawesome_svg_core_layer = api.layer;
var fontawesome_svg_core_text = api.text;
var counter = api.counter;



// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faArrowRightToBracket.js
var faArrowRightToBracket = __webpack_require__(4194);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faChevronDown.js
var faChevronDown = __webpack_require__(9464);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faSuitcase.js
var faSuitcase = __webpack_require__(4127);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faCommentAlt.js
var faCommentAlt = __webpack_require__(8848);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faGift.js
var faGift = __webpack_require__(7249);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faCommentAltSmile.js
var faCommentAltSmile = __webpack_require__(5227);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/useRegisterModal-23dbb00b.js + 1 modules
var useRegisterModal_23dbb00b = __webpack_require__(6518);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/constants.js
var constants = __webpack_require__(8719);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/_rollupPluginBabelHelpers-388f54e6.js
var _rollupPluginBabelHelpers_388f54e6 = __webpack_require__(8336);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js + 1 modules
var context = __webpack_require__(7715);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 7 modules
var i18next = __webpack_require__(5751);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/apiCalls-c0fe2c19.js
const apiCalls_c0fe2c19_e={middlewares:{verifyUser:"/api/v3/users/is-authenticated/",studentHomeAccess:"/api/v3/users/has-new-home-stundents/",isBetaTester:"/api/v3/users/is-organizer-beta-tester/",enterpriseActivationsAccess:e=>`/api/v3/enterprise/${e}/permissions/can-access-enterprise-activations/`,orgCanAccess:"/api/v3/users/is-es-organization/"},header:"/api/bff/org/header/",home:"/api/bff/web/home/",conf:e=>`/api/v4/conferences/${e}/`,contact:"/api/bff/web/contact-info/",metatags:e=>`/api/bff/org/meta-tags/${e}/`,userLp:"/api/v3/users-learning-paths/",categories:"/api/v3/categories/",b2bDashboard:e=>`/api/v3/companies/${e}/dashboard/overview/`,studentLearningPaths:"/api/v4/user-learning-paths/",studentCategories:"/api/v3/home-user-custom-catalog/",enterpriseActivationsMenu:e=>`/api/v3/enterprise/${e}/menu/`,deals:"/entrenamiento-google/code/",recentLaunches:"/api/v4/recent-launches/",getSchools:"/api/v4/schools-list/",promos:e=>`/api/v4/promo/${e}/`},apiCalls_c0fe2c19_s={auth:{credentials:"/api/v3/users/credentials/",liveCredentials:e=>`/api/v4/live-credentials/${e}/`},preRegister:"/api/v4/preregister-countdown/",registerB2B:"/empresas/",courses:{manualCourses:"/api/v3/courses/user-manual-courses/",privateCourses:"/api/v3/courses/user-private-courses/",bougthCourses:"/api/v3/courses/user-purchased-courses/",getNewCourses:"/api/v3/courses/new-courses/"},users:{statsUrl:"/api/v3/users/stats/",getAlerts:"/api/v3/users/notifications/",mailVerified:"/api/v3/users/mail-verified/"},materials:{getMaterialProgress:"/api/v3/materials/progress/",removeLatestMaterial:e=>`/api/v3/materials/${e}/remove-latest/`},categories:{getCategories:"/api/v3/categories/"},learningPaths:{getUserLp:"/api/v3/learning-paths/",deleteLp:e=>`/api/v3/users-learning-paths/${e}/`,addLp:e=>`/api/v3/users-learning-paths/${e}/assign/`,availableForAdition:e=>`/api/v4/user-learning-paths/get-lps-available/${e}/`},live:{checkLive:"api/v1/lives/"},notifications:{getHomeFeed:e=>`/api/v3/home-feed/?page=${e}`},recommendations:{courses:"/api/v3/users/recommendations/"},discussions:{like:"/api/v3/home-feed/toggle-star/"},homeCatalog:{categoryDetail:e=>`/api/v3/home-catalog/?category=${e}`,categoryLearningPathDetail:e=>`/api/v3/home-catalog/${e}/`},homeUserCatalog:{studentLearningPathDetail:e=>`/api/v3/home-user-catalog/${e}/`,deleteCourse:()=>"/api/v3/home-user-custom-catalog/course/",addCourse:()=>"/api/v3/home-user-custom-catalog/course/"},globalSearch:e=>`/global-search/?search=${e}`,billing:{getInfo:()=>"/api/v3/payment-data/",saveInfo:()=>"/api/v3/billing-data/"},geo:{getStates:()=>"/api/bff/geo/states/",getCities:e=>`/api/bff/geo/municipalities/${e}/`},conf:{registration:(e,s)=>`/api/v4/conferences/${e}/register/?ticket_type=${s}`},deals:{submitCode:()=>"/entrenamiento-google/code/",registerData:()=>"/entrenamiento-google/data/"},platziDay:()=>"/api/v4/progress/courses/get_progress_platzi_day/",getBenefitiaryProgress:e=>`/api/v4/progress/courses/beneficiary-progress/${e}/`,sif:{tracking:"/api/v1/tracking/"},user:{getUserInfo:"/api/v1/components/headerv2/user/",isAccountless:"/api/v3/users/accountless/"}};

// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/axiosInstance-1cddbf84.js
var axiosInstance_1cddbf84 = __webpack_require__(6830);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/index-8d56a83f.js
var index_8d56a83f_e,index_8d56a83f_n,r,index_8d56a83f_t,index_8d56a83f_o,index_8d56a83f_a,i,u,c,f,index_8d56a83f_s,l,index_8d56a83f_p={exports:{}},y={exports:{}},index_8d56a83f_d={};function m(){return index_8d56a83f_n?y.exports:(index_8d56a83f_n=1,y.exports=(index_8d56a83f_e||(index_8d56a83f_e=1,function(){var e="function"==typeof Symbol&&Symbol.for,n=e?Symbol.for("react.element"):60103,r=e?Symbol.for("react.portal"):60106,t=e?Symbol.for("react.fragment"):60107,o=e?Symbol.for("react.strict_mode"):60108,a=e?Symbol.for("react.profiler"):60114,i=e?Symbol.for("react.provider"):60109,u=e?Symbol.for("react.context"):60110,c=e?Symbol.for("react.async_mode"):60111,f=e?Symbol.for("react.concurrent_mode"):60111,s=e?Symbol.for("react.forward_ref"):60112,l=e?Symbol.for("react.suspense"):60113,p=e?Symbol.for("react.suspense_list"):60120,y=e?Symbol.for("react.memo"):60115,m=e?Symbol.for("react.lazy"):60116,b=e?Symbol.for("react.block"):60121,v=e?Symbol.for("react.fundamental"):60117,h=e?Symbol.for("react.responder"):60118,g=e?Symbol.for("react.scope"):60119;function w(e){if("object"==typeof e&&null!==e){var p=e.$$typeof;switch(p){case n:var d=e.type;switch(d){case c:case f:case t:case a:case o:case l:return d;default:var b=d&&d.$$typeof;switch(b){case u:case s:case m:case y:case i:return b;default:return p}}case r:return p}}}var O=c,S=f,x=u,j=i,T=n,E=s,I=t,P=m,$=y,k=r,R=a,A=o,C=l,_=!1;function M(e){return w(e)===f}index_8d56a83f_d.AsyncMode=O,index_8d56a83f_d.ConcurrentMode=S,index_8d56a83f_d.ContextConsumer=x,index_8d56a83f_d.ContextProvider=j,index_8d56a83f_d.Element=T,index_8d56a83f_d.ForwardRef=E,index_8d56a83f_d.Fragment=I,index_8d56a83f_d.Lazy=P,index_8d56a83f_d.Memo=$,index_8d56a83f_d.Portal=k,index_8d56a83f_d.Profiler=R,index_8d56a83f_d.StrictMode=A,index_8d56a83f_d.Suspense=C,index_8d56a83f_d.isAsyncMode=function(e){return _||(_=!0,console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")),M(e)||w(e)===c},index_8d56a83f_d.isConcurrentMode=M,index_8d56a83f_d.isContextConsumer=function(e){return w(e)===u},index_8d56a83f_d.isContextProvider=function(e){return w(e)===i},index_8d56a83f_d.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===n},index_8d56a83f_d.isForwardRef=function(e){return w(e)===s},index_8d56a83f_d.isFragment=function(e){return w(e)===t},index_8d56a83f_d.isLazy=function(e){return w(e)===m},index_8d56a83f_d.isMemo=function(e){return w(e)===y},index_8d56a83f_d.isPortal=function(e){return w(e)===r},index_8d56a83f_d.isProfiler=function(e){return w(e)===a},index_8d56a83f_d.isStrictMode=function(e){return w(e)===o},index_8d56a83f_d.isSuspense=function(e){return w(e)===l},index_8d56a83f_d.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===t||e===f||e===a||e===o||e===l||e===p||"object"==typeof e&&null!==e&&(e.$$typeof===m||e.$$typeof===y||e.$$typeof===i||e.$$typeof===u||e.$$typeof===s||e.$$typeof===v||e.$$typeof===h||e.$$typeof===g||e.$$typeof===b)},index_8d56a83f_d.typeOf=w}()),index_8d56a83f_d))}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/function b(){if(index_8d56a83f_a)return index_8d56a83f_o;index_8d56a83f_a=1;return index_8d56a83f_o="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}function v(){return u?i:(u=1,i=Function.call.bind(Object.prototype.hasOwnProperty))}var h=m();index_8d56a83f_p.exports=function(){if(l)return index_8d56a83f_s;l=1;var e,n=m(),o=function(){if(index_8d56a83f_t)return r;index_8d56a83f_t=1;var e=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,o=Object.prototype.propertyIsEnumerable;function a(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}return r=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var n={},r=0;r<10;r++)n["_"+String.fromCharCode(r)]=r;if("0123456789"!==Object.getOwnPropertyNames(n).map((function(e){return n[e]})).join(""))return!1;var t={};return"abcdefghijklmnopqrst".split("").forEach((function(e){t[e]=e})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},t)).join("")}catch(e){return!1}}()?Object.assign:function(r,t){for(var i,u,c=a(r),f=1;f<arguments.length;f++){for(var s in i=Object(arguments[f]))n.call(i,s)&&(c[s]=i[s]);if(e){u=e(i);for(var l=0;l<u.length;l++)o.call(i,u[l])&&(c[u[l]]=i[u[l]])}}return c},r}(),a=b(),i=v(),u=function(){if(f)return c;f=1;var e,n=b(),r={},t=v();function o(o,a,i,u,c){for(var f in o)if(t(o,f)){var s;try{if("function"!=typeof o[f]){var l=Error((u||"React class")+": "+i+" type `"+f+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof o[f]+"`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");throw l.name="Invariant Violation",l}s=o[f](a,f,u,i,null,n)}catch(e){s=e}if(!s||s instanceof Error||e((u||"React class")+": type specification of "+i+" `"+f+"` is invalid; the type checker function must return `null` or an `Error` but returned a "+typeof s+". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."),s instanceof Error&&!(s.message in r)){r[s.message]=!0;var p=c?c():"";e("Failed "+i+" type: "+s.message+(null!=p?p:""))}}}return e=function(e){var n="Warning: "+e;"undefined"!=typeof console&&console.error(n);try{throw new Error(n)}catch(e){}},o.resetWarningCache=function(){r={}},c=o}();function p(){return null}return e=function(e){var n="Warning: "+e;"undefined"!=typeof console&&console.error(n);try{throw new Error(n)}catch(e){}},index_8d56a83f_s=function(r,t){var c="function"==typeof Symbol&&Symbol.iterator,f="<<anonymous>>",s={array:m("array"),bigint:m("bigint"),bool:m("boolean"),func:m("function"),number:m("number"),object:m("object"),string:m("string"),symbol:m("symbol"),any:d(p),arrayOf:function(e){return d((function(n,r,t,o,i){if("function"!=typeof e)return new y("Property `"+i+"` of component `"+t+"` has invalid PropType notation inside arrayOf.");var u=n[r];if(!Array.isArray(u))return new y("Invalid "+o+" `"+i+"` of type `"+h(u)+"` supplied to `"+t+"`, expected an array.");for(var c=0;c<u.length;c++){var f=e(u,c,t,o,i+"["+c+"]",a);if(f instanceof Error)return f}return null}))},element:d((function(e,n,t,o,a){var i=e[n];return r(i)?null:new y("Invalid "+o+" `"+a+"` of type `"+h(i)+"` supplied to `"+t+"`, expected a single ReactElement.")})),elementType:d((function(e,r,t,o,a){var i=e[r];return n.isValidElementType(i)?null:new y("Invalid "+o+" `"+a+"` of type `"+h(i)+"` supplied to `"+t+"`, expected a single ReactElement type.")})),instanceOf:function(e){return d((function(n,r,t,o,a){if(!(n[r]instanceof e)){var i=e.name||f;return new y("Invalid "+o+" `"+a+"` of type `"+((u=n[r]).constructor&&u.constructor.name?u.constructor.name:f)+"` supplied to `"+t+"`, expected instance of `"+i+"`.")}var u;return null}))},node:d((function(e,n,r,t,o){return v(e[n])?null:new y("Invalid "+t+" `"+o+"` supplied to `"+r+"`, expected a ReactNode.")})),objectOf:function(e){return d((function(n,r,t,o,u){if("function"!=typeof e)return new y("Property `"+u+"` of component `"+t+"` has invalid PropType notation inside objectOf.");var c=n[r],f=h(c);if("object"!==f)return new y("Invalid "+o+" `"+u+"` of type `"+f+"` supplied to `"+t+"`, expected an object.");for(var s in c)if(i(c,s)){var l=e(c,s,t,o,u+"."+s,a);if(l instanceof Error)return l}return null}))},oneOf:function(n){if(!Array.isArray(n))return e(arguments.length>1?"Invalid arguments supplied to oneOf, expected an array, got "+arguments.length+" arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).":"Invalid argument supplied to oneOf, expected an array."),p;function r(e,r,t,o,a){for(var i=e[r],u=0;u<n.length;u++)if(l(i,n[u]))return null;var c=JSON.stringify(n,(function(e,n){return"symbol"===g(n)?String(n):n}));return new y("Invalid "+o+" `"+a+"` of value `"+String(i)+"` supplied to `"+t+"`, expected one of "+c+".")}return d(r)},oneOfType:function(n){if(!Array.isArray(n))return e("Invalid argument supplied to oneOfType, expected an instance of array."),p;for(var r=0;r<n.length;r++){var t=n[r];if("function"!=typeof t)return e("Invalid argument supplied to oneOfType. Expected an array of check functions, but received "+w(t)+" at index "+r+"."),p}return d((function(e,r,t,o,u){for(var c=[],f=0;f<n.length;f++){var s=(0,n[f])(e,r,t,o,u,a);if(null==s)return null;s.data&&i(s.data,"expectedType")&&c.push(s.data.expectedType)}return new y("Invalid "+o+" `"+u+"` supplied to `"+t+"`"+(c.length>0?", expected one of type ["+c.join(", ")+"]":"")+".")}))},shape:function(e){return d((function(n,r,t,o,i){var u=n[r],c=h(u);if("object"!==c)return new y("Invalid "+o+" `"+i+"` of type `"+c+"` supplied to `"+t+"`, expected `object`.");for(var f in e){var s=e[f];if("function"!=typeof s)return b(t,o,i,f,g(s));var l=s(u,f,t,o,i+"."+f,a);if(l)return l}return null}))},exact:function(e){return d((function(n,r,t,u,c){var f=n[r],s=h(f);if("object"!==s)return new y("Invalid "+u+" `"+c+"` of type `"+s+"` supplied to `"+t+"`, expected `object`.");var l=o({},n[r],e);for(var p in l){var d=e[p];if(i(e,p)&&"function"!=typeof d)return b(t,u,c,p,g(d));if(!d)return new y("Invalid "+u+" `"+c+"` key `"+p+"` supplied to `"+t+"`.\nBad object: "+JSON.stringify(n[r],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(e),null,"  "));var m=d(f,p,t,u,c+"."+p,a);if(m)return m}return null}))}};function l(e,n){return e===n?0!==e||1/e==1/n:e!=e&&n!=n}function y(e,n){this.message=e,this.data=n&&"object"==typeof n?n:{},this.stack=""}function d(n){var r={},o=0;function i(i,u,c,s,l,p,d){if(s=s||f,p=p||c,d!==a){if(t){var m=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");throw m.name="Invariant Violation",m}if("undefined"!=typeof console){var b=s+":"+c;!r[b]&&o<3&&(e("You are manually calling a React.PropTypes validation function for the `"+p+"` prop on `"+s+"`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."),r[b]=!0,o++)}}return null==u[c]?i?null===u[c]?new y("The "+l+" `"+p+"` is marked as required in `"+s+"`, but its value is `null`."):new y("The "+l+" `"+p+"` is marked as required in `"+s+"`, but its value is `undefined`."):null:n(u,c,s,l,p)}var u=i.bind(null,!1);return u.isRequired=i.bind(null,!0),u}function m(e){return d((function(n,r,t,o,a,i){var u=n[r];return h(u)!==e?new y("Invalid "+o+" `"+a+"` of type `"+g(u)+"` supplied to `"+t+"`, expected `"+e+"`.",{expectedType:e}):null}))}function b(e,n,r,t,o){return new y((e||"React class")+": "+n+" type `"+r+"."+t+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+o+"`.")}function v(e){switch(typeof e){case"number":case"string":case"undefined":return!0;case"boolean":return!e;case"object":if(Array.isArray(e))return e.every(v);if(null===e||r(e))return!0;var n=function(e){var n=e&&(c&&e[c]||e["@@iterator"]);if("function"==typeof n)return n}(e);if(!n)return!1;var t,o=n.call(e);if(n!==e.entries){for(;!(t=o.next()).done;)if(!v(t.value))return!1}else for(;!(t=o.next()).done;){var a=t.value;if(a&&!v(a[1]))return!1}return!0;default:return!1}}function h(e){var n=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":function(e,n){return"symbol"===e||!!n&&("Symbol"===n["@@toStringTag"]||"function"==typeof Symbol&&n instanceof Symbol)}(n,e)?"symbol":n}function g(e){if(null==e)return""+e;var n=h(e);if("object"===n){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return n}function w(e){var n=g(e);switch(n){case"array":case"object":return"an "+n;case"boolean":case"date":case"regexp":return"a "+n;default:return n}}return y.prototype=Error.prototype,s.checkPropTypes=u,s.resetWarningCache=u.resetWarningCache,s.PropTypes=s,s},index_8d56a83f_s}()(h.isElement,!0);

// EXTERNAL MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(6245);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/index-f0f30b4f.js
var index_f0f30b4f_m=Object.freeze({__proto__:null,ReactTranslationsHOC:r=>a=>{const{t:s,i18n:o}=(0,useTranslation/* useTranslation */.$)();return react.createElement(r,(0,_rollupPluginBabelHelpers_388f54e6._)({},a,{t:s,i18n:o}))},translationsConfig:({messages:e,locale:t})=>{const r={[t]:{translations:e}};i18next/* default.use */.ZP.use(context/* initReactI18next */.Db).init({resources:r,lng:t,fallbackLng:t,debug:!1,ns:["translations"],defaultNS:"translations",keySeparator:!1,interpolation:{escapeValue:!1}})}}),index_f0f30b4f_h=Object.freeze({__proto__:null,serverApi:apiCalls_c0fe2c19_e,clientApi:apiCalls_c0fe2c19_s,axiosInstance:axiosInstance_1cddbf84.a,axiosServerInstance:axiosInstance_1cddbf84.b});const _=(0,react.createContext)(),E=(e,t)=>{switch(t.type){case"init":return{...e,token:t.payload.token,url:t.payload.url,headers:t.payload.headers||{}};case"track":case"visit":return{...e,lastEvent:t.payload.event}}return e},index_f0f30b4f_f={token:null,url:null,lastEvent:null},index_f0f30b4f_w=({children:e})=>{const[r,n]=(0,react.useReducer)(E,index_f0f30b4f_f),s={init:async()=>{const e=await (0,axiosInstance_1cddbf84.a)(!0).get(apiCalls_c0fe2c19_s.auth.credentials),{token:t}=null==e?void 0:e.data,r={token:t.access,url:t.microservices.sif_url,headers:t.headers?t.headers:{}};n({type:"init",payload:r})},trackVisit:async(e,t)=>{const a={baseURL:r.url,headers:{Authorization:`Bearer ${r.token}`,...r.headers}},s={source:"web","user-agent":navigator.userAgent,properties:t},o={event:{...s,event:e}};await (0,axiosInstance_1cddbf84.a)(!1,a).post(apiCalls_c0fe2c19_s.sif.tracking,{...s,event:e}),n({type:"visit",payload:o})},track:async(e,t)=>{const a={baseURL:r.url,headers:{Authorization:`Bearer ${r.token}`,...r.headers}},s={source:"web",properties:t},o={event:{...s,event:e}};await (0,axiosInstance_1cddbf84.a)(!1,a).post(apiCalls_c0fe2c19_s.sif.tracking,{...s,event:e}),n({type:"track",payload:o})}};return react.createElement(_.Provider,{value:{sif:r,sifActions:s}},e)};index_f0f30b4f_w.propTypes={children:index_8d56a83f_p.exports.node};const index_f0f30b4f_v=async(e="credentials")=>{const t=localStorage.getItem(`${e}_token`),r=localStorage.getItem(`${e}_headers`),a=localStorage.getItem(`${e}_microservicesUrl`);return t&&a?{token:t,headers:JSON.parse(r),microservicesUrl:JSON.parse(a)}:await index_f0f30b4f_y(e)},index_f0f30b4f_y=async(e="credentials",t=null)=>{try{const r=t?`${apiCalls_c0fe2c19_s.auth.credentials}?company_id=${t}`:apiCalls_c0fe2c19_s.auth.credentials,a=await (0,axiosInstance_1cddbf84.a)(!0).get("credentials"===e?r:apiCalls_c0fe2c19_s.auth.liveCredentials(e)),{token:{access:n,headers:s,microservices:o}}=a.data;return await localStorage.setItem(`${e}_token`,n),await localStorage.setItem(`${e}_headers`,JSON.stringify(a.data.token.headers?s:{})),await localStorage.setItem(`${e}_microservicesUrl`,JSON.stringify(a.data.token.microservices?a.data.token.microservices:{})),await{token:n,headers:s,microservicesUrl:o}}catch(e){throw new Error({type:"::ERROR::CLIENT_REQUEST_CREDENTIALS_REFRESH_TOKEN",error:e})}};const g=async(e="credentials",t=null,r=null)=>{const a=localStorage.getItem(`${e}_token`);return a?function(e){const{exp:t}=p(e);return Date.now()>=1e3*t}(a)||function(e,t){if(!e)return!1;const{sub:r}=p(t);return Number(e)!==Number(r)}(t,a)||function(e,t){if(!e)return!1;const{cid:r}=p(t);return Number(e)!==Number(r)}(r,a)?await index_f0f30b4f_y(e,r):void 0:await index_f0f30b4f_v(e)},R=async(e,t,r="credentials")=>{let a=await index_f0f30b4f_v(r);void 0===a.microservicesUrl[`${e}_url`]&&(a=await index_f0f30b4f_y(r));const n={baseURL:`${a.microservicesUrl[`${e}_url`]}`,headers:k(a.token,a.headers)};return await S(0,n,t,r,e)},S=async(e,t,r,a="credentials",n)=>{if(e>=3)return new Promise(((e,t)=>{e({})}));{const{requestURL:o,payload:i,method:c}=r;try{const e=await (0,axiosInstance_1cddbf84.a)(!1,t)[c](o,i);return await e.data}catch(o){var s;if(401===(null==o||null===(s=o.response)||void 0===s?void 0:s.status))return index_f0f30b4f_y(a).then((s=>S(e+1,{...t,headers:k(s.token,s.headers),baseURL:`${s.microservicesUrl[`${n}_url`]}`},r,a,n).catch((e=>{throw new Error({type:"::ERROR::CLIENT_REQUEST_SEND_REQUEST",error:e})})))).catch((e=>{throw new Error({type:"::ERROR::CLIENT_REQUEST_REFRESH_TOKEN",error:e})}));throw new Error({type:"::ERROR::CLIENT_REQUEST_REQUEST",err:o})}}},k=(e,t)=>t==={}?{"API-Authorization":`Bearer ${e}`}:{"API-Authorization":`Bearer ${e}`,...t};var index_f0f30b4f_b=Object.freeze({__proto__:null,SIF:(e,t={},r=!1)=>{let a={source:"web",event:e,properties:t};if(r){const e=(()=>{let e={landing:window.location.href,meta_request_method:"GET",meta_path_info:location.pathname};document.referrer.length&&(e={...e,meta_http_referer:document.referrer}),location.search.length&&(e={...e,meta_query_string:location.search});const t=new URLSearchParams(window.location.search);for(const r of t)r[0].includes("utm_")&&(e={...e,[r[0]]:r[1]});return e})();a={...a,properties:{...t,...e},"user-agent":navigator.userAgent}}return a},GOSSIP:()=>{throw new Error("Not implemente yet!")},ENIGMA:()=>{throw new Error("Not implemente yet!")}});

// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/index-7de6c45f.js + 1 modules
var index_7de6c45f = __webpack_require__(758);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/DataDogAsyncCollector-03c24e8a.js
const DataDogAsyncCollector_03c24e8a_i=(t,n,e)=>{window.ga&&ga.create&&window.ga("platziFull.send","event",t,n,e)};function DataDogAsyncCollector_03c24e8a_r(t={},{type:n,payload:e}){return t}const DataDogAsyncCollector_03c24e8a_c=t=>{const n=document.getElementById(t);n.parentNode.removeChild(n)},DataDogAsyncCollector_03c24e8a_d=()=>{delete window.__PRELOADED_STATE__,delete window.initialProps,delete window.translations,DataDogAsyncCollector_03c24e8a_c("preloadedState"),DataDogAsyncCollector_03c24e8a_c("initialProps"),DataDogAsyncCollector_03c24e8a_c("translations")},DataDogAsyncCollector_03c24e8a_p=()=>(0,axiosInstance_1cddbf84.a)(!0).get(apiCalls_c0fe2c19_s.user.getUserInfo).then((({data:t})=>t)),DataDogAsyncCollector_03c24e8a_l=()=>t(!0).get(n.user.isAccountless).then((({data:t})=>t));function DataDogAsyncCollector_03c24e8a_u(t=""){return!(String(t).trim()<=0||!e.test(String(t).toLowerCase().trim()))}function DataDogAsyncCollector_03c24e8a_f(t=""){return!(String(t).trim()<=0||!o.test(String(t).toLowerCase().trim()))}const DataDogAsyncCollector_03c24e8a_w=(t="")=>{const n=String(t).toLowerCase().trim();return!(n<=0||!a.test(n))},DataDogAsyncCollector_03c24e8a_h=t=>{try{const n=t||window.location.hostname;return["localhost","staging","platzi.dev"].some((t=>n.includes(t)))?"test":"production"}catch(t){return"test"}},DataDogAsyncCollector_03c24e8a_m=t=>{const n=DataDogAsyncCollector_03c24e8a_h();"undefined"!=typeof window&&"production"===n&&window.dataLayer&&window.dataLayer.push(t)},DataDogAsyncCollector_03c24e8a_g=(t,n,e)=>{try{const o=DataDogAsyncCollector_03c24e8a_h(),a=t,s="production"===o?a:`${a} Test`;window.ga&&window.ga("platziFull.send","event",s,n,e)}catch(t){throw new Error(`'::ERROR::analytics' ${t}`)}},DataDogAsyncCollector_03c24e8a_y=t=>{const n=DataDogAsyncCollector_03c24e8a_h();"undefined"!=typeof window&&"production"===n&&window.hj&&window.hj("event",t)};var DataDogAsyncCollector_03c24e8a_="https://static.platzi.com/commons/assets/images/one-person850ef8d9ec30c125.png";const D={default:DataDogAsyncCollector_03c24e8a_,platzi_academy:DataDogAsyncCollector_03c24e8a_,monthly_plan:DataDogAsyncCollector_03c24e8a_,expert_plan:DataDogAsyncCollector_03c24e8a_,annual_plan:"https://static.platzi.com/commons/assets/images/two-people4e0c1925472ce45a.png",family_plan:"https://static.platzi.com/commons/assets/images/four-people7d0727bbebfe9dea.png"},DataDogAsyncCollector_03c24e8a_E=t=>D[t]?D[t]:D.default;function DataDogAsyncCollector_03c24e8a_S(t){const{token:n,showFreshChat:e,delay:o=1e3,additionalProps:a={}}=t||{};if(!e)return"";const i=s({token:n,host:"https://wchat.freshchat.com",config:{headerProperty:{foregroundColor:"#7F2C98"}}},a);return`\n    <script async defer>\n      function initFreshChat() {\n        window.fcWidget.init(${JSON.stringify(i)});\n      }\n      (function(d, id) {\n        var fcJS;\n        if (d.getElementById(id)) {\n          setTimeout(function() { initFreshChat(); }, ${o});\n          return;\n        }\n        fcJS = d.createElement('script');\n        fcJS.id = id;\n        fcJS.async = true;\n        fcJS.src = 'https://wchat.freshchat.com/js/widget.js';\n        fcJS.onload = initFreshChat;\n        d.head.appendChild(fcJS);\n      }(document, 'freshchat-js-sdk'));\n    <\/script>\n  `}function C(t,n={}){const{DATADOG_CLIENT_TOKEN:e,DATADOG_APPLICATION_ID:o,DATADOG_SERVICE_NAME:a}=t||{};if(!e)return"";const i=s({clientToken:e,applicationId:o,site:"datadoghq.com",service:a,sampleRate:100,trackInteractions:!0},n);return`<script async defer>\n    (function(h,o,u,n,d) {\n      h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}\n      d=o.createElement(u);d.async=1;d.src=n\n      n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)\n    })(window,document,'script','https://www.datadoghq-browser-agent.com/datadog-rum-v4.js','DD_RUM')\n      DD_RUM.onReady(function() {\n        DD_RUM.init(${JSON.stringify(i)});\n      })\n    <\/script>`}const DataDogAsyncCollector_03c24e8a_R=t=>`<script>\n      window.dataLayer && window.dataLayer.push({\n        event: 'page_viewed',\n        ${t?`user_id:${t},`:""}\n      })\n    <\/script>`;const DataDogAsyncCollector_03c24e8a_v={captureException:function(t,n={}){"undefined"!=typeof DD_RUM&&DD_RUM.onReady((function(){DD_RUM.addError(t,n)}))}};

// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/Image-4b46b89d.js
var Image_4b46b89d = __webpack_require__(6363);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faBars.js
var faBars = __webpack_require__(8811);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faChevronRight.js
var faChevronRight = __webpack_require__(5972);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/free-solid-svg-icons/faChevronDown.js
var free_solid_svg_icons_faChevronDown = __webpack_require__(3719);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/free-solid-svg-icons/faChevronUp.js
var faChevronUp = __webpack_require__(7365);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faList.js
var faList = __webpack_require__(7204);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-solid-svg-icons/faBadgeCheck.js
var faBadgeCheck = __webpack_require__(17);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faCode.js
var faCode = __webpack_require__(9844);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faGlobe.js
var faGlobe = __webpack_require__(8112);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faChartLine.js
var faChartLine = __webpack_require__(2359);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faRocket.js
var faRocket = __webpack_require__(8511);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faMegaphone.js
var faMegaphone = __webpack_require__(5099);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faSeedling.js
var faSeedling = __webpack_require__(8069);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faPenNib.js
var faPenNib = __webpack_require__(8453);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faVideo.js
var faVideo = __webpack_require__(3036);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/TabSection-9807b9f3.js
var TabSection_9807b9f3 = __webpack_require__(2321);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/dist/es/PromoBanner-b380d5ea.js
const PromoBanner_b380d5ea_i={flag:index_5808dc9d.p.exports.string,price:index_5808dc9d.p.exports.string},PromoBanner_b380d5ea_c={"PromoBanner.cta":index_5808dc9d.p.exports.string,countdown_text:index_5808dc9d.p.exports.string,PromoBanner_details_previous_saving:index_5808dc9d.p.exports.string},PromoBanner_b380d5ea_m={status:index_5808dc9d.p.exports.string,primary_logo:index_5808dc9d.p.exports.string,end_date:index_5808dc9d.p.exports.string,pricing:index_5808dc9d.p.exports.shape(PromoBanner_b380d5ea_i),previous_price:index_5808dc9d.p.exports.shape(PromoBanner_b380d5ea_i),saving:index_5808dc9d.p.exports.shape(PromoBanner_b380d5ea_i),url:index_5808dc9d.p.exports.string,secondary_logo:index_5808dc9d.p.exports.string,primary_color:index_5808dc9d.p.exports.string,secondary_color:index_5808dc9d.p.exports.string,tertiary_color:index_5808dc9d.p.exports.string,font_color:index_5808dc9d.p.exports.string,lang:index_5808dc9d.p.exports.string,pre_banner_text:index_5808dc9d.p.exports.string,banner_text:index_5808dc9d.p.exports.string,promo:index_5808dc9d.p.exports.string,useWhitePaymentMethods:index_5808dc9d.p.exports.string,show_counter:index_5808dc9d.p.exports.bool,has_pricing:index_5808dc9d.p.exports.bool,is_platzi_day_registered:index_5808dc9d.p.exports.bool,messages:index_5808dc9d.p.exports.shape(PromoBanner_b380d5ea_c),type:index_5808dc9d.p.exports.string,cta_color:index_5808dc9d.p.exports.string,cta_font_color:index_5808dc9d.p.exports.string,installments_banner:{image:index_5808dc9d.p.exports.string,installments:index_5808dc9d.p.exports.number,message:index_5808dc9d.p.exports.string}},PromoBanner_b380d5ea_p=e=>{const r="undefined"!=typeof document&&document.cookie.match(new RegExp("(?:^|; )"+e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g,"\\$1")+"=([^;]*)"));return r?decodeURIComponent(r[1]):void 0},PromoBanner_b380d5ea_d=({days:r,hours:t,minutes:n,seconds:o})=>{const a=[{id:1,value:r,text:"D"},{id:2,value:t,text:"H"},{id:3,value:n,text:"M"},{id:4,value:o,text:"S"}];return react.createElement("div",{className:"PromoBanner-countdown-element"},a.map((({id:r,value:t,text:n})=>react.createElement("div",{className:"PromoBanner-countdown-item",key:r},t,react.createElement("span",{className:"PromoBanner-countdown-unit"},n)))))},PromoBanner_b380d5ea_g=l=>{const{t:i}=(0,useTranslation/* useTranslation */.$)(),{show_counter:c,has_pricing:m,status:g,type:u}=l,{pre_banner_text:_,banner_text:x,end_date:v,promo:y,primary_logo:P}=l,{pricing:E,previous_price:B,messages:h,url:f}=l,{primary_color:b,secondary_color:N,font_color:w,cta_color:C,cta_font_color:k,installments_banner:I}=l,[M,$]=(0,react.useState)(!1),H={backgroundColor:b,color:w},L={backgroundColor:N},S=classnames_default()("PromoBanner",`PromoBanner--${y}`,{"PromoBanner--basic":"basic"===u,"PromoBanner-pre":"pre"===g});return (0,react.useEffect)((()=>{const e=PromoBanner_b380d5ea_p("referral_url"),r=PromoBanner_b380d5ea_p("referral_expire");$(!(!e||!r))}),[]),M?null:react.createElement("div",{className:S,style:H},react.createElement("div",{className:"PromoBanner-content"},react.createElement("div",{className:"PromoBanner-details"},P&&react.createElement(Image_4b46b89d.I,{customClass:"PromoBanner-content-logo",src:P,alt:x}),react.createElement("div",{className:"PromoBanner-details-saving"},"promo"===g?react.createElement(react.Fragment,null,react.createElement("p",{dangerouslySetInnerHTML:{__html:x},className:"PromoBanner-details-saving-layout"})):react.createElement("p",{dangerouslySetInnerHTML:{__html:_},className:"PromoBanner-details-saving-layout"})),"promo"===g&&react.createElement("div",{className:"PromoBanner-promoContent"},react.createElement("div",{className:"PromoBanner-details-before"},react.createElement("p",{className:"PromoBanner-details-previous-content","data-trans":"Antes"},i("Antes"),": ",react.createElement("span",{className:"PromoBanner-details-previous-price"},B.price)),react.createElement("div",{className:"PromoBanner-details-pricing"},react.createElement("figure",null,react.createElement(Image_4b46b89d.I,{src:E.flag,alt:"Currency",width:"16",height:"16"})),react.createElement("div",{className:"PromoBanner-details-price"},react.createElement("strong",null,E.price),"/año"))),m&&I&&react.createElement("div",{className:"PromoBanner-details-previous",style:{borderLeft:`1px solid ${w||"white"}`}},react.createElement("p",{className:"PromoBanner-details-previous-content is-msi"},null==I?void 0:I.message),react.createElement("figure",null,react.createElement(Image_4b46b89d.I,{src:null==I?void 0:I.image,alt:null==I?void 0:I.message})))),react.createElement("a",{href:f,className:"PromoBanner-cta",style:{background:C,color:k}},null==h?void 0:h["PromoBanner.cta"])),c&&react.createElement("div",{className:"PromoBanner-countdown",style:L},react.createElement("p",{className:"PromoBanner-countdown-text"},null==h?void 0:h.countdown_text),react.createElement(dist_index_es,{date:new Date(v),renderer:PromoBanner_b380d5ea_d}))),react.createElement("a",{href:f,className:"PromoBanner-anchor"}))};PromoBanner_b380d5ea_g.propTypes=PromoBanner_b380d5ea_m,PromoBanner_b380d5ea_g.defaultProps={status:"",primary_logo:"",end_date:"",pricing:null,previous_price:null,saving:null,url:"",secondary_logo:"",primary_color:"",secondary_color:"",tertiary_color:"",font_color:"",lang:"",msi_banner:"",pre_banner_text:"",banner_text:"",promo:"",useWhitePaymentMethods:"",show_counter:!1,has_pricing:!1,is_platzi_day_registered:!1,messages:{},installments_banner:null};

;// CONCATENATED MODULE: ./node_modules/@platzi/ui/dist/es/FormCheckbox-a2d652c7.js
class FormCheckbox_a2d652c7_a extends react.Component{constructor(...e){return super(...e),this.state={value:this.props.value},this.handleContent=()=>{this.setState({value:!this.state.value}),this.props.handleContent&&this.props.handleContent(!this.state.value,this.props.name)},this}render(){const t=classnames_default()("FormCheckbox-field",{error:this.props.error,switch:this.props.isSwitch}),r=classnames_default()("FormCheckbox",{switch:this.props.isSwitch});return react.createElement("div",{className:`${r} ${this.props.className}`},react.createElement("input",(0,_rollupPluginBabelHelpers_1fef267c._)({},this.props,{type:"checkbox",className:t,onChange:this.handleContent,checked:this.state.value,value:this.state.value})),this.props.isSwitch&&react.createElement("span",{className:"FormCheckbox-switch",onClick:this.handleContent}),react.createElement("label",{className:"FormCheckbox-label",htmlFor:this.props.id}))}}FormCheckbox_a2d652c7_a.propTypes={className:index_5808dc9d.p.exports.string,required:index_5808dc9d.p.exports.bool,error:index_5808dc9d.p.exports.bool,value:index_5808dc9d.p.exports.value,id:index_5808dc9d.p.exports.string,handleContent:index_5808dc9d.p.exports.func,isSwitch:index_5808dc9d.p.exports.bool},FormCheckbox_a2d652c7_a.defaultProps={className:"",required:!1,error:"",value:!1,id:"",isSwitch:!1};

// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(9960);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/free-solid-svg-icons/faCreditCard.js
var faCreditCard = __webpack_require__(3460);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faChartPieAlt.js
var faChartPieAlt = __webpack_require__(2045);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(9634);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/dayjs/locale/es.js
var locale_es = __webpack_require__(6445);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/free-solid-svg-icons/faTimes.js
var free_solid_svg_icons_faTimes = __webpack_require__(5774);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-solid-svg-icons/faCalendarCirclePlus.js
var faCalendarCirclePlus = __webpack_require__(9423);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-solid-svg-icons/faCircle.js
var faCircle = __webpack_require__(9853);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-solid-svg-icons/faMapMarkerAlt.js
var faMapMarkerAlt = __webpack_require__(1677);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-solid-svg-icons/faArrowRight.js
var faArrowRight = __webpack_require__(5235);
// EXTERNAL MODULE: ./node_modules/loadjs/dist/loadjs.umd.js
var loadjs_umd = __webpack_require__(5107);
var loadjs_umd_default = /*#__PURE__*/__webpack_require__.n(loadjs_umd);
;// CONCATENATED MODULE: ./node_modules/react-twitter-widgets/es/utils.js


var twScriptUrl = "https://platform.twitter.com/widgets.js";
var twScriptWindowFieldName = "twttr";
var twScriptName = twScriptWindowFieldName;
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function loadTwitterLibrary() {
  if (!loadjs_umd_default().isDefined(twScriptName)) {
    loadjs_umd_default()(twScriptUrl, twScriptName);
  }
}
function twWidgetFactory() {
  return new Promise(function (resolve, reject) {
    var rejectWithError = function rejectWithError() {
      return reject(new Error("Could not load remote twitter widgets js"));
    };

    loadTwitterLibrary();
    loadjs_umd_default().ready(twScriptName, {
      success: function success() {
        // Ensure loaded
        var twttr = window[twScriptWindowFieldName];

        if (!twttr || !twttr.widgets) {
          rejectWithError();
        }

        resolve(twttr.widgets);
      },
      error: rejectWithError
    });
  });
}
function removeChildrenWithAttribute(node, attribute) {
  if (node) {
    node.querySelectorAll("*").forEach(function (child) {
      if (child.hasAttribute(attribute)) {
        child.remove();
      }
    });
  }
}

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function isShallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function useShallowCompareMemoize(value) {
  var ref = (0,react.useRef)();

  if (!isShallowEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}
function cloneShallow(value) {
  return typeof value === "object" ? Object.assign({}, value) : value;
}
;// CONCATENATED MODULE: ./node_modules/react-twitter-widgets/es/index.js



var childDivIdentifyingAttribute = "twdiv";

function useTwitterWidget(factoryFunctionName, primaryArg, options, onLoad) {
  var _useState = (0,react.useState)(null),
      error = _useState[0],
      setError = _useState[1];

  var ref = (0,react.useRef)(null); // noop if ssr

  if (!canUseDOM) {
    return {
      ref: ref,
      error: error
    };
  } // Make deps for useEffect.
  // options, and possibly primaryArg, are objects that should be compared (shallow).
  // There currently aren't any nested arrays or objects, so they
  // can be cloned in a shallow manner.
  // NOTE onLoad is used in useCallback, but it is not listed as a dependency.
  // Listing it would likely cause unnecessary loads. The latest onLoad should be
  // used regardless, since it will not be called unless the other dependencies
  // change, so it works out.


  var deps = [factoryFunctionName, useShallowCompareMemoize(primaryArg), useShallowCompareMemoize(options)];
  (0,react.useEffect)(function () {
    // Reset error
    setError(null); // Protect against race conditions
    // (set to true in cleanup function;
    // checked if canceled in async loadWidget)

    var isCanceled = false;

    if (ref.current) {
      removeChildrenWithAttribute(ref.current, childDivIdentifyingAttribute);

      if (!ref || !ref.current) {
        return;
      }

      var childEl = document.createElement("div");
      childEl.setAttribute(childDivIdentifyingAttribute, "yes");
      ref.current.appendChild(childEl);
      twWidgetFactory().then(function (wf) {
        // primaryArg (possibly an object) and options must be cloned
        // since twitter mutates them (gah!).
        // There currently aren't any nested arrays or objects, so they
        // can be cloned in a shallow manner.
        return wf[factoryFunctionName](cloneShallow(primaryArg), childEl, cloneShallow(options));
      }).then(function (resultMaybe) {
        // Twitter returns undefined if widget creation fails.
        // However, if deps are stale (isCanceled), suppress error (likely race condition).
        if (!resultMaybe && !isCanceled) {
          throw new Error("Twitter could not create widget. If it is a Timeline or " + "Tweet, ensure the screenName/tweetId exists.");
        }

        if (!ref || !ref.current) {
          return;
        }

        if (isCanceled) {
          if (childEl) {
            childEl.remove();
          }

          return;
        }

        if (onLoad) {
          onLoad();
        }
      })["catch"](function (e) {
        console.error(e);
        setError(e);
      });
    }

    return function () {
      isCanceled = true;
    };
  }, deps);
  return {
    ref: ref,
    error: error
  };
}

var Follow = function Follow(_ref) {
  var username = _ref.username,
      options = _ref.options,
      onLoad = _ref.onLoad,
      renderError = _ref.renderError;

  var _useTwitterWidget = useTwitterWidget("createFollowButton", username, options, onLoad),
      ref = _useTwitterWidget.ref,
      error = _useTwitterWidget.error;

  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, error && renderError && renderError(error));
};
var Hashtag = function Hashtag(_ref2) {
  var hashtag = _ref2.hashtag,
      options = _ref2.options,
      onLoad = _ref2.onLoad,
      renderError = _ref2.renderError;

  var _useTwitterWidget2 = useTwitterWidget("createHashtagButton", hashtag, options, onLoad),
      ref = _useTwitterWidget2.ref,
      error = _useTwitterWidget2.error;

  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, error && renderError && renderError(error));
};
var Mention = function Mention(_ref3) {
  var username = _ref3.username,
      options = _ref3.options,
      onLoad = _ref3.onLoad,
      renderError = _ref3.renderError;

  var _useTwitterWidget3 = useTwitterWidget("createMentionButton", username, options, onLoad),
      ref = _useTwitterWidget3.ref,
      error = _useTwitterWidget3.error;

  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, error && renderError && renderError(error));
};
var Share = function Share(_ref4) {
  var url = _ref4.url,
      options = _ref4.options,
      onLoad = _ref4.onLoad,
      renderError = _ref4.renderError;

  var _useTwitterWidget4 = useTwitterWidget("createShareButton", url, options, onLoad),
      ref = _useTwitterWidget4.ref,
      error = _useTwitterWidget4.error;

  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, error && renderError && renderError(error));
};
var Timeline = function Timeline(_ref5) {
  var dataSource = _ref5.dataSource,
      options = _ref5.options,
      onLoad = _ref5.onLoad,
      renderError = _ref5.renderError;

  var _useTwitterWidget5 = useTwitterWidget("createTimeline", dataSource, options, onLoad),
      ref = _useTwitterWidget5.ref,
      error = _useTwitterWidget5.error;

  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, error && renderError && renderError(error));
};
var Tweet = function Tweet(_ref6) {
  var tweetId = _ref6.tweetId,
      options = _ref6.options,
      onLoad = _ref6.onLoad,
      renderError = _ref6.renderError;

  var _useTwitterWidget6 = useTwitterWidget("createTweet", tweetId, options, onLoad),
      ref = _useTwitterWidget6.ref,
      error = _useTwitterWidget6.error;

  return /*#__PURE__*/react.createElement("div", {
    ref: ref
  }, error && renderError && renderError(error));
};
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(9238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-solid-svg-icons/faTimes.js
var pro_solid_svg_icons_faTimes = __webpack_require__(1584);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-solid-svg-icons/faSparkles.js
var faSparkles = __webpack_require__(8606);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-solid-svg-icons/faClock.js
var faClock = __webpack_require__(7324);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-solid-svg-icons/faShieldCheck.js
var faShieldCheck = __webpack_require__(7409);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/dist/es/DynamicHTML-3586636e.js
var DynamicHTML_3586636e_a=react.forwardRef((function(a,i){var f=a.tag,n=a.html,l=(0,tslib_es6/* __rest */._T)(a,["tag","html"]),p=(0,react.useMemo)((function(){return{__html:browser_default().sanitize(n)}}),[n]);return react.createElement(f,(0,_rollupPluginBabelHelpers_1fef267c._)({ref:i},l,{dangerouslySetInnerHTML:p}))})),DynamicHTML_3586636e_i=react.memo(DynamicHTML_3586636e_a);

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(1296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faSearch.js
var faSearch = __webpack_require__(8853);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faPlay.js
var faPlay = __webpack_require__(8368);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/dist/es/NewSearch-db1704c6.js
class NewSearch_db1704c6_m extends react.Component{constructor(e){super(e),this.handleClearInput=e=>{e.preventDefault(),this.setState({query:"",resultAutocomplete:[],resultCourses:[],resultClasses:[],resultSelectedItem:-1}),this.props.showMobileSearch&&this.props.toggleMobileSearch()},this.handleQuerySearch=e=>{const t=e.target.value.toLowerCase();this.setState({query:t}),t.length>=2&&(this.debounce&&this.debounce.cancel(),this.debounce=lodash_debounce_default()((()=>{this.getSuggestions(t),this.getSearchInfo(t),this.sendTinyBirdEvent("search")}),350),this.debounce())},this.getSuggestions=e=>{const t=encodeURIComponent((({searchTerm:e,index:t,limit:s})=>`\n    query SearchQuery {\n      searchAutocomplete(searchTerm: "${e}", index: ${t}, limit: ${s}) {\n        data\n        total\n      }\n    }\n  `)({searchTerm:e,index:"COURSE",limit:3}));R("search",{method:"get",requestURL:`/graphql?query=${t}`}).then((e=>{if(e.data.searchAutocomplete)return this.printResults({autocomplete:e.data.searchAutocomplete.data})})).catch((e=>{throw new Error({type:"::ERROR::FL-UI__NEW-SEARCH__GET-SUGGESTIONS",err:e})}))},this.getSearchInfo=e=>{const t=encodeURIComponent((({searchTerm:e,index:t,limit:s})=>`\n    query SearchQuery {\n      searchByTermStructured(searchTerm: "${e}", index: ${t}, limit: ${s}) {\n        data\n        total\n      }\n    }\n  `)({searchTerm:e,index:"ALL",limit:3}));R("search",{method:"get",requestURL:`/graphql?query=${t}`}).then((e=>{if(e.data.searchByTermStructured)return this.printResults({searchByTerm:e.data.searchByTermStructured.data})})).catch((e=>{throw new Error({type:"::ERROR::FL-UI__NEW-SEARCH__GET-SEARCH-INFO",err:e})}))},this.printResults=e=>{void 0!==e.autocomplete&&void 0!==e.searchByTerm&&this.setState({query:"",resultAutocomplete:[],resultCourses:[],resultClasses:[],resultSelectedItem:-1}),void 0!==e.autocomplete&&this.setState({resultAutocomplete:e.autocomplete,resultSelectedItem:-1}),void 0!==e.searchByTerm&&this.setState({resultCourses:e.searchByTerm.course?e.searchByTerm.course:[],resultClasses:e.searchByTerm.class?e.searchByTerm.class:[],resultSelectedItem:-1})},this.searchHasResults=()=>{const{resultAutocomplete:e,resultCourses:t,resultClasses:s}=this.state;return t.length>0||s.length>0||e.length>0},this.handleKeyUp=e=>{const t="ArrowUp",s="ArrowDown";window.addEventListener("keydown",(e=>{const{query:r}=this.state;this.searchHasResults()&&r.length>=2&&[t,s].includes(e.key)&&e.preventDefault()})),window.addEventListener("keyup",(e=>{const{query:t}=this.state;this.searchHasResults()&&t.length>=2&&this.selectResultsUsingKeyboard(e),"Escape"===e.key&&this.setState({resultAutocomplete:[],resultCourses:[],resultClasses:[],resultSelectedItem:-1})}))},this.selectResultsUsingKeyboard=e=>{if("ArrowUp"===e.key){const{resultSelectedItem:e}=this.state,t=document.querySelectorAll(".NewSearch-dropdown-item");if(0===e){const e=t.length-1;t[e].firstChild.focus(),this.setState({resultSelectedItem:e})}else{const s=e-1;t[s].firstChild.focus(),this.setState({resultSelectedItem:s})}}if("ArrowDown"===e.key){const{resultSelectedItem:e}=this.state,t=document.querySelectorAll(".NewSearch-dropdown-item");if(e===t.length-1){this.setState({resultSelectedItem:0});t[0].firstChild.focus()}else{const s=e+1;t[s].firstChild.focus(),this.setState({resultSelectedItem:s})}}},this.handleBlur=e=>{e.preventDefault();const t=e.relatedTarget;var s,r;t?null!=t&&null!==(s=t.classList)&&void 0!==s&&s.contains("NewSearch")||null!=t&&null!==(r=t.classList)&&void 0!==r&&r.contains("NewSearch-dropdown-link")||this.setState({resultAutocomplete:[],resultClasses:[],resultCourses:[]}):this.setState({resultAutocomplete:[],resultClasses:[],resultCourses:[]})},this.handleSubmit=async e=>{e.preventDefault();try{await this.sendTinyBirdEvent("enter_on_header"),window.location.href=`/buscar/?search=${this.state.query}`}catch(e){window.location.href=`/buscar/?search=${this.state.query}`}},this.handleShowAllResults=async e=>{e.preventDefault();try{await this.sendTinyBirdEvent("show_all_results_on_header"),window.location.href=`/buscar/?search=${this.state.query}`}catch(e){window.location.href=`/buscar/?search=${this.state.query}`}},this.sendTinyBirdEvent=async(e,{textValue:t=null,objectId:s=null}={})=>{const{userId:r=0,userType:a="accountless",userName:l=null,isLogged:o=!1}=this.props,{query:n}=this.state,c=index_7de6c45f.m.create({name:"search_staging"}),i=window.location.pathname;return c.send({user_id:r,user_type:a,username:l,url:i,type:e,event_location:"header",search_tab:null,text_value:t,query:n,active_inactive:o,object_id:s})},this.handleAutocomplete=async e=>{this.setState({query:e,resultAutocomplete:[],resultCourses:[],resultClasses:[],resultSelectedItem:-1});try{await this.sendTinyBirdEvent("click_on_suggestion",{textValue:e}),window.location.href=`/buscar/?search=${e}`}catch(t){window.location.href=`/buscar/?search=${e}`}},this.handleGoTo=async(e,t)=>{e.preventDefault();const s="class"===t.object_type?t.metadata.material_url:t.metadata.url,r=`click_on_${t.object_type}`;try{await this.sendTinyBirdEvent(r,{objectId:t.metadata.id}),window.location.href=s}catch(e){window.location.href=s}},this.debounce=null,this.state={componentMount:!0,query:"",resultAutocomplete:[],resultClasses:[],resultCourses:[],resultSelectedItem:-1}}componentDidMount(){this.handleKeyUp();const e=new URLSearchParams(window.location.search).get("search")||"";this.setState({componentMount:!1,query:e,resultAutocomplete:[],resultCourses:[],resultClasses:[]}),window.addEventListener("resize",(()=>{document.body.clientWidth>=constants/* SM_BREAKPOINT */.Zb&&(this.props.showMobileSearch&&this.props.toggleMobileSearch(),this.setState({componentMount:!1,query:e,resultAutocomplete:[],resultCourses:[],resultClasses:[]}))}))}render(){const{isLogged:t,toggleMobileSearch:s,showMobileSearch:a,t:i}=this.props,{query:u,resultAutocomplete:h,resultCourses:d,resultClasses:m,componentMount:p}=this.state,w=classnames_default()("NewSearch",{"NewSearch--active":a,"NewSearch--noLogged":!t}),S=classnames_default()("NewSearch-mobileBtn",{"NewSearch-mobileBtn--inactive":a}),y=classnames_default()("NewSearch-dropdown",{"NewSearch-dropdown--active":this.searchHasResults()&&u.length>0}),g=classnames_default()("NewSearch-box-container",{"NewSearch-box-container--active":a});return react.createElement("div",{className:w,tabIndex:1,onBlur:this.handleBlur},react.createElement("button",{type:"button",className:S,onClick:s},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faSearch/* faSearch */.wn})),react.createElement("form",{method:"GET",autoComplete:"off",onSubmit:this.handleSubmit,className:g},react.createElement("div",{className:"NewSearch-box"},react.createElement("button",{className:"NewSearch-button",type:"button",onClick:e=>this.handleSubmit(e)},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faSearch/* faSearch */.wn})),react.createElement("input",{type:"text",className:"NewSearch-input",placeholder:i("header.search.whatToLearn"),value:u,maxLength:"100",onChange:this.handleQuerySearch,name:"search"}),(u.length>=2||a)&&react.createElement("button",{type:"button",className:"NewSearch-input-clear",onClick:this.handleClearInput},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faTimes/* faTimes */.NB})))),react.createElement("ul",{className:y},h.map(((t,s)=>react.createElement("li",{className:"NewSearch-dropdown-item",key:s,id:`autocomplete-${s}`},react.createElement("button",{type:"button",className:"NewSearch-dropdown-link",onClick:()=>this.handleAutocomplete(t)},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faSearch/* faSearch */.wn}),react.createElement("div",null,t))))),react.createElement("hr",null),d.map(((t,s)=>react.createElement("li",{className:"NewSearch-dropdown-item",key:s,id:`result-${s}`},react.createElement("a",{onClick:e=>this.handleGoTo(e,t),href:t.metadata.url,className:"NewSearch-dropdown-link"},react.createElement("img",{src:t.metadata.badge,alt:`Badge de ${t.metadata.title}`}),react.createElement("div",null,t.metadata.title))))),react.createElement("hr",null),m.map(((t,s)=>react.createElement("li",{className:"NewSearch-dropdown-item",key:s,id:`result-resultClass-${s}`},react.createElement("a",{onClick:e=>this.handleGoTo(e,t),href:t.metadata.material_url,className:"NewSearch-dropdown-link"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faPlay/* faPlay */.zc}),react.createElement("div",null,t.metadata.name,react.createElement("p",null,t.metadata.course_title)))))),react.createElement("li",{className:"NewSearch-dropdown-all-results NewSearch-dropdown-item"},react.createElement("a",{onClick:this.handleShowAllResults,href:`/buscar/?search=${u}`,className:"NewSearch-dropdown-link"},react.createElement("img",{src:"data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%209%2010%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20d%3D%22M0%204.97703V0H1.12498V4.97703C1.12498%205.23086%201.22373%205.47428%201.39965%205.65388C1.57543%205.83334%201.81387%205.93415%202.06252%205.93415H7.08035L5.0177%203.82842L5.8128%203.01685L8.83546%206.10264C8.94075%206.21026%209%206.35621%209%206.50842C9%206.66064%208.94075%206.80659%208.83546%206.91421L5.8128%2010L5.01784%209.18829L7.08049%207.08256L2.06265%207.08269C1.51567%207.08269%200.991047%206.86077%200.604145%206.46593C0.217378%206.07095%200.000137329%205.53537%200.000137329%204.97696L0%204.97703Z%22%20fill%3D%22%23637A9D%22%2F%3E%3C%2Fsvg%3E"}),i("header.search.seeAllResults")))))}}NewSearch_db1704c6_m.propTypes={toggleMobileSearch:index_5808dc9d.p.exports.func.isRequired,showMobileSearch:index_5808dc9d.p.exports.bool.isRequired,isLogged:index_5808dc9d.p.exports.bool.isRequired,userId:index_5808dc9d.p.exports.number,userName:index_5808dc9d.p.exports.string,userType:index_5808dc9d.p.exports.string};var NewSearch_db1704c6_p=index_f0f30b4f_m.ReactTranslationsHOC(NewSearch_db1704c6_m);

// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/dayjs/plugin/isBetween.js
var isBetween = __webpack_require__(3938);
var isBetween_default = /*#__PURE__*/__webpack_require__.n(isBetween);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-solid-svg-icons/faInfoCircle.js
var faInfoCircle = __webpack_require__(2653);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faCheck.js
var faCheck = __webpack_require__(8149);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faSparkles.js
var pro_regular_svg_icons_faSparkles = __webpack_require__(128);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faMessageLines.js
var faMessageLines = __webpack_require__(5857);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-solid-svg-icons/faTag.js
var faTag = __webpack_require__(2580);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faArrowLeft.js
var faArrowLeft = __webpack_require__(837);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faCog.js
var faCog = __webpack_require__(7758);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faEllipsisV.js
var faEllipsisV = __webpack_require__(5654);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faEyeSlash.js
var faEyeSlash = __webpack_require__(228);
// EXTERNAL MODULE: ./node_modules/moment/locale/es.js
var moment_locale_es = __webpack_require__(5655);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faArrowRight.js
var pro_regular_svg_icons_faArrowRight = __webpack_require__(2305);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/dist/es/index-77f09d62.js
const index_77f09d62_a=a=>({type:"MARK_ALL_AS_READ",payload:a}),index_77f09d62_o=a=>({type:"UPDATE_USER_INFO",payload:a}),index_77f09d62_e=a=>({type:"SHOW_BILLING_MODAL",payload:a});var index_77f09d62_l={notificationsEnabled:a=>({type:"SET_NOTIFICATIONS_STATE",payload:a}),markAllAsRead:index_77f09d62_a,updateUserInfo:index_77f09d62_o,showBillingModal:index_77f09d62_e,setRegisterModalConfig:a=>({type:"SET_REGISTER_MODAL",payload:a})};

// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faTimesCircle.js
var faTimesCircle = __webpack_require__(465);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-regular-svg-icons/faInfoCircle.js
var pro_regular_svg_icons_faInfoCircle = __webpack_require__(8097);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/free-brands-svg-icons/faFacebook.js
var faFacebook = __webpack_require__(1855);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/free-brands-svg-icons/faGoogle.js
var faGoogle = __webpack_require__(3361);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/free-brands-svg-icons/faTwitter.js
var faTwitter = __webpack_require__(2443);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/pro-solid-svg-icons/faEnvelope.js
var faEnvelope = __webpack_require__(1560);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/free-solid-svg-icons/faHeart.js
var faHeart = __webpack_require__(5554);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/free-brands-svg-icons/faYoutube.js
var faYoutube = __webpack_require__(5567);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/free-brands-svg-icons/faFacebookF.js
var faFacebookF = __webpack_require__(8101);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@fortawesome/free-brands-svg-icons/faInstagram.js
var faInstagram = __webpack_require__(4087);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/dist/es/AccountFooter-a9001bf4.js
class AccountFooter_a9001bf4_l extends react.Component{constructor(...e){return super(...e),this.state={value:this.props.value||this.props.defaultValue||""},this.handleContent=e=>{this.props.handleContent?this.props.handleContent(e.target.value,e.target.name):this.setState({value:e.target.value})},this.onBlurInput=(e,t)=>{this.props.error?e.target.placeholder="":e.target.placeholder=t,this.props.onBlur&&this.props.onBlur(e)},this.getFieldClass=()=>classnames_default()("FormInput-field",{error:this.props.error,filled:this.state.value||this.props.value,isTextArea:this.props.isTextArea,isUrl:"url"===this.props.type,isDate:"date"===this.props.type}),this}render(){const t=this.getFieldClass(),{t:r}=this.props;return react.createElement("div",{className:`FormInput ${this.props.className}`},this.props.isTextArea?react.createElement("textarea",{maxLength:"140",id:this.props.id,name:this.props.name,type:this.props.type,required:this.props.required,ref:this.props.inputRef,autoComplete:this.props.autoComplete,placeholder:this.props.error?"":r(this.props.formattedMessageId),className:t,onFocus:e=>e.target.placeholder="",onBlur:e=>this.props.error?e.target.placeholder="":e.target.placeholder=r(this.props.formattedMessageId),onChange:this.handleContent}):react.createElement("input",{id:this.props.id,name:this.props.name,type:this.props.type,required:this.props.required,ref:this.props.inputRef,autoComplete:"off",placeholder:this.props.error?"":r(this.props.formattedMessageId),className:t,onFocus:e=>e.target.placeholder="",onBlur:e=>this.onBlurInput(e,r(this.props.formattedMessageId)),onChange:this.handleContent,value:this.props.handleContent?this.props.value:this.state.value}),react.createElement("label",{htmlFor:this.props.id,className:"FormInput-label"},r(this.props.formattedMessageId)),this.props.children,react.createElement("p",{className:"FormInput-error"},this.props.error))}}AccountFooter_a9001bf4_l.propTypes={className:index_5808dc9d.p.exports.string,type:index_5808dc9d.p.exports.string,required:index_5808dc9d.p.exports.bool,formattedMessageId:index_5808dc9d.p.exports.string,defaultMessage:index_5808dc9d.p.exports.string,error:index_5808dc9d.p.exports.node,handleContent:index_5808dc9d.p.exports.func,value:index_5808dc9d.p.exports.string,onBlur:index_5808dc9d.p.exports.func,autoComplete:index_5808dc9d.p.exports.string,defaultValue:index_5808dc9d.p.exports.string},AccountFooter_a9001bf4_l.defaultProps={className:"",type:"text",required:!1,placeholder:"",error:"",autoComplete:"off"};var AccountFooter_a9001bf4_c=index_f0f30b4f_m.ReactTranslationsHOC(AccountFooter_a9001bf4_l);const AccountFooter_a9001bf4_m=({isLogin:t,next:r})=>{const{t:o}=(0,useTranslation/* useTranslation */.$)(),s=r.length>0?`?next=${r}`:"";return react.createElement("div",{className:"LoginSocial"},react.createElement("div",{className:"LoginSocial-facebook"},react.createElement("a",{href:`/login/facebook/${s}`,className:"btn-fcbk btn--big btn--responsive"},react.createElement(index_es/* FontAwesomeIcon */.G,{className:"icon--line",icon:faFacebookF/* faFacebookF */.AY}),o(t?"LoginSocial-facebook-login":"LoginSocial-facebook-register"))),react.createElement("div",{className:"LoginSocial-twitter"},react.createElement("a",{href:`/login/twitter/${s}`,className:"btn-twt btn--big btn--responsive "},react.createElement(index_es/* FontAwesomeIcon */.G,{className:"icon--line",icon:faTwitter/* faTwitter */.md}),o(t?"LoginSocial-twitter-login":"LoginSocial-twitter-register"))))};AccountFooter_a9001bf4_m.propTypes={next:index_5808dc9d.p.exports.string,isLogin:index_5808dc9d.p.exports.bool};const AccountFooter_a9001bf4_h=()=>{const{t:t}=a();return e.createElement("div",{className:"LoginDivider"},e.createElement("span",{className:"LoginDivider-text"},t("login_or")))},AccountFooter_a9001bf4_u=({signup:t,handleAccount:r,isLogin:o,next:s})=>{const{t:n}=(0,useTranslation/* useTranslation */.$)(),i=o?t:"/login/",p=s.length>0?`${i}?next=${s}`:`${i}`;return react.createElement("div",{className:"AccountFooter"},react.createElement("div",{className:"AccountFooter-create"},n(o?"AccountFooter-title-register":"AccountFooter-title-login")),react.createElement("div",{className:"AccountFooter-link"},r?react.createElement("a",{onClick:r,className:"AccountFooter-btn"},n(o?"AccountFooter-register":"AccountFooter-login")):react.createElement("a",{href:p,className:"AccountFooter-btn"},n(o?"AccountFooter-register":"AccountFooter-login"))))};AccountFooter_a9001bf4_u.propTypes={signup:index_5808dc9d.p.exports.string,handleAccount:index_5808dc9d.p.exports.func,isLogin:index_5808dc9d.p.exports.bool,next:index_5808dc9d.p.exports.string};

;// CONCATENATED MODULE: ./node_modules/@platzi/ui/dist/es/ModalPortal-040aa0eb.js
var rt=function(t){var a=t.show,s=t.close,n=t.showFromBottom,r=t.children,o=classnames_default()("Modal-wrapper",{showModal:a},{"Modal-wrapper--bottom":n});return react.createElement("div",{className:"Modal"},a?react.createElement("div",{className:"Modal-overlay",role:"button",tabIndex:0,onClick:s,onKeyPress:function(e){"Escape"===e.key&&s()}}):null,react.createElement("div",{className:o},r))};rt.defaultProps={showFromBottom:!1};const ot=t=>{const{isOpen:a,isDisabledCloseBtn:s,handleClose:n,headerIcon:r,title:o,actionsConfig:l,children:i,subtitle:c}=t,g=l&&0===Object.keys(l).length;return a&&i?react.createElement("div",{className:"ModalDark",role:"dialog","aria-labelledby":o,tabIndex:"-1"},react.createElement("button",{className:"ModalDark-backdrop",onClick:n}),react.createElement("section",{className:"ModalDark-container"},!s&&react.createElement("button",{type:"button",onClick:n,className:"ModalDark-closeBtn","aria-label":"Close Modal"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faTimes/* faTimes */.NB})),(r||o)&&react.createElement("header",{className:"ModalDark-header"},r&&react.createElement("span",{className:"ModalDark-headerIcon"},r),react.createElement("h2",{className:"ModalDark-title",id:o},o),c&&react.createElement("span",{className:"ModalDark-subtitle"},c)),react.createElement("div",{className:"ModalDark-content"},i),l&&!g&&react.createElement("footer",{className:"ModalDark-actions"},l.error&&react.createElement("p",{className:"ModalDark-error"},l.error),l.btnTextSubmit&&react.createElement(Button_4cf71a18.B,{type:"submit",onClick:l.handleSubmit,color:l.btnColors,hierarchy:"primary",disabled:l.validations},l.loading&&react.createElement(index_2fbf0eeb.L,null),l.btnTextSubmit),l.btnTextCancel&&react.createElement(Button_4cf71a18.B,{type:"button",onClick:l.handleCancel,color:l.btnColors,hierarchy:"tertiary"},l.btnTextCancel)))):null};ot.propTypes={isOpen:index_5808dc9d.p.exports.bool.isRequired,isDisabledCloseBtn:index_5808dc9d.p.exports.bool,handleClose:index_5808dc9d.p.exports.func.isRequired,headerIcon:index_5808dc9d.p.exports.object,title:index_5808dc9d.p.exports.string,subtitle:index_5808dc9d.p.exports.string,actionsConfig:index_5808dc9d.p.exports.shape({handleSubmit:index_5808dc9d.p.exports.func,handleCancel:index_5808dc9d.p.exports.func,btnColors:index_5808dc9d.p.exports.oneOf(["platzi","sky","admin","danger"]),btnTextSubmit:index_5808dc9d.p.exports.string,validations:index_5808dc9d.p.exports.bool,error:index_5808dc9d.p.exports.string,btnTextCancel:index_5808dc9d.p.exports.string,loading:index_5808dc9d.p.exports.bool}),children:index_5808dc9d.p.exports.node},ot.defaultProps={isOpen:!1,isDisabledCloseBtn:!1,handleClose:()=>{},headerIcon:null,title:"",subtitle:"",actionsConfig:null,children:"",loading:!1};var lt=function(t){var a=t.className,s=t.children,n="".concat(a," ModalHead");return react.createElement("div",{className:n},s)};lt.defaultProps={className:""};const it={ERROR:"error",WARNING:"warning"},ct={RADIANCE:"radiance",DEFAULT:"default"},mt={type:index_5808dc9d.p.exports.oneOf(Object.values(it)).isRequired,title:index_5808dc9d.p.exports.string.isRequired,subtitle:index_5808dc9d.p.exports.string.isRequired,icon:index_5808dc9d.p.exports.object,children:index_5808dc9d.p.exports.node.isRequired,theme:index_5808dc9d.p.exports.oneOf(Object.values(ct)),onClose:index_5808dc9d.p.exports.func},pt=t=>{const a=classnames_default()("FloatNotification",{[`FloatNotification--${t.theme}`]:Boolean(t.theme),"is-error":t.type===it.ERROR,"is-warning":t.type===it.WARNING});return react.createElement("div",{className:a},t.onClose&&react.createElement("button",{className:"FloatNotification-close",onClick:t.onClose,"aria-label":"Close"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faTimes/* faTimes */.NB})),react.createElement("div",{className:"FloatNotification-icon"},react.createElement("div",{className:"FloatNotification-icon-container"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:t.icon||faExclamationTriangle/* faExclamationTriangle */.eH}))),react.createElement("div",{className:"FloatNotification-content"},react.createElement("p",{className:"FloatNotification-content-title"},t.title),react.createElement("p",{className:"FloatNotification-content-subtitle"},t.subtitle),react.createElement("div",{className:"FloatNotification-content-actions"},t.children)))};pt.propTypes=mt;const dt={updateCTA:index_5808dc9d.p.exports.string.isRequired,updateAction:index_5808dc9d.p.exports.func.isRequired,contactCTA:index_5808dc9d.p.exports.string,contactAction:index_5808dc9d.p.exports.func},ut=t=>{const{updateCTA:a,updateAction:s,contactCTA:n,contactAction:r,theme:o}=t,l=o===ct.RADIANCE;return react.createElement(pt,t,react.createElement(Button_4cf71a18.B,{customClass:"PastDueNotification-updateBut",color:l?null:"danger",hierarchy:l?"secondary":"primary",onClick:s},a),r&&n&&react.createElement(Button_4cf71a18.B,{customClass:"PastDueNotification-contactBut",color:"danger",onClick:r,hierarchy:"secondary"},n))};ut.propTypes=dt;const gt=({id:e,idSection:a,handleFetchData:s,children:n})=>((0,react.useEffect)((()=>{s(e,a)}),[]),n);gt.propTypes={children:index_5808dc9d.p.exports.node.isRequired,id:index_5808dc9d.p.exports.string.isRequired,idSection:index_5808dc9d.p.exports.string.isRequired,handleFetchData:index_5808dc9d.p.exports.func};const Ct=s=>{const[n,r]=(0,react.useState)(!1),{width:o}=(0,useRegisterModal_23dbb00b.a)(),{idSection:l,tabs:i,handleFetchData:c,numberOfElements:m}=s;(0,react.useEffect)((()=>{r(o<constants/* SM_BREAKPOINT */.Zb)}),[o]);return react.createElement(TabSection_9807b9f3.S,{customClass:"Tabs"},i.map((({id:t,title:a,shouldShow:s,childrens:n})=>react.createElement(TabSection_9807b9f3.T,{key:t,title:a,shouldShow:s},react.createElement(gt,{id:t,handleFetchData:c,idSection:l},(t=>react.createElement(Carousel_7034b698.C,{numberOfElements:m,elements:t,customSizeItems:!0}))(n))))))};Ct.propTypes={idSection:index_5808dc9d.p.exports.string,tabs:index_5808dc9d.p.exports.array,handleFetchData:index_5808dc9d.p.exports.func,numberOfElements:index_5808dc9d.p.exports.shape({xs:index_5808dc9d.p.exports.number,sm:index_5808dc9d.p.exports.number,md:index_5808dc9d.p.exports.number,lg:index_5808dc9d.p.exports.number})};const Et=t=>{const{title:a,handleFetchData:s,id:n,link:{text:r,url:o},tabs:l,numberOfElements:i,linkBottomResponsive:c}=t,p={tabs:l,idSection:n,handleFetchData:s,numberOfElements:i};return react.createElement("section",{className:"CarouselTabs",id:n},react.createElement("div",{className:"CarouselTabs-head"},react.createElement("h2",{className:"CarouselTabs-title"},a),o?react.createElement("a",{className:"CarouselTabs-action",href:o},react.createElement("span",{className:"isWeb"},r),!c&&react.createElement(index_es/* FontAwesomeIcon */.G,{icon:pro_regular_svg_icons_faArrowRight/* faArrowRight */.eF})):react.createElement("div",{className:"CarouselTabs-action"},react.createElement("span",{className:"isWeb"},r))),react.createElement("div",{className:"CarouselTabs-tabs"},react.createElement(Ct,p)),c&&react.createElement("a",{href:o,className:"buttonLink isResponsive"},react.createElement(Button_4cf71a18.B,{size:"small"},r)))};Et.propTypes={title:index_5808dc9d.p.exports.string,handleFetchData:index_5808dc9d.p.exports.func,link:index_5808dc9d.p.exports.shape({text:index_5808dc9d.p.exports.any,url:index_5808dc9d.p.exports.string}),linkBottomResponsive:index_5808dc9d.p.exports.bool,tabs:index_5808dc9d.p.exports.array,numberOfElements:index_5808dc9d.p.exports.shape({xs:index_5808dc9d.p.exports.number,sm:index_5808dc9d.p.exports.number,md:index_5808dc9d.p.exports.number,lg:index_5808dc9d.p.exports.number})},Et.defaultProps={title:"",handleFetchData:()=>{},link:{text:"",url:""},tabs:[],linkBottomResponsive:!1,numberOfElements:{xs:1,sm:1,md:3,lg:4}};const ft={date:index_5808dc9d.p.exports.string,ended:index_5808dc9d.p.exports.func,image:index_5808dc9d.p.exports.string,customClass:index_5808dc9d.p.exports.string,isMobile:index_5808dc9d.p.exports.bool,messages:index_5808dc9d.p.exports.shape({title:index_5808dc9d.p.exports.shape({key:index_5808dc9d.p.exports.string,value:index_5808dc9d.p.exports.string}),days:index_5808dc9d.p.exports.func,hours:index_5808dc9d.p.exports.func,minutes:index_5808dc9d.p.exports.func,seconds:index_5808dc9d.p.exports.func})},ht=t=>{const{ended:a,date:s,image:n,isMobile:r,messages:o,customClass:l}=t,{title:c,days:m,hours:p,minutes:d,seconds:u}=o;if(!s)return null;const g=(t,a)=>react.createElement("div",{className:"CountDown-element-single"},react.createElement("strong",null,String(t).padStart(2,"0")),react.createElement("p",{"data-trans":r?a("short").key:a("long").key},r?a("short").value:a("long").value));return react.createElement("div",{className:`CountDown ${l}`},c&&react.createElement("p",{className:"CountDown-title","data-trans":c.key},c.value),react.createElement(dist_index_es,{className:"CountDown-element",date:new Date(s),onComplete:()=>{a&&a(),window.location.reload()},renderer:t=>{const a=0===t.days,s=classnames_default()("CountDown-element-wrapper",{"CountDown-element-wrapper--isDayZero":a}),r={backgroundImage:`url('${n}')`};return react.createElement("div",{className:s,style:n?r:{}},!a&&g(t.days,m),g(t.hours,p),g(t.minutes,d),g(t.seconds,u))}}))};function xt(t){return react.createElement("div",{className:"LiveMainHeader","data-testid":"live-logo"},react.createElement("div",{className:"LiveMainHeader-logo"},"LIVE"),react.createElement("div",{className:"LiveMainHeader-title"},t.title),react.createElement("a",{href:t.url,className:"LiveMainHeader-link"}))}ht.propTypes=ft,ht.defaultProps={date:"",ended:()=>{},isMobile:!1};const vt=()=>{const{t:t}=(0,useTranslation/* useTranslation */.$)();return react.createElement("div",{className:"Logoutv"},react.createElement("a",{href:"/logout/",onClick:()=>{window.localStorage.removeItem("credentials_token"),window.localStorage.removeItem("credentials_microservicesUrl"),window.localStorage.removeItem("credentials_headers")}},t("logout")))},bt=()=>react.createElement("svg",{viewBox:"0 0 29 32",fill:"none",xmlns:"http://www.w3.org/2000/svg"},react.createElement("path",{"fill-rule":"evenodd","clip-rule":"evenodd",d:"M12.3231 1.49486L1.49486 12.3231C-0.498044 14.3165 -0.498044 17.5479 1.49486 19.5413L12.3231 30.3695C14.3165 32.3624 17.5479 32.3624 19.5413 30.3695L23.1512 26.7596L19.5413 23.1512L15.9314 26.7596L5.11239 15.9314L15.9391 5.11239L23.1589 12.3307L15.9391 19.549L19.549 23.1589L26.7672 15.9391C28.7602 13.9456 28.7602 10.7142 26.7672 8.72077L19.5413 1.49486C17.5479 -0.498044 14.3165 -0.498044 12.3231 1.49486Z"})),yt=t=>{let a;switch(t){case"icon-suitecase_B":a=faSuitcase/* faSuitcase */.qb;break;case"icon-cloud":a=faCommentAlt/* faCommentAlt */.Eg;break;case"icon-gift_A":a=faGift/* faGift */.Cl;break;case"icon-cloud-smile":a=faCommentAltSmile/* faCommentAltSmile */.Pj}return a?react.createElement(index_es/* FontAwesomeIcon */.G,{icon:a}):null},Nt=t=>{const a=t.directMessages>0,s=t.notifications>0;return react.createElement("div",{className:"LoggedMenu"},react.createElement("div",{className:"LoggedMenu-content"},react.createElement("ul",null,t.loggedMenu.map(((n,r)=>"contact"!==n.type?react.createElement("li",{key:`LoggedMenu-${r}`},react.createElement("a",{href:n.url},"icon-platzi"===n.icon?react.createElement(bt,null):yt(n.icon),n.name,"direct_messages"===n.type&&a?react.createElement("span",{className:"LoggedMenu-badge"},t.directMessages):null,"notifications"===n.type&&s?react.createElement("span",{className:"LoggedMenu-badge"},t.notifications):null)):react.createElement("li",{key:`LoggedMenu-${r}`},react.createElement("div",{onClick:t.handleContact,role:"button",tabIndex:"0",onKeyPress:e=>{"Enter"===e.key&&t.handleContact()}},"icon-platzi"===n.icon?react.createElement(bt,null):yt(n.icon),n.name)))))))};Nt.propTypes={loggedMenu:index_5808dc9d.p.exports.array,notifications:index_5808dc9d.p.exports.string,directMessages:index_5808dc9d.p.exports.string,handleActions:index_5808dc9d.p.exports.func};class kt extends react.Component{constructor(...e){return super(...e),this.state={days:null},this.componentDidMount=()=>{if(this.props.subscriptionTime){const e=moment_default()().format(),t=moment_default()(this.props.subscriptionTime).format(),a=moment_default().duration(moment_default()(t).diff(e)),s=Math.round(a.asDays());this.setState({days:s})}},this}render(){var t;const{t:a}=this.props;return react.createElement("div",{className:"Usernamev"},react.createElement("div",{className:"Usernamev-content"},react.createElement("div",{className:"Usernamev-title"},react.createElement("span",null,a("username",{user_name:this.props.name}))),react.createElement("div",{className:"Usernamev-plan"},react.createElement("span",null,a(this.props.plan)),null!==this.state.days&&this.state.days>=0&&react.createElement("span",null,1===this.state.days&&a("subscriptionTimeSingular",{subscription_time:this.state.days}),1!==this.state.days&&a("subscriptionTimePlural",{subscription_time:this.state.days}))),Object.keys(null===(t=this.props)||void 0===t?void 0:t.basicUpgrade).length>0&&react.createElement("a",{className:"Usernamev-banner",href:`${this.props.basicUpgrade.urlPromo}?utm_source=header_banner_upgradeBasic_${this.props.userId}`},react.createElement("figure",{className:"Usernamev-banner-image"},react.createElement(Image_4b46b89d.I,{src:"https://static.platzi.com/media/uploads/banner_header_cta_03f8c4b096.png",alt:a("header_actions_banner_alt"),dataTrans:"header_actions_banner_alt",customClass:"asd"})),react.createElement("div",{className:"Usernamev-banner-message","data-trans":"header_actions_banner_message"},react.createElement("p",{"data-trans":"header_actions_banner_message"},a("header_actions_banner_message")))),react.createElement("div",{className:"Usernamev-profile"},react.createElement("a",{href:this.props.profileUrl},react.createElement("span",{"data-trans":"view_profile"},a("view_profile"))))))}}kt.propTypes={avatar:index_5808dc9d.p.exports.string,name:index_5808dc9d.p.exports.string,points:index_5808dc9d.p.exports.object,plan:index_5808dc9d.p.exports.string,subscriptionTime:index_5808dc9d.p.exports.string,locale:index_5808dc9d.p.exports.string,profileUrl:index_5808dc9d.p.exports.string,basicUpgrade:index_5808dc9d.p.exports.object,userId:index_5808dc9d.p.exports.number.isRequired},kt.defaultProps={basicUpgrade:{}};var Dt=index_f0f30b4f_m.ReactTranslationsHOC(kt);const wt=t=>{const a=()=>{ga("platziFull.send","event","Test_header","Click","Continue Watching")},s=t.course[0].approved?100:Math.ceil(70*parseInt(t.course[0].completed,10)/100),n=t.course[0].approved?"100%":`${t.course[0].completed}%`,r=classnames_default()({"LastCourse-progressExam":!t.course[0].approved,"LastCourse-progressExam-approved":t.course[0].approved}),{t:o}=(0,useTranslation/* useTranslation */.$)();return react.createElement("div",null,t.course.map((t=>react.createElement("div",{className:"LastCourse",key:t.id},t.id&&react.createElement("div",null,react.createElement("div",{className:"LastCourse-content"},react.createElement("a",{href:t.url,onClick:a,className:"LastCourse-anchor"},react.createElement("div",{className:"LastCourse-continue"},o("continue_watching")),react.createElement("div",{className:"LastCourse-box"},react.createElement("figure",{className:"LastCourse-badge"},react.createElement("img",{loading:"lazy",src:t.badge,alt:t.title})),react.createElement("div",{className:"LastCourse-info"},react.createElement("span",{className:"LastCourse-title"},t.title),react.createElement("span",{className:"LastCourse-percentage"},s,"%"),react.createElement("div",{className:"LastCourse-percentageBar"},react.createElement("div",{className:"LastCourse-percentageFull",style:{width:`${n}`}}),react.createElement("div",{className:r})))))),react.createElement("div",{className:"LastCourse-allCourses"},react.createElement("a",{href:"/home/"},o("all_courses"))))))))};wt.propTypes={course:index_5808dc9d.p.exports.array};const Bt=t=>{const{t:a}=(0,useTranslation/* useTranslation */.$)(),s=t.notifications,n=t.directMessages,r=t.points,o=classnames_default()({"toggle-down":!t.actionsOpen,"toggle-up":t.actionsOpen});return react.createElement("div",null,react.createElement("div",null,react.createElement("div",{className:"Actionsv2-menu-logged",onClick:()=>{t.handleOpen("actionsOpen")},role:"button",tabIndex:"0",onKeyPress:e=>{t.actionsOpen&&"Escape"===e.key&&t.handleOpen("actionsOpen"),t.actionsOpen||"Enter"!==e.key||t.handleOpen("actionsOpen")}},react.createElement("img",{loading:"lazy",className:"Actionsv2-avatar",src:t.avatar,alt:t.name}),react.createElement(index_es/* FontAwesomeIcon */.G,{className:o,icon:faChevronDown/* faChevronDown */.pt}),react.createElement("span",null,a("user_points",{points:r})),(n>0||s>0)&&react.createElement("div",{className:"Actionsv2-alert"})),t.actionsOpen&&"unlogged"!==t.role&&react.createElement("div",{className:"Actionsv2-content isOpenActions"},react.createElement("div",{className:"triangle"}),react.createElement("div",{className:"box"},react.createElement(wt,{course:t.lastCourse.toJS()}),react.createElement(Dt,{name:t.name,plan:t.plan,subscriptionTime:t.subscriptionTime,profileUrl:t.profileUrl,locale:t.locale,basicUpgrade:t.basicUpgrade,userId:t.userId}),react.createElement(Nt,(0,_rollupPluginBabelHelpers_1fef267c._)({},t,{directMessages:n,notifications:s,handleContact:t.handleContact})),react.createElement(vt,null))),t.actionsOpen&&"unlogged"===t.role&&react.createElement("div",{className:"Actionsv2-content isOpenActions"},react.createElement("div",{className:"triangle"}),react.createElement("div",{className:"box"},react.createElement("br",null),react.createElement("br",null),react.createElement(index_2fbf0eeb.L,null),react.createElement("br",null),react.createElement("br",null)))))};Bt.propTypes={avatar:index_5808dc9d.p.exports.string,name:index_5808dc9d.p.exports.string,points:index_5808dc9d.p.exports.node,plan:index_5808dc9d.p.exports.string,subscriptionTime:index_5808dc9d.p.exports.string,profileUrl:index_5808dc9d.p.exports.string,lastCourse:index_5808dc9d.p.exports.node,notifications:index_5808dc9d.p.exports.string,directMessages:index_5808dc9d.p.exports.string,visible:index_5808dc9d.p.exports.bool,isOpen:index_5808dc9d.p.exports.bool,handleActions:index_5808dc9d.p.exports.func,role:index_5808dc9d.p.exports.string,basicUpgrade:index_5808dc9d.p.exports.object};var Ft=(0,es/* connect */.$j)((function(e){return{avatar:e.get("header").get("userInfo").get("avatar"),name:e.get("header").get("userInfo").get("name"),role:e.get("header").get("userInfo").get("role"),points:e.get("header").get("userInfo").get("points"),plan:e.get("header").get("userInfo").get("plan"),subscriptionTime:e.get("header").get("userInfo").get("subscription_time"),profileUrl:e.get("header").get("userInfo").get("profileUrl"),lastCourse:e.get("header").get("userInfo").get("lastCourse")}}))(Bt);const St=t=>{const{t:a}=(0,useTranslation/* useTranslation */.$)();return react.createElement("div",{className:"Actionsv2"},t.isLogged?react.createElement(Ft,(0,_rollupPluginBabelHelpers_1fef267c._)({},t,{handleOpen:t.handleOpen,actionsOpen:t.actionsOpen,handleContact:t.handleContact})):react.createElement("a",{className:"Actionsv2-enterprise",href:"/empresas/"},a("Activations.enterprise.cta")))};St.propTypes={isOpenActions:index_5808dc9d.p.exports.bool,enableSubscription:index_5808dc9d.p.exports.bool,isLogged:index_5808dc9d.p.exports.bool,notifications:index_5808dc9d.p.exports.string,directMessages:index_5808dc9d.p.exports.string,visible:index_5808dc9d.p.exports.bool,handleActions:index_5808dc9d.p.exports.func};const _t=()=>{var e;const s=null===(e=(0,es/* useSelector */.v9)((e=>{var t;return null==e||null===(t=e.get("header"))||void 0===t?void 0:t.get("userInfo")})))||void 0===e?void 0:e.toJS(),n=(0,es/* useSelector */.v9)((e=>{var t;return null==e||null===(t=e.get("header"))||void 0===t?void 0:t.get("country_name")})),[r,o]=(0,react.useState)({client_id:"",transaction_id:"",email:s.email,name:s.name,user_type:s.userType,uuid:s.userId,place:"",country:n});(0,react.useEffect)((()=>{o({...r,email:s.email,name:s.name,user_type:s.userType,uuid:s.userId,place:location.href})}),[s.userId]);return{tinyBirdClick:({page:e,object_id:t})=>{const a=index_7de6c45f.m.create({name:"click"});a.addPlugin(index_7de6c45f.m.SessionStudentPlugin),a.send({...r,page:e,object_id:t})}}},Mt=({displayMenu:t,toogleMenu:a,nameItem:s})=>{const{t:n}=(0,useTranslation/* useTranslation */.$)(),r=!s,o=classnames_default()("ExploreButton",r?"ExploreButton--explore":"ExploreButton--item");return react.createElement("button",{type:"button",onClick:()=>a(),className:o,"data-testid":"ctaDropdown","data-trans":r?"header_explore_exploreButton":null},r?n("header_explore_exploreButton"):s,react.createElement(index_es/* FontAwesomeIcon */.G,{icon:"none"===t?free_solid_svg_icons_faChevronDown/* faChevronDown */.pt:faChevronUp/* faChevronUp */.mT}))};Mt.propTypes={displayMenu:index_5808dc9d.p.exports.oneOf(["none","block"]),toogleMenu:index_5808dc9d.p.exports.func.isRequired,nameItem:index_5808dc9d.p.exports.string},Mt.defaultProps={displayMenu:"none"};const Tt={5:{icon:faCode/* faCode */.dT,background:"school_graphic_development_3d3b4073cf.png"},6:{icon:faPenNib/* faPenNib */.Qz,background:"school_graphic_design_ba39a0c9e2.png"},7:{icon:faMegaphone/* faMegaphone */.Au,background:"school_graphic_marketing_6098510d4e.png"},11:{icon:faSeedling/* faSeedling */.YK,background:"school_graphic_soft_351e5c0f90.png"},8:{icon:faChartLine/* faChartLine */.St,background:"school_graphic_business_fa22370a52.png"},10:{icon:faVideo/* faVideo */.Iy,background:"school_graphic_digital_content_340586f6c7.png"},16:{icon:faRocket/* faRocket */.tM,background:"school_graphic_startups_225d812cd7.png"},17:{icon:faGlobe/* faGlobe */.g4,background:"school_graphic_english_b477187ffa.png"}},At=t=>{var a,s;return react.createElement("section",{className:"itemsDropdown"},react.createElement("ul",null,null==t||null===(a=t.item)||void 0===a||null===(s=a.items)||void 0===s?void 0:s.map((t=>react.createElement("li",{"data-testid":"itemDropdown",key:`itemDropdown_${null==t?void 0:t.name}`,onClick:()=>{return e=null==t?void 0:t.url,window.location.href=e;var e}},(null==t?void 0:t.icon)&&react.createElement("figure",null,react.createElement(Image_4b46b89d.I,{src:t.icon,alt:null==t?void 0:t.name})),null==t?void 0:t.name)))))};At.propTypes={item:index_5808dc9d.p.exports.shape({name:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string,items:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({icon:index_5808dc9d.p.exports.string,name:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string}))})};const Lt=({displayMenu:a,toogleMenu:s,tinyBirdClick:r,item:o})=>{const l=(0,es/* useSelector */.v9)((e=>e.get("explore"))).toJS()||null,i=(0,react.useRef)(null),{t:c}=(0,useTranslation/* useTranslation */.$)(),p=!o,d=e=>`https://static.platzi.com/media/uploads/${e}`;(0,react.useEffect)((()=>{var e;"block"===a&&(null==i||null===(e=i.current)||void 0===e||e.focus())}),[a]),(0,react.useEffect)((()=>{const e=document.querySelectorAll(".linksTinyBird");return null==e||e.forEach((e=>{e.addEventListener("auxclick",(function(t){1==t.button&&r({page:e.dataset.page,object_id:parseInt(e.dataset.id,10)})}))})),e.forEach((e=>e.removeEventListener("auxclick",(()=>{}))))}),[]);const u=(e,t)=>()=>{r({page:e,object_id:t})};return react.createElement("section",{className:"ExploreMenu",style:{display:a}},react.createElement("div",{className:"ExploreMenu-content",tabIndex:1,ref:i,onBlur:e=>{e.preventDefault();e.relatedTarget||s()}},p?react.createElement("div",{className:"ExploreMenu-categories"},react.createElement("p",{className:"ExploreMenu-title","data-trans":"header_explore_exploreMenu_category"},c("header_explore_exploreMenu_category")),react.createElement("ul",null,l.categories.map((t=>react.createElement("li",{key:`category-${t.id}`,"data-testid":"category-item"},react.createElement("span",null,react.createElement(index_es/* FontAwesomeIcon */.G,{icon:Tt[t.id].icon,style:{color:t.color}}),t.name,react.createElement(index_es/* FontAwesomeIcon */.G,{className:"ExploreMenu-hover",icon:faChevronRight/* faChevronRight */._t})),react.createElement("div",{className:"ExploreMenu-schools",style:{backgroundImage:`url(${d(Tt[t.id].background)})`}},react.createElement("p",{className:"ExploreMenu-title","data-trans":"header_explore_exploreMenu_schools"},c("header_explore_exploreMenu_schools")," ",react.createElement("b",null,t.schools_count)),react.createElement("ul",null,t.schools.map((t=>react.createElement("li",{key:`school-${t.id}`,"data-testid":"school-item"},react.createElement("a",{href:t.url,className:"linksTinyBird","data-id":t.id,"data-page":"explorer_desktop_school",onClick:u("explorer_desktop_school",t.id)},t.name," ",react.createElement(index_es/* FontAwesomeIcon */.G,{className:"ExploreMenu-hover",icon:faChevronRight/* faChevronRight */._t})),react.createElement("div",{className:"ExploreMenu-routes"},react.createElement("p",{className:"ExploreMenu-title","data-trans":"header_explore_exploreMenu_routes"},c("header_explore_exploreMenu_routes")," ",react.createElement("b",null,t.learning_paths_count)),react.createElement("ul",null,t.learning_paths.map(((t,a)=>react.createElement("li",{key:`route-${a}`,"data-testid":"route-item"},react.createElement("a",{href:l.learning_paths[t].url,className:"linksTinyBird","data-id":t,"data-page":"explorer_desktop_route",onClick:u("explorer_desktop_route",t)},react.createElement("div",null,l.learning_paths[t].name,l.learning_paths[t].is_professional&&react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faBadgeCheck/* faBadgeCheck */.fi})),l.learning_paths[t].is_new&&react.createElement("div",{className:"ExploreMenu-newRoute","data-trans":"header_explore_exploreMenu_new"},c("header_explore_exploreMenu_new")))))))))))))))),react.createElement("li",null,react.createElement("a",{href:"/cursos/","data-trans":"header_explore_exploreMenu_seeAll"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faList/* faList */.Zr})," ",c("header_explore_exploreMenu_seeAll"))))):react.createElement(react.Fragment,null,react.createElement(At,{item:o}))))};Lt.propTypes={displayMenu:index_5808dc9d.p.exports.oneOf(["none","block"]),toogleMenu:index_5808dc9d.p.exports.func.isRequired,tinyBirdClick:index_5808dc9d.p.exports.func,item:index_5808dc9d.p.exports.shape({name:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string,items:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({icon:index_5808dc9d.p.exports.string,name:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string}))})},Lt.defaultProps={displayMenu:"none",tinyBirdClick:()=>{},item:null};const Pt=t=>{var s;const n=(0,es/* useSelector */.v9)((e=>{var t;return null===(t=e.get("explore"))||void 0===t?void 0:t.get("categories")}))||null,r=(0,es/* useSelector */.v9)((e=>e.get("header").get("locale")))||"es-CO",[o,l]=(0,react.useState)("none"),{tinyBirdClick:i}=_t(),c=r===constants/* LOCALES.PORTUGUESE */.lE.PORTUGUESE;if(!n||c)return null;const m=()=>{const e=document.getElementById("Header-v2");"none"===o?(i({page:"explore_desktop"}),e.style.position="sticky",l("block")):(e.style.position="relative",l("none"))},p=(null==t||null===(s=t.item)||void 0===s?void 0:s.name)||null;return react.createElement("div",{className:"Explore"},react.createElement(Mt,{displayMenu:o,toogleMenu:m,nameItem:p}),react.createElement(Lt,(0,_rollupPluginBabelHelpers_1fef267c._)({displayMenu:o,toogleMenu:m,tinyBirdClick:i},t)))};Pt.propTypes={isItemDropdown:index_5808dc9d.p.exports.bool,isLiveActive:index_5808dc9d.p.exports.bool,item:index_5808dc9d.p.exports.shape({name:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string,items:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({icon:index_5808dc9d.p.exports.string,name:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string}))})};const Ot=t=>{var s,n;const{t:r}=(0,useTranslation/* useTranslation */.$)(),o=(0,es/* useSelector */.v9)((e=>e.get("explore"))).toJS()||{categories:[]},[l,i]=(0,react.useState)(null==o||null===(s=o.categories)||void 0===s?void 0:s[0]),[c,p]=(0,react.useState)({}),[d,u]=(0,react.useState)(0),C=100,E=(null==t||null===(n=t.item)||void 0===n?void 0:n.name)||"",f=t.isItemDropdown,h=e=>()=>{i(e),u(-100)};return react.createElement("div",{className:"ExploreMobile"},react.createElement("div",{className:"ExploreMobile-wrapper"},react.createElement("div",{className:"ExploreMobile-content",style:{transform:`translateX(${d}vw)`}},react.createElement("div",{className:"ExploreMobile-categories"},react.createElement("button",{type:"button",onClick:()=>{f&&(t.handleSelectItem(null==t?void 0:t.item),u(-100)),t.handleExplore()},className:"ExploreMobile-title","data-trans":f?null:"header_explore_exploreMenu_category"},f?react.createElement("div",{className:"ExploreMobile-title-itemMultiple"},react.createElement("span",null,E),react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faChevronRight/* faChevronRight */._t})):react.createElement(react.Fragment,null,r("header_explore_exploreMenu_category"),react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faArrowLeft/* faArrowLeft */.ac}))),!f&&react.createElement("ul",null,null==o?void 0:o.categories.map((t=>{var a;return react.createElement("li",{key:`category-${null==t?void 0:t.id}`,"data-testid":"category-item"},react.createElement("button",{type:"buttton",onClick:h(t)},react.createElement("div",null,react.createElement(index_es/* FontAwesomeIcon */.G,{icon:null===(a=Tt[null==t?void 0:t.id])||void 0===a?void 0:a.icon,style:{color:null==t?void 0:t.color}}),null==t?void 0:t.name),react.createElement(index_es/* FontAwesomeIcon */.G,{className:"ExploreMobile-hover",icon:faChevronRight/* faChevronRight */._t})))})))),!f&&react.createElement(react.Fragment,null,react.createElement(It,{categorySelected:l,changeSchool:e=>()=>{p(e),u(-200)},translateInX:u}),react.createElement(Rt,{schoolSelected:c,viewportTranslate:C,translateInX:u})))))};Ot.propTypes={handleExplore:index_5808dc9d.p.exports.func.isRequired,isItemDropdown:index_5808dc9d.p.exports.bool,handleSelectItem:index_5808dc9d.p.exports.func};const It=({categorySelected:t,changeSchool:a,translateInX:s})=>{var n,r;const{t:o}=(0,useTranslation/* useTranslation */.$)();return react.createElement("div",{className:"ExploreSchools"},react.createElement("button",{type:"button",onClick:()=>s(0),className:"ExploreSchools-title"},react.createElement("div",null,react.createElement(index_es/* FontAwesomeIcon */.G,{icon:null===(n=Tt[null==t?void 0:t.id])||void 0===n?void 0:n.icon,style:{color:null==t?void 0:t.color}}),null==t?void 0:t.name),react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faArrowLeft/* faArrowLeft */.ac})),react.createElement("p",{"data-trans":"header_explore_exploreMenu_schools"},o("header_explore_exploreMenu_schools")," ",react.createElement("b",null,null==t?void 0:t.schools_count)),react.createElement("ul",null,null==t||null===(r=t.schools)||void 0===r?void 0:r.map((t=>react.createElement("li",{"data-testid":"school-item"},react.createElement("button",{type:"button",onClick:a(t)},null==t?void 0:t.name," ",react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faChevronRight/* faChevronRight */._t})))))))};It.propTypes={categorySelected:index_5808dc9d.p.exports.object.isRequired,changeSchool:index_5808dc9d.p.exports.func.isRequired,translateInX:index_5808dc9d.p.exports.func.isRequired};const Rt=({schoolSelected:t,viewportTranslate:a,translateInX:s})=>{var n;const{t:r}=(0,useTranslation/* useTranslation */.$)(),{tinyBirdClick:o}=_t(),l=(0,es/* useSelector */.v9)((e=>e.get("explore"))).toJS()||null;if(!t)return null;const i=(e,t)=>()=>{o({page:e,object_id:t})};return react.createElement("div",{className:"ExploreRoutes"},react.createElement("button",{type:"button",onClick:()=>s(-a),className:"ExploreRoutes-title"},null==t?void 0:t.name,react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faArrowLeft/* faArrowLeft */.ac})),react.createElement("a",{className:"ExploreRoutes-goToSchool",href:t.url,onClick:i("explorer_mobile_school",null==t?void 0:t.id)},r("header_explore_exploreRoutes_goToSchool")," ",null==t?void 0:t.name),react.createElement("p",{"data-trans":"header_explore_exploreMenu_routes"},r("header_explore_exploreRoutes_routeTitle")," ",react.createElement("b",null,t.learning_paths_count)),react.createElement("div",{className:"ExploreRoutes-content"},react.createElement("ul",null,null===(n=t.learning_paths)||void 0===n?void 0:n.map(((t,a)=>{var s,n;return react.createElement("li",{key:`route-${a}`,"data-testid":"route-item"},react.createElement("a",{href:l.learning_paths[t].url,onClick:i("explorer_mobile_route",t)},react.createElement("div",null,null===(s=l.learning_paths[t])||void 0===s?void 0:s.name,(null===(n=l.learning_paths[t])||void 0===n?void 0:n.is_professional)&&react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faBadgeCheck/* faBadgeCheck */.fi})),l.learning_paths[t].is_new&&react.createElement("span",{className:"ExploreRoutes-newRoute","data-trans":"header_explore_exploreMenu_new"},r("header_explore_exploreMenu_new"))))})))))};Rt.propTypes={schoolSelected:index_5808dc9d.p.exports.object.isRequired,viewportTranslate:index_5808dc9d.p.exports.number.isRequired,translateInX:index_5808dc9d.p.exports.func.isRequired},Rt.defaultProps={};const zt=({handleExplore:t,itemToShow:a})=>{const{name:s,items:n}=a;return react.createElement("div",null,react.createElement("button",{type:"button",onClick:t,className:"ExploreSchools-title"},react.createElement("div",null,s),react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faArrowLeft/* faArrowLeft */.ac})),react.createElement("ul",{className:"dropdown-items"},n.map((t=>react.createElement("a",{href:null==t?void 0:t.url,className:"dropdown-items-item"},react.createElement("li",{className:"dropdown-items-item"},(null==t?void 0:t.icon)&&react.createElement("figure",null,react.createElement(Image_4b46b89d.I,{src:t.icon,alt:null==t?void 0:t.name})),react.createElement("span",null,null==t?void 0:t.name)))))))};zt.propTypes={handleExplore:index_5808dc9d.p.exports.func,itemToShow:index_5808dc9d.p.exports.shape({name:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string,items:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({icon:index_5808dc9d.p.exports.string,name:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string}).isRequired)})};const jt=({items:t,handleContact:a,handleExplore:s,handleSelectItem:n})=>{const r=(0,es/* useSelector */.v9)((e=>{var t;return null===(t=e.get("explore"))||void 0===t?void 0:t.get("categories")}))||null,o=((0,es/* useSelector */.v9)((e=>e.get("header").get("locale")))||"es-CO")===constants/* LOCALES.PORTUGUESE */.lE.PORTUGUESE,{t:l}=(0,useTranslation/* useTranslation */.$)(),{tinyBirdClick:i}=_t(),{width:c}=(0,useRegisterModal_23dbb00b.a)(),p=t=>react.createElement("a",{href:t.url},t.name),d=t=>react.createElement("div",{onClick:a,role:"button",tabIndex:"0",onKeyPress:e=>{"Enter"===e.key&&a()}},t.name);return react.createElement("ul",{className:"Menu-list","data-testid":"menu-list"},r&&!o&&react.createElement("li",{className:"Menu-list-explore"},react.createElement("button",{className:"Menu-button",type:"button",onClick:()=>{i({page:"explorer_mobile"}),s()}},l("header_explore_exploreButton"),react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faChevronRight/* faChevronRight */._t}))),t.map(((t,a)=>react.createElement("li",{key:`MenuItems-${a}`},(t=>{const a=c<=constants/* LG_BREAKPOINT */.bK,r={LINK:p(t),CONTACT:d(t),EXPLORE:a?react.createElement(Ot,{isItemDropdown:!0,item:t,handleExplore:()=>s(),handleSelectItem:n}):react.createElement(Pt,{isItemDropdown:!0,item:t})},o=t.hasOwnProperty("items");return"contact"===t.type?r.CONTACT:o?r.EXPLORE:r.LINK})(t)))))};jt.propTypes={items:index_5808dc9d.p.exports.array,handleContact:index_5808dc9d.p.exports.func,handleSelectItem:index_5808dc9d.p.exports.func,showExplore:index_5808dc9d.p.exports.bool};const qt=()=>{const{t:t}=(0,useTranslation/* useTranslation */.$)();return react.createElement("div",{className:"UserLogin"},react.createElement("div",{className:"UserLogin-content"},react.createElement("div",{className:"UserLogin-button"},react.createElement("a",{href:"/login",className:"btn btn-green btn--big"},react.createElement("span",null,t("user_login")))),react.createElement("div",{className:"UserLogin-info"},react.createElement("ul",null,react.createElement("li",null,react.createElement("span",null,t("login_live_text"))),react.createElement("li",null,react.createElement("span",null,t("login_courses_text"))),react.createElement("li",null,react.createElement("span",null,t("login_opportunities")))))))},Ht=s=>{const[n,r]=(0,react.useState)(!1),[o,l]=(0,react.useState)(null),{t:c}=s,d=()=>window.innerWidth<1330||!0!==s.menuOpen?null:u(),u=()=>{s.handleOpen("menuOpen"),r(!1)},g=()=>{n&&l(null),r(!n)},C=e=>{l(e)};(0,react.useEffect)((()=>(window.addEventListener("resize",d()),()=>{window.removeEventListener("resize",d())})),[]);const E=classnames_default()("Menu-content",{"Menu-content--is-dark":s.isDark,open:s.menuOpen}),f=n&&!o,h=n&&o,x=!n,v=classnames_default()("Menu-dropdown",{"Menu-dropdown--green":s.isExperimentHome,"Menu-dropdown--classic":!s.isExperimentHome});return react.createElement("div",{className:"Menu",role:"menu"},react.createElement("button",{className:v,onClick:u,type:"button",tabIndex:"0",onKeyPress:e=>{"Enter"===e.key&&u()},"aria-label":c("menu")},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:s.menuOpen?faTimes/* faTimes */.NB:faBars/* faBars */.xi})),react.createElement("div",{className:E},f&&react.createElement(Ot,{handleExplore:g,handleSelectItem:C}),x&&react.createElement("div",null,react.createElement(jt,{handleSelectItem:C,items:s.menuItems,handleContact:s.handleContact,handleExplore:g}),!s.isLogged&&react.createElement(qt,null)),h&&react.createElement(zt,{itemToShow:o,handleExplore:g})))};Ht.propTypes={isLogged:index_5808dc9d.p.exports.bool,menuOpen:index_5808dc9d.p.exports.bool,menuItems:index_5808dc9d.p.exports.array,isDark:index_5808dc9d.p.exports.bool,handleOpen:index_5808dc9d.p.exports.func,handleContact:index_5808dc9d.p.exports.func,isExperimentHome:index_5808dc9d.p.exports.bool};var Ut=index_f0f30b4f_m.ReactTranslationsHOC(Ht);const $t=s=>{const{t:n}=(0,useTranslation/* useTranslation */.$)(),[r,o]=(0,react.useState)("/login/");return (0,react.useEffect)((()=>{const e=location.pathname;"/"!==e&&o(`/login/?next=${e}`)}),[]),react.createElement("div",{className:"ButtonLogin showButton"},react.createElement("div",null,react.createElement("a",{href:r,className:"ButtonLogin-cta"},n("login"))))};function Vt(t){const a=classnames_default()({"Bell-clapper":t.new&&t.enabled}),s=classnames_default()({"Bell-body":t.new&&t.enabled});return react.createElement("svg",{version:"1.1",id:"Layer_1",width:"24",height:"24",xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",x:"0px",y:"0px",viewBox:"0 0 24 24",style:{enableBackground:"new 0 0 24 24"},xmlSpace:"preserve"},react.createElement("g",{className:s},react.createElement("path",{id:"campanita2",className:a,style:{fill:"white"},d:"M12.9,18.9c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9H9.7c0,1.3,1,2.3,2.3,2.3s2.3-1,2.3-2.3H12.9z"}),react.createElement("path",{id:"camapanita1",style:{fill:"white"},d:"M19.2,14.7c-0.6-0.6-1.2-1.2-1.2-4.1c0-3-2.2-5.4-5-5.9c0.1-0.2,0.2-0.4,0.2-0.6 c0-0.6-0.5-1.1-1.1-1.1S10.9,3.4,10.9,4c0,0.2,0.1,0.5,0.2,0.6c-2.8,0.5-5,2.9-5,5.9c0,2.9-0.6,3.5-1.2,4.1 c-1.7,1.7-0.5,4.2,1.6,4.2h3.3h4.6h3.3C19.7,18.9,20.9,16.4,19.2,14.7z M17.6,17.1H6.4c-0.6,0-0.9-0.7-0.5-1.1c1-1,1.8-2,1.8-5.5 c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2c0,3.5,0.8,4.4,1.8,5.5C18.5,16.4,18.2,17.1,17.6,17.1z"})),t.new&&t.enabled&&react.createElement("circle",{style:{fill:"#FF4842"},cx:"17",cy:"7",r:"5"}),!t.enabled&&react.createElement("path",{id:"inactive",style:{fill:"white"},d:"M3.3,3C3.1,2.8,2.8,2.8,2.7,3L2.1,3.7C2,3.8,2,4.1,2.1,4.3L20.7,21c0.2,0.2,0.4,0.1,0.6,0 l0.6-0.7c0.2-0.2,0.1-0.5,0-0.6v0L3.3,3z"}))}$t.propTypes={isLogged:index_5808dc9d.p.exports.bool},Vt.propTypes={new:index_5808dc9d.p.exports.bool,enabled:index_5808dc9d.p.exports.bool};const Kt=t=>{const{t:a}=(0,useTranslation/* useTranslation */.$)(),s=classnames_default()("EmptyState-container",{"is-landing":t.isLanding}),n=classnames_default()("EmptyState-btns",{"is-landing":t.isLanding});return react.createElement("div",{className:"EmptyState"},react.createElement("div",{className:"EmptyState-image"},react.createElement("div",{className:s,style:{backgroundImage:`url(${t.background})`}},react.createElement("img",{loading:"lazy",src:t.image,alt:"Notificaciones",className:"EmptyState-astronaut"}),react.createElement("div",{className:"EmptyState-pulse"},react.createElement("div",{className:"EmptyState-p1"}),react.createElement("div",{className:"EmptyState-p2"}),react.createElement("div",{className:"EmptyState-p3"})))),react.createElement("strong",null,a(t.idTitle)),react.createElement("p",{className:"ModalContact-label",dangerouslySetInnerHTML:{__html:a(t.subtitleId)}}),react.createElement("div",{className:n},t.recommendations.map((t=>react.createElement("div",{className:"EmptyState-btn",key:t.text},react.createElement("span",null,t.text),react.createElement("a",{href:t.url}))))))};function Wt(t){return react.createElement("div",{className:"LoadingState"},t.children)}Kt.propTypes={recommendations:index_5808dc9d.p.exports.array,title:index_5808dc9d.p.exports.string,idTitle:index_5808dc9d.p.exports.string,subtitle:index_5808dc9d.p.exports.string,subtitleId:index_5808dc9d.p.exports.string,background:index_5808dc9d.p.exports.string,image:index_5808dc9d.p.exports.string,isLanding:index_5808dc9d.p.exports.bool},Wt.propTypes={children:index_5808dc9d.p.exports.element};const Gt=t=>{const a=20*t.width/100,s={width:t.width,height:t.width},n={border:`${a}px solid #97C93E`,borderRadius:`${a}px ${a}px 0 0`,borderBottom:"none"},r={border:`${a}px solid #97C93E`,borderRadius:`0 0 ${a}px ${a}px`,borderTop:"none"};return react.createElement("div",{className:"LoadingPlatziLogo",style:s},react.createElement("div",{className:"LoadingPlatziLogo-left",style:n}),react.createElement("div",{className:"LoadingPlatziLogo-right",style:r}))};function Jt(t){const a=classnames_default()("Notifications",{isDropdown:t.isDropdown});return react.createElement("div",{className:a},t.children)}Gt.propTypes={width:index_5808dc9d.p.exports.number},Jt.propTypes={children:index_5808dc9d.p.exports.element,isDropdown:index_5808dc9d.p.exports.bool};const{axiosInstance:Xt}=index_f0f30b4f_h,Yt={notifications:{markAllAsRead:()=>Xt().get("/tinkerbell/mark-all-as-read/"),handleNotification:(e,t)=>Xt().get(`/tinkerbell/toogle-notification/?notification_id=${e}&status=${t}`)}};class Zt extends react.Component{constructor(...e){return super(...e),this.openNotificationMenu=e=>{e.preventDefault(),this.props.openNotificationMenu({index:this.props.index})},this.handleHideNotification=e=>{e.preventDefault(),this.props.hideNotification({index:this.props.index}),Yt.notifications.handleNotification(this.props.id,!1).then((()=>{}))},this.handleShowNotification=e=>{e.preventDefault(),this.props.showNotification({index:this.props.index}),Yt.notifications.handleNotification(this.props.id,!0).then((()=>{}))},this}render(){const{t:t}=this.props;if(!this.props.hide){moment_default().locale("es",{relativeTime:{future:"en %s",past:"hace %s",s:"1s",ss:"%d s",m:"1 m",mm:"%d m",h:"1 h",hh:"%d h",d:"1 d",dd:"%d d",M:"1 mes",MM:"%d meses",y:"1 a",yy:"%d a"}});const a=classnames_default()("NotificationHeader",{"not-read":!this.props.read&&!this.props.markAllAsRead}),s=moment_default()(new Date),n=moment_default()(new Date(this.props.date)),r=s.diff(n,"days")>1?n.format("D MMM"):n.fromNow(!0);return react.createElement("div",{className:a},react.createElement("div",{className:"NotificationHeader-type"},react.createElement("i",{className:`icon-${this.props.type}`})),react.createElement("div",{className:"NotificationHeader-info"},react.createElement("div",{className:"NotificationHeader-avatares"},this.props.avatares.map((t=>react.createElement("figure",null,react.createElement("img",{loading:"lazy",src:this.props.users[t].src,width:"24",height:"24"}))))),react.createElement("div",{className:"NotificationHeader-title",dangerouslySetInnerHTML:{__html:this.props.title}}),this.props.subtitle&&react.createElement("div",{className:"NotificationHeader-subtitle"},this.props.subtitle),react.createElement("div",{className:"NotificationHeader-time"},r),this.props.isLanding&&react.createElement("div",{className:"NotificationHeader-menu",onClick:this.openNotificationMenu},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faEllipsisV/* faEllipsisV */.iV})),this.props.menuNotification===this.props.index&&this.props.isLanding&&react.createElement("div",{className:"NotificationHeader-tooltip"},react.createElement("div",{className:"NotificationHeader-options"},react.createElement("div",{className:"NotificationHeader-option",onClick:this.handleHideNotification},react.createElement("div",{className:"NotificationHeader-icon"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faEyeSlash/* faEyeSlash */.Aq})),react.createElement("div",{className:"NotificationHeader-optionContent"},react.createElement("div",{className:"NotificationHeader-hide"},react.createElement("span",null,t("hide"))),react.createElement("div",null,react.createElement("span",null,t("hide_description")))))),react.createElement("div",{className:"NotificationHeader-triangle"}))),react.createElement("a",{href:this.props.url,className:"NotificationHeader-url"}))}return this.props.hide&&this.props.isLanding?react.createElement("div",{className:"NotificationHeader is-hidden"},react.createElement("div",{className:"NotificationHeader-hidden"},react.createElement("span",null,t("notificationHeader_hidden")),react.createElement("span",{className:"NotificationHeader-undo",onClick:this.handleShowNotification},react.createElement("span",null,t("undo"))))):null}}Zt.propTypes={type:index_5808dc9d.p.exports.string,avatares:index_5808dc9d.p.exports.array,users:index_5808dc9d.p.exports.array,title:index_5808dc9d.p.exports.string,subtitle:index_5808dc9d.p.exports.string,date:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string,read:index_5808dc9d.p.exports.bool,markAllAsRead:index_5808dc9d.p.exports.bool,index:index_5808dc9d.p.exports.number,isLanding:index_5808dc9d.p.exports.bool,openNotificationMenu:index_5808dc9d.p.exports.func,menuNotification:index_5808dc9d.p.exports.number,hideNotification:index_5808dc9d.p.exports.func,showNotification:index_5808dc9d.p.exports.func,hide:index_5808dc9d.p.exports.bool,id:index_5808dc9d.p.exports.number};const Qt={openNotificationMenu:function(e){return{type:"OPEN_NOTIFICATION_MENU",payload:e}},hideNotification:function(e){return{type:"HIDE_NOTIFICATION",payload:e}},showNotification:function(e){return{type:"SHOW_NOTIFICATION",payload:e}}};var ea=index_f0f30b4f_m.ReactTranslationsHOC((0,es/* connect */.$j)((function(e){return{markAllAsRead:e.get("mark_all_as_read")||!1,menuNotification:e.get("menuNotification"),showOverlay:e.get("showOverlay")||!1}}),Qt)(Zt));const ta=t=>{const{t:a}=(0,useTranslation/* useTranslation */.$)();return react.createElement("div",{className:"NotificationsFooter"},react.createElement("div",{onClick:t.markAllAsRead},a("mark_as_read")),react.createElement("a",{href:t.url},a("see_all"),react.createElement(index_es/* FontAwesomeIcon */.G,{className:"icon",icon:pro_regular_svg_icons_faArrowRight/* faArrowRight */.eF})))};ta.propTypes={url:index_5808dc9d.p.exports.string,markAllAsRead:index_5808dc9d.p.exports.func};const aa=t=>{const{t:a}=(0,useTranslation/* useTranslation */.$)();return react.createElement("div",{className:"TinkerbellLayout"},react.createElement("div",{className:"TinkerbellLayout-triangle"}),react.createElement("div",{className:"TinkerbellLayout-content"},react.createElement("div",{className:"TinkerbellLayout-top"},react.createElement("div",{className:"TinkerbellLayout-title"},a("title")),react.createElement("a",{href:t.settings},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faCog/* faCog */.b7}))),t.children))};aa.propTypes={children:index_5808dc9d.p.exports.element,settings:index_5808dc9d.p.exports.string};class sa extends react.Component{constructor(...t){return super(...t),this.markAllAsRead=()=>{this.props.markAllAsRead({mark_all_as_read:!0}),Yt.notifications.markAllAsRead().then((()=>{}))},this.content=()=>!this.props.enabled_notifications||this.props.notifications.size<=0?react.createElement(Kt,(0,_rollupPluginBabelHelpers_1fef267c._)({},this.props.emptyState.toJS(),{idTitle:this.props.enabled_notifications?"notification_empty_title":"notifications_disabled_title",title:this.props.enabled_notifications?"¡Aún no tienes notificaciones!":"¡Tus notificaciones están desactivadas!",subtitle:this.props.enabled_notifications?"Participa, comparte y discute para empezar a recibir notificaciones.":`Para recibir nuevamente tus notificaciones debes activarlas en ${react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faCog/* faCog */.b7})}`,subtitleId:this.props.enabled_notifications?"notification_empty_subtitle":"notifications_disabled_subtitle",background:this.props.enabled_notifications?"data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%220%200%20320%20184%22%20style%3D%22enable-background%3Anew%200%200%20320%20184%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23F2F2F2%3B%7D%20.st1%7Bfill%3A%232E586E%3B%7D%20.st2%7Bfill%3A%231C3643%3Bstroke%3A%23FFFFFF%3Bstroke-width%3A1.0476%3Bstroke-miterlimit%3A10%3B%7D%20.st3%7Bfill%3A%2313252E%3B%7D%20.st4%7Bfill%3Anone%3Bstroke%3A%23F2F2F2%3Bstroke-width%3A0.75%3Bstroke-miterlimit%3A10%3B%7D%20.st5%7Bfill%3A%2398CA3F%3B%7D%20.st6%7Bfill%3A%2365872A%3B%7D%3C%2Fstyle%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M179.7%2C33.7c2.6%2C0%2C2.6-4%2C0-4C177.1%2C29.7%2C177.1%2C33.7%2C179.7%2C33.7L179.7%2C33.7z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20class%3D%22st1%22%20d%3D%22M302%2C84.3c0.2-36.7-22.9-57.7-41.6-66.5C215.6-3.3%2C122.3%2C2.6%2C109.6%2C3.2C8%2C7.9%2C16.7%2C86.9%2C19.5%2C101.6%20%20c9.3%2C49.6%2C52.3%2C80.4%2C142.7%2C80.4C215%2C182%2C301.7%2C161.3%2C302%2C84.3z%22%2F%3E%3C%2Fg%3E%3Cpath%20class%3D%22st2%22%20d%3D%22M286.8%2C74.1c-1.9-31.9-27.7-51-45.1-57.8c-41.6-16.3-125.4-4.4-136.9-3c-91.3%2C11.3-78.7%2C83.1-75.3%2C96.5%20c11.4%2C44.8%2C52%2C70.2%2C133.5%2C64C210.6%2C170.1%2C291.9%2C158.9%2C286.8%2C74.1z%22%2F%3E%3Cg%3E%20%3Cpath%20class%3D%22st3%22%20d%3D%22M281.8%2C90.8c-0.2-34-20.5-51.2-35.8-59.6c-36.6-20.1-114.6-18.6-125.2-18.6C36%2C12.8%2C40.6%2C81.8%2C42.5%2C94.7%20%20c6.2%2C43.5%2C40.9%2C72%2C116.2%2C75.5C202.8%2C172.3%2C282.1%2C170%2C281.8%2C90.8z%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M92.9%2C36.7c3.9%2C0%2C3.9-6%2C0-6S89%2C36.7%2C92.9%2C36.7L92.9%2C36.7z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M96.8%2C77.1c2.6%2C0%2C2.6-4%2C0-4S94.2%2C77.1%2C96.8%2C77.1L96.8%2C77.1z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M168.6%2C27c2.6%2C0%2C2.6-4%2C0-4C166%2C23%2C166%2C27%2C168.6%2C27L168.6%2C27z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M248%2C126.5c3.9%2C0%2C3.9-6%2C0-6S244.1%2C126.5%2C248%2C126.5L248%2C126.5z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M210%2C148c2.6%2C0%2C2.6-4%2C0-4S207.4%2C148%2C210%2C148L210%2C148z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20class%3D%22st4%22%20d%3D%22M76.8%2C118.8c1.9%2C1.1%2C3.8%2C2.1%2C5.6%2C3.3%22%2F%3E%20%3Cpath%20class%3D%22st4%22%20d%3D%22M76.6%2C122.1c2-1.2%2C4-2.3%2C6-3.4%22%2F%3E%20%3Cpath%20class%3D%22st4%22%20d%3D%22M79.6%2C117.2c-0.1%2C2.2-0.1%2C4.3%2C0.1%2C6.5%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20class%3D%22st4%22%20d%3D%22M213.7%2C103c1.9%2C1.1%2C3.8%2C2.1%2C5.6%2C3.3%22%2F%3E%20%3Cpath%20class%3D%22st4%22%20d%3D%22M213.5%2C106.3c2-1.2%2C4-2.3%2C6-3.4%22%2F%3E%20%3Cpath%20class%3D%22st4%22%20d%3D%22M216.5%2C101.4c-0.1%2C2.2-0.1%2C4.3%2C0.1%2C6.5%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Ccircle%20class%3D%22st5%22%20cx%3D%22204%22%20cy%3D%2257%22%20r%3D%2224%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st6%22%20d%3D%22M218.4%2C76.2c-10.6%2C8-25.6%2C5.9-33.6-4.7c20%2C4.4%2C38.9-11.9%2C38.3-28.9C231.1%2C53.1%2C229%2C68.2%2C218.4%2C76.2z%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Ccircle%20class%3D%22st6%22%20cx%3D%22209.6%22%20cy%3D%2257.4%22%20r%3D%223%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Ccircle%20class%3D%22st6%22%20cx%3D%22196.6%22%20cy%3D%2257.8%22%20r%3D%221.5%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Ccircle%20class%3D%22st6%22%20cx%3D%22201.2%22%20cy%3D%2270.8%22%20r%3D%226%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Ccircle%20class%3D%22st5%22%20cx%3D%22201.2%22%20cy%3D%2270.8%22%20r%3D%224.3%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M247.5%2C61.5c2.6%2C0%2C2.6-4%2C0-4S244.9%2C61.5%2C247.5%2C61.5L247.5%2C61.5z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E":"data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%220%200%20320%20184%22%20style%3D%22enable-background%3Anew%200%200%20320%20184%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23F2F2F2%3B%7D%20.st1%7Bfill%3A%23DDDDDD%3B%7D%20.st2%7Bfill%3A%23BBBBBB%3Bstroke%3A%23FFFFFF%3Bstroke-width%3A1.0476%3Bstroke-miterlimit%3A10%3B%7D%20.st3%7Bfill%3A%23AAAAAA%3B%7D%20.st4%7Bfill%3Anone%3Bstroke%3A%23F2F2F2%3Bstroke-width%3A0.75%3Bstroke-miterlimit%3A10%3B%7D%20.st5%7Bfill%3A%23C2C2C2%3B%7D%20.st6%7Bfill%3A%23999999%3B%7D%3C%2Fstyle%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M179.7%2C33.7c2.6%2C0%2C2.6-4%2C0-4C177.1%2C29.7%2C177.1%2C33.7%2C179.7%2C33.7L179.7%2C33.7z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20class%3D%22st1%22%20d%3D%22M302%2C84.3c0.2-36.7-22.9-57.7-41.6-66.5C215.6-3.3%2C122.3%2C2.6%2C109.6%2C3.2C8%2C7.9%2C16.7%2C86.9%2C19.5%2C101.6%20%20c9.3%2C49.6%2C52.3%2C80.4%2C142.7%2C80.4C215%2C182%2C301.7%2C161.3%2C302%2C84.3z%22%2F%3E%3C%2Fg%3E%3Cpath%20class%3D%22st2%22%20d%3D%22M286.8%2C74.1c-1.9-31.9-27.7-51-45.1-57.8c-41.6-16.3-125.4-4.4-136.9-3c-91.3%2C11.3-78.7%2C83.1-75.3%2C96.5%20c11.4%2C44.8%2C52%2C70.2%2C133.5%2C64C210.6%2C170.1%2C291.9%2C158.9%2C286.8%2C74.1z%22%2F%3E%3Cg%3E%20%3Cpath%20class%3D%22st3%22%20d%3D%22M281.8%2C90.8c-0.2-34-20.5-51.2-35.8-59.6c-36.6-20.1-114.6-18.6-125.2-18.6C36%2C12.8%2C40.6%2C81.8%2C42.5%2C94.7%20%20c6.2%2C43.5%2C40.9%2C72%2C116.2%2C75.5C202.8%2C172.3%2C282.1%2C170%2C281.8%2C90.8z%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M92.9%2C36.7c3.9%2C0%2C3.9-6%2C0-6S89%2C36.7%2C92.9%2C36.7L92.9%2C36.7z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M96.8%2C77.1c2.6%2C0%2C2.6-4%2C0-4S94.2%2C77.1%2C96.8%2C77.1L96.8%2C77.1z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M168.6%2C27c2.6%2C0%2C2.6-4%2C0-4S166%2C27%2C168.6%2C27L168.6%2C27z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M248%2C126.5c3.9%2C0%2C3.9-6%2C0-6S244.1%2C126.5%2C248%2C126.5L248%2C126.5z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M210%2C148c2.6%2C0%2C2.6-4%2C0-4S207.4%2C148%2C210%2C148L210%2C148z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20class%3D%22st4%22%20d%3D%22M76.8%2C118.8c1.9%2C1.1%2C3.8%2C2.1%2C5.6%2C3.3%22%2F%3E%20%3Cpath%20class%3D%22st4%22%20d%3D%22M76.6%2C122.1c2-1.2%2C4-2.3%2C6-3.4%22%2F%3E%20%3Cpath%20class%3D%22st4%22%20d%3D%22M79.6%2C117.2c-0.1%2C2.2-0.1%2C4.3%2C0.1%2C6.5%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20class%3D%22st4%22%20d%3D%22M213.7%2C103c1.9%2C1.1%2C3.8%2C2.1%2C5.6%2C3.3%22%2F%3E%20%3Cpath%20class%3D%22st4%22%20d%3D%22M213.5%2C106.3c2-1.2%2C4-2.3%2C6-3.4%22%2F%3E%20%3Cpath%20class%3D%22st4%22%20d%3D%22M216.5%2C101.4c-0.1%2C2.2-0.1%2C4.3%2C0.1%2C6.5%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Ccircle%20class%3D%22st5%22%20cx%3D%22204%22%20cy%3D%2257%22%20r%3D%2224%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st6%22%20d%3D%22M218.4%2C76.2c-10.6%2C8-25.6%2C5.9-33.6-4.7c20%2C4.4%2C38.9-11.9%2C38.3-28.9C231.1%2C53.1%2C229%2C68.2%2C218.4%2C76.2z%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Ccircle%20class%3D%22st6%22%20cx%3D%22209.6%22%20cy%3D%2257.4%22%20r%3D%223%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Ccircle%20class%3D%22st6%22%20cx%3D%22196.6%22%20cy%3D%2257.8%22%20r%3D%221.5%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Ccircle%20class%3D%22st6%22%20cx%3D%22201.2%22%20cy%3D%2270.8%22%20r%3D%226%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Ccircle%20class%3D%22st5%22%20cx%3D%22201.2%22%20cy%3D%2270.8%22%20r%3D%224.3%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M247.5%2C61.5c2.6%2C0%2C2.6-4%2C0-4S244.9%2C61.5%2C247.5%2C61.5L247.5%2C61.5z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E",image:this.props.enabled_notifications?"data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%220%200%20168%20168%22%20style%3D%22enable-background%3Anew%200%200%20168%20168%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23666666%3B%7D%20.st1%7Bfill%3A%23F2F2F2%3B%7D%20.st2%7Bfill%3A%2333B1FF%3B%7D%20.st3%7Bfill%3Anone%3Bstroke%3A%2398CA3F%3Bstroke-width%3A2.6658%3Bstroke-linecap%3Around%3Bstroke-linejoin%3Around%3Bstroke-miterlimit%3A10%3B%7D%20.st4%7Bfill%3Anone%3Bstroke%3A%2398CA3F%3Bstroke-width%3A2.958%3Bstroke-linecap%3Around%3Bstroke-linejoin%3Around%3Bstroke-miterlimit%3A10%3B%7D%20.st5%7Bfill%3Anone%3Bstroke%3A%2398CA3F%3Bstroke-width%3A3.0438%3Bstroke-linecap%3Around%3Bstroke-linejoin%3Around%3Bstroke-miterlimit%3A10%3B%7D%20.st6%7Bfill%3A%23999999%3B%7D%20.st7%7Bfill%3Anone%3Bstroke%3A%23CCCCCC%3Bstroke-width%3A1.2844%3Bstroke-linecap%3Around%3Bstroke-linejoin%3Around%3Bstroke-miterlimit%3A10%3B%7D%20%20%20.st8%7Bopacity%3A0.8%3Bfill%3Anone%3Bstroke%3A%23FFFFFF%3Bstroke-linecap%3Around%3Bstroke-linejoin%3Around%3Bstroke-miterlimit%3A10%3Benable-background%3Anew%20%20%20%20%3B%7D%20.st9%7Bfill%3Anone%3Bstroke%3A%23F2F2F2%3Bstroke-width%3A1.2844%3Bstroke-linecap%3Around%3Bstroke-linejoin%3Around%3Bstroke-miterlimit%3A10%3B%7D%20.st10%7Bfill%3A%230791E6%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M83.7%2C103.2L106%2C92.8c11.2-5.2%2C16-18.6%2C10.8-29.8L93.3%2C12.6C89.8%2C5.2%2C81%2C1.9%2C73.5%2C5.4L37.7%2C22.1%20c-7.4%2C3.5-10.7%2C12.4-7.2%2C19.8L54%2C92.3C59.2%2C103.5%2C72.6%2C108.4%2C83.7%2C103.2z%22%2F%3E%3Cpath%20class%3D%22st1%22%20d%3D%22M93.6%2C38.4c14.3-6.7%2C25.3%2C8.9%2C36.4%2C5.6c6.3-1.9%2C12.6-5.9%2C12.6-5.9c3.3-1.5%2C7.1-0.1%2C8.6%2C3.1l0%2C0%20c1.5%2C3.2%2C0.1%2C7.1-3.1%2C8.6c0%2C0-14.4%2C8.8-26.4%2C7.2c-11.1-1.5-15.2-8.3-21.9-5.2l0%2C0l15.3%2C32.8l30.3%2C48.4c2.2%2C4.6%2C0.1%2C10.2-4.5%2C12.3%20l0%2C0c-4.6%2C2.2-10.2%2C0.1-12.3-4.5L105%2C106.7c-1.1-2.3-3.8-3.3-6.2-2.2c-2.3%2C1.1-3.3%2C3.8-2.2%2C6.2l9.6%2C40c2.2%2C4.6%2C0.1%2C10.2-4.5%2C12.3%20l0%2C0c-4.6%2C2.2-10.2%2C0.1-12.3-4.5l-16.2-54.3L57.9%2C71.5c-6.7%2C3.1-4.1%2C10.7-10.1%2C20.1c-6.5%2C10.2-22.5%2C15.6-22.5%2C15.6%20c-3.2%2C1.5-7.1%2C0.1-8.6-3.1l0%2C0c-1.5-3.3-0.1-7.1%2C3.1-8.6c0%2C0%2C7.1-2.3%2C12.6-5.9c9.7-6.4%2C4.8-24.8%2C19.2-31.5L93.6%2C38.4L93.6%2C38.4z%22%2F%3E%3Cellipse%20transform%3D%22matrix%280.9063%20-0.4226%200.4226%200.9063%20-7.2729%2030.3853%29%22%20class%3D%22st1%22%20cx%3D%2264.9%22%20cy%3D%2231.6%22%20rx%3D%2227.7%22%20ry%3D%2225.7%22%2F%3E%3Cellipse%20transform%3D%22matrix%280.9063%20-0.4226%200.4226%200.9063%20-8.1869%2031.0774%29%22%20class%3D%22st2%22%20cx%3D%2266%22%20cy%3D%2234%22%20rx%3D%2223.1%22%20ry%3D%2218%22%2F%3E%3Cpath%20class%3D%22st1%22%20d%3D%22M87.5%2C15.6L87.5%2C15.6c1.5-0.7%2C3.3%2C0%2C3.9%2C1.4l1.7%2C3.6c0.7%2C1.5%2C0%2C3.3-1.4%2C3.9l0%2C0%22%2F%3E%3Cpath%20class%3D%22st1%22%20d%3D%22M38%2C38.7L38%2C38.7c-1.5%2C0.7-2.1%2C2.5-1.4%2C3.9l1.7%2C3.6c0.7%2C1.5%2C2.5%2C2.1%2C3.9%2C1.4l0%2C0%22%2F%3E%3Cline%20class%3D%22st3%22%20x1%3D%22127.9%22%20y1%3D%22106.6%22%20x2%3D%22112.3%22%20y2%3D%22115.6%22%2F%3E%3Cline%20class%3D%22st3%22%20x1%3D%2298.3%22%20y1%3D%22122.2%22%20x2%3D%2281.4%22%20y2%3D%22128.3%22%2F%3E%3Cline%20class%3D%22st4%22%20x1%3D%2253.5%22%20y1%3D%2275.3%22%20x2%3D%2247%22%20y2%3D%2261.4%22%2F%3E%3Cline%20class%3D%22st5%22%20x1%3D%22105.7%22%20y1%3D%2250.9%22%20x2%3D%2299.2%22%20y2%3D%2237%22%2F%3E%3Cpath%20class%3D%22st6%22%20d%3D%22M74.3%2C78.2l20.2-9.4c1.8-0.9%2C2.6-3.1%2C1.8-4.9L93.2%2C57c-0.9-1.8-3.1-2.6-4.9-1.8L68%2C64.7%20c-1.8%2C0.9-2.6%2C3.1-1.8%2C4.9l3.2%2C6.8C70.2%2C78.2%2C72.4%2C79%2C74.3%2C78.2z%22%2F%3E%3Cline%20class%3D%22st7%22%20x1%3D%22142.6%22%20y1%3D%22128.5%22%20x2%3D%22126.5%22%20y2%3D%22137.8%22%2F%3E%3Cline%20class%3D%22st7%22%20x1%3D%22105.3%22%20y1%3D%22147%22%20x2%3D%2287.8%22%20y2%3D%22153.4%22%2F%3E%3Cline%20class%3D%22st7%22%20x1%3D%2232%22%20y1%3D%22104%22%20x2%3D%2226.7%22%20y2%3D%2292.7%22%2F%3E%3Cpath%20class%3D%22st8%22%20d%3D%22M61.4%2C20.6c8.9-4.2%2C18.8-1.8%2C22.1%2C5.2%22%2F%3E%3Cline%20class%3D%22st9%22%20x1%3D%2280.5%22%20y1%3D%2265%22%20x2%3D%2290.6%22%20y2%3D%2260.3%22%2F%3E%3Ccircle%20class%3D%22st9%22%20cx%3D%2274.6%22%20cy%3D%2269.9%22%20r%3D%223.7%22%2F%3E%3Cline%20class%3D%22st9%22%20x1%3D%2282.1%22%20y1%3D%2268.4%22%20x2%3D%2292.2%22%20y2%3D%2263.7%22%2F%3E%3Cline%20class%3D%22st7%22%20x1%3D%22141.5%22%20y1%3D%2253%22%20x2%3D%22136.2%22%20y2%3D%2241.6%22%2F%3E%3Cpath%20class%3D%22st10%22%20d%3D%22M44%2C40.3c3%2C12.8%2C18.1%2C15.3%2C29.7%2C9.9s17.5-17%2C13.3-26C90.6%2C45.2%2C51.3%2C50.2%2C44%2C40.3z%22%2F%3E%3C%2Fsvg%3E":"data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%220%200%20168%20168%22%20style%3D%22enable-background%3Anew%200%200%20168%20168%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23888888%3B%7D%20.st1%7Bfill%3A%23F2F2F2%3B%7D%20.st2%7Bfill%3A%23949494%3B%7D%20.st3%7Bfill%3Anone%3Bstroke%3A%23ACACAC%3Bstroke-width%3A2.6658%3Bstroke-linecap%3Around%3Bstroke-linejoin%3Around%3Bstroke-miterlimit%3A10%3B%7D%20.st4%7Bfill%3Anone%3Bstroke%3A%23ACACAC%3Bstroke-width%3A2.958%3Bstroke-linecap%3Around%3Bstroke-linejoin%3Around%3Bstroke-miterlimit%3A10%3B%7D%20.st5%7Bfill%3Anone%3Bstroke%3A%23ACACAC%3Bstroke-width%3A3.0438%3Bstroke-linecap%3Around%3Bstroke-linejoin%3Around%3Bstroke-miterlimit%3A10%3B%7D%20.st6%7Bfill%3A%23999999%3B%7D%20.st7%7Bfill%3Anone%3Bstroke%3A%23CCCCCC%3Bstroke-width%3A1.2844%3Bstroke-linecap%3Around%3Bstroke-linejoin%3Around%3Bstroke-miterlimit%3A10%3B%7D%20%20%20.st8%7Bopacity%3A0.8%3Bfill%3Anone%3Bstroke%3A%23FFFFFF%3Bstroke-linecap%3Around%3Bstroke-linejoin%3Around%3Bstroke-miterlimit%3A10%3Benable-background%3Anew%20%20%20%20%3B%7D%20.st9%7Bfill%3Anone%3Bstroke%3A%23F2F2F2%3Bstroke-width%3A1.2844%3Bstroke-linecap%3Around%3Bstroke-linejoin%3Around%3Bstroke-miterlimit%3A10%3B%7D%20.st10%7Bfill%3A%23828282%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M83.7%2C103.2L106%2C92.8c11.2-5.2%2C16-18.6%2C10.8-29.8L93.3%2C12.6C89.8%2C5.2%2C81%2C1.9%2C73.5%2C5.4L37.7%2C22.1%20c-7.4%2C3.5-10.7%2C12.4-7.2%2C19.8L54%2C92.3C59.2%2C103.5%2C72.6%2C108.4%2C83.7%2C103.2z%22%2F%3E%3Cpath%20class%3D%22st1%22%20d%3D%22M93.6%2C38.4c14.3-6.7%2C25.3%2C8.9%2C36.4%2C5.6c6.3-1.9%2C12.6-5.9%2C12.6-5.9c3.3-1.5%2C7.1-0.1%2C8.6%2C3.1l0%2C0%20c1.5%2C3.2%2C0.1%2C7.1-3.1%2C8.6c0%2C0-14.4%2C8.8-26.4%2C7.2c-11.1-1.5-15.2-8.3-21.9-5.2l0%2C0l15.3%2C32.8l30.3%2C48.4c2.2%2C4.6%2C0.1%2C10.2-4.5%2C12.3%20l0%2C0c-4.6%2C2.2-10.2%2C0.1-12.3-4.5L105%2C106.7c-1.1-2.3-3.8-3.3-6.2-2.2c-2.3%2C1.1-3.3%2C3.8-2.2%2C6.2l9.6%2C40c2.2%2C4.6%2C0.1%2C10.2-4.5%2C12.3%20l0%2C0c-4.6%2C2.2-10.2%2C0.1-12.3-4.5l-16.2-54.3L57.9%2C71.5c-6.7%2C3.1-4.1%2C10.7-10.1%2C20.1c-6.5%2C10.2-22.5%2C15.6-22.5%2C15.6%20c-3.2%2C1.5-7.1%2C0.1-8.6-3.1l0%2C0c-1.5-3.3-0.1-7.1%2C3.1-8.6c0%2C0%2C7.1-2.3%2C12.6-5.9c9.7-6.4%2C4.8-24.8%2C19.2-31.5L93.6%2C38.4L93.6%2C38.4z%22%2F%3E%3Cellipse%20transform%3D%22matrix%280.9063%20-0.4226%200.4226%200.9063%20-7.2731%2030.3875%29%22%20class%3D%22st1%22%20cx%3D%2264.9%22%20cy%3D%2231.6%22%20rx%3D%2227.7%22%20ry%3D%2225.7%22%2F%3E%3Cellipse%20transform%3D%22matrix%280.9063%20-0.4226%200.4226%200.9063%20-8.1855%2031.0762%29%22%20class%3D%22st2%22%20cx%3D%2266%22%20cy%3D%2234%22%20rx%3D%2223.1%22%20ry%3D%2218%22%2F%3E%3Cpath%20class%3D%22st1%22%20d%3D%22M87.5%2C15.6L87.5%2C15.6c1.5-0.7%2C3.3%2C0%2C3.9%2C1.4l1.7%2C3.6c0.7%2C1.5%2C0%2C3.3-1.4%2C3.9l0%2C0%22%2F%3E%3Cpath%20class%3D%22st1%22%20d%3D%22M38%2C38.7L38%2C38.7c-1.5%2C0.7-2.1%2C2.5-1.4%2C3.9l1.7%2C3.6c0.7%2C1.5%2C2.5%2C2.1%2C3.9%2C1.4l0%2C0%22%2F%3E%3Cline%20class%3D%22st3%22%20x1%3D%22127.9%22%20y1%3D%22106.6%22%20x2%3D%22112.3%22%20y2%3D%22115.6%22%2F%3E%3Cline%20class%3D%22st3%22%20x1%3D%2298.3%22%20y1%3D%22122.2%22%20x2%3D%2281.4%22%20y2%3D%22128.3%22%2F%3E%3Cline%20class%3D%22st4%22%20x1%3D%2253.5%22%20y1%3D%2275.3%22%20x2%3D%2247%22%20y2%3D%2261.4%22%2F%3E%3Cline%20class%3D%22st5%22%20x1%3D%22105.7%22%20y1%3D%2250.9%22%20x2%3D%2299.2%22%20y2%3D%2237%22%2F%3E%3Cpath%20class%3D%22st6%22%20d%3D%22M74.3%2C78.2l20.2-9.4c1.8-0.9%2C2.6-3.1%2C1.8-4.9L93.2%2C57c-0.9-1.8-3.1-2.6-4.9-1.8L68%2C64.7%20c-1.8%2C0.9-2.6%2C3.1-1.8%2C4.9l3.2%2C6.8C70.2%2C78.2%2C72.4%2C79%2C74.3%2C78.2z%22%2F%3E%3Cline%20class%3D%22st7%22%20x1%3D%22142.6%22%20y1%3D%22128.5%22%20x2%3D%22126.5%22%20y2%3D%22137.8%22%2F%3E%3Cline%20class%3D%22st7%22%20x1%3D%22105.3%22%20y1%3D%22147%22%20x2%3D%2287.8%22%20y2%3D%22153.4%22%2F%3E%3Cline%20class%3D%22st7%22%20x1%3D%2232%22%20y1%3D%22104%22%20x2%3D%2226.7%22%20y2%3D%2292.7%22%2F%3E%3Cpath%20class%3D%22st8%22%20d%3D%22M61.4%2C20.6c8.9-4.2%2C18.8-1.8%2C22.1%2C5.2%22%2F%3E%3Cline%20class%3D%22st9%22%20x1%3D%2280.5%22%20y1%3D%2265%22%20x2%3D%2290.6%22%20y2%3D%2260.3%22%2F%3E%3Ccircle%20class%3D%22st9%22%20cx%3D%2274.6%22%20cy%3D%2269.9%22%20r%3D%223.7%22%2F%3E%3Cline%20class%3D%22st9%22%20x1%3D%2282.1%22%20y1%3D%2268.4%22%20x2%3D%2292.2%22%20y2%3D%2263.7%22%2F%3E%3Cline%20class%3D%22st7%22%20x1%3D%22141.5%22%20y1%3D%2253%22%20x2%3D%22136.2%22%20y2%3D%2241.6%22%2F%3E%3Cpath%20class%3D%22st10%22%20d%3D%22M44%2C40.3c3%2C12.8%2C18.1%2C15.3%2C29.7%2C9.9s17.5-17%2C13.3-26C90.6%2C45.2%2C51.3%2C50.2%2C44%2C40.3z%22%2F%3E%3C%2Fsvg%3E"})):this.props.loading?react.createElement(Wt,null,react.createElement(Gt,{width:"50"})):react.createElement(Jt,{isDropdown:!0},this.props.notifications.map((t=>react.createElement(ea,(0,_rollupPluginBabelHelpers_1fef267c._)({},t.toJS(),{users:this.props.users.toJS()})))),react.createElement(ta,{markAllAsRead:this.markAllAsRead,url:this.props.url})),this}render(){const t=this.content();return react.createElement(aa,{settings:this.props.settings},t)}}sa.propTypes={settings:index_5808dc9d.p.exports.string,emptyState:index_5808dc9d.p.exports.object,notifications:index_5808dc9d.p.exports.array,users:index_5808dc9d.p.exports.object,url:index_5808dc9d.p.exports.string,enabled_notifications:index_5808dc9d.p.exports.bool,loading:index_5808dc9d.p.exports.bool,markAllAsRead:index_5808dc9d.p.exports.func};var na=(0,es/* connect */.$j)((function(e){return{enabled_notifications:e.get("header").get("notifications").get("enabled"),users:e.get("header").get("notifications").get("users"),notifications:e.get("header").get("notifications").get("notifications")||[],url:e.get("header").get("notifications").get("url")||"",settings:e.get("header").get("notifications").get("settings")||"",emptyState:e.get("header").get("notifications").get("emptyState")||[]}}),{markAllAsRead:index_77f09d62_a})(sa);function ra(t){const{t:a}=(0,useTranslation/* useTranslation */.$)(),s=classnames_default()("Tinkerbell-icon",{"is-disabled":!t.enabled,"is-new":t.new});return react.createElement("div",{className:"Tinkerbell"},react.createElement("div",{className:s,onClick:()=>{t.handleOpen("tinkerbellOpen")},role:"button",tabIndex:"0","aria-label":a("tinkerbell.buttonAria"),onKeyPress:e=>{t.tinkerbellOpen&&"Escape"===e.key&&t.handleOpen("tinkerbellOpen"),t.tinkerbellOpen||"Enter"!==e.key||t.handleOpen("tinkerbellOpen")}},react.createElement(Vt,{enabled:t.enabled,new:!!t.new&&!t.markAllAsReadClicked})),t.tinkerbellOpen&&react.createElement(na,null))}ra.propTypes={tinkerbellOpen:index_5808dc9d.p.exports.bool,notifications:index_5808dc9d.p.exports.object,handleOpen:index_5808dc9d.p.exports.func};var oa=(0,es/* connect */.$j)((function(e){var t,a,s,n,r;return{enabled:null==e||null===(t=e.get("header"))||void 0===t||null===(a=t.get("notifications"))||void 0===a?void 0:a.get("enabled"),new:null==e||null===(s=e.get("header"))||void 0===s||null===(n=s.get("notifications"))||void 0===n?void 0:n.get("new"),markAllAsReadClicked:(null==e||null===(r=e.get("header"))||void 0===r?void 0:r.get("mark_all_as_read"))||!1}}))(ra),la="https://static.platzi.com/ui/assets/image/platzi-isotipod71e9b26404c1b14.png";const ia=t=>{const a=classnames_default()("LogoHeader-name",{"is-live":t.isLive}),s=t.isLogged?"/home":"/";return react.createElement("div",{className:"Logo"},t.minimal?react.createElement("div",{className:"LogoHeader"},react.createElement("a",{href:s,className:"LogoHeader-link"},react.createElement("div",{className:"LogoHeader-container"},!t.isExperimentHome&&react.createElement("figure",null,react.createElement("img",{loading:"lazy",src:"https://static.platzi.com/media/platzi-isotipo@2x.png",alt:"Platzi isotipo",height:"25"})),t.customLogo?react.createElement("figure",{className:a},react.createElement("img",{loading:"lazy",src:t.customLogo,alt:"Platzi Logo",height:"19"})):react.createElement("figure",{className:a},react.createElement("img",{loading:"lazy",src:"https://static.platzi.com/media/logotipo-platzi.png",alt:"Platzi Logo",height:"25"}))))):react.createElement("a",{href:s,title:"Platzi.com"},react.createElement("img",{loading:"lazy",src:la,srcSet:`${la} 1x, https://static.platzi.com/ui/assets/image/platzi-isotipo@2x098c6fe45032d8af.png 2x`,className:"Logo-minimal",alt:"Platzi.com"})))};ia.propTypes={minimal:index_5808dc9d.p.exports.bool,isLogged:index_5808dc9d.p.exports.bool,customLogo:index_5808dc9d.p.exports.string,isExperimentHome:index_5808dc9d.p.exports.bool};class ca extends react.Component{constructor(...e){return super(...e),this.state={isOpenLang:!1,directMessages:null,notifications:null,showMobileSearch:!1},this.toggleMobileSearch=()=>{this.setState((e=>({...e,showMobileSearch:!e.showMobileSearch})))},this.handleLogin=()=>{window.location.href="/login/"},this.handleOnboarding=()=>{if(this.props.isExperimentHome)return this.props.handleOpenRegisterModal();window.location.href="/onboarding/"},this}componentDidMount(){document.addEventListener("click",this.handleClick,!1)}render(){const{live:t,menuItems:a,isLogged:s,userId:n,userName:r,userType:o,isExperimentHome:l}=this.props,{showMobileSearch:c}=this.state,p=classnames_default()({"Nav-header-logged":s,"Nav-header":!s,"Nav-header-mobile-search--active":c});return react.createElement(react.Fragment,null,l&&react.createElement("nav",{className:[p,"Nav-header-mobileCtas"].join(" ")},react.createElement(ia,{minimal:this.props.isTop,isLogged:s,isLive:this.props.live.active,customLogo:this.props.customLogo,isExperimentHome:l}),this.props.live.active&&react.createElement(xt,t),l&&!this.props.isLogged&&react.createElement("section",{className:"Nav-header-mobileCtas-actions"},react.createElement(Button_4cf71a18.B,{onClick:this.handleOnboarding,customClass:"Nav-header-mobileCtas-actions--join"},"Crear cuenta"),react.createElement(Button_4cf71a18.B,{onClick:this.handleLogin,customClass:"Nav-header-mobileCtas-actions--login"},react.createElement("span",null,"Iniciar sesión")," ",react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faArrowRightToBracket/* faArrowRightToBracket */.Zh,className:"Nav-header-mobile-actions-icon"}))),react.createElement(Ut,{isLogged:s,menuItems:a,menuOpen:this.props.menuOpen,handleOpen:this.props.handleOpen,handleContact:this.props.handleContact,isDark:this.props.isDark,isExperimentHome:l})),react.createElement("nav",{className:[p,l?"Nav-header-desktopCtas":""].join(" ")},react.createElement(ia,{minimal:this.props.isTop,isLogged:s,isLive:this.props.live.active,customLogo:this.props.customLogo,isExperimentHome:l}),this.props.live.active&&react.createElement(xt,t),react.createElement(Pt,{isLiveActive:this.props.live.active}),!l&&!this.props.menuOpen&&react.createElement(St,(0,_rollupPluginBabelHelpers_1fef267c._)({},this.props,{directMessages:this.state.directMessages,notifications:this.state.notifications,handleOpen:this.props.handleOpen,actionsOpen:this.props.actionsOpen,plansOpen:this.props.plansOpen,handleContact:this.props.handleContact})),react.createElement(Ut,{isLogged:s,menuItems:a,menuOpen:this.props.menuOpen,handleOpen:this.props.handleOpen,handleContact:this.props.handleContact,isDark:this.props.isDark,isExperimentHome:l}),l&&!this.props.isLogged&&react.createElement("section",{className:"Nav-header-mobileCtas-actions"},react.createElement(Button_4cf71a18.B,{onClick:this.handleOnboarding,customClass:"Nav-header-mobileCtas-actions--join"},"Crear cuenta"),react.createElement(Button_4cf71a18.B,{onClick:this.handleLogin,customClass:"Nav-header-mobileCtas-actions--login"},"Iniciar sesión")),!l&&!this.props.isLogged&&!this.props.menuOpen&&react.createElement($t,{isLogged:s}),!this.props.menuOpen&&s&&this.props.notifications_feature&&react.createElement(oa,{handleOpen:this.props.handleOpen,tinkerbellOpen:this.props.tinkerbellOpen}),!l&&!this.props.menuOpen&&react.createElement(NewSearch_db1704c6_p,{isLogged:s,toggleMobileSearch:this.toggleMobileSearch,showMobileSearch:c,userId:n,userName:r,userType:o})))}}ca.propTypes={live:index_5808dc9d.p.exports.object,menuItems:index_5808dc9d.p.exports.array,isLogged:index_5808dc9d.p.exports.bool,isDark:index_5808dc9d.p.exports.bool,userId:index_5808dc9d.p.exports.number,userName:index_5808dc9d.p.exports.string,userType:index_5808dc9d.p.exports.string,isExperimentHome:index_5808dc9d.p.exports.bool};var ma=index_f0f30b4f_m.ReactTranslationsHOC(class extends react.Component{constructor(...e){return super(...e),this.state={close:!1},this.handleClose=e=>{e.preventDefault(),this.setState({close:!0},(()=>{localStorage.setItem("god-lang-message-active",!0)}))},this}componentDidMount(){localStorage.getItem("god-lang-message-active")&&this.setState({close:!0})}render(){if(this.state.close)return null;const{t:t}=this.props;return react.createElement("div",{className:"SwitchLanguage"},react.createElement("div",{className:"SwitchLanguage-content"},react.createElement("div",{className:"SwitchLanguage-title"},react.createElement("span",null,t("switch_language"))),react.createElement("div",{className:"SwitchLanguage-button"},react.createElement("a",{href:"https://courses.platzi.com/",className:"btn btn-sky btn--small btn--responsive"},react.createElement("span",null,t("switch_english")))),react.createElement("div",{className:"SwitchLanguage-close"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faTimesCircle/* faTimesCircle */.nY,onClick:this.handleClose,role:"button",tabIndex:"0",onKeyPress:e=>{"Escape"===e.key&&this.handleClose()}}))))}});const pa=t=>{const{faq:a,title:s}=t;return react.createElement("div",{className:"ContactFreeUser"},react.createElement("h2",{className:"ContactFreeUser-title"},s),a.length&&a.map(((t,a)=>react.createElement("a",{className:"ContactFreeUser-item",href:t.cta,target:"_blank",key:`faq-${a}`},react.createElement("div",{className:"ContactFreeUser-item-content"},t.title),react.createElement(index_es/* FontAwesomeIcon */.G,{className:"ContactFreeUser-icon",icon:faChevronRight/* faChevronRight */._t})))))};pa.propTypes={faq:index_5808dc9d.p.exports.array,title:index_5808dc9d.p.exports.string},pa.defaultProps={faq:[]};const{axiosInstance:da}=index_f0f30b4f_h,ua={modal:{telephoneState(e){const t=new FormData;return t.append("contact_us_status",e),da(!0).post("/contact_us_toggle/",t)}},gdpr:{accept:e=>da(!0).post(`/tos-accepted/?user=${e}`)}},{axiosInstance:Ca}=index_f0f30b4f_h,Ea=s=>{const{t:n}=(0,useTranslation/* useTranslation */.$)(),[r,o]=(0,react.useState)(!1),[l,c]=(0,react.useState)(null);(0,react.useEffect)((()=>{Ca().get("/api/bff/web/contact-info/").then((e=>c(e.data))).catch((e=>{throw new Error("::ERROR::contact-info",{cause:e})}))}),[]);const d=[{prefix:"email",type:"Email",label:19===(null==l?void 0:l.organizationId)?'<span class="is-link">ajuda@platzi.com.br</span>':'<span class="is-link">team@platzi.com</span>',image:"https://static.platzi.com/ui/assets/image/canal_mail6e15a3a3b730b26a.png",link:19===(null==l?void 0:l.organizationId)?"mailto:ajuda@platzi.com.br":"mailto:team@platzi.com",target:"_top",rel:null}];(null!=l&&l.hasSubscription||null!=l&&l.isOrganizer)&&19!==(null==l?void 0:l.organizationId)&&d.push({prefix:"whatsapp",type:"Whatsapp",label:`<span class="is-link">${n("translations:write")}</span>`,image:"https://static.platzi.com/ui/assets/image/canal_whatsapp2b3659df2e42f9c9.png",link:"https://platzi.com/whatsapp",target:"_blank",rel:"noreferrer"});const u=()=>{o(!r),ua.modal.telephoneState(!r).catch((e=>{throw new Error("::ERROR::telephoneState",{cause:e})}))};return react.createElement("div",{className:"ModalContact-content"},react.createElement("div",{className:"ModalContact-close",onClick:s.handleCloseModal,onKeyPress:e=>{"Escape"===e.key&&s.handleCloseModal()},role:"button",tabIndex:"0"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faTimes/* faTimes */.NB})),react.createElement("div",{className:"ModalContact-logo"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faCommentAltSmile/* faCommentAltSmile */.Pj})),null!=l&&l.hasSubscription||null!=l&&l.isOrganizer?react.createElement("div",{className:"row center-xs"},react.createElement("div",{className:"col-xs-12"},react.createElement("h3",{className:"ModalContact-title"},n("translations:contactus_title")),react.createElement("p",{className:"ModalContact-subtitle"},n("translations:contactus_subtitle"),react.createElement("strong",null,"Email"))),2===d.length&&react.createElement("div",{className:"col-xs-0 col-sm-2"}),d.map(((t,a)=>{const s=classnames_default()("ModalContact-item","ModalContact-link",{"is-disabled":"tel"===t.prefix&&!r});return react.createElement("div",{className:"col-xs-6 col-sm-4",key:`${t.label}-${a}`},react.createElement("a",{className:s,href:t.link,target:t.target,rel:t.rel},react.createElement("figure",null,react.createElement("img",{loading:"lazy",src:t.image,width:"40",alt:t.type})),react.createElement("div",{className:"ModalContact-checkbox"},(null==l?void 0:l.isOrganizer)&&"tel"===t.prefix&&react.createElement("input",{type:"checkbox",onChange:u,defaultChecked:null==l?void 0:l.enabled}),react.createElement("div",{className:"ModalContact-name"},t.type)),react.createElement("div",{className:"ModalContact-label",dangerouslySetInnerHTML:{__html:t.label}})))}))):react.createElement(pa,{faq:null==l?void 0:l.faq,title:null==l?void 0:l.faq_title}))};Ea.propTypes={handleCloseModal:index_5808dc9d.p.exports.func};const fa=t=>{const{t:a}=(0,useTranslation/* useTranslation */.$)();let s,n,r,o,l;const{type:c}=t;switch(c){case"beneficiary":s=t.text,n=a("header.notification.cta-beneficiary"),r=a("/mi-suscripcion/beneficiario/");break;case"billing":s=a("header.notification.text-billing"),n=a("header.notification.cta-billing"),r=a("/mi-suscripcion/facturas/"),l=!0;break;case"custom":({text:s,cta:n,url:r,img:o}=t);break;default:s=""}if(""===s)return null;const p=classnames_default()("HeaderNotification",{isRed:l});return react.createElement("div",{className:p},react.createElement("div",{className:"u-wrapper"},react.createElement("div",{className:"HeaderNotification-content"},react.createElement("div",{className:"HeaderNotification-content-left"},"custom"!==c?react.createElement(index_es/* FontAwesomeIcon */.G,{icon:pro_regular_svg_icons_faInfoCircle/* faInfoCircle */.sq}):react.createElement("figure",{className:"HeaderNotification-content-left-image"},react.createElement("img",{src:o,alt:"Notification Image"})),react.createElement("p",{className:"HeaderNotification-text",dangerouslySetInnerHTML:{__html:s}})),n&&react.createElement("a",{className:"HeaderNotification-anchor",onClick:()=>{var e;ga("platziFull.send","event",`Test-Notification-${null===(e=n)||void 0===e?void 0:e.replaceAll(" ","-")}`,"CTA","Click")},href:r},n))))};fa.propTypes={text:index_5808dc9d.p.exports.string,cta:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string,type:index_5808dc9d.p.exports.string,img:index_5808dc9d.p.exports.string};const ha=s=>{const{type:n,locale:r,url:o,time:l}=s,{getCookie:i}=(0,useRegisterModal_23dbb00b.c)(),{t:c}=(0,useTranslation/* useTranslation */.$)(),[m,p]=(0,react.useState)(""),[d,u]=(0,react.useState)(""),[C,E]=(0,react.useState)(""),[f,x]=(0,react.useState)(""),v=((e,t)=>{if(!e||""===e)return"-";const a=e.replace(" ","T");moment_default().locale(t||"es");let s=moment_default()(a).format("DD MMM YYYY");return s=s.replace(s.charAt(3),s.charAt(3).toUpperCase()),s})(f,r);if((0,react.useEffect)((()=>{p(i(`${n}_name`)),u(i(`${n}_avatar`)&&i(`${n}_avatar`).replaceAll('"',"")),E(o&&o.replaceAll('"',"")),x(l)}),[]),!C&&!f)return null;return react.createElement("a",{href:C},react.createElement("div",{className:`StickyCustomBanner StickyCustomBanner--${n}`},react.createElement("div",{className:"u-wrapper"},react.createElement("div",{className:"StickyCustomBanner-container"},react.createElement("span",{className:"StickyCustomBanner-icon"},react.createElement("img",{src:"https://static.platzi.com/ui/assets/image/gift-notification816b8f5c05fc3d63.png",alt:"banner icon"})),react.createElement("div",{className:"StickyCustomBanner-info"},react.createElement("div",{className:"StickyCustomBanner-content"},react.createElement("img",{src:d,className:"StickyCustomBanner-avatar",alt:`Avatar ${m}`}),react.createElement("p",{className:"StickyCustomBanner-description",dangerouslySetInnerHTML:{__html:c(`${n}.stickyCustomBanner.description`,{name:m,expirationDate:v})}})),react.createElement("div",{className:"StickyCustomBanner-cta"},react.createElement("a",{href:C,className:"StickyCustomBanner-btn"},c(`${n}.stickyCustomBanner.cta`)))),react.createElement("div",{className:"StickyCustomBanner-countdown"},react.createElement("p",{className:"StickyCustomBanner-countdownTitle"},c(`${n}.stickyCustomBanner.countdownTitle`)),f&&react.createElement(dist_index_es,{date:f,onComplete:()=>{window.location.reload()},renderer:({days:t,hours:a,minutes:s,seconds:n})=>{const r=0===t;return react.createElement("div",{className:"StickyCustomBanner-countdownWrapper"},!r&&react.createElement("div",{className:"StickyCustomBanner-countdownSingle"},react.createElement("strong",null,String(t).padStart(2,"0"),"D")),react.createElement("div",{className:"StickyCustomBanner-countdownSingle"},react.createElement("strong",null,String(a).padStart(2,"0"),"H")),react.createElement("div",{className:"StickyCustomBanner-countdownSingle"},react.createElement("strong",null,String(s).padStart(2,"0"),"M")),react.createElement("div",{className:"StickyCustomBanner-countdownSingle"},react.createElement("strong",null,String(n).padStart(2,"0"),"S")))}}))))))};ha.propTypes={type:index_5808dc9d.p.exports.oneOf(["referral","individual_promo"]),locale:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string,time:index_5808dc9d.p.exports.string};var xa=function(e,t){return"/login/".concat(e,"/").concat(t?"?next=".concat(t,"%3fskp_onb=1"):"")},va=[{name:"google-oauth2",icon:faGoogle/* faGoogle */.xY,publicName:"Google",color:"#EA7065",url:function(e){return xa(this.name,e)}},{name:"facebook",icon:faFacebook/* faFacebook */.ne,publicName:"Facebook",color:"#3F92FC",url:function(e){return xa(this.name,e)}},{name:"twitter",icon:faTwitter/* faTwitter */.md,publicName:"Twitter",color:"#49B7FA",url:function(e){return xa(this.name,e)}},{name:"email",color:"#49B7FA",icon:faEnvelope/* faEnvelope */.FU,publicName:"Correo y Contraseña",url:function(e){return"/onboarding/?next=".concat(e)}}],ba=function(t){var a=t.nextUrl,s=t.messages,n=t.extraDataEvent,r=window.location.pathname;return react.createElement("div",{className:"InnerRegisterModal"},react.createElement(lt,{className:"InnerRegisterModal-head"},react.createElement("h3",{className:"InnerRegisterModal-head-title"},s.headTitle),react.createElement("p",{className:"InnerRegisterModal-head-description"},s.headDescription)),react.createElement(Rs,null,react.createElement("p",{className:"InnerRegisterModal-body-title"},s.bodyTitle),react.createElement("div",{className:"InnerRegisterModal-body-social"},va.map((function(t){return react.createElement(ka,{network:t,key:t.name,nextUrl:a})}))),react.createElement("div",{className:"InnerRegisterModal-body-login"},react.createElement("p",null,s.bodyLogin," ",react.createElement("a",{onClick:function(){index_7de6c45f.T.send((0,tslib_es6/* __assign */.pi)({event:"register_modal_button_click",source:r,provider:"login"},n))},href:"".concat("/login/").concat(a?"?next=".concat(a):"")},s.bodyLoginCTA)))))};ba.defaultProps={extraDataEvent:{}};var ya=function(t){return react.createElement(zs,{show:t.isOpen,portalId:"RegisterModal",close:t.closeModal,showFromBottom:!0},react.createElement(Is,{closeModal:t.closeModal},react.createElement(ba,{nextUrl:t.nextUrl,messages:t.messages,extraDataEvent:t.extraDataEvent})))};ya.defaultProps={isOpen:!1,closeModal:function(){return null},nextUrl:"",messages:{headTitle:"Regístrate sin costo y sigue aprendiendo",headDescription:"Con una cuenta gratuita puedes ver muchas más clases gratis, crear planes de estudio y participar en la comunidad.",bodyTitle:"Regístrate con:",bodyLogin:"¿Ya tienes una cuenta?",bodyLoginCTA:"Inicia Sesión"},extraDataEvent:{}};var Na=function(){"undefined"!=typeof window&&(window.localStorage.removeItem("credentials_token"),window.localStorage.removeItem("credentials_microservicesUrl"),window.localStorage.removeItem("credentials_headers"))},ka=function(t){var a=t.network,s=t.nextUrl,n=t.extraDataEvent;return react.createElement("div",{className:"SocialNetworkSSO SocialNetworkSSO--".concat(a.name),onSubmit:Na},react.createElement("a",{href:a.url(s),onClick:function(){var e=window.location.pathname;index_7de6c45f.T.send((0,tslib_es6/* __assign */.pi)({event:"register_modal_button_click",source:e,provider:a.name},n)),Na()},className:"SocialNetworkSSO"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:a.icon,color:a.color}),a.publicName))};ka.defaultProps={nextUrl:"",extraDataEvent:{}};const Da=s=>{const[n,r]=(0,react.useState)({isTop:!0,overlay:!1,menuOpen:!1,actionsOpen:!1,contactOpen:s.openContact||!1,tinkerbellOpen:!1,miniSearchOpen:!1,plansOpen:!1,searchOpen:!1}),{getCookie:o}=(0,useRegisterModal_23dbb00b.c)(),{isRegisterModalOpen:l,openRegisterModal:c,closeRegisterModal:m,configRegisterModal:p}=(0,useRegisterModal_23dbb00b.e)(),[d,u]=(0,react.useState)(void 0),{isHispanic:g,locale:C,isDark:E,notificationDisabled:f,noReferralBanner:h,noUsernameBanner:x,headerNotification:b,customLogo:y,userInfo:N,isTransparent:k,isExperimentHome:D,getMenuOpenState:w}=s,B=n.contactOpen,F=classnames_default()("Header-v2",{"is-transparent-header":k&&!n.menuOpen},"Header-v2-content",{"Header-v2--is-sticky":n.menuOpen},{"is-dark-header":E&&(!k||n.menuOpen)}),S=[{type:"individual_promo",show:!x},{type:"referral",show:!h}];(0,react.useEffect)((()=>{const e=document.getElementById("selectLanguage")||null,t=new URLSearchParams(window.location.search);if("sso"===t.get("status")&&index_7de6c45f.T.send({event:"sso_success_registration",type:t.get("account"),provider:t.get("provider")}),e){const t=document.getElementById("laguageDropdown");e.addEventListener("click",(function(){t.classList.toggle("Footer-languageShow")}))}document.cookie=`isLogged=${s.isLogged};path=/`,s.isLogged&&M(),_()}),[]);const _=()=>{let e,t=!1;for(let a=0;a<S.length&&!t;a++){const s=S[a];if(s.show){const a=o(`${s.type}_url`),n=o(`${s.type}_expire`);e={url:a,time:n,type:s.type},t=a&&n&&s.type}}u(e)},M=async()=>{try{const e=await DataDogAsyncCollector_03c24e8a_p();await s.updateUserInfo(e)}catch(e){throw new Error(e)}},T=()=>{r({...n,overlay:!1,menuOpen:!1,actionsOpen:!1,tinkerbellOpen:!1,searchOpen:!1,miniSearchOpen:!1,plansOpen:!1,contactOpen:!1,billingOpen:!1}),s.showBillingModal(!1)};(0,react.useEffect)((()=>{n.menuOpen?document.querySelector("body").classList.add("fixedBody"):document.querySelector("body").classList.remove("fixedBody")}),[n.menuOpen]);return react.createElement(react.Fragment,null,n.overlay&&react.createElement("div",{id:"overlay",className:"Header-v2-overlay showOverlay",onClick:T,role:"button",tabIndex:"0",onKeyPress:e=>{"Escape"===e.key&&T()}}),B&&react.createElement(rt,{show:B,close:n.handleOverlay},react.createElement(Ea,{handleCloseModal:T})),react.createElement("header",{id:"Header-v2",className:F},react.createElement(ca,(0,_rollupPluginBabelHelpers_1fef267c._)({},s,n,{customLogo:y,handleContact:()=>{r({...n,overlay:!1,menuOpen:!1,actionsOpen:!1,tinkerbellOpen:!1,searchOpen:!1,miniSearchOpen:!1,plansOpen:!1,contactOpen:!0,billingOpen:!1})},handleOpen:e=>{"menuOpen"===e&&w(!n[e]),r({...n,menuOpen:!1,actionsOpen:!1,tinkerbellOpen:!1,searchOpen:!1,miniSearchOpen:!1,plansOpen:!1,overlay:!n[e],[e]:!n[e]})},handleOpenRegisterModal:()=>{const e=window.location.pathname;c({source:"header",path:e})}}))),D&&react.createElement(ya,(0,_rollupPluginBabelHelpers_1fef267c._)({isOpen:l,closeModal:()=>{const e=window.location.pathname;m({path:e})}},p)),!g&&"es"===C&&react.createElement(ma,null),d&&react.createElement(ha,(0,_rollupPluginBabelHelpers_1fef267c._)({},d,{locale:C})),!f&&b&&react.createElement(fa,(0,_rollupPluginBabelHelpers_1fef267c._)({},b,{img:N.avatar})))};Da.propTypes={locale:index_5808dc9d.p.exports.string,userType:index_5808dc9d.p.exports.string,headerNotification:index_5808dc9d.p.exports.object,customLogo:index_5808dc9d.p.exports.string,userInfo:index_5808dc9d.p.exports.object,isLogged:index_5808dc9d.p.exports.bool,basicUpgrade:index_5808dc9d.p.exports.object,isTransparent:index_5808dc9d.p.exports.bool,isExperimentHome:index_5808dc9d.p.exports.bool,getMenuOpenState:index_5808dc9d.p.exports.func},Da.defaultProps={getMenuOpenState:()=>{}};var wa=(0,es/* connect */.$j)((e=>({userId:e.get("header").get("userInfo").get("userId"),userName:e.get("header").get("userInfo").get("username"),userType:e.get("header").get("userInfo").get("userType")})),{showBillingModal:index_77f09d62_e,updateUserInfo:index_77f09d62_o})(Da);const Ba=t=>react.createElement("div",{className:"Award"},react.createElement("a",{href:t.url,target:"_blank",rel:"noreferrer",className:"Award-link"},react.createElement("figure",null,react.createElement("img",{loading:"lazy",src:t.logo,alt:t.name}))));Ba.propTypes={logo:index_5808dc9d.p.exports.string,name:index_5808dc9d.p.exports.string};const Fa=({color:t,name:a,url:s})=>react.createElement("div",{href:s,className:"Category",style:{borderLeft:`solid 3px ${t}`}},react.createElement("a",{href:s},a),react.createElement("div",{className:"Arrow"}));Fa.propTypes={color:index_5808dc9d.p.exports.string.isRequired,name:index_5808dc9d.p.exports.string.isRequired,url:index_5808dc9d.p.exports.string.isRequired};const Sa=({categories:t})=>react.createElement("div",{className:"CategoriesSection"},t.map((t=>react.createElement(Fa,(0,_rollupPluginBabelHelpers_1fef267c._)({key:t.url},t)))));Sa.propTypes={categories:index_5808dc9d.p.exports.array.isRequired};const _a=t=>react.createElement("div",{className:"Certifier"},react.createElement("a",{href:t.url,target:"_blank",rel:"noreferrer",className:"Certifier-link"},react.createElement("figure",null,react.createElement("img",{loading:"lazy",src:t.logo,alt:t.name}))));_a.propTypes={logo:index_5808dc9d.p.exports.string,name:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string};const Ma=t=>react.createElement("img",{loading:"lazy",className:"FlagCircle",src:t.src,alt:t.countryName,width:t.width,height:t.height,onError:e=>{e.target.src=t.fallBackSrc||"https://static.platzi.com/ui/assets/image/teambadged8b0d2c394c9c8d9.png"}});Ma.propTypes={src:index_5808dc9d.p.exports.string.isRequired,countryName:index_5808dc9d.p.exports.string,width:index_5808dc9d.p.exports.string,height:index_5808dc9d.p.exports.string,fallBackSrc:index_5808dc9d.p.exports.string},Ma.defaultProps={alt:"Country",width:"16px",height:"16px"};const Ta=t=>react.createElement("a",{className:"LangButton",href:t.url},react.createElement("span",null,t.lang),react.createElement(Ma,{src:t.flag,alt:t.lang_name}));Ta.propTypes={url:index_5808dc9d.p.exports.string,lang:index_5808dc9d.p.exports.string,lang_name:index_5808dc9d.p.exports.string,flag:index_5808dc9d.p.exports.string},Ta.defaultProps={url:"/",lang_name:"Language"};const Aa=t=>react.createElement("a",{href:t.url,className:"MenuItem"},t.title);Aa.propTypes={url:index_5808dc9d.p.exports.string,title:index_5808dc9d.p.exports.string};const La=({logo:t})=>{const{t:a}=(0,useTranslation/* useTranslation */.$)();return react.createElement("div",{className:"SloganSection"},react.createElement("figure",null,react.createElement("img",{loading:"lazy",src:t,alt:"Platzi"})),react.createElement("p",null,react.createElement("span",null,a("qualityEducation"))))};La.propTypes={logo:index_5808dc9d.p.exports.string};const Pa=t=>react.createElement("a",{href:t.url,className:"SocialItem",target:"_blank",rel:"noreferrer"},(t=>{let a;switch(t){case"icon-twt":a=faTwitter/* faTwitter */.md;break;case"icon-youtube-play":a=faYoutube/* faYoutube */.op;break;case"icon-fcbk":a=faFacebookF/* faFacebookF */.AY;break;case"icon-instagram":a=faInstagram/* faInstagram */.Zz}return a?react.createElement(index_es/* FontAwesomeIcon */.G,{icon:a}):null})(t.icon));Pa.propTypes={url:index_5808dc9d.p.exports.string,icon:index_5808dc9d.p.exports.string};const Oa=t=>{const{t:a}=(0,useTranslation/* useTranslation */.$)();return react.createElement(Layout_981b30d6_r,{className:"SocialLayout"},react.createElement("span",null,a("FooterfollowUs")),t.socials.map(((t,a)=>react.createElement(Pa,(0,_rollupPluginBabelHelpers_1fef267c._)({key:`social-${a}`},t)))))};Oa.propTypes={socials:index_5808dc9d.p.exports.array};const{axiosInstance:Ia}=index_f0f30b4f_h;class Ra extends react.Component{constructor(...e){return super(...e),this.state={subscribe:"",subscribed:!1},this.handleSubmit=e=>{e.preventDefault();const t=window.location.href,a=new FormData(e.target);a.append("full_path",t),(e=>Ia(!0).post("/webhookemail/hola/",e))(a).then((()=>{this.setState({subscribe:"",subscribed:!0})}))},this.handleContent=(e,t)=>{this.setState({[t]:e})},this}render(){const{t:t}=this.props;return react.createElement("div",{className:"SubscribeSectionV2 u-wrapper"},react.createElement("div",{className:"SubscribeSectionV2-copy"},react.createElement("span",null,t("SubscribeSectionTitle"))),this.state.subscribed?react.createElement("div",{className:"SubscribeSectionV2-subscribed"},t("SubscribeSectionSuccess")):react.createElement("form",{onSubmit:this.handleSubmit,className:"SubscribeSectionV2-form"},react.createElement("input",{type:"hidden",name:"origin",value:"footer_subscription"}),react.createElement(AccountFooter_a9001bf4_c,{name:"subscribe",id:"subscribe",className:"SubscribeInput",formattedMessageId:"EnterYourEmail",defaultMessage:"Tu Correo electrónico",value:this.state.subscribe,handleContent:this.handleContent,error:!!this.props.errors&&this.props.errors.get("subscribe"),type:"email",required:!0}),react.createElement("button",{className:"btn btn-sky btn--medium"},react.createElement("span",null,t("SubscribeSectionCTA")))))}}Ra.propTypes={errors:index_5808dc9d.p.exports.object};var za=index_f0f30b4f_m.ReactTranslationsHOC(Ra);const ja=t=>{const{t:a}=(0,useTranslation/* useTranslation */.$)(),{logo:s,socials:n,categories:r,certifiers:o,awards:l,options:c,languages:p,locale:d,theme:u}=t,C=classnames_default()("Footer",{"Footer--dark":"dark"===u});return react.createElement("footer",{className:C},react.createElement(Layout_981b30d6_r,{className:"FooterContainer-up"},react.createElement(Layout_981b30d6_r,{className:"u-wrapper FooterGrid-up"},react.createElement(La,{logo:s}),react.createElement(Oa,{socials:n}),react.createElement(Sa,{categories:r}),react.createElement(Layout_981b30d6_r,{className:"CertifiersLayout"},react.createElement("span",null,a("CertifiersText")),o.map(((t,a)=>react.createElement(_a,(0,_rollupPluginBabelHelpers_1fef267c._)({key:`Certifier-${a}`},t))))),react.createElement(Layout_981b30d6_r,{className:"AwardsLayout"},react.createElement("span",null,a("awardsText")),l.map(((t,a)=>react.createElement(Ba,(0,_rollupPluginBabelHelpers_1fef267c._)({key:`Award-${a}`},t))))))),react.createElement(Layout_981b30d6_r,{className:"FooterContainer-mid"},react.createElement(za,null)),react.createElement(Layout_981b30d6_r,{className:"FooterContainer-bottom"},react.createElement(Layout_981b30d6_r,{className:"u-wrapper FooterGrid-bottom"},react.createElement(Layout_981b30d6_r,{className:"MenuLayout"},c.map(((t,a)=>react.createElement(Aa,(0,_rollupPluginBabelHelpers_1fef267c._)({key:`MenuItem-${a}`},t))))),react.createElement(Layout_981b30d6_r,{className:"LanguageLayout"},p.filter((e=>e.lang!==d)).map(((t,a)=>react.createElement(Ta,(0,_rollupPluginBabelHelpers_1fef267c._)({key:`LangButton-${a}`},t))))),react.createElement("p",{className:"LoveLayout"},react.createElement("span",null,a("fromLatam")),react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faHeart/* faHeart */.m6}),react.createElement("span",null,a("toTheWorld"))))))};ja.propTypes={logo:index_5808dc9d.p.exports.string,socials:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({icon:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string})),categories:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({color:index_5808dc9d.p.exports.string,name:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string})),certifiers:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({logo:index_5808dc9d.p.exports.string,name:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string})),awards:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({logo:index_5808dc9d.p.exports.string,name:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string})),options:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({title:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string})),languages:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({lang_name:index_5808dc9d.p.exports.string,lang:index_5808dc9d.p.exports.string,flag:index_5808dc9d.p.exports.string,url:index_5808dc9d.p.exports.string})),locale:index_5808dc9d.p.exports.string,theme:index_5808dc9d.p.exports.oneOf(["dark",""])},config$1.autoAddCss=!1;const qa=t=>{var a;const{children:s,noFooter:n,noBanner:r,noReferralBanner:o,noUsernameBanner:l,notificationDisabled:i,isDark:c,customLogo:m,renderBanner:p,isTransparent:d,isExperimentHome:u,getMenuOpenState:g}=t,C=(null===(a=(0,es/* useSelector */.v9)((e=>null==e?void 0:e.get("header"))))||void 0===a?void 0:a.toJS())||{},E=(null==C?void 0:C.promo_banner)||{},f=!r&&(null==E?void 0:E.active);return react.createElement(react.Fragment,null,react.createElement(wa,(0,_rollupPluginBabelHelpers_1fef267c._)({openContact:!1},C,{isDark:c,customLogo:m,notificationDisabled:i,noUsernameBanner:l,noReferralBanner:o,isTransparent:d,isExperimentHome:u,getMenuOpenState:g})),f&&(p&&p(E)||react.createElement(PromoBanner_b380d5ea_g,(0,_rollupPluginBabelHelpers_1fef267c._)({},E,{isLogged:null==C?void 0:C.isLogged}))),s,!n&&react.createElement(ja,{options:C.options,socials:C.socials,awards:C.awards,languages:C.languages,locale:C.locale,categories:C.categories,certifiers:C.official_companies,logo:C.logo,theme:c?"dark":""}))};qa.propTypes={noBanner:index_5808dc9d.p.exports.bool,isDark:index_5808dc9d.p.exports.bool,notificationDisabled:index_5808dc9d.p.exports.bool,customLogo:index_5808dc9d.p.exports.string,renderBanner:index_5808dc9d.p.exports.func,isTransparent:index_5808dc9d.p.exports.bool,getMenuOpenState:index_5808dc9d.p.exports.func},qa.defaultProps={noBanner:!1,isDark:!1,notificationDisabled:!1,headerNotification:null,noUsernameBanner:null,renderBanner:null,isTransparent:!1,isExperimentHome:!1,getMenuOpenState:()=>{}};var Ha,Ua={plans:[],benefits:{},messages:{},userType:"user",ctaEvents:void 0,locale:"es",theme:"dark",selectedPlan:void 0,noSingleCards:void 0,experiment:"c"},$a=function(e){switch(e){case"basic":return constants/* PLAN_BASIC */.zo;case"expert":return constants/* PLAN_EXPERT */.ag;case"duo":return constants/* PLAN_EXPERT_DUO */.P2;case"family":return constants/* PLAN_FAMILY */.yP;case"b2b":return"b2b";default:return""}},Va=function(e,t){if(!e||0===e.length)return null;var a=t.selectedPlan,s=t.experiment,n=e.filter((function(e){var t;return null===(t=null==e?void 0:e.promo)||void 0===t?void 0:t.active})),r=n.length,o=e.find((function(e){return e.name===constants/* PLAN_EXPERT */.ag})),l=e.find((function(e){var t,n,l=e.name,i=o&&(null===(t=o.promo)||void 0===t?void 0:t.active),c=null===(n=null==e?void 0:e.promo)||void 0===n?void 0:n.active,m=null==e?void 0:e.highlight,p=$a(a);return p&&p===l||"b2b"!==p&&s&&"expert"===l||!p&&c&&m?e:!p&&r>1&&i?l===constants/* PLAN_EXPERT */.ag:!p&&m?e:void 0}))||o||e[0];return s&&"duo"===a?(0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({},l),{defaultPlan:constants/* PLAN_EXPERT_DUO */.P2}):l},Ka=function(e,t){var a=t.messages;return 1===e?a.studentsSlots(1):e>1?a.studentsSlotsPlural(e):""},Wa=function(e,t){var a=t.isSinglePlan,s=t.fullBenefits,n=t.benefits,r=t.isB2b;if(a){var o=[];return 1===(null==e?void 0:e.length)?s:(null==e||e.forEach((function(e){if("b2b"!==e.name){var t=e.benefits;o.length<t.length&&(o=t)}})),o)}if(r){var l=[];return null==e||e.forEach((function(e){if("b2b"===e.name){var t=e.items;Object.keys(t).forEach((function(e){var a=t[e],s=null==a?void 0:a.benefits;l.length<s.length&&(l=s)}))}})),l}return n},Ga=[10,11,12,13,16,21],Ja={"platzi-installments":"pricing.benefits.extra.4_installments","cc-12-installments":"pricing.benefits.extra.12_installments"},Xa={text:index_5808dc9d.p.exports.string},Ya=((Ha={})[index_5808dc9d.p.exports.string]=index_5808dc9d.p.exports.shape(Xa),Ha),Za={title:index_5808dc9d.p.exports.string,content:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({id:index_5808dc9d.p.exports.number,text:index_5808dc9d.p.exports.string,tooltip:index_5808dc9d.p.exports.string}))},Qa={features:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape(Za))},ModalPortal_040aa0eb_es={active:index_5808dc9d.p.exports.bool,link:index_5808dc9d.p.exports.string,endAt:index_5808dc9d.p.exports.string,styles:index_5808dc9d.p.exports.object,discountAmount:index_5808dc9d.p.exports.string},ts={name:index_5808dc9d.p.exports.string,students:index_5808dc9d.p.exports.number,promo:index_5808dc9d.p.exports.shape(ModalPortal_040aa0eb_es),price:index_5808dc9d.p.exports.string,title:index_5808dc9d.p.exports.string,buyUrl:index_5808dc9d.p.exports.string,planPrice:index_5808dc9d.p.exports.string,installmentPrice:index_5808dc9d.p.exports.string,slug:index_5808dc9d.p.exports.string,flagUrl:index_5808dc9d.p.exports.string,symbol:index_5808dc9d.p.exports.string,priceMonth:index_5808dc9d.p.exports.string,annualPrice:index_5808dc9d.p.exports.string,fullPrice:index_5808dc9d.p.exports.string,saveMoney:index_5808dc9d.p.exports.string,currencyCode:index_5808dc9d.p.exports.string,highlight:index_5808dc9d.p.exports.bool,frequency:index_5808dc9d.p.exports.oneOf(["monthly","annual"]),features:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.number),benefits:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.oneOfType([index_5808dc9d.p.exports.string,index_5808dc9d.p.exports.number])),extraBenefits:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.string)};(0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({},Qa),{benefits:index_5808dc9d.p.exports.shape(Ya),locale:index_5808dc9d.p.exports.string,academyPlan:index_5808dc9d.p.exports.object,flagUrl:index_5808dc9d.p.exports.string,currencyText:index_5808dc9d.p.exports.string,totalCourses:index_5808dc9d.p.exports.number,course:index_5808dc9d.p.exports.shape((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({},ts),{courseName:index_5808dc9d.p.exports.string})),plans:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape(ts))});var as={studentsSlots:index_5808dc9d.p.exports.func,studentsSlotsPlural:index_5808dc9d.p.exports.func,priceFrequency:index_5808dc9d.p.exports.string,planFrequency:index_5808dc9d.p.exports.func,saveMoneyBasic:index_5808dc9d.p.exports.func,ctaContact:index_5808dc9d.p.exports.string,cta:index_5808dc9d.p.exports.func,ctaAlt:index_5808dc9d.p.exports.string,highlight:index_5808dc9d.p.exports.string,promoBefore:index_5808dc9d.p.exports.string,compareWith:index_5808dc9d.p.exports.func,benefitsFrom:index_5808dc9d.p.exports.func,benefitsLabel:index_5808dc9d.p.exports.func,saveMoney:index_5808dc9d.p.exports.func,recurrentBasic:index_5808dc9d.p.exports.string,annualFrequency:index_5808dc9d.p.exports.string,copyFrequency:index_5808dc9d.p.exports.func,copyB2B:index_5808dc9d.p.exports.func,descriptionB2B:index_5808dc9d.p.exports.string},ss=(0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({},ts),{benefitsList:index_5808dc9d.p.exports.shape(Ya),plans:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape(ts)),prevPlan:index_5808dc9d.p.exports.shape(ts),messages:index_5808dc9d.p.exports.shape(as),screenType:index_5808dc9d.p.exports.oneOf(["mobile","desktop"]),userType:index_5808dc9d.p.exports.oneOf(["user","b2b"]),ctaEvents:index_5808dc9d.p.exports.func,theme:index_5808dc9d.p.exports.oneOf(["dark","light","darker"]),setSelectedTitleTab:index_5808dc9d.p.exports.func}),ns={benefits:[],plans:[],title:"",extraBenefits:void 0,installmentPrice:"",theme:"dark",setSelectedPlanInfo:function(){}},rs=function(t){var a=t.benefit;t.toggleModal;var s=t.formattedInstallmentPrice,n=t.messages,r=a.id,o=a.fees;n.installmentsBtnText;var l=n.extraBenefitContent,i=o?faChartPieAlt/* faChartPieAlt */.ki:faCreditCard/* faCreditCard */.Oz;return react.createElement("li",{className:"ExtraBenefitItem"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:i,className:"ExtraBenefitItem-icon"}),react.createElement("div",{className:"ExtraBenefitItem-content"},react.createElement("p",{dangerouslySetInnerHTML:{__html:l(Ja[r],{price:s,fees:o})}})))};rs.propTypes={benefit:index_5808dc9d.p.exports.string.isRequired,toggleModal:index_5808dc9d.p.exports.func.isRequired,formattedInstallmentPrice:index_5808dc9d.p.exports.string.isRequired,messages:index_5808dc9d.p.exports.object};var os=function(t){var a=t.extraBenefits,s=t.formattedInstallmentPrice,n=t.planName,r=t.toggleModal,o=t.theme,l=t.messages;if(!a||0===a.length)return null;var c=classnames_default()("ExtraBenefits",{"ExtraBenefits--dark":"dark"===o,"ExtraBenefits--light":"light"===o});return react.createElement("ul",{"aria-label":l.installmentsInformation(n),className:c},a.map((function(t){return react.createElement(rs,{key:t.id,benefit:t,toggleModal:r,formattedInstallmentPrice:s,messages:l})})))};os.propTypes={extraBenefits:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.string).isRequired,formattedInstallmentPrice:index_5808dc9d.p.exports.string.isRequired,planName:index_5808dc9d.p.exports.string.isRequired,toggleModal:index_5808dc9d.p.exports.func,theme:index_5808dc9d.p.exports.oneOf(["dark","light","darker"]),messages:index_5808dc9d.p.exports.object},os.defaultProps={theme:"dark"},(0,dayjs_min.locale)("es");var ls=function(t){var a=t.formattedInstallmentPrice,s=t.messages,n=t.fees,r=s.installmentsModalTodayDate,o=a.split(" ")[0],l=function(e,t){return Array.from(Array(e)).map((function(e,a){return 0===a?t:dayjs_min_default()().add(a,"months").format("DD MMM")}))}(n,r),c=classnames_default()("TimelineInstallments",{"TimelineInstallments--small":n<=2});return react.createElement("section",{className:c},react.createElement("div",{className:"TimelineInstallments-container"},l.map((function(t){return react.createElement("div",{key:t,className:"TimelineInstallments-item"},react.createElement("span",{className:"TimelineInstallments-dot"}),react.createElement("p",{className:"TimelineInstallments-price"},react.createElement("strong",{className:"TimelineInstallments-date"},t),o))}))))};ls.propTypes={formattedInstallmentPrice:index_5808dc9d.p.exports.string.isRequired,messages:index_5808dc9d.p.exports.object,fees:index_5808dc9d.p.exports.number};var ModalPortal_040aa0eb_is=function(t){var a=t.closeModal,s=t.planName,n=t.buyUrl,r=t.formattedInstallmentPrice,o=t.messages,l=t.extraBenefits;if(!t.show)return null;var i=l.find((function(e){return"platzi-installments"===e.id}))||null,c=(null==i?void 0:i.fees)||1,p=o.installmentsModalTitle,d=o.installmentsModalCloseBtnLabel,u=o.installmentsStepsLabel,g=o.installmentsSteps,C=o.installmentsConditions,E=o.installmentsModalCta,f=p(s,c);return react.createElement(rt,{close:a,show:!0},react.createElement("div",{className:"exit-cross"},react.createElement("button",{"aria-label":d,className:"exit-cross-button",onClick:a,type:"button"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:free_solid_svg_icons_faTimes/* faTimes */.NB}))),react.createElement("section",{className:"ModalInstallments-content"},react.createElement("header",{className:"ModalInstallments-header"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faChartPieAlt/* faChartPieAlt */.ki,className:"ModalInstallments-icon"}),react.createElement("h3",{className:"ModalInstallments-title"},f)),react.createElement("ol",{className:"ModalInstallments-steps","aria-label":u(c)},react.createElement("li",{dangerouslySetInnerHTML:{__html:g.step1(s,n)},className:"ModalInstallments-step"}),react.createElement("li",{className:"ModalInstallments-step"},g.step2),react.createElement("li",{className:"ModalInstallments-step"},g.step3(c)),react.createElement("li",{className:"ModalInstallments-step"},g.step4)),react.createElement(ls,{formattedInstallmentPrice:r,messages:o,fees:c}),react.createElement("section",{className:"ModalInstallments-conditions","aria-label":C.label},react.createElement("p",null,C.text1),react.createElement("p",null,C.text2))),react.createElement("footer",{className:"ModalInstallments-footer"},react.createElement("button",{type:"button",onClick:a,className:"ModalInstallments-footer-btn btn btn-sky"},E)))};ModalPortal_040aa0eb_is.propTypes={closeModal:index_5808dc9d.p.exports.func.isRequired,planName:index_5808dc9d.p.exports.string.isRequired,buyUrl:index_5808dc9d.p.exports.string.isRequired,formattedInstallmentPrice:index_5808dc9d.p.exports.string.isRequired,messages:index_5808dc9d.p.exports.object,extraBenefits:index_5808dc9d.p.exports.array,show:index_5808dc9d.p.exports.bool};var cs=function(e){return e?faCheck/* faCheck */.LE:faTimes/* faTimes */.NB},ms=function(t){var s=t.list,n=t.item,r=t.status,o=t.prevPlan,l=t.theme,c=[];if((null==o?void 0:o.name)===constants/* PLAN_ACADEMY */.cY&&c.push(22),null==c?void 0:c.includes(n))return null;if("{}"===JSON.stringify(s))return null;var p=s[n];if(void 0===p)return null;var d=(0,react.useState)(!1),u=d[0],g=d[1],E=classnames_default()("Benefit",{"Benefit--on":r,"Benefit--off":!r,"Benefit--dark":"dark"===l,"Benefit--light":"light"===l,"Benefit--darker":"darker"===l}),f=function(){g(!u)};return react.createElement("li",{className:E},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:cs(r),className:"Benefit-icon"}),react.createElement("p",{className:"Benefit-text"},p.text),(null==p?void 0:p.tooltip)&&react.createElement("span",{className:"Benefit-tooltip"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faInfoCircle/* faInfoCircle */.sq,className:"Benefit-tooltipIcon",onMouseEnter:function(){return f()},onTouchStart:function(){return f()},onMouseLeave:function(){return f()},onTouchEnd:function(){return f()}}),react.createElement(BasicTooltip_61801623.B,{isActive:u,position:"left"},p.tooltip)))};ms.propTypes={list:index_5808dc9d.p.exports.shape(Ya).isRequired,item:index_5808dc9d.p.exports.number,status:index_5808dc9d.p.exports.bool,prevPlan:index_5808dc9d.p.exports.object,theme:index_5808dc9d.p.exports.oneOf(["dark","light","darker"])},ms.defaultProps={theme:"dark"};var ps=function(t){var a=t.title,s=t.fullBenefitsList,n=t.benefitsList,r=t.benefits,o=t.prevPlan,l=t.messages,c=t.userType,p=t.theme,d=l.benefitsLabel(a),u=c===constants/* USER_TYPE */.$A,g=c===constants/* B2B_TYPE */.DN,C=classnames_default()("Benefit","Benefit--previous",{"Benefit--dark":"dark"===p,"Benefit--light":"light"===p,"Benefit--darker":"darker"===p});return react.createElement(react.Fragment,null,u&&react.createElement(react.Fragment,null,react.createElement("ul",{"aria-label":d,className:"Benefits"},s.map((function(t){var a=r.includes(t);return react.createElement(ms,{key:t,list:n,item:t,status:a,theme:p})})))),g&&react.createElement("ul",{"aria-label":d,className:"Benefits"},o&&react.createElement("li",{className:C},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:pro_regular_svg_icons_faSparkles/* faSparkles */.Jy,className:"Benefit-icon"}),l.benefitsFrom(null==o?void 0:o.title)),r.filter((function(e){return!(null==o?void 0:o.benefits.includes(e))})).map((function(t){return react.createElement(ms,{key:t,list:n,item:t,status:!0,prevPlan:o,theme:p})}))))};ps.propTypes={benefitsLabel:index_5808dc9d.p.exports.string,fullBenefitsList:index_5808dc9d.p.exports.array,benefitsList:index_5808dc9d.p.exports.object,benefits:index_5808dc9d.p.exports.array,prevPlan:index_5808dc9d.p.exports.object,messages:index_5808dc9d.p.exports.object,userType:index_5808dc9d.p.exports.string,theme:index_5808dc9d.p.exports.oneOf(["dark","light","darker"]),title:index_5808dc9d.p.exports.string},ps.defaultProps={theme:"dark"};var ds=function(s){var n,r,o=s.highlight,l=s.ctaEvents,c=s.userType,m=s.theme,p=s.messages,d=s.name,u=s.title,g=s.description,C=s.students,E=s.frequency,f=s.planPrice,h=s.symbol,x=s.price,v=s.flagUrl,b=s.currencyCode,y=s.buyUrl,N=s.fullPrice,k=s.priceMonth,D=s.promo,w=s.benefits,B=s.benefitsList,F=s.plans,S=s.prevPlan,_=s.extraBenefits,M=s.installmentPrice,T=s.experiment,A=s.items,L=s.defaultPlan,P=s.licenceMin,O=s.licenceMax,I=s.defaultExpertPlan,R=s.setSelectedPlanInfo;if("b2b"!==d&&"expert"!==d&&!y&&!x)return null;var z=null==D?void 0:D.active,j=null==D?void 0:D.styles,q=null==D?void 0:D.discountAmount,H=c===constants/* B2B_TYPE */.DN,U=d===constants/* PLAN_BASIC */.zo,$=o&&p.highlight,K=d!==constants/* PLAN_BASIC */.zo||o,W=(0,react.useState)(!1),J=W[0],X=W[1],Y="b2b"!==d?"".concat(h).concat(M):"",Z=classnames_default()("PriceCard",d,"experiment-".concat(T),{"PriceCard--promo":z,"PriceCard--b2b":H,"PriceCard--dark":"dark"===m,"PriceCard--light":"light"===m,"PriceCard--darker":"darker"===m,"PriceCard--highlight":$}),Q="expert"===d,ee="b2b"===d&&A&&A[L]||null,te=ee&&(0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({},ee),{currentValue:ee.licenceMin})||null,ae=(0,react.useState)(te),se=ae[0],ne=ae[1],re=(0,react.useState)(null),oe=re[0],le=re[1],ie={isSinglePlan:U,fullBenefits:Ga,benefits:w,selectedPlan:"b2b"===d?null==se?void 0:se.name:"",isB2b:"b2b"===d},ce=Wa(F,ie),me=A&&(null===(n=A[null==se?void 0:se.name])||void 0===n?void 0:n.benefits)||[],pe="b2b"===d?me:w,de="expert"===d?"".concat(h).concat(null==oe?void 0:oe.installmentPrice):Y;return (0,react.useEffect)((function(){if("expert"===d){var e=A&&A[I||L]||null,t=e&&(0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({},e),{currentValue:I||L})||null;le(t)}}),[]),react.createElement("div",{className:Z},react.createElement("div",{className:"PriceCard-content"},$&&react.createElement(gs,{messages:p}),react.createElement("div",{className:"PriceCard-head"},react.createElement(Cs,{title:u,isB2bType:H,frequency:E,messages:p,students:C,experiment:T,isB2b:"b2b"===d,isPromo:z,description:g}),react.createElement(Es,{price:x,flagUrl:v,currencyCode:b,symbol:h,plans:F,isB2bType:H,planPrice:f,messages:p,promoStyles:j,name:d,frequency:E,promoActive:z,isPlanBasic:U,priceMonth:k,fullPrice:N,discountAmount:q,experiment:T,isB2b:"b2b"===d,b2bData:se,isExpert:Q,b2cData:oe}),"b2b"===d&&react.createElement(xs,{items:A,b2bData:se,handleChangeB2bData:ne,licenceMin:P,licenceMax:O}),"expert"===d&&(null===(r=Object.keys(A))||void 0===r?void 0:r.length)>0&&react.createElement(bs,{b2cData:oe,handleChangeB2cData:le,items:A,setSelectedPlanInfo:R})),react.createElement("div",{className:"PriceCard-benefits"},react.createElement(ps,{title:u,fullBenefitsList:ce,benefits:pe,benefitsList:B,prevPlan:S,messages:p,userType:c,theme:m}),_&&(null==_?void 0:_.length)>0&&react.createElement(os,{extraBenefits:_,formattedInstallmentPrice:de,planName:u,toggleModal:function(){return X(!J)},theme:m,messages:p})),react.createElement("div",{className:"PriceCard-ctaSection"},react.createElement(us,{buyUrl:y,shouldHighlight:K,handleCta:function(e){l&&l(s,e)},title:u,price:x,messages:p,experiment:T,b2bData:se,isB2b:"b2b"===d,isB2c:"expert"===d,b2cData:oe}),"b2b"===d&&react.createElement("p",{className:"PriceCard-copyB2b"},"¿Más de 30 estudiantes? ",react.createElement("a",{href:"https://platzi.com/lp/planes-hr"},"Agenda un demo")))))};ds.propTypes=ss,ds.defaultProps=ns;var us=function(t){var a,s,n,r,o,l,i,c=t.buyUrl,m=t.shouldHighlight,p=t.handleCta,u=t.title,g=t.price,C=t.messages,E=t.experiment,f=t.b2bData,h=t.isB2b,x=t.isB2c,v=t.b2cData,b=c;return E&&h&&(a=null==f?void 0:f.buyUrl,s={paramName:"students",paramValue:null==f?void 0:f.currentValue},n=s.paramName,r=s.paramValue,o=a.includes("?"),l="".concat(n,"=").concat(r),i=o?"&":"?",b="".concat(a).concat(i).concat(l)),E&&x&&(b=null==v?void 0:v.buyUrl),react.createElement(Button_4cf71a18.B,{as:"a",href:b,color:"platzi",hierarchy:m?"primary":"secondary",customClass:"PriceCard-cta",size:"lg",onClick:p,id:"PriceCard-cta-".concat(u)},""===g&&C.ctaContact,"0"===g&&C.ctaAlt,""!==g&&"0"!==g&&C.cta(u))},gs=function(t){var a=t.messages;return react.createElement("div",{className:"PriceCard-hightlightFlag"},a.highlight)},Cs=function(t){var a=t.title,s=t.description,n=t.isB2bType,r=t.frequency,o=t.messages,l=t.students,c=t.experiment,m=t.isPromo,p=classnames_default()("PriceCard-textStrong",{"PriceCard-textStrong--b2b":n});return c&&!n?react.createElement("div",{className:"PriceCard-info"},react.createElement("div",{className:"PriceCard-titleCont"},react.createElement("h3",{className:"PriceCard-name"},a),react.createElement("p",{className:"PriceCard-description"},s))):react.createElement("div",{className:"PriceCard-info"},react.createElement("h3",{className:"PriceCard-name"},a,(n||r)&&react.createElement("span",{className:"PriceCard-tag"},o.planFrequency(r))),n&&react.createElement("p",{className:"PriceCard-copy"},o.copyB2B(a)),l&&react.createElement("p",{className:p},1===l&&o.studentsSlots(l),l>1&&o.studentsSlotsPlural(l)),m&&react.createElement("hr",{className:"PriceCard-line"}))},Es=function(t){var a=t.price,s=t.flagUrl,n=t.currencyCode,r=t.symbol,o=t.plans,l=t.isB2bType,i=t.planPrice,c=t.messages,p=t.promoStyles,d=t.name,u=t.frequency,g=t.promoActive,C=t.isPlanBasic,E=t.priceMonth,f=t.fullPrice,h=t.discountAmount,x=t.experiment,v=t.isB2b,b=t.b2bData,y=t.isExpert,N=t.b2cData;o.some((function(e){var t;return null===(t=e.promo)||void 0===t?void 0:t.active}));var k=l?c.annualFrequency:c.priceFrequency;return react.createElement("div",{className:"PriceCard-pricing"},a&&!v&&react.createElement("div",{className:"PriceCard-price-info"},g&&react.createElement("div",{className:"PriceCard-specialPrice",style:{color:null==p?void 0:p.primaryColor}},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faTag/* faTag */.LE}),react.createElement("p",null,"precio especial")),react.createElement("div",{className:"PriceCard-price"},react.createElement("img",{src:s,alt:"flag ".concat(n),className:"PriceCard-flag"}),react.createElement("p",{className:"PriceCard-priceValue"},g&&react.createElement("span",null,r),!g&&r,l?i:a,c.priceFrequency&&"/".concat(k))),!l&&g&&react.createElement("div",{className:"PriceCard-description"},"Un pago anual recurrente de ",r,i),!g&&y&&react.createElement("p",{className:"PriceCard-description"},"Un pago anual recurrente de ",r,null==N?void 0:N.fullPrice,"ars"===(null==n?void 0:n.toLowerCase())&&react.createElement(react.Fragment,null,react.createElement("br",null)," No se agregarán impuestos"))),x&&v&&react.createElement(react.Fragment,null,react.createElement("div",{className:"PriceCard-price"},react.createElement("img",{src:s,alt:"flag ".concat(n),className:"PriceCard-flag"}),react.createElement("p",{className:"PriceCard-priceValue"},r,"".concat(b.priceMonth),"/mes/licencia")),react.createElement("p",{className:"PriceCard-description"},"Un pago anual recurrente de ",r,b.annualPrice,"/licencia","ars"===(null==n?void 0:n.toLowerCase())&&react.createElement(react.Fragment,null,react.createElement("br",null)," No se agregarán impuestos"))),!a&&l&&react.createElement(index_es/* FontAwesomeIcon */.G,{size:"2x",icon:faMessageLines/* faMessageLines */.sN,color:(null==p?void 0:p.primaryColor)||"",className:"PriceCard-contact"}),(!g||l)&&!v&&!y&&react.createElement("p",{className:"PriceCard-description"},d===constants/* PLAN_BASIC */.zo&&c.recurrentBasic,l&&d!==constants/* PLAN_ENTERPRISE */.BG&&c.descriptionB2B,d!==constants/* PLAN_BASIC */.zo&&!l&&react.createElement(react.Fragment,null,u&&c.copyFrequency(u),""!==i&&"0"!==i&&react.createElement("strong",{className:"PriceCard-description-price"},r,i)),"ars"===(null==n?void 0:n.toLowerCase())&&react.createElement(react.Fragment,null,react.createElement("br",null)," No se agregarán impuestos")),g&&react.createElement("div",{className:"PriceCard-promo-info"},react.createElement("p",{className:"PriceCard-description linethrough"},"".concat(c.promoBefore," "),react.createElement("span",{className:"PriceCard-description-price"},r,C?E:f)),react.createElement("span",{className:"PriceCard-description-separator"}),react.createElement("p",{className:"PriceCard-description PriceCard-description--saved"},C?c.saveMoneyBasic(r,h):h?c.saveMoney(r,h):void 0)))},fs=function(e,t){var a=t.min;return 100*(e-a)/(t.max-a)+"% 100%"},hs=function(t){var a=t.value,s=t.min,n=t.max,r=t.handleChange,o=t.label;return react.createElement("div",{className:"SlideRange"},o&&react.createElement("label",{htmlFor:o,className:"SlideRange-label"},o),react.createElement("input",{type:"range",id:o,name:o,className:"SlideRange-input",min:s,max:n,onInput:r,value:a,style:{backgroundSize:fs(a,{min:s,max:n})}}))},xs=function(t){var a=t.items,s=t.b2bData,n=t.handleChangeB2bData,r=t.licenceMin,o=t.licenceMax;return react.createElement("div",{className:"SliderSlots"},react.createElement(hs,{value:s.currentValue,min:r,max:o,handleChange:function(e){var t=Number(e.target.value),r=(0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({},s),{currentValue:t});if(t<=9&&s.previousPlan){var o=a&&a[s.previousPlan];r=(0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({},o),{currentValue:t})}if(t>=10&&s.nextPlan){var l=a&&a[s.nextPlan];r=(0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({},l),{currentValue:t})}n(r)},label:"".concat(s.currentValue," estudiantes")}))},vs=function(t){var a=t.content,s=t.handleChange,n=t.currentValue,r=a.value,o=a.label,l=r===n,c=classnames_default()("Radio-input",{"Radio-input--checked":l});return react.createElement("label",{className:"Radio"},react.createElement("input",{type:"radio",name:String(r),className:c,onChange:s,value:r,checked:l}),o)},bs=function(a){var s=a.b2cData,n=a.handleChangeB2cData,r=a.setSelectedPlanInfo,o=a.items,l=[{label:"2 estudiantes",value:"annual_plan",students:2},{label:"4 estudiantes",value:"family_plan",students:4}],i=function(e){var t=e.target.value,a=o[t],s=(0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({},a),{currentValue:t});n(s),r(a)};return (0,react.useEffect)((function(){var e=l[0],t=o[e.value];r(t)}),[]),react.createElement("div",{className:"StudentSelector"},l.map((function(t){return react.createElement(vs,{key:t.value,content:t,handleChange:i,currentValue:null==s?void 0:s.currentValue})})))},ys=function(t){var s=t.plans,n=t.benefits,r=t.messages,o=t.screenType,l=t.userType,c=t.ctaEvents;t.locale;var m=t.theme,p=t.defaultExpertPlan,d=t.experiment;if(!s||0===s.length)return null;var u=classnames_default()("PricePlans-container",{"is-b2b":"b2b"===l});return react.createElement("div",{className:u,id:"tabla-Planes","data-testid":"landing-prices-pricecards"},s.map((function(t,i){var u=i>0?s[i-1]:null,g=(null==t?void 0:t.items)||{},C=Object.keys(g).length,E=Object.keys(g),f=C>0&&"b2b"!==t.name?null==t?void 0:t.items[E[0]]:t,h=(0,react.useState)(f),x=h[0],b=h[1];return react.createElement(ds,(0,_rollupPluginBabelHelpers_1fef267c._)({key:t.name},t,x,{setSelectedPlanInfo:b,name:t.name,highlight:t.highlight,benefitsList:n,plans:s,prevPlan:u,messages:r,screenType:o,userType:l,ctaEvents:c,theme:m,experiment:d,defaultExpertPlan:p,description:t.description}))})))};ys.propTypes={plans:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape(ts)).isRequired,benefits:index_5808dc9d.p.exports.shape(Ya).isRequired,messages:index_5808dc9d.p.exports.shape(as),screenType:index_5808dc9d.p.exports.oneOf(["mobile","desktop"]),userType:index_5808dc9d.p.exports.oneOf(["user","b2b"]),ctaEvents:index_5808dc9d.p.exports.func,locale:index_5808dc9d.p.exports.string,theme:index_5808dc9d.p.exports.oneOf(["dark","light","darker"]),hideSinglePlan:index_5808dc9d.p.exports.bool,experiment:index_5808dc9d.p.exports.string,defaultExpertPlan:index_5808dc9d.p.exports.string},ys.defaultProps={plans:[],benefits:{},messages:{},screenType:"desktop",userType:"user",ctaEvents:function(){},locale:"es",theme:"dark",hideSinglePlan:!0,experiment:void 0},index_5808dc9d.p.exports.string,index_5808dc9d.p.exports.string,index_5808dc9d.p.exports.number,index_5808dc9d.p.exports.object,index_5808dc9d.p.exports.string,index_5808dc9d.p.exports.string,index_5808dc9d.p.exports.string,index_5808dc9d.p.exports.string,index_5808dc9d.p.exports.string,index_5808dc9d.p.exports.string,index_5808dc9d.p.exports.string,index_5808dc9d.p.exports.array,index_5808dc9d.p.exports.array,index_5808dc9d.p.exports.object,index_5808dc9d.p.exports.oneOf(["dark","light"]);var Ns=function(t){var s=t.theme,n=t.plans,r=t.selectedPlan,o=t.messages,l=t.benefits,c=t.userType,m=t.ctaEvents,p=t.experiment,d=Va(n,{selectedPlan:r,experiment:p}),u=classnames_default()("PricePlans","PricePlans--mobile",{"PricePlans--light":"light"===s,"PricePlans--darker":"darker"===s});return react.createElement("div",{className:u},react.createElement(TabSection_9807b9f3.S,{customClass:"PriceAltTabs",defaultTab:d.name},n.map((function(t){var r=(null==t?void 0:t.items)||{},i=Object.keys(r).length,u=Object.keys(r),g=i>0&&"b2b"!==t.name?null==t?void 0:t.items[u[0]]:t,C=(0,react.useState)(g),E=C[0],f=C[1],h=E.students;return"b2b"===t.name&&(h="+3"),react.createElement(TabSection_9807b9f3.T,{key:t.name,title:E.title,subtitle:Ka(h,{messages:o,experiment:p}),shouldShow:!0},react.createElement(ds,(0,_rollupPluginBabelHelpers_1fef267c._)({},t,E,{name:t.name,highlight:t.highlight,benefitsList:l,plans:n,messages:o,screenType:"mobile",userType:c,ctaEvents:m,theme:s,experiment:p,defaultExpertPlan:null==d?void 0:d.defaultPlan,setSelectedPlanInfo:f})))}))))},ks=function(t){var a=t.plans,s=t.benefits,n=t.messages,r=t.userType,o=t.ctaEvents,l=t.locale,i=t.theme,c=t.noSingleCards,m=t.selectedPlan,p=t.experiment,d=Va(a,{selectedPlan:m,experiment:p});return react.createElement("div",{className:"PricePlans PricePlans--desktop"},react.createElement(ys,{plans:a,benefits:s,messages:n,screenType:"desktop",userType:r,ctaEvents:o,locale:l,theme:i,hideSinglePlan:c,experiment:p,defaultExpertPlan:"b2b"!==d.name?null==d?void 0:d.defaultPlan:""}))},Ds=function(t){var a=t.plans,s=t.benefits,n=t.messages,r=t.userType,o=t.ctaEvents,l=t.locale,i=t.theme,c=t.selectedPlan,m=t.noSingleCards,p=t.experiment;return a&&0!==a.length?react.createElement(react.Fragment,null,react.createElement(Ns,{theme:i,plans:a,messages:n,benefits:s,userType:r,ctaEvents:o,selectedPlan:c,experiment:p}),react.createElement(ks,{theme:i,plans:a,messages:n,benefits:s,userType:r,ctaEvents:o,locale:l,noSingleCards:m,selectedPlan:c,experiment:p})):null};Ds.defaultProps=Ua;const ws=({theme:t,data:a,messages:s})=>{const{subscriptionNote:n,priceIn:r,paymentMethods:o}=s,{currencyText:l,features:c}=a,m=null==a?void 0:a.flagUrl,p="argentina"===((null==a?void 0:a.countryName)||"").toLowerCase(),d=null==c?void 0:c.map((e=>e.content)).flat().map((e=>e.methods)).flat().filter((e=>e)),u=d&&d.length>0,g=classnames_default()("PriceFooter",{"PriceFooter--dark":"dark"===t,"PriceFooter--light":"light"===t});return react.createElement("div",{className:g},!p&&react.createElement("p",{className:"PriceFooter-text"},n),u&&react.createElement("div",{className:"PriceFooter-payments"},(m||l)&&react.createElement("p",{className:"PriceFooter-payments-text"},m&&react.createElement("img",{src:m,alt:"flag",className:"PriceFooter-payments-image PriceFooter-payments-image--flag",loading:"lazy"}),l&&react.createElement("strong",null,r," ",l,".")),react.createElement("div",{className:"PriceFooter-payments-text"},o,react.createElement("div",{className:"PriceFooter-payments-methods"},null==d?void 0:d.map(((a,s)=>react.createElement("img",{key:`footer-payment-method-${s}`,className:`PriceFooter-payments-image ${a}`,loading:"lazy",src:"light"===t?constants/* PAYMENT_METHOD_IMG_LIGHT */.u3[a]:constants/* PAYMENT_METHOD_IMG */.lB[a],alt:a})))))))};ws.propTypes={theme:index_5808dc9d.p.exports.oneOf(["dark","light"]),data:index_5808dc9d.p.exports.shape({flagUrl:index_5808dc9d.p.exports.string,currencyText:index_5808dc9d.p.exports.string,features:index_5808dc9d.p.exports.array}),messages:index_5808dc9d.p.exports.shape({subscriptionNote:index_5808dc9d.p.exports.string,priceIn:index_5808dc9d.p.exports.string,paymentMethods:index_5808dc9d.p.exports.string})},ws.defaultProps={theme:"dark"};const Bs=({tabs:t,currentTab:a,handleTab:s,theme:n})=>{const r=classnames_default()("PriceTabs",{"PriceTabs--dark":"dark"===n,"PriceTabs--light":"light"===n});return react.createElement("div",{className:r,"data-testid":"landing-prices-pricetabs"},react.createElement("ul",{className:"PriceTabs-list"},t.map((t=>{const{id:n,icon:r,text:o}=t,l=classnames_default()("PriceTabs-btn",{"PriceTabs-btn--active":a===o});return react.createElement("li",{className:"PriceTabs-item",key:n},react.createElement("button",{type:"button",onClick:()=>s(o),className:l},r&&react.createElement(index_es/* FontAwesomeIcon */.G,{icon:r,className:"PriceTabs-icon"}),o))}))))};Bs.propTypes={tabs:index_5808dc9d.p.exports.array,currentTab:index_5808dc9d.p.exports.string,handleTab:index_5808dc9d.p.exports.func,theme:index_5808dc9d.p.exports.oneOf(["dark","light","darker"])},Bs.defaultProps={tabs:[],currentTab:"",handleTab:()=>{},theme:"dark"};const Fs=t=>{const{text:a,alignment:s,subtitle:n,image:r,noSeparator:o}=t,l=classnames_default()("SectionHeading-text",`SectionHeading-text--${s}`,{"SectionHeading-text--image":r,"SectionHeading-text--noSeparator":o});return react.createElement(react.Fragment,null,r&&react.createElement("figure",{className:`SectionHeading-image SectionHeading-image--${s}`},react.createElement(Image_4b46b89d.I,{src:r,alt:a,quality:75,loading:"lazy"})),react.createElement("h2",{className:l},a),n&&""!==n&&react.createElement("p",{className:`SectionHeading-subtitle SectionHeading-subtitle--${s}`},n))};Fs.propTypes={text:index_5808dc9d.p.exports.string.isRequired,alignment:index_5808dc9d.p.exports.oneOf(["is-left","is-center","is-right"]),subtitle:index_5808dc9d.p.exports.string,image:index_5808dc9d.p.exports.string,noSeparator:index_5808dc9d.p.exports.bool},Fs.defaultProps={text:"",alignment:"is-center",subtitle:"",image:"",noSeparator:!1};const Ss=({customClass:t,imageSeparator:a})=>{if(!a)return null;const s=classnames_default()(["Separator",{[t]:!!t}]);return react.createElement("span",{className:s},a&&react.createElement(Image_4b46b89d.I,{src:a,alt:a}))};Ss.propTypes={customClass:index_5808dc9d.p.exports.string,imageSeparator:index_5808dc9d.p.exports.string},Ss.defaultProps={customClass:"",imageSeparator:""};const _s=({titleKey:t,version:a,separator:s,messages:n})=>{const{t:r}=(0,useTranslation/* useTranslation */.$)();let o="https://static.platzi.com/ui/assets/image/comunity_1@2x9b91129f4988956a.png",l="https://static.platzi.com/ui/assets/image/comunity_2@2xde2bd05edd6dbb04.png";return"BR"===a&&(o="https://static.platzi.com/ui/assets/image/comunity-brdb4f73e8bcfa688c.png",l="https://static.platzi.com/ui/assets/image/comunity-2-bre2c0e64fa251a11d.png"),react.createElement("section",{className:"Community",id:"Community"},react.createElement("div",{className:"u-wrapper"},s&&react.createElement(Ss,{customClass:"--left",imageSeparator:s}),react.createElement(Fs,{text:r(t),alignment:"is-left"}),react.createElement("div",{className:"Community-content"},react.createElement("div",{className:"Community-content-section"},react.createElement("img",{className:"Community-image",src:o,alt:"Community comments"}),react.createElement("ul",{className:"Community-list"},react.createElement("li",{className:"Community-item"},react.createElement("p",{className:"Community-item-title"},react.createElement("strong",null,n.section1.item1.title)),react.createElement("p",{className:"Community-item-subtitle"},n.section1.item1.description)),react.createElement("li",{className:"Community-item"},react.createElement("p",{className:"Community-item-title"},react.createElement("strong",null,n.section1.item2.title)),react.createElement("p",{className:"Community-item-subtitle"},n.section1.item2.description)))),react.createElement("div",{className:"Community-content-section Community-content-section-bottom"},react.createElement("ul",{className:"Community-list"},react.createElement("li",{className:"Community-item"},react.createElement("p",{className:"Community-item-title"},react.createElement("strong",null,n.section2.item1.title)),react.createElement("p",{className:"Community-item-subtitle"},n.section2.item1.description)),react.createElement("li",{className:"Community-item"},react.createElement("p",{className:"Community-item-title"},react.createElement("strong",null,n.section2.item2.title)),react.createElement("p",{className:"Community-item-subtitle"},n.section2.item2.description))),react.createElement("img",{className:"Community-image",src:l,alt:"Community comments"})))))};_s.propTypes={titleKey:index_5808dc9d.p.exports.string,version:index_5808dc9d.p.exports.oneOf(["ES","BR"]),separator:index_5808dc9d.p.exports.string};const Ms=t=>{const{items:a,handleSelectStage:s,stageSelected:n}=t,r=(0,es/* useSelector */.v9)((e=>e.get("header").get("country_flag"))),o=(0,es/* useSelector */.v9)((e=>e.get("header").get("country_name"))),{t:l}=(0,useTranslation/* useTranslation */.$)(),c=r&&(r.includes("http")?r:`https://static.platzi.com${r}`);return react.createElement("section",{role:"menuCategories",className:"menuStages"},react.createElement("p",{className:"menuStages-title","data-trans":"conf_stages_title"},l("conf_stages_title")),a.map(((t,a)=>{const r=classnames_default()("menuStages-stage",{disabled:n!==a,active:n===a}),o=classnames_default()("Stage-Indicator",{"Stage-Indicator--selected":n===a});return react.createElement("div",{key:`linkStage_${a}`},react.createElement("button",{className:r,onClick:()=>s(a)},null==t?void 0:t.name),react.createElement("div",{className:o}))})),react.createElement("div",{className:"menuStages__Underline"}),react.createElement("p",{className:"menuStages-location","data-trans":"conf_stages_location_hour"},l("conf_stages_location_hour")," ",o," ",react.createElement(Image_4b46b89d.I,{customClass:"menuStages-location--flag",src:c,alt:"flag"})))};Ms.propTypes={items:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({name:index_5808dc9d.p.exports.string.isRequired,icon:index_5808dc9d.p.exports.string,slug:index_5808dc9d.p.exports.string.isRequired})),handleSelectStage:index_5808dc9d.p.exports.func,stageSelected:index_5808dc9d.p.exports.number};dayjs_min_default().extend((isBetween_default()));const Ts=t=>{var a;const{title:s,id:n,description:r,eventType:o,speaker:l,speakersPanel:c,allDay:p,eventImage:d}=t,u=e=>{let t=e;return t=t.replace(/-/g,""),t=t.replace(/:/g,""),t=t.replace(/\./g,""),t},g=()=>{const e=u(dayjs_min_default()(null==t?void 0:t.startDate).format()),a=u(dayjs_min_default()(null==t?void 0:t.endDate).format()),n=`https://calendar.google.com/calendar/r/eventedit?text=${s}&dates=${e}/${a}&details=${r}`;window.open(n,"_blank")},C=dayjs_min_default()(null==t?void 0:t.startDate).format("hh:mm"),E=dayjs_min_default()(null==t?void 0:t.startDate).format("A"),f=null!=l&&null!==(a=l.avatar)&&void 0!==a&&a.includes("http")?`${null==l?void 0:l.avatar}`:`https://static.platzi.com${null==l?void 0:l.avatar}`,h=dayjs_min_default()(),x=dayjs_min_default()(null==t?void 0:t.startDate),v=dayjs_min_default()(null==t?void 0:t.endDate),b=dayjs_min_default()(h).isBetween(x,v),y=b&&t.live,N="panel"===o||"ignite"===o,k=p,D=!b&&!k,w=null==r?void 0:r.split("@location:"),B=null==w?void 0:w[1],F=classnames_default()("Talk-image",{"Talk-image--featured":(S=null==l?void 0:l.priority,S>0&&S<=8)});var S;const _=classnames_default()("Talk",{"Talk--live":y}),M=()=>react.createElement("article",{key:`talk_${n}`,className:_},react.createElement("span",{className:"Talk-time"},react.createElement("time",{className:"Talk-time--hour"},C),react.createElement("span",{className:"Talk-time--journey"},E)),react.createElement("div",{className:"Talk-info"},k&&react.createElement("figure",{className:"Talk-image Talk-image--activity"},react.createElement(Image_4b46b89d.I,{src:d,alt:s})),!k&&(N&&c.length>0?react.createElement("div",{className:"Talk-info-speakers"},c.map((t=>react.createElement("figure",{className:"Talk-info-speakers-image",key:`speakersPanel_speaker_${null==t?void 0:t.name}`},react.createElement(Image_4b46b89d.I,{src:t.avatar,alt:null==t?void 0:t.name}))))):react.createElement("figure",{className:F},react.createElement(Image_4b46b89d.I,{src:f,alt:null==l?void 0:l.name}))),react.createElement("div",{className:"Talk-info-contain"},react.createElement("h4",{className:"Talk-info-contain-title"},s),react.createElement("span",{className:"Talk-info-contain-speaker"},(()=>{if(k)return null;if(N){let e="";return c.forEach(((t,a)=>{e+=`${null==t?void 0:t.name}${a<c.length-1?", ":""}`})),e}return`${null==l?void 0:l.name} | ${null==l?void 0:l.occupation}`})()),B&&react.createElement("span",{className:"Talk-info-contain-location"},react.createElement(index_es/* FontAwesomeIcon */.G,{size:"sm",icon:faMapMarkerAlt/* faMapMarkerAlt */.FG})," ",B),react.createElement("div",{className:"Talk-info-contain-tags"},b&&react.createElement("div",{className:"Talk-info-contain-tags--live"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faCircle/* faCircle */.di,size:"xs"})," En vivo")),react.createElement("p",{className:"Talk-info-contain-description"},w[0])),b&&!k&&react.createElement("span",{className:"Talk-info-navigate"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faArrowRight/* faArrowRight */.eF})),D&&react.createElement("button",{className:"Talk-info-schedule",onClick:g},react.createElement(index_es/* FontAwesomeIcon */.G,{size:"sm",icon:faCalendarCirclePlus/* faCalendarCirclePlus */.TI}))));return y&&!k?react.createElement("a",{href:`/live/${null==t?void 0:t.live.slug}`},M()):M()};Ts.propTypes={id:index_5808dc9d.p.exports.number.isRequired,title:index_5808dc9d.p.exports.string.isRequired,eventType:index_5808dc9d.p.exports.string.isRequired,startDate:index_5808dc9d.p.exports.string.isRequired,endDate:index_5808dc9d.p.exports.string.isRequired,live:{slug:index_5808dc9d.p.exports.string},speaker:index_5808dc9d.p.exports.shape({name:index_5808dc9d.p.exports.string.isRequired,avatar:index_5808dc9d.p.exports.string.isRequired,country:index_5808dc9d.p.exports.string.isRequired,occupation:index_5808dc9d.p.exports.string.isRequired}),speakersPanel:index_5808dc9d.p.exports.array,link:index_5808dc9d.p.exports.string,allDay:index_5808dc9d.p.exports.bool};const As=t=>{const{listTalks:a}=t;return react.createElement("div",{className:"listStages",id:"Stages"},a.map((t=>react.createElement(Ts,(0,_rollupPluginBabelHelpers_1fef267c._)({key:`talk_${t.id}`},t)))))};As.propTypes={listTalks:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({id:index_5808dc9d.p.exports.number.isRequired,title:index_5808dc9d.p.exports.string.isRequired,eventType:index_5808dc9d.p.exports.string.isRequired,startDate:index_5808dc9d.p.exports.string.isRequired,speaker:index_5808dc9d.p.exports.shape({name:index_5808dc9d.p.exports.string.isRequired,avatar:index_5808dc9d.p.exports.string.isRequired,country:index_5808dc9d.p.exports.string.isRequired,occupation:index_5808dc9d.p.exports.string.isRequired})})),elRefs:index_5808dc9d.p.exports.array,textSite:index_5808dc9d.p.exports.string,groupByDays:index_5808dc9d.p.exports.bool};const Ls=t=>{const{stages:s,showMenu:n,hideStageInfo:o}=t;if(!s||0===s.length)return null;const{handleSelectStage:l,listTalks:c,stageSelected:m}=(e=>{const[t,s]=(0,react.useState)(0);return{listTalks:(0,react.useMemo)((()=>{var a;return null===(a=e[t])||void 0===a?void 0:a.talks}),[t]),stageSelected:t,handleSelectStage:e=>s(e)}})(s),p={items:s.map((({name:e,slug:t,icon:a})=>({name:e,slug:t,icon:a}))),handleSelectStage:l,stageSelected:m},d={listTalks:c,hideStageInfo:o},u=classnames_default()("schedule");return react.createElement("section",{role:"schedule",className:u},react.createElement("div",{className:"schedule-container"},react.createElement("div",{className:"schedule-container-content"},n&&react.createElement(Ms,p),react.createElement(As,d))))};Ls.propTypes={data:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({name:index_5808dc9d.p.exports.string.isRequired,description:index_5808dc9d.p.exports.string.isRequired,icon:index_5808dc9d.p.exports.string,slug:index_5808dc9d.p.exports.string.isRequired,talks:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.shape({id:index_5808dc9d.p.exports.number.isRequired,title:index_5808dc9d.p.exports.string.isRequired,eventType:index_5808dc9d.p.exports.string.isRequired,startDate:index_5808dc9d.p.exports.string.isRequired,speaker:index_5808dc9d.p.exports.shape({name:index_5808dc9d.p.exports.string.isRequired,avatar:index_5808dc9d.p.exports.string.isRequired,country:index_5808dc9d.p.exports.string.isRequired,occupation:index_5808dc9d.p.exports.string.isRequired})}))})),showMenu:index_5808dc9d.p.exports.oneOfType([null|index_5808dc9d.p.exports.bool])};const Ps=({tweetIds:t,separator:a})=>{const{t:s}=(0,useTranslation/* useTranslation */.$)();if(!t||0===t.length)return null;const n=t.map((t=>react.createElement(Tweet,{tweetId:t,options:{theme:"dark",conversation:"none",cards:"hidden"}})));return react.createElement("section",{className:"TwitterTestimonies"},react.createElement("div",{className:"u-wrapper"},a&&react.createElement(Ss,{imageSeparator:a}),react.createElement("h2",{className:"TwitterTestimonies-title"},s("prices.testimonies.title")),react.createElement("div",{id:"first-tweet"}),react.createElement(Carousel_7034b698.C,{elements:n,numberOfElements:{xs:1,sm:2,md:2,lg:3}})))};Ps.propTypes={tweetIds:index_5808dc9d.p.exports.arrayOf(index_5808dc9d.p.exports.string).isRequired,separator:index_5808dc9d.p.exports.string},Ps.defaultProps={tweetIds:[]};const Os=t=>{const{t:a}=(0,useTranslation/* useTranslation */.$)();return react.createElement(index_c9810a9c.C,{customClass:"SalaryModalCard",isDark:!0},react.createElement("div",{className:"SalaryModalCard-close"},react.createElement("button",{type:"button",onClick:t.handleClose,"data-trans":"salaryModal_closeModal","arial-label":a("salaryModal_closeModal")},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:pro_solid_svg_icons_faTimes/* faTimes */.NB}))),react.createElement("div",{className:"SalaryModalCard-body"},react.createElement("div",{className:"SalaryModalCard-body-head"},react.createElement("img",{src:"https://static.platzi.com/media/uploads/impacto_Modal_5123fc02e3.png?updated_at=2022-10-27T02:35:34.312Z",alt:a("salaryModal_image")}),react.createElement("h3",{"data-trans":"salaryModal_subtitle"},a("salaryModal_subtitle"))),react.createElement("div",{className:"SalaryModalCard-body-content"},react.createElement("ul",null,react.createElement("li",null,react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faSparkles/* faSparkles */.Jy}),react.createElement("p",{"data-trans":"salaryModal_badge"},a("salaryModal_badge"))),react.createElement("li",null,react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faClock/* faClock */.SZ}),react.createElement("p",{"data-trans":"salaryModal_time"},a("salaryModal_time"))),react.createElement("li",null,react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faShieldCheck/* faShieldCheck */.ip}),react.createElement(DynamicHTML_3586636e_i,{tag:"span",html:a("salaryModal_security_copy")}))))),react.createElement("div",{className:"SalaryModalCard-footer"},react.createElement("div",{className:"SalaryModalCard-doNotShow"},react.createElement(FormCheckbox_a2d652c7_a,{name:"doNotShowAgain",id:"doNotShowAgain",handleContent:t.handleCheckbox}),react.createElement("p",{"data-trans":"salaryModal_doNotShowAgain"},a("salaryModal_doNotShowAgain"))),react.createElement(Button_4cf71a18.B,{as:"a",href:"/form-salarios/","data-trans":"salaryModal_security_cta"},a("salaryModal_security_cta")),react.createElement(Button_4cf71a18.B,{as:"button",onClick:t.handleClose,hierarchy:"secondary","data-trans":"salaryModal_skip"},a("salaryModal_skip"))))};Os.propTypes={handleClose:index_5808dc9d.p.exports.func.isRequired,handleCheckbox:index_5808dc9d.p.exports.func.isRequired};var Is=function(t){var a=t.closeModal,s=t.children,n=(0,useTranslation/* useTranslation */.$)().t;return react.createElement("div",{className:"ModalBase"},react.createElement(Button_4cf71a18.B,{onClick:a,"aria-label":n("modalbase_close"),type:"button"},react.createElement(index_es/* FontAwesomeIcon */.G,{icon:faTimes/* faTimes */.NB})),s)},Rs=function(t){var a=t.className,s=t.children,n="".concat(a," ModalBody");return react.createElement("div",{className:n},s)};Rs.defaultProps={className:""};var zs=function(s){var n=(0,react.useState)(!1),r=n[0],l=n[1];return (0,react.useEffect)((function(){if(!document.getElementById(s.portalId)){var e=document.createElement("div");e.id=s.portalId,e.setAttribute("data-testid",s.portalId),document.body.appendChild(e)}l(!0)}),[]),r?(0,react_dom.createPortal)(react.createElement(rt,{show:s.show,close:s.close,showFromBottom:s.showFromBottom},s.children),document.getElementById(s.portalId)):null};


/***/ }),

/***/ 2321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ r; },
/* harmony export */   "T": function() { return /* binding */ c; }
/* harmony export */ });
/* unused harmony export a */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3731);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
const n=({title:t,subtitle:a,onClick:l,prefix:n,active:r})=>{const c=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Tab",{"is-active":r});return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:c,onClick:e=>l(n)},t,null!=a&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("p",null,a))},r=({customClass:l,defaultTab:s,children:r,handleClickOnTab:c})=>{const i=r.filter((e=>e.props.shouldShow)),m=""===s?i[0].key:s,[o,p]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(m),u=e=>(p(e),c(e));return i.length?((0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{p(m)}),[m]),react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:l},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"u-wrapper"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:`${l}-tabs`},i.map((t=>react__WEBPACK_IMPORTED_MODULE_0__.createElement(n,{key:t.key,onClick:u,title:t.props.title,subtitle:t.props.subtitle,prefix:t.key,active:t.key===o}))))),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:`${l}-content`},i.length&&i.filter((e=>e.key===o))[0])))):null};r.propTypes={customClass:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,defaultTab:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,handleClickOnTab:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.func},r.defaultProps={customClass:"SmartTabs",defaultTab:"",handleClickOnTab:()=>{}};const c=({children:t})=>react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,t);


/***/ }),

/***/ 4597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ r; }
/* harmony export */ });
function r(){return r=Object.assign?Object.assign.bind():function(r){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(r[a]=n[a])}return r},r.apply(this,arguments)}


/***/ }),

/***/ 2413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ r; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3731);
const r=({customStyle:t})=>react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:`Loader ${t}`},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:"Loader-circle"}));r.propTypes={customStyle:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_1__.p.exports.string},r.defaultProps={customStyle:""};


/***/ }),

/***/ 3731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ r; }
/* harmony export */ });
var e,r={exports:{}},n={exports:{}},t={};var o,a,i,c,u,f,s,p,l,y,d,m,b,v,h={};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */function g(){return a||(a=1,r=n, true?r.exports=function(){if(e)return t;e=1;var r="function"==typeof Symbol&&Symbol.for,n=r?Symbol.for("react.element"):60103,o=r?Symbol.for("react.portal"):60106,a=r?Symbol.for("react.fragment"):60107,i=r?Symbol.for("react.strict_mode"):60108,c=r?Symbol.for("react.profiler"):60114,u=r?Symbol.for("react.provider"):60109,f=r?Symbol.for("react.context"):60110,s=r?Symbol.for("react.async_mode"):60111,p=r?Symbol.for("react.concurrent_mode"):60111,l=r?Symbol.for("react.forward_ref"):60112,y=r?Symbol.for("react.suspense"):60113,d=r?Symbol.for("react.suspense_list"):60120,m=r?Symbol.for("react.memo"):60115,b=r?Symbol.for("react.lazy"):60116,v=r?Symbol.for("react.block"):60121,h=r?Symbol.for("react.fundamental"):60117,g=r?Symbol.for("react.responder"):60118,S=r?Symbol.for("react.scope"):60119;function O(e){if("object"==typeof e&&null!==e){var r=e.$$typeof;switch(r){case n:switch(e=e.type){case s:case p:case a:case c:case i:case y:return e;default:switch(e=e&&e.$$typeof){case f:case l:case b:case m:case u:return e;default:return r}}case o:return r}}}function w(e){return O(e)===p}return t.AsyncMode=s,t.ConcurrentMode=p,t.ContextConsumer=f,t.ContextProvider=u,t.Element=n,t.ForwardRef=l,t.Fragment=a,t.Lazy=b,t.Memo=m,t.Portal=o,t.Profiler=c,t.StrictMode=i,t.Suspense=y,t.isAsyncMode=function(e){return w(e)||O(e)===s},t.isConcurrentMode=w,t.isContextConsumer=function(e){return O(e)===f},t.isContextProvider=function(e){return O(e)===u},t.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===n},t.isForwardRef=function(e){return O(e)===l},t.isFragment=function(e){return O(e)===a},t.isLazy=function(e){return O(e)===b},t.isMemo=function(e){return O(e)===m},t.isPortal=function(e){return O(e)===o},t.isProfiler=function(e){return O(e)===c},t.isStrictMode=function(e){return O(e)===i},t.isSuspense=function(e){return O(e)===y},t.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===a||e===p||e===c||e===i||e===y||e===d||"object"==typeof e&&null!==e&&(e.$$typeof===b||e.$$typeof===m||e.$$typeof===u||e.$$typeof===f||e.$$typeof===l||e.$$typeof===h||e.$$typeof===g||e.$$typeof===S||e.$$typeof===v)},t.typeOf=O,t}():0),n.exports;var r}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/function S(){if(f)return u;f=1;return u="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}function O(){return p?s:(p=1,s=Function.call.bind(Object.prototype.hasOwnProperty))}if(false){ var w; }else r.exports=function(){if(v)return b;v=1;var e=S();function r(){}function n(){}return n.resetWarningCache=r,b=function(){function t(r,n,t,o,a,i){if(i!==e){var c=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function o(){return t}t.isRequired=t;var a={array:t,bigint:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:o,element:t,elementType:t,instanceOf:o,node:t,objectOf:o,oneOf:o,oneOfType:o,shape:o,exact:o,checkPropTypes:n,resetWarningCache:r};return a.PropTypes=a,a}}()();


/***/ }),

/***/ 7740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ e; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3731);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
const e=r=>{const e=classnames__WEBPACK_IMPORTED_MODULE_1___default()("Card",r.customClass,{"Card--dark":r.isDark});return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:e},r.children)};e.propTypes={children:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.node,customClass:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.string,isDark:_index_5808dc9d_js__WEBPACK_IMPORTED_MODULE_2__.p.exports.bool},e.defaultProps={customClass:""};


/***/ }),

/***/ 1855:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'facebook';
var width = 512;
var height = 512;
var aliases = [62000];
var unicode = 'f09a';
var svgPathData = 'M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.ne = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8101:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'facebook-f';
var width = 320;
var height = 512;
var aliases = [];
var unicode = 'f39e';
var svgPathData = 'M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.AY = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 3361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'google';
var width = 488;
var height = 512;
var aliases = [];
var unicode = 'f1a0';
var svgPathData = 'M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.xY = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 4087:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'instagram';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f16d';
var svgPathData = 'M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Zz = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2443:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'twitter';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f099';
var svgPathData = 'M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.md = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 5567:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'youtube';
var width = 576;
var height = 512;
var aliases = [61802];
var unicode = 'f167';
var svgPathData = 'M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.op = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 3719:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'chevron-down';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f078';
var svgPathData = 'M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.pt = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 7365:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'chevron-up';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f077';
var svgPathData = 'M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.mT = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 3460:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'credit-card';
var width = 576;
var height = 512;
var aliases = [128179,62083,"credit-card-alt"];
var unicode = 'f09d';
var svgPathData = 'M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Oz = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 5554:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'heart';
var width = 512;
var height = 512;
var aliases = [128153,128154,128155,128156,128420,129293,129294,129505,9829,10084,61578];
var unicode = 'f004';
var svgPathData = 'M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.m6 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 5774:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(8470);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.NB = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 8470:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'xmark';
var width = 320;
var height = 512;
var aliases = [128473,10005,10006,10060,215,"close","multiply","remove","times"];
var unicode = 'f00d';
var svgPathData = 'M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 2901:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'angle-left';
var width = 256;
var height = 512;
var aliases = [8249];
var unicode = 'f104';
var svgPathData = 'M166.5 424.5l-143.1-152c-4.375-4.625-6.562-10.56-6.562-16.5c0-5.938 2.188-11.88 6.562-16.5l143.1-152c9.125-9.625 24.31-10.03 33.93-.9375c9.688 9.125 10.03 24.38 .9375 33.94l-128.4 135.5l128.4 135.5c9.094 9.562 8.75 24.75-.9375 33.94C190.9 434.5 175.7 434.1 166.5 424.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Ey = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 4962:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'angle-right';
var width = 256;
var height = 512;
var aliases = [8250];
var unicode = 'f105';
var svgPathData = 'M89.45 87.5l143.1 152c4.375 4.625 6.562 10.56 6.562 16.5c0 5.937-2.188 11.87-6.562 16.5l-143.1 152C80.33 434.1 65.14 434.5 55.52 425.4c-9.688-9.125-10.03-24.38-.9375-33.94l128.4-135.5l-128.4-135.5C45.49 110.9 45.83 95.75 55.52 86.56C65.14 77.47 80.33 77.87 89.45 87.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.yO = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 837:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'arrow-left';
var width = 448;
var height = 512;
var aliases = [8592];
var unicode = 'f060';
var svgPathData = 'M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.ac = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2305:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'arrow-right';
var width = 448;
var height = 512;
var aliases = [8594];
var unicode = 'f061';
var svgPathData = 'M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.eF = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 4194:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'arrow-right-to-bracket';
var width = 512;
var height = 512;
var aliases = ["sign-in"];
var unicode = 'f090';
var svgPathData = 'M512 128v256c0 53.02-42.98 96-96 96h-72C330.7 480 320 469.3 320 456c0-13.26 10.75-24 24-24H416c26.4 0 48-21.6 48-48V128c0-26.4-21.6-48-48-48h-72C330.7 80 320 69.25 320 56C320 42.74 330.7 32 344 32H416C469 32 512 74.98 512 128zM345.5 239.6l-128-136C208.4 93.88 193.2 93.44 183.6 102.5C173.9 111.6 173.4 126.8 182.5 136.4L272.4 232H24C10.75 232 0 242.8 0 256s10.75 24 24 24h248.4l-89.92 95.56c-9.094 9.656-8.625 24.84 1.031 33.91C188.2 413.8 194.1 416 200 416c6.375 0 12.75-2.531 17.47-7.562l128-136C354.2 263.2 354.2 248.8 345.5 239.6z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Zh = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8811:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'bars';
var width = 448;
var height = 512;
var aliases = ["navicon"];
var unicode = 'f0c9';
var svgPathData = 'M0 88C0 74.75 10.75 64 24 64H424C437.3 64 448 74.75 448 88C448 101.3 437.3 112 424 112H24C10.75 112 0 101.3 0 88zM0 248C0 234.7 10.75 224 24 224H424C437.3 224 448 234.7 448 248C448 261.3 437.3 272 424 272H24C10.75 272 0 261.3 0 248zM424 432H24C10.75 432 0 421.3 0 408C0 394.7 10.75 384 24 384H424C437.3 384 448 394.7 448 408C448 421.3 437.3 432 424 432z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.xi = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2359:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'chart-line';
var width = 512;
var height = 512;
var aliases = ["line-chart"];
var unicode = 'f201';
var svgPathData = 'M48 408C48 421.3 58.75 432 72 432H488C501.3 432 512 442.7 512 456C512 469.3 501.3 480 488 480H72C32.24 480 0 447.8 0 408V56C0 42.75 10.75 32 24 32C37.25 32 48 42.75 48 56V408zM336.1 304.1C327.6 314.3 312.4 314.3 303 304.1L223.1 225.9L144.1 304.1C135.6 314.3 120.4 314.3 111 304.1C101.7 295.6 101.7 280.4 111 271L207 175C211.5 170.5 217.6 168 223.1 168C230.4 168 236.5 170.5 240.1 175L320 254.1L439 135C448.4 125.7 463.6 125.7 472.1 135C482.3 144.4 482.3 159.6 472.1 168.1L336.1 304.1z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.St = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(5779);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.ki = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 5779:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'chart-pie-simple';
var width = 512;
var height = 512;
var aliases = ["chart-pie-alt"];
var unicode = 'f64e';
var svgPathData = 'M495.4 240H272V16.58C272 7.555 278.1 0 288 0C411.7 0 512 100.3 512 224C512 233 504.4 240 495.4 240zM224 288H445.3C463.8 288 478.6 303.7 474.8 321.8C451.9 430.5 355.5 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.53 60.12 190.2 37.18C208.3 33.36 224 48.2 224 66.7V288zM176 90.91C101.4 117.3 48 188.4 48 272C48 378 133.1 464 240 464C323.6 464 394.7 410.6 421.1 336H176V90.91z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChartPieSimple = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 8149:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'check';
var width = 448;
var height = 512;
var aliases = [10003,10004];
var unicode = 'f00c';
var svgPathData = 'M440.1 103C450.3 112.4 450.3 127.6 440.1 136.1L176.1 400.1C167.6 410.3 152.4 410.3 143 400.1L7.029 264.1C-2.343 255.6-2.343 240.4 7.029 231C16.4 221.7 31.6 221.7 40.97 231L160 350.1L407 103C416.4 93.66 431.6 93.66 440.1 103V103z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.LE = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 9464:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'chevron-down';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f078';
var svgPathData = 'M432.6 209.3l-191.1 183.1C235.1 397.8 229.1 400 224 400s-11.97-2.219-16.59-6.688L15.41 209.3C5.814 200.2 5.502 184.1 14.69 175.4c9.125-9.625 24.38-9.938 33.91-.7187L224 342.8l175.4-168c9.5-9.219 24.78-8.906 33.91 .7187C442.5 184.1 442.2 200.2 432.6 209.3z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.pt = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 5972:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'chevron-right';
var width = 320;
var height = 512;
var aliases = [9002];
var unicode = 'f054';
var svgPathData = 'M113.3 47.41l183.1 191.1c4.469 4.625 6.688 10.62 6.688 16.59s-2.219 11.97-6.688 16.59l-183.1 191.1c-9.152 9.594-24.34 9.906-33.9 .7187c-9.625-9.125-9.938-24.38-.7187-33.91l168-175.4L78.71 80.6c-9.219-9.5-8.906-24.78 .7187-33.91C88.99 37.5 104.2 37.82 113.3 47.41z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports._t = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 3830:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'circle-info';
var width = 512;
var height = 512;
var aliases = ["info-circle"];
var unicode = 'f05a';
var svgPathData = 'M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM296 336h-16V248C280 234.8 269.3 224 256 224H224C210.8 224 200 234.8 200 248S210.8 272 224 272h8v64h-16C202.8 336 192 346.8 192 360S202.8 384 216 384h80c13.25 0 24-10.75 24-24S309.3 336 296 336zM256 192c17.67 0 32-14.33 32-32c0-17.67-14.33-32-32-32S224 142.3 224 160C224 177.7 238.3 192 256 192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleInfo = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 1375:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'circle-xmark';
var width = 512;
var height = 512;
var aliases = [61532,"times-circle","xmark-circle"];
var unicode = 'f057';
var svgPathData = 'M175 175C184.4 165.7 199.6 165.7 208.1 175L255.1 222.1L303 175C312.4 165.7 327.6 165.7 336.1 175C346.3 184.4 346.3 199.6 336.1 208.1L289.9 255.1L336.1 303C346.3 312.4 346.3 327.6 336.1 336.1C327.6 346.3 312.4 346.3 303 336.1L255.1 289.9L208.1 336.1C199.6 346.3 184.4 346.3 175 336.1C165.7 327.6 165.7 312.4 175 303L222.1 255.1L175 208.1C165.7 199.6 165.7 184.4 175 175V175zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 9844:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'code';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f121';
var svgPathData = 'M414.9 31.11L270.9 495.1C266.1 507.8 253.5 514.8 240.9 510.9C228.2 506.1 221.1 493.5 225.1 480.9L369.1 16.89C373 4.226 386.5-2.852 399.1 1.077C411.8 5.006 418.9 18.45 414.9 31.11V31.11zM504.4 118.5L632.4 238.5C637.3 243 640 249.4 640 255.1C640 262.6 637.3 268.1 632.4 273.5L504.4 393.5C494.7 402.6 479.6 402.1 470.5 392.4C461.4 382.7 461.9 367.6 471.6 358.5L580.9 255.1L471.6 153.5C461.9 144.4 461.4 129.3 470.5 119.6C479.6 109.9 494.7 109.4 504.4 118.5V118.5zM168.4 153.5L59.09 255.1L168.4 358.5C178.1 367.6 178.6 382.7 169.5 392.4C160.4 402.1 145.3 402.6 135.6 393.5L7.585 273.5C2.746 268.1 0 262.6 0 255.1C0 249.4 2.746 243 7.585 238.5L135.6 118.5C145.3 109.4 160.4 109.9 169.5 119.6C178.6 129.3 178.1 144.4 168.4 153.5V153.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.dT = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 7758:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(6498);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.b7 = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 8848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(2326);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.Eg = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 5227:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(9256);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.Pj = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 5654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(5956);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.iV = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 5956:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'ellipsis-vertical';
var width = 128;
var height = 512;
var aliases = ["ellipsis-v"];
var unicode = 'f142';
var svgPathData = 'M64 368C90.51 368 112 389.5 112 416C112 442.5 90.51 464 64 464C37.49 464 16 442.5 16 416C16 389.5 37.49 368 64 368zM64 208C90.51 208 112 229.5 112 256C112 282.5 90.51 304 64 304C37.49 304 16 282.5 16 256C16 229.5 37.49 208 64 208zM64 144C37.49 144 16 122.5 16 96C16 69.49 37.49 48 64 48C90.51 48 112 69.49 112 96C112 122.5 90.51 144 64 144z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEllipsisVertical = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 9907:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(6776);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.eH = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 228:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'eye-slash';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f070';
var svgPathData = 'M150.7 92.77C195 58.27 251.8 32 320 32C400.8 32 465.5 68.84 512.6 112.6C559.4 156 590.7 207.1 605.5 243.7C608.8 251.6 608.8 260.4 605.5 268.3C592.1 300.6 565.2 346.1 525.6 386.7L630.8 469.1C641.2 477.3 643.1 492.4 634.9 502.8C626.7 513.2 611.6 515.1 601.2 506.9L9.196 42.89C-1.236 34.71-3.065 19.63 5.112 9.196C13.29-1.236 28.37-3.065 38.81 5.112L150.7 92.77zM189.8 123.5L235.8 159.5C258.3 139.9 287.8 128 320 128C390.7 128 448 185.3 448 256C448 277.2 442.9 297.1 433.8 314.7L487.6 356.9C521.1 322.8 545.9 283.1 558.6 256C544.1 225.1 518.4 183.5 479.9 147.7C438.8 109.6 385.2 79.1 320 79.1C269.5 79.1 225.1 97.73 189.8 123.5L189.8 123.5zM394.9 284.2C398.2 275.4 400 265.9 400 255.1C400 211.8 364.2 175.1 320 175.1C319.3 175.1 318.7 176 317.1 176C319.3 181.1 320 186.5 320 191.1C320 202.2 317.6 211.8 313.4 220.3L394.9 284.2zM404.3 414.5L446.2 447.5C409.9 467.1 367.8 480 320 480C239.2 480 174.5 443.2 127.4 399.4C80.62 355.1 49.34 304 34.46 268.3C31.18 260.4 31.18 251.6 34.46 243.7C44 220.8 60.29 191.2 83.09 161.5L120.8 191.2C102.1 214.5 89.76 237.6 81.45 255.1C95.02 286 121.6 328.5 160.1 364.3C201.2 402.4 254.8 432 320 432C350.7 432 378.8 425.4 404.3 414.5H404.3zM192 255.1C192 253.1 192.1 250.3 192.3 247.5L248.4 291.7C258.9 312.8 278.5 328.6 302 333.1L358.2 378.2C346.1 381.1 333.3 384 319.1 384C249.3 384 191.1 326.7 191.1 255.1H192z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Aq = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 6498:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'gear';
var width = 512;
var height = 512;
var aliases = [9881,"cog"];
var unicode = 'f013';
var svgPathData = 'M160 256C160 202.1 202.1 160 256 160C309 160 352 202.1 352 256C352 309 309 352 256 352C202.1 352 160 309 160 256zM256 208C229.5 208 208 229.5 208 256C208 282.5 229.5 304 256 304C282.5 304 304 282.5 304 256C304 229.5 282.5 208 256 208zM293.1 .0003C315.3 .0003 334.6 15.19 339.8 36.74L347.6 69.21C356.1 73.36 364.2 78.07 371.9 83.28L404 73.83C425.3 67.56 448.1 76.67 459.2 95.87L496.3 160.1C507.3 179.3 503.8 203.6 487.8 218.9L463.5 241.1C463.8 246.6 464 251.3 464 256C464 260.7 463.8 265.4 463.5 270L487.8 293.1C503.8 308.4 507.3 332.7 496.3 351.9L459.2 416.1C448.1 435.3 425.3 444.4 404 438.2L371.9 428.7C364.2 433.9 356.1 438.6 347.6 442.8L339.8 475.3C334.6 496.8 315.3 512 293.1 512H218.9C196.7 512 177.4 496.8 172.2 475.3L164.4 442.8C155.9 438.6 147.8 433.9 140.1 428.7L107.1 438.2C86.73 444.4 63.94 435.3 52.85 416.1L15.75 351.9C4.66 332.7 8.168 308.4 24.23 293.1L48.47 270C48.16 265.4 48 260.7 48 255.1C48 251.3 48.16 246.6 48.47 241.1L24.23 218.9C8.167 203.6 4.66 179.3 15.75 160.1L52.85 95.87C63.94 76.67 86.73 67.56 107.1 73.83L140.1 83.28C147.8 78.07 155.9 73.36 164.4 69.21L172.2 36.74C177.4 15.18 196.7 0 218.9 0L293.1 .0003zM205.5 103.6L194.3 108.3C181.6 113.6 169.8 120.5 159.1 128.7L149.4 136.1L94.42 119.9L57.31 184.1L98.81 223.6L97.28 235.6C96.44 242.3 96 249.1 96 256C96 262.9 96.44 269.7 97.28 276.4L98.81 288.4L57.32 327.9L94.42 392.1L149.4 375.9L159.1 383.3C169.8 391.5 181.6 398.4 194.3 403.7L205.5 408.4L218.9 464H293.1L306.5 408.4L317.7 403.7C330.4 398.4 342.2 391.5 352.9 383.3L362.6 375.9L417.6 392.1L454.7 327.9L413.2 288.4L414.7 276.4C415.6 269.7 416 262.9 416 256C416 249.1 415.6 242.3 414.7 235.6L413.2 223.6L454.7 184.1L417.6 119.9L362.6 136.1L352.9 128.7C342.2 120.5 330.4 113.6 317.7 108.3L306.5 103.6L293.1 48H218.9L205.5 103.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGear = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 7249:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'gift';
var width = 512;
var height = 512;
var aliases = [127873];
var unicode = 'f06b';
var svgPathData = 'M256 85.46L280.1 44.45C296.3 16.91 325.9 0 357.8 0H360C408.6 0 448 39.4 448 88C448 102.4 444.5 115.1 438.4 128H464C490.5 128 512 149.5 512 176V240C512 260.9 498.6 278.7 480 285.3V448C480 483.3 451.3 512 416 512H96C60.65 512 32 483.3 32 448V285.3C13.36 278.7 0 260.9 0 240V176C0 149.5 21.49 128 48 128H73.6C67.46 115.1 64 102.4 64 88C64 39.4 103.4 0 152 0H154.2C186.1 0 215.7 16.91 231.9 44.45L256 85.46zM288 176V240H464V176H288zM224 176H48V240H224V176zM224 288H80V448C80 456.8 87.16 464 96 464H224V288zM288 464H416C424.8 464 432 456.8 432 448V288H288V464zM360 128C382.1 128 400 110.1 400 88C400 65.91 382.1 48 360 48H357.8C342.9 48 329.1 55.91 321.5 68.78L286.7 128H360zM225.3 128L190.5 68.78C182.9 55.91 169.1 48 154.2 48H152C129.9 48 112 65.91 112 88C112 110.1 129.9 128 152 128H225.3z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Cl = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8112:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'globe';
var width = 512;
var height = 512;
var aliases = [127760];
var unicode = 'f0ac';
var svgPathData = 'M256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM256 464C263.4 464 282.1 456.8 303.6 415.6C312.4 397.9 319.1 376.4 325.6 352H186.4C192 376.4 199.6 397.9 208.4 415.6C229 456.8 248.6 464 256 464zM178.5 304H333.5C335.1 288.7 336 272.6 336 256C336 239.4 335.1 223.3 333.5 208H178.5C176.9 223.3 176 239.4 176 256C176 272.6 176.9 288.7 178.5 304V304zM325.6 160C319.1 135.6 312.4 114.1 303.6 96.45C282.1 55.22 263.4 48 256 48C248.6 48 229 55.22 208.4 96.45C199.6 114.1 192 135.6 186.4 160H325.6zM381.8 208C383.2 223.5 384 239.6 384 256C384 272.4 383.2 288.5 381.8 304H458.4C462.1 288.6 464 272.5 464 256C464 239.5 462.1 223.4 458.4 208H381.8zM342.1 66.61C356.2 92.26 367.4 124.1 374.7 160H440.6C419.2 118.9 384.4 85.88 342.1 66.61zM169.9 66.61C127.6 85.88 92.84 118.9 71.43 160H137.3C144.6 124.1 155.8 92.26 169.9 66.61V66.61zM48 256C48 272.5 49.93 288.6 53.57 304H130.2C128.8 288.5 128 272.4 128 256C128 239.6 128.8 223.5 130.2 208H53.57C49.93 223.4 48 239.5 48 256zM440.6 352H374.7C367.4 387.9 356.2 419.7 342.1 445.4C384.4 426.1 419.2 393.1 440.6 352zM137.3 352H71.43C92.84 393.1 127.6 426.1 169.9 445.4C155.8 419.7 144.6 387.9 137.3 352V352z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.g4 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8097:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(3830);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.sq = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 7204:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'list';
var width = 512;
var height = 512;
var aliases = ["list-squares"];
var unicode = 'f03a';
var svgPathData = 'M88 48C101.3 48 112 58.75 112 72V120C112 133.3 101.3 144 88 144H40C26.75 144 16 133.3 16 120V72C16 58.75 26.75 48 40 48H88zM488 72C501.3 72 512 82.75 512 96C512 109.3 501.3 120 488 120H184C170.7 120 160 109.3 160 96C160 82.75 170.7 72 184 72H488zM488 232C501.3 232 512 242.7 512 256C512 269.3 501.3 280 488 280H184C170.7 280 160 269.3 160 256C160 242.7 170.7 232 184 232H488zM488 392C501.3 392 512 402.7 512 416C512 429.3 501.3 440 488 440H184C170.7 440 160 429.3 160 416C160 402.7 170.7 392 184 392H488zM16 232C16 218.7 26.75 208 40 208H88C101.3 208 112 218.7 112 232V280C112 293.3 101.3 304 88 304H40C26.75 304 16 293.3 16 280V232zM88 368C101.3 368 112 378.7 112 392V440C112 453.3 101.3 464 88 464H40C26.75 464 16 453.3 16 440V392C16 378.7 26.75 368 40 368H88z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Zr = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2278:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'magnifying-glass';
var width = 512;
var height = 512;
var aliases = [128269,"search"];
var unicode = 'f002';
var svgPathData = 'M504.1 471l-134-134C399.1 301.5 415.1 256.8 415.1 208c0-114.9-93.13-208-208-208S-.0002 93.13-.0002 208S93.12 416 207.1 416c48.79 0 93.55-16.91 129-45.04l134 134C475.7 509.7 481.9 512 488 512s12.28-2.344 16.97-7.031C514.3 495.6 514.3 480.4 504.1 471zM48 208c0-88.22 71.78-160 160-160s160 71.78 160 160s-71.78 160-160 160S48 296.2 48 208z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMagnifyingGlass = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 5099:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'megaphone';
var width = 576;
var height = 512;
var aliases = [128227];
var unicode = 'f675';
var svgPathData = 'M576 55.1V456C576 469.3 565.3 480 552 480C538.7 480 528 469.3 528 456V450.3L350.3 401.9C341.1 446.4 302.9 480 256 480C202.1 480 160 437 160 384C160 372.6 161.1 361.7 165.6 351.5L48 319.4V328C48 341.3 37.25 352 24 352C10.75 352 0 341.3 0 328V184C0 170.7 10.75 160 24 160C37.25 160 48 170.7 48 184V192.6L528 61.67V56C528 42.75 538.7 32 552 32C565.3 32 576 42.75 576 56V55.1zM528 400.6V111.4L48 242.3V269.7L528 400.6zM256 432C280.8 432 301.1 413.2 303.7 389.2L212.3 364.2C209.5 370.2 208 376.9 208 384C208 410.5 229.5 432 256 432H256z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Au = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2326:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'message';
var width = 512;
var height = 512;
var aliases = ["comment-alt"];
var unicode = 'f27a';
var svgPathData = 'M447.1 0h-384c-35.25 0-64 28.75-64 63.1v287.1c0 35.25 28.75 63.1 64 63.1h96v83.98c0 9.836 11.02 15.55 19.12 9.7l124.9-93.68h144c35.25 0 64-28.75 64-63.1V63.1C511.1 28.75 483.2 0 447.1 0zM464 352c0 8.75-7.25 16-16 16h-160l-80 60v-60H64c-8.75 0-16-7.25-16-16V64c0-8.75 7.25-16 16-16h384c8.75 0 16 7.25 16 16V352z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMessage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 5857:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'message-lines';
var width = 512;
var height = 512;
var aliases = ["comment-alt-lines"];
var unicode = 'f4a6';
var svgPathData = 'M360 144h-208C138.8 144 128 154.8 128 168S138.8 192 152 192h208C373.3 192 384 181.3 384 168S373.3 144 360 144zM264 240h-112C138.8 240 128 250.8 128 264S138.8 288 152 288h112C277.3 288 288 277.3 288 264S277.3 240 264 240zM447.1 0h-384c-35.25 0-64 28.75-64 63.1v287.1c0 35.25 28.75 63.1 64 63.1h96v83.1c0 9.836 11.02 15.55 19.12 9.7l124.9-93.7h144c35.25 0 64-28.75 64-63.1V63.1C511.1 28.75 483.2 0 447.1 0zM464 352c0 8.75-7.25 16-16 16h-160l-80 60v-60H64c-8.75 0-16-7.25-16-16V64c0-8.75 7.25-16 16-16h384c8.75 0 16 7.25 16 16V352z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.sN = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 9256:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'message-smile';
var width = 512;
var height = 512;
var aliases = ["comment-alt-smile"];
var unicode = 'f4aa';
var svgPathData = 'M447.1 .0041h-384c-35.25 0-64 28.75-64 63.1v287.1c0 35.25 28.75 63.1 64 63.1h96v83.99c0 9.836 11.02 15.55 19.12 9.7l124.9-93.69h144c35.25 0 64-28.75 64-63.1V63.1C511.1 28.75 483.2 .0041 447.1 .0041zM464 352c0 8.75-7.25 16-16 16h-160l-80 60v-60H64c-8.75 0-16-7.25-16-16V64c0-8.75 7.25-16 16-16h384c8.75 0 16 7.25 16 16V352zM320 175.1c17.75 0 32-14.25 32-31.1s-14.25-32-31.1-32s-31.1 14.25-31.1 32S302.3 175.1 320 175.1zM192 175.1c17.75 0 32-14.25 32-31.1s-14.25-32-31.1-32s-31.1 14.25-31.1 32S174.3 175.1 192 175.1zM325.8 240.3C308.5 260.4 283.2 272 256 272c-27.12 0-52.49-11.62-69.74-31.75C177.7 230.1 162.4 229 152.4 237.5C142.3 246.1 141.3 261.3 149.8 271.3c26.5 31 65.09 48.74 106.2 48.74c41.12 0 79.76-17.74 106.3-48.74c8.5-10 7.375-25.12-2.75-33.75C349.5 228.9 334.4 230.1 325.8 240.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMessageSmile = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 8453:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'pen-nib';
var width = 512;
var height = 512;
var aliases = [10001];
var unicode = 'f5ad';
var svgPathData = 'M368.4 18.34C390.3-3.526 425.7-3.526 447.6 18.34L493.7 64.4C515.5 86.27 515.5 121.7 493.7 143.6L412.2 225L371.6 374.1C366.7 391.9 353.5 406.1 336.1 412.2L71.97 505C53.47 511.5 32.89 506.8 19.03 492.1C5.168 479.1 .4845 458.5 6.982 440L99.79 175.9C105.9 158.5 120.1 145.3 137.9 140.4L286.1 99.77L368.4 18.34zM296.9 146.8L150.5 186.7C147.1 187.4 145.9 189.3 145.1 191.8L62.47 426.9L164.7 324.7C161.7 318.4 160 311.4 160 304C160 277.5 181.5 256 208 256C234.5 256 256 277.5 256 304C256 330.5 234.5 352 208 352C200.6 352 193.6 350.3 187.3 347.3L85.1 449.5L320.2 366.9C322.7 366.1 324.6 364 325.3 361.5L365.2 215.1L296.9 146.8z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Qz = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8368:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'play';
var width = 384;
var height = 512;
var aliases = [9654];
var unicode = 'f04b';
var svgPathData = 'M24.52 38.13C39.66 29.64 58.21 29.99 73.03 39.04L361 215C375.3 223.8 384 239.3 384 256C384 272.7 375.3 288.2 361 296.1L73.03 472.1C58.21 482 39.66 482.4 24.52 473.9C9.377 465.4 0 449.4 0 432V80C0 62.64 9.377 46.63 24.52 38.13V38.13zM48 432L336 256L48 80V432z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.zc = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8511:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'rocket';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f135';
var svgPathData = 'M408 143.1C408 166.1 390.1 183.1 368 183.1C345.9 183.1 328 166.1 328 143.1C328 121.9 345.9 103.1 368 103.1C390.1 103.1 408 121.9 408 143.1zM23.1 288C15.38 288 7.414 283.4 3.145 275.9C-1.123 268.4-1.043 259.2 3.356 251.8L55.83 163.3C68.79 141.4 92.33 127.1 117.8 127.1H199.9C202.4 124 204.8 120.3 207.2 116.7C289.1-4.07 411.1-8.142 483.9 5.275C495.6 7.414 504.6 16.43 506.7 28.06C520.1 100.9 516.1 222.9 395.3 304.8C391.7 307.2 387.1 309.6 384 312.1V394.2C384 419.7 370.6 443.2 348.7 456.2L260.2 508.6C252.8 513 243.6 513.1 236.1 508.9C228.6 504.6 223.1 496.6 223.1 488V391.8C215.2 395.6 207.4 398.9 200.1 401.7C189.1 406.6 175.5 403.9 166.5 394.8L115.8 344.1C106.6 334.9 103.9 321.1 109.1 309.2C111.7 303.2 114.9 296 118.5 288L23.1 288zM461.7 50.32C398.4 41.85 309.1 51.1 246.1 143.7C216.8 188.1 178.1 271.9 157.6 318.1L192.6 353.1C239.1 333.2 323.9 295.2 368.3 265C460 202.9 470.2 113.6 461.7 50.32V50.32z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.tM = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8853:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(2278);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.wn = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 8069:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'seedling';
var width = 512;
var height = 512;
var aliases = [127793,"sprout"];
var unicode = 'f4d8';
var svgPathData = 'M436.4 32c-91 0-168.3 67.88-194.6 161.4C204.6 134.6 144 96 75.63 96L0 95.1V120C0 247.9 91.75 352 204.4 352H232v104C232 469.2 242.8 480 255.1 480S280 469.2 280 456V288h27.62C420.2 288 512 183.9 512 56V32H436.4zM204.4 304c-79.25 0-145.1-69.75-155.1-160h26.25c79.25 0 145.1 69.75 155.1 160H204.4zM307.6 240h-26.25c10-90.25 75.87-160 155.1-160h26.25C452.8 170.2 386.9 240 307.6 240z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.YK = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 128:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'sparkles';
var width = 512;
var height = 512;
var aliases = [10024];
var unicode = 'f890';
var svgPathData = 'M327.5 85.19L384 64L405.2 7.491C406.9 2.985 411.2 0 416 0C420.8 0 425.1 2.985 426.8 7.491L448 64L504.5 85.19C509 86.88 512 91.19 512 96C512 100.8 509 105.1 504.5 106.8L448 128L426.8 184.5C425.1 189 420.8 192 416 192C411.2 192 406.9 189 405.2 184.5L384 128L327.5 106.8C322.1 105.1 320 100.8 320 96C320 91.19 322.1 86.88 327.5 85.19V85.19zM176 73.29C178.6 67.63 184.3 64 190.6 64C196.8 64 202.5 67.63 205.1 73.29L257.8 187.3L371.8 240C377.5 242.6 381.1 248.3 381.1 254.6C381.1 260.8 377.5 266.5 371.8 269.1L257.8 321.8L205.1 435.8C202.5 441.5 196.8 445.1 190.6 445.1C184.3 445.1 178.6 441.5 176 435.8L123.3 321.8L9.292 269.1C3.627 266.5 0 260.8 0 254.6C0 248.3 3.627 242.6 9.292 240L123.3 187.3L176 73.29zM166.9 207.5C162.1 217.8 153.8 226.1 143.5 230.9L92.32 254.6L143.5 278.2C153.8 282.1 162.1 291.3 166.9 301.6L190.6 352.8L214.2 301.6C218.1 291.3 227.3 282.1 237.6 278.2L288.8 254.6L237.6 230.9C227.3 226.1 218.1 217.8 214.2 207.5L190.6 156.3L166.9 207.5zM405.2 327.5C406.9 322.1 411.2 320 416 320C420.8 320 425.1 322.1 426.8 327.5L448 384L504.5 405.2C509 406.9 512 411.2 512 416C512 420.8 509 425.1 504.5 426.8L448 448L426.8 504.5C425.1 509 420.8 512 416 512C411.2 512 406.9 509 405.2 504.5L384 448L327.5 426.8C322.1 425.1 320 420.8 320 416C320 411.2 322.1 406.9 327.5 405.2L384 384L405.2 327.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Jy = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 4127:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'suitcase';
var width = 512;
var height = 512;
var aliases = [129523];
var unicode = 'f0f2';
var svgPathData = 'M128 96V56C128 25.07 153.1 0 184 0H328C358.9 0 384 25.07 384 56V96H448C483.3 96 512 124.7 512 160V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V160C0 124.7 28.65 96 64 96H128zM176 96H336V56C336 51.58 332.4 48 328 48H184C179.6 48 176 51.58 176 56V96zM144 144V432H368V144H144zM48 160V416C48 424.8 55.16 432 64 432H96V144H64C55.16 144 48 151.2 48 160zM464 416V160C464 151.2 456.8 144 448 144H416V432H448C456.8 432 464 424.8 464 416z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.qb = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 224:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(8425);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.NB = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 465:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(1375);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.nY = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 6776:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'triangle-exclamation';
var width = 512;
var height = 512;
var aliases = [9888,"exclamation-triangle","warning"];
var unicode = 'f071';
var svgPathData = 'M506.3 417l-213.3-364C284.8 39 270.4 32 256 32C241.6 32 227.2 39 218.1 53l-213.2 364C-10.59 444.9 9.851 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM52.58 432L255.1 84.8L459.4 432H52.58zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44c0 17.36 14.11 31.44 31.48 31.44s31.4-14.08 31.4-31.44C287.4 351.2 273.4 337.1 256 337.1zM232 184v96C232 293.3 242.8 304 256 304s24-10.75 24-24v-96C280 170.8 269.3 160 256 160S232 170.8 232 184z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTriangleExclamation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 3036:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'video';
var width = 576;
var height = 512;
var aliases = ["video-camera"];
var unicode = 'f03d';
var svgPathData = 'M557.6 102.3c-11.53-7.406-25.88-8.391-38.28-2.688L416 147V128c0-35.35-28.65-64-64-64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h288c35.35 0 64-28.65 64-64v-19.02l103.3 47.36c5.344 2.453 11.03 3.672 16.69 3.672c7.531 0 15.02-2.141 21.59-6.359C569.1 402.3 576 389.7 576 375.1V136C576 122.3 569.1 109.8 557.6 102.3zM368 384c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16V128c0-8.822 7.178-16 16-16h288c8.822 0 16 7.178 16 16V384zM528 363.5L416 312.2V199.8l112-51.33V363.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Iy = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8425:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'xmark';
var width = 320;
var height = 512;
var aliases = [128473,10005,10006,10060,215,"close","multiply","remove","times"];
var unicode = 'f00d';
var svgPathData = 'M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 5235:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'arrow-right';
var width = 448;
var height = 512;
var aliases = [8594];
var unicode = 'f061';
var svgPathData = 'M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.eF = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 17:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = 'M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zm97 225c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0L353 225z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.fi = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 9423:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'calendar-circle-plus';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e470';
var svgPathData = 'M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3V192H0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.TI = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 9853:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'circle';
var width = 512;
var height = 512;
var aliases = [128308,128309,128992,128993,128994,128995,128996,9679,9898,9899,11044,61708,61915];
var unicode = 'f111';
var svgPathData = 'M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.di = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 9447:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'circle-info';
var width = 512;
var height = 512;
var aliases = ["info-circle"];
var unicode = 'f05a';
var svgPathData = 'M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-144c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleInfo = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 7324:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'clock';
var width = 512;
var height = 512;
var aliases = [128339,"clock-four"];
var unicode = 'f017';
var svgPathData = 'M256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.SZ = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 1560:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'envelope';
var width = 512;
var height = 512;
var aliases = [128386,9993,61443];
var unicode = 'f0e0';
var svgPathData = 'M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.FU = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2653:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(9447);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.sq = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 1870:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'location-dot';
var width = 384;
var height = 512;
var aliases = ["map-marker-alt"];
var unicode = 'f3c5';
var svgPathData = 'M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 256c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLocationDot = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 1677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(1870);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.FG = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 7409:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'shield-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f2f7';
var svgPathData = 'M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.ip = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 8606:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'sparkles';
var width = 512;
var height = 512;
var aliases = [10024];
var unicode = 'f890';
var svgPathData = 'M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Jy = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2580:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'tag';
var width = 448;
var height = 512;
var aliases = [127991];
var unicode = 'f02b';
var svgPathData = 'M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 96c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.LE = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 1584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(2414);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.NB = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 2414:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'xmark';
var width = 320;
var height = 512;
var aliases = [128473,10005,10006,10060,215,"close","multiply","remove","times"];
var unicode = 'f00d';
var svgPathData = 'M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 8336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ r; }
/* harmony export */ });
function r(){return r=Object.assign?Object.assign.bind():function(r){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(r[a]=n[a])}return r},r.apply(this,arguments)}


/***/ }),

/***/ 6830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ o; },
/* harmony export */   "b": function() { return /* binding */ i; }
/* harmony export */ });
/* unused harmony export c */
/* harmony import */ var _rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8336);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var process = __webpack_require__(4155);
function n(e=""){return e.split("; ").reduce(((e,t)=>{const n=t.split("=");return e[n[0]]=n[1],e}),{})}const o=(o=!1,i={})=>{var r;let s="",c=(0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)({"X-Requested-With":"XMLHttpRequest","Content-Type":"application/json"},undefined);const a="undefined"!=typeof window&&(null===(r=n(null===document||void 0===document?void 0:document.cookie))||void 0===r?void 0:r.csrftoken)||"";return i.headers&&(c=(0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)({},c),i.headers)),i.baseURL&&(s=i.baseURL),i.custom?(axios__WEBPACK_IMPORTED_MODULE_0___default()):(i.isAuthRequired&&a&&(c=(0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)({},c),{"X-CSRFToken":a})),o?axios__WEBPACK_IMPORTED_MODULE_0___default().create({headers:(0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)({},c),{"X-CSRFToken":a})}):axios__WEBPACK_IMPORTED_MODULE_0___default().create({baseURL:s,headers:c}))},i=(n,o=process.env.API_URL)=>axios__WEBPACK_IMPORTED_MODULE_0___default().create({baseURL:o,headers:(0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)((0,_rollupPluginBabelHelpers_388f54e6_js__WEBPACK_IMPORTED_MODULE_1__._)({},n),undefined),{"bff-ip-rewrite":n["cf-connecting-ip"]?n["cf-connecting-ip"]:"","bff-country-rewrite":n["cf-ipcountry"]?n["cf-ipcountry"]:"","Content-Type":"application/json"}),timeout:15e3});


/***/ }),

/***/ 8719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ g; },
/* harmony export */   "BG": function() { return /* binding */ n; },
/* harmony export */   "DN": function() { return /* binding */ l; },
/* harmony export */   "P2": function() { return /* binding */ i; },
/* harmony export */   "Pt": function() { return /* binding */ z; },
/* harmony export */   "Zb": function() { return /* binding */ h; },
/* harmony export */   "ag": function() { return /* binding */ o; },
/* harmony export */   "bK": function() { return /* binding */ v; },
/* harmony export */   "cY": function() { return /* binding */ m; },
/* harmony export */   "lB": function() { return /* binding */ a; },
/* harmony export */   "lE": function() { return /* binding */ t; },
/* harmony export */   "qY": function() { return /* binding */ r; },
/* harmony export */   "u3": function() { return /* binding */ s; },
/* harmony export */   "yP": function() { return /* binding */ p; },
/* harmony export */   "zo": function() { return /* binding */ e; }
/* harmony export */ });
/* unused harmony exports ACADEMY, B2B, EXPERT, EXPERT_PLUS, PLAN_FREE, b2bEmailRegex, emailRegex, nameRegex */
const a={amex:"https://static.platzi.com/commons/assets/images/amex8c702aae174e8d5b.png",baloto:"https://static.platzi.com/commons/assets/images/baloto7621e7f822d4583d.png",banorte:"https://static.platzi.com/commons/assets/images/banorte87e6a5073635d557.png",bitcoin:"https://static.platzi.com/commons/assets/images/bitcoinadad1b8d54a97811.png",davivienda:"https://static.platzi.com/commons/assets/images/davivienda5f0ce9d108e6b1ee.png",efecty:"https://static.platzi.com/commons/assets/images/efecty91f6cb277fa29fea.png",mastercard:"https://static.platzi.com/commons/assets/images/mastercardbf4ad752b3fb3d0e.png",oxxo:"https://static.platzi.com/commons/assets/images/oxxoe3985c89b2ec0bf5.png",pago_efectivo:"https://static.platzi.com/commons/assets/images/pago_efectivod8f46b2bdaf56e7f.png",pago_facil:"https://static.platzi.com/commons/assets/images/pago_facil5df441661803d43a.png",paypal:"https://static.platzi.com/commons/assets/images/paypalbc538ab7210a384a.png",pse:"https://static.platzi.com/commons/assets/images/psebb0ce4c4463aa51b.png",rapipago:"https://static.platzi.com/commons/assets/images/rapipago1001d95e1020bdf8.png",visa:"https://static.platzi.com/commons/assets/images/visa52d765334f273be7.png",sencillito:"https://static.platzi.com/commons/assets/images/sencillitof1aa0eb82ecec56d.png",servipag:"https://static.platzi.com/commons/assets/images/servipage7972ff9af0f8a91.png"};const s={amex:"https://static.platzi.com/commons/assets/images/amexda647adf95f30924.png",baloto:"https://static.platzi.com/commons/assets/images/baloto7621e7f822d4583d.png",banorte:"https://static.platzi.com/commons/assets/images/banorte87e6a5073635d557.png",bitcoin:"https://static.platzi.com/commons/assets/images/bitcoinadad1b8d54a97811.png",davivienda:"https://static.platzi.com/commons/assets/images/davivienda5f0ce9d108e6b1ee.png",efecty:"https://static.platzi.com/commons/assets/images/efecty22311be7d0475e8f.png",mastercard:"https://static.platzi.com/commons/assets/images/mastercardbf4ad752b3fb3d0e.png",oxxo:"https://static.platzi.com/commons/assets/images/oxxoe3985c89b2ec0bf5.png",pago_efectivo:"https://static.platzi.com/commons/assets/images/pago_efectivo39a4341bf1f15d31.png",pago_facil:"https://static.platzi.com/commons/assets/images/pago_facil632781fca2af5541.png",paypal:"https://static.platzi.com/commons/assets/images/paypal03ae8e5a43fc2f23.png",pse:"https://static.platzi.com/commons/assets/images/pse3962764fe3faa4ea.png",rapipago:"https://static.platzi.com/commons/assets/images/rapipago3cefa48fe3375a12.png",visa:"https://static.platzi.com/commons/assets/images/visa91625977f7206bc0.png"},t={SPANISH_CO:"es-CO",SPANISH_ES:"es-ES",PORTUGUESE:"pt",ENGLISH:"en"},e="monthly_plan",o="expert_plan",i="annual_plan",m="platzi_academy",p="family_plan",c="free_plan",n="enterprise",g="user",l="b2b",f=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,b=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(?!(?:hotmail|gmail|googlemail|yahoo|gmx|ymail|outlook|bluewin|protonmail|live))((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,d=/^[a-zA-Z\s]*$/,z=480,h=768,r=1024,v=1200,x="Platzi Expert",_="Platzi Expert+",y="Plan Empresarial",A="Platzi English Academy";


/***/ }),

/***/ 758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ u; },
  "m": function() { return /* binding */ a; }
});

// UNUSED EXPORTS: a, d

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(1296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/uuid-d9b73e12.js
const uuid_d9b73e12_e=()=>{const e=new Date;return`${e.getTime()}${e.getMilliseconds()}`};

// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/axiosInstance-1cddbf84.js
var axiosInstance_1cddbf84 = __webpack_require__(6830);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/index-7de6c45f.js
const i=lodash_debounce_default()(((e,t)=>{t(e)}),350),r=(t,n,i=350)=>{e(((e=t,i=n)=>{i(e)}),i)()};class s{constructor(e){this.options=e,this.plugins=[]}static#e="p.eyJ1IjogIjVjYTk5NDc5LTVkY2EtNDFiNC1hZGJiLWZiN2UwMmJmNjU1NSIsICJpZCI6ICI0OWQxYjEyMC04ODVhLTRiNTAtYTc1Ny0zNGMzM2UyMGMyNDgifQ.T8ubGgyDRv0-75Nl3pOlewUHPLM9eanXPRrAxVrY2Y8";addPlugin(e){this.plugins.push(e)}prepare(e){const t={agent:window.navigator.userAgent,date:(new Date).toISOString(),origin:window.origin,referer:document.referrer,...e};return this.plugins.reduce(((e,t)=>t(e)),t)}send(e){const{token:t=s.#e,name:i}=this.options,r=this.prepare(e);return (0,axiosInstance_1cddbf84.a)(!1,{headers:{Authorization:`Bearer ${t}`}}).post(`${s.urlTinyBird}?name=${i}`,r).catch((e=>{throw new Error("::ERROR::Event",{cause:e})}))}}function o(e,n){const i=uuid_d9b73e12_e();return n.setItem(e,JSON.stringify({data:i,timestamp:Date.now()})),i}s.urlTinyBird="https://api.us-east.tinybird.co/v0/events";var a={create:function(e={}){return new s(e)},SessionStudentPlugin:function(e){let n=window.sessionStorage.getItem("student-session");return n||(n=uuid_d9b73e12_e(),window.sessionStorage.setItem("student-session",n)),{...e,session:n}},createSessionPlugin:function(e,t,n={expireTime:18e5}){return function(i){const r=function(e,t,n={}){try{const i=t.getItem(e),r=JSON.parse(i),{timestamp:s=Date.now(),data:a}=r??{},{expireTime:u=0}=n;return!a||function(e,t,n){return e+t<=Date.now()}(s,u)?o(e,t):a}catch(n){return o(e,t)}}(e,t,n);return{...i,session:r}}}};var u={send:function(e){"undefined"!=typeof window&&window.dataLayer&&window.dataLayer.push(e)}};


/***/ }),

/***/ 6518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ c; },
  "c": function() { return /* binding */ p; },
  "e": function() { return /* binding */ f; }
});

// UNUSED EXPORTS: b, d, g, u

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__(6064);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/ActionTypes-f5b854b0.js
const E="SET_REGISTER_MODAL";

// EXTERNAL MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/index-7de6c45f.js + 1 modules
var index_7de6c45f = __webpack_require__(758);
;// CONCATENATED MODULE: ./node_modules/@platzi/ui/node_modules/@platzi/commons/dist/es/useRegisterModal-23dbb00b.js
const d=o=>{const[t,n]=e(o);return{value:t,onChange:e=>n(e.target.value)}},s="undefined"!=typeof window,a=()=>({width:s?window.innerWidth:void 0,height:s?window.innerHeight:void 0}),c=()=>{const[t,n]=(0,react.useState)(a());return (0,react.useEffect)((()=>{const e=()=>{n(a())};return s?(window.addEventListener("resize",e),()=>{window.removeEventListener("resize",e)}):null}),[]),t},l=(t,n)=>{if("undefined"==typeof window)return[n,null];const[i,r]=e((()=>window.localStorage.getItem(t)||n));return o((()=>{window.localStorage.setItem(t,i)}),[t,i]),[i,r]},m=e=>"undefined"!=typeof document&&document.cookie.split(";").some((o=>o.trim().startsWith(`${e}=`))),u=(e,o,t)=>document.cookie=`${e}=${o}; max-age=${t}`,g=e=>{const o="undefined"!=typeof document&&document.cookie.match(new RegExp("(?:^|; )"+e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g,"\\$1")+"=([^;]*)"));return o?decodeURIComponent(o[1]):void 0},p=()=>({checkCookie:m,setCookie:u,getCookie:g}),w=t=>{const[n,i]=e("");return o((()=>{if("undefined"!=typeof window){const e=new URLSearchParams(window.location.search);i(e.get(t))}}),[]),{variable:n}},f=()=>{var e;const o=(0,es/* useDispatch */.I0)(),d=(null===(e=(0,es/* useSelector */.v9)((e=>e.get("header").get("register_modal"))))||void 0===e?void 0:e.toJS())||{},s=e=>{var t;o((t={...d,...e},{type:E,payload:t}))};return{isRegisterModalOpen:(null==d?void 0:d.isOpen)||!1,openRegisterModal:(e={})=>{index_7de6c45f.T.send({event:"register_modal_impression",...e}),s({isOpen:!0})},closeRegisterModal:(e={})=>{index_7de6c45f.T.send({event:"register_modal_close",...e}),s({isOpen:!1})},setModalConfig:s,configRegisterModal:d}};


/***/ }),

/***/ 9634:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 6445:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,o){ true?module.exports=o(__webpack_require__(9634)):0}(this,(function(e){"use strict";function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=o(e),d={name:"es",monthsShort:"ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),weekStart:1,formats:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},ordinal:function(e){return e+"º"}};return s.default.locale(d,null,!0),d}));

/***/ }),

/***/ 3938:
/***/ (function(module) {

!function(e,i){ true?module.exports=i():0}(this,(function(){"use strict";return function(e,i,t){i.prototype.isBetween=function(e,i,s,f){var n=t(e),o=t(i),r="("===(f=f||"()")[0],u=")"===f[1];return(r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))}}}));

/***/ }),

/***/ 9960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __extends, __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 7856:
/***/ (function(module) {

/*! @license DOMPurify 2.4.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.3/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }
  /* Add properties to a lookup table */

  function addToSet(set, array, transformCaseFunc) {
    transformCaseFunc = transformCaseFunc ? transformCaseFunc : stringToLowerCase;

    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;

    while (l--) {
      var element = array[l];

      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);

        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }
  /* Shallow clone an object */

  function clone(object) {
    var newObject = create(null);
    var property;

    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }
  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */

  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);

      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.

  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.

  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */


  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    } // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.


    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';

    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };
    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */


    DOMPurify.version = '2.4.3';
    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */

    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }

    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');

      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};

    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */

    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
    /* Allowed attribute names */

    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */

    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

    var FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

    var FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */

    var ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */

    var ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */

    var ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */

    var SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */

    var WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */

    var SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */

    var FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */

    var RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */

    var RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */

    var RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */

    var SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */

    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */

    var KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */

    var IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */

    var USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */

    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */

    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */

    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */

    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */

    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
    /* Parsing of strict XHTML documents */

    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;
    /* Keep a reference to config to pass to hooks */

    var CONFIG = null;
    /* Ideally, do not touch anything below this line */

    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity


    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */


      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */


      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
      /* Set configuration parameters */

      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

      RETURN_DOM = cfg.RETURN_DOM || false; // Default false

      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

      FORCE_BODY = cfg.FORCE_BODY || false; // Default false

      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

      IN_PLACE = cfg.IN_PLACE || false; // Default false

      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */


      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];

        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */


      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */


      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      } // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.


      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.

    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */

    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */

    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.

      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        } // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.


        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        } // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.


        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        } // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points


        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        } // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.


        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        } // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace


        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      } // For XHTML and XML documents that support custom namespaces


      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      } // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.


      return false;
    };
    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */


    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });

      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };
    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */


    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */


    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */

      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */


      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);

        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {// Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */


      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */


    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */


    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };
    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */


    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };
    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */


    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */


    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeElements', currentNode, null);
      /* Check if element is clobbered or can clobber */


      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Check if tagname contains Unicode */


      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Now let's check the element's type and name */


      var tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */

      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */


      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Mitigate a problem with templates inside select */


      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Remove element if anything forbids its presence */


      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements */


        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);

        return true;
      }
      /* Check whether element has a valid namespace */


      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Sanitize element content to be template-safe */


      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');

        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity


    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */


      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */

      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };
    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */


    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */


    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;
      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */

      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);
        /* Execute a hook if present */

        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */

        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */


        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */


        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */


        if (regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);

          continue;
        }
        /* Sanitize attribute content to be template-safe */


        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }
        /* Is `value` valid for this attribute? */


        var lcTag = transformCaseFunc(currentNode.nodeName);

        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */


        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Handle attributes that require Trusted Types */


        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                value = trustedTypesPolicy.createHTML(value);
                break;

              case 'TrustedScriptURL':
                value = trustedTypesPolicy.createScriptURL(value);
                break;
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */


        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */


    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;

      var shadowIterator = _createIterator(fragment);
      /* Execute a hook if present */


      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */


        if (_sanitizeElements(shadowNode)) {
          continue;
        }
        /* Deep shadow DOM detected */


        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(shadowNode);
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity


    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */

      IS_EMPTY_INPUT = !dirty;

      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */


      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();

          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }
      /* Check we can run. Otherwise fall back or ignore */


      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }
      /* Assign config vars */


      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */


      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */

      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);

          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);

        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */


        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */

        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */


      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */


      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */


      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }
        /* Sanitize tags and elements */


        if (_sanitizeElements(currentNode)) {
          continue;
        }
        /* Shadow DOM detected, sanitize it */


        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;
      /* If we sanitized `dirty` in-place, return it. */

      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */


      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */

      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */


      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */


    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);

      SET_CONFIG = true;
    };
    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */


    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */


    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */


    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */


    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };
    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */


    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };
    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */


    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ 9238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = window.DOMPurify || (window.DOMPurify = (__webpack_require__(7856)["default"]) || __webpack_require__(7856));

/***/ }),

/***/ 6245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InvalidTokenError */
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (o)));
//# sourceMappingURL=jwt-decode.esm.js.map


/***/ }),

/***/ 5107:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this, function() {
/**
 * Global dependencies.
 * @global {Object} document - DOM
 */

var devnull = function() {},
    bundleIdCache = {},
    bundleResultCache = {},
    bundleCallbackQueue = {};


/**
 * Subscribe to bundle load event.
 * @param {string[]} bundleIds - Bundle ids
 * @param {Function} callbackFn - The callback function
 */
function subscribe(bundleIds, callbackFn) {
  // listify
  bundleIds = bundleIds.push ? bundleIds : [bundleIds];

  var depsNotFound = [],
      i = bundleIds.length,
      numWaiting = i,
      fn,
      bundleId,
      r,
      q;

  // define callback function
  fn = function (bundleId, pathsNotFound) {
    if (pathsNotFound.length) depsNotFound.push(bundleId);

    numWaiting--;
    if (!numWaiting) callbackFn(depsNotFound);
  };

  // register callback
  while (i--) {
    bundleId = bundleIds[i];

    // execute callback if in result cache
    r = bundleResultCache[bundleId];
    if (r) {
      fn(bundleId, r);
      continue;
    }

    // add to callback queue
    q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];
    q.push(fn);
  }
}


/**
 * Publish bundle load event.
 * @param {string} bundleId - Bundle id
 * @param {string[]} pathsNotFound - List of files not found
 */
function publish(bundleId, pathsNotFound) {
  // exit if id isn't defined
  if (!bundleId) return;

  var q = bundleCallbackQueue[bundleId];

  // cache result
  bundleResultCache[bundleId] = pathsNotFound;

  // exit if queue is empty
  if (!q) return;

  // empty callback queue
  while (q.length) {
    q[0](bundleId, pathsNotFound);
    q.splice(0, 1);
  }
}


/**
 * Execute callbacks.
 * @param {Object or Function} args - The callback args
 * @param {string[]} depsNotFound - List of dependencies not found
 */
function executeCallbacks(args, depsNotFound) {
  // accept function as argument
  if (args.call) args = {success: args};

  // success and error callbacks
  if (depsNotFound.length) (args.error || devnull)(depsNotFound);
  else (args.success || devnull)(args);
}


/**
 * Load individual file.
 * @param {string} path - The file path
 * @param {Function} callbackFn - The callback function
 */
function loadFile(path, callbackFn, args, numTries) {
  var doc = document,
      async = args.async,
      maxTries = (args.numRetries || 0) + 1,
      beforeCallbackFn = args.before || devnull,
      pathname = path.replace(/[\?|#].*$/, ''),
      pathStripped = path.replace(/^(css|img)!/, ''),
      isLegacyIECss,
      e;

  numTries = numTries || 0;

  if (/(^css!|\.css$)/.test(pathname)) {
    // css
    e = doc.createElement('link');
    e.rel = 'stylesheet';
    e.href = pathStripped;

    // tag IE9+
    isLegacyIECss = 'hideFocus' in e;

    // use preload in IE Edge (to detect load errors)
    if (isLegacyIECss && e.relList) {
      isLegacyIECss = 0;
      e.rel = 'preload';
      e.as = 'style';
    }
  } else if (/(^img!|\.(png|gif|jpg|svg|webp)$)/.test(pathname)) {
    // image
    e = doc.createElement('img');
    e.src = pathStripped;    
  } else {
    // javascript
    e = doc.createElement('script');
    e.src = path;
    e.async = async === undefined ? true : async;
  }

  e.onload = e.onerror = e.onbeforeload = function (ev) {
    var result = ev.type[0];

    // treat empty stylesheets as failures to get around lack of onerror
    // support in IE9-11
    if (isLegacyIECss) {
      try {
        if (!e.sheet.cssText.length) result = 'e';
      } catch (x) {
        // sheets objects created from load errors don't allow access to
        // `cssText` (unless error is Code:18 SecurityError)
        if (x.code != 18) result = 'e';
      }
    }

    // handle retries in case of load failure
    if (result == 'e') {
      // increment counter
      numTries += 1;

      // exit function and try again
      if (numTries < maxTries) {
        return loadFile(path, callbackFn, args, numTries);
      }
    } else if (e.rel == 'preload' && e.as == 'style') {
      // activate preloaded stylesheets
      return e.rel = 'stylesheet'; // jshint ignore:line
    }
    
    // execute callback
    callbackFn(path, result, ev.defaultPrevented);
  };

  // add to document (unless callback returns `false`)
  if (beforeCallbackFn(path, e) !== false) doc.head.appendChild(e);
}


/**
 * Load multiple files.
 * @param {string[]} paths - The file paths
 * @param {Function} callbackFn - The callback function
 */
function loadFiles(paths, callbackFn, args) {
  // listify paths
  paths = paths.push ? paths : [paths];

  var numWaiting = paths.length,
      x = numWaiting,
      pathsNotFound = [],
      fn,
      i;

  // define callback function
  fn = function(path, result, defaultPrevented) {
    // handle error
    if (result == 'e') pathsNotFound.push(path);

    // handle beforeload event. If defaultPrevented then that means the load
    // will be blocked (ex. Ghostery/ABP on Safari)
    if (result == 'b') {
      if (defaultPrevented) pathsNotFound.push(path);
      else return;
    }

    numWaiting--;
    if (!numWaiting) callbackFn(pathsNotFound);
  };

  // load scripts
  for (i=0; i < x; i++) loadFile(paths[i], fn, args);
}


/**
 * Initiate script load and register bundle.
 * @param {(string|string[])} paths - The file paths
 * @param {(string|Function|Object)} [arg1] - The (1) bundleId or (2) success
 *   callback or (3) object literal with success/error arguments, numRetries,
 *   etc.
 * @param {(Function|Object)} [arg2] - The (1) success callback or (2) object
 *   literal with success/error arguments, numRetries, etc.
 */
function loadjs(paths, arg1, arg2) {
  var bundleId,
      args;

  // bundleId (if string)
  if (arg1 && arg1.trim) bundleId = arg1;

  // args (default is {})
  args = (bundleId ? arg2 : arg1) || {};

  // throw error if bundle is already defined
  if (bundleId) {
    if (bundleId in bundleIdCache) {
      throw "LoadJS";
    } else {
      bundleIdCache[bundleId] = true;
    }
  }

  function loadFn(resolve, reject) {
    loadFiles(paths, function (pathsNotFound) {
      // execute callbacks
      executeCallbacks(args, pathsNotFound);
      
      // resolve Promise
      if (resolve) {
        executeCallbacks({success: resolve, error: reject}, pathsNotFound);
      }

      // publish bundle load event
      publish(bundleId, pathsNotFound);
    }, args);
  }
  
  if (args.returnPromise) return new Promise(loadFn);
  else loadFn();
}


/**
 * Execute callbacks when dependencies have been satisfied.
 * @param {(string|string[])} deps - List of bundle ids
 * @param {Object} args - success/error arguments
 */
loadjs.ready = function ready(deps, args) {
  // subscribe to bundle load event
  subscribe(deps, function (depsNotFound) {
    // execute callbacks
    executeCallbacks(args, depsNotFound);
  });

  return loadjs;
};


/**
 * Manually satisfy bundle dependencies.
 * @param {string} bundleId - The bundle id
 */
loadjs.done = function done(bundleId) {
  publish(bundleId, []);
};


/**
 * Reset loadjs dependencies statuses
 */
loadjs.reset = function reset() {
  bundleIdCache = {};
  bundleResultCache = {};
  bundleCallbackQueue = {};
};


/**
 * Determine if bundle has already been defined
 * @param String} bundleId - The bundle id
 */
loadjs.isDefined = function isDefined(bundleId) {
  return bundleId in bundleIdCache;
};


// export
return loadjs;

}));


/***/ }),

/***/ 5655:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),

/***/ 2703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 5697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2703)();
}


/***/ }),

/***/ 414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 7058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ useTranslation; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(3878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js + 1 modules
var unsupportedIterableToArray = __webpack_require__(1563);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(5267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js + 1 modules
var context = __webpack_require__(7715);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(context/* I18nContext */.OO) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || (0,context/* getI18n */.nI)();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new context/* ReportNamespaces */.zv();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = _objectSpread(_objectSpread(_objectSpread({}, (0,context/* getDefaults */.JP)()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = _slicedToArray(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}

/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 9396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

}]);